
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("67UrT", function(module, exports) {
$parcel$export(module.exports, "UniformEntryPage", function () { return $567142e6bd5e85f1$export$f0d4a992b207ed41; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $iSeHD = parcelRequire("iSeHD");

var $4EfnG = parcelRequire("4EfnG");

var $7WM7y = parcelRequire("7WM7y");

var $ipRTK = parcelRequire("ipRTK");
const $567142e6bd5e85f1$export$f0d4a992b207ed41 = ({ composition: composition, compositionMetrics: compositionMetrics, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>{
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { compositionFetchStart: compositionFetchStart, compositionCacheStatus: compositionCacheStatus, ssrEndTime: ssrEndTime } = compositionMetrics || {};
    const sendPageRenderAnalyticsEvent = (0, $1oC0p.useCallback)((pageRenderTime, ssrEndTime, compositionFetchStart, fcp)=>{
        if (pageRenderTime && analyticsClient) analyticsClient.sendUIEvent({
            action: 'pageRender',
            actionSubject: 'uniformPage',
            source: window.location.pathname,
            attributes: {
                pageRenderTime: pageRenderTime,
                compositionFetchStart: compositionFetchStart,
                ssrEndTime: ssrEndTime,
                compositionCacheStatus: compositionCacheStatus,
                fcp: fcp,
                isUniformPlayground: isUniformPlayground || false
            }
        });
    }, [
        analyticsClient,
        compositionCacheStatus,
        isUniformPlayground
    ]);
    (0, $1oC0p.useEffect)(()=>{
        // @ts-ignore
        const measureFirstContentfulPaint = ()=>{
            try {
                // First, check if FCP is already available
                const paintEntries = performance.getEntriesByType('paint');
                const firstContentfulPaint = paintEntries.find((entry)=>entry.name === 'first-contentful-paint');
                if (firstContentfulPaint && ssrEndTime && compositionFetchStart) {
                    const fcp = firstContentfulPaint.startTime;
                    // Calculate page render time
                    const pageRenderTime = ssrEndTime - compositionFetchStart + fcp;
                    if (pageRenderTime) sendPageRenderAnalyticsEvent(pageRenderTime, ssrEndTime, compositionFetchStart, fcp);
                    return firstContentfulPaint.startTime;
                }
                // If FCP isn't available yet, observe for it
                const observer = new PerformanceObserver((list)=>{
                    const entries = list.getEntries();
                    const fcpEntry = entries.find((entry)=>entry.name === 'first-contentful-paint');
                    if (fcpEntry && compositionFetchStart && ssrEndTime) {
                        const fcp = fcpEntry.startTime;
                        // Calculate page render time
                        const pageRenderTime = ssrEndTime - compositionFetchStart + fcp;
                        if (pageRenderTime) sendPageRenderAnalyticsEvent(pageRenderTime, ssrEndTime, compositionFetchStart, fcp);
                        observer.disconnect();
                    }
                });
                observer.observe({
                    entryTypes: [
                        'paint'
                    ]
                });
                // Cleanup observer after 10 seconds to prevent memory leaks
                setTimeout(()=>{
                    observer.disconnect();
                }, 10000);
                return undefined;
            } catch (error) {
                console.warn('Error measuring Page Render Time:', error);
                return undefined;
            }
        };
        measureFirstContentfulPaint();
    }, [
        compositionFetchStart,
        compositionMetrics,
        sendPageRenderAnalyticsEvent,
        ssrEndTime
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4EfnG.default), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7WM7y.FourOhFourPageTemplate), {}),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            "data-testid": "uniform-entry-page-root",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ipRTK.UniformEntryPageTemplate), {
                    composition: composition,
                    isUniformPlayground: isUniformPlayground,
                    isAllowPostMessage: isAllowPostMessage
                })
            })
        })
    });
};

});
parcelRegister("7WM7y", function(module, exports) {
$parcel$export(module.exports, "FourOhFourPageTemplate", function () { return $b3e0454f7f1f85f3$export$580adf4c24c28053; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $9GLx2 = parcelRequire("9GLx2");

var $bv77X = parcelRequire("bv77X");

var $7GVWk = parcelRequire("7GVWk");

var $5Ntyw = parcelRequire("5Ntyw");

var $iLjCW = parcelRequire("iLjCW");

var $hcVGp = parcelRequire("hcVGp");

var $1ka2O = parcelRequire("1ka2O");

var $4d61Q = parcelRequire("4d61Q");
const $b3e0454f7f1f85f3$export$580adf4c24c28053 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9GLx2.default), {
        locale: "en",
        messages: {},
        defaultLocale: "en",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5Ntyw.BxpWebStargateClientProvider), {
            baseUrl: (0, $5Ntyw.getStargateBaseUrl)(),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bv77X.SitesContextProvider), {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7GVWk.UserContextProvider), {
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        "data-testid": "404-page",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1ka2O.LocationProvider), {
                            location: typeof window !== 'undefined' ? window.location : {
                                pathname: '/',
                                href: '/'
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hcVGp.GlobalNav), {
                                        isShowTryNowLink: true,
                                        tryNowLinkCtaButtonColor: "light_grey",
                                        productKey: "404"
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4d61Q.MainSection), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iLjCW.GlobalFooter), {})
                            ]
                        })
                    })
                })
            })
        })
    });
};

});

parcelRegister("ipRTK", function(module, exports) {
$parcel$export(module.exports, "UniformEntryPageTemplate", function () { return $9b881e462c85fa95$export$8328465fb6b6a7d2; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $dNSrU = parcelRequire("dNSrU");

var $4EfnG = parcelRequire("4EfnG");

var $7WM7y = parcelRequire("7WM7y");

var $g7CEg = parcelRequire("g7CEg");

var $9rnwe = parcelRequire("9rnwe");
const $9b881e462c85fa95$export$8328465fb6b6a7d2 = ({ composition: composition, isUniformPlayground: isUniformPlayground, isAllowPostMessage: isAllowPostMessage })=>{
    const { uniformContext: uniformContext } = (0, $9rnwe.useWAEContext)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4EfnG.default), {
        fallback: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7WM7y.FourOhFourPageTemplate), {}),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $dNSrU.UniformContext), {
            context: uniformContext,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $g7CEg.UniformWrapper), {
                composition: composition,
                isUniformPlayground: isUniformPlayground,
                isAllowPostMessage: isAllowPostMessage
            })
        })
    });
};

});


parcelRegister("3NQOU", function(module, exports) {
$parcel$export(module.exports, "init", function () { return $b6785f1d81c92020$export$2cd8252107eb640b; });

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $yhhhl = parcelRequire("yhhhl");

var $konOj = parcelRequire("konOj");

var $fuLgT = parcelRequire("fuLgT");

var $eQyIx = parcelRequire("eQyIx");

var $g0QpW = parcelRequire("g0QpW");

var $gLm0b = parcelRequire("gLm0b");

var $6r14Z = parcelRequire("6r14Z");

var $hgaI1 = parcelRequire("hgaI1");

var $7mHQv = parcelRequire("7mHQv");

var $hZy36 = parcelRequire("hZy36");

var $3H7QB = parcelRequire("3H7QB");

var $hp3ar = parcelRequire("hp3ar");

var $6gQvZ = parcelRequire("6gQvZ");

var $idVA4 = parcelRequire("idVA4");

var $hu7gH = parcelRequire("hu7gH");
window.BUILD_KEY = "p-86e40d3aa8";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $fuLgT.default)()
    }
};
(0, $hZy36.configureCastle)();
const $b6785f1d81c92020$var$SUPPORTED_LOCALES = [
    {
        hrefLang: 'ja',
        langRoute: 'ja'
    },
    {
        hrefLang: 'fr',
        langRoute: 'fr'
    },
    {
        hrefLang: 'de',
        langRoute: 'de'
    },
    {
        hrefLang: 'es',
        langRoute: 'es'
    },
    {
        hrefLang: 'pt-BR',
        langRoute: 'br'
    },
    {
        hrefLang: 'zh-Hans',
        langRoute: 'zh'
    },
    {
        hrefLang: 'ko',
        langRoute: 'ko'
    },
    {
        hrefLang: 'ru',
        langRoute: 'ru'
    },
    {
        hrefLang: 'pl',
        langRoute: 'pl'
    },
    {
        hrefLang: 'it',
        langRoute: 'it'
    },
    {
        hrefLang: 'nl',
        langRoute: 'nl'
    }
];
const $b6785f1d81c92020$export$2cd8252107eb640b = (Component)=>{
    const isStatic = typeof window !== 'undefined' && window.IS_STATIC;
    const analyticsWebClient = (0, $g0QpW.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $hu7gH.parseRoute)(window.location);
    // Get location data for experiments and feature gates from server-provided data
    let locationData;
    // Use server-provided data (no client-side API calls)
    if (typeof window !== 'undefined') locationData = {
        countryIsoCode: window.countryCode || '',
        regionIsoCode: window.regionIsoCode || ''
    };
    // In Uniform Playground (preview authoring environment), skip OneTrust check
    // and assume performance tracking is enabled — mirrors OneTrustProvider behavior.
    // Cookies are unavailable in the cross-origin iframe context, so the normal
    // cookie-based check always returns false for CPRA users (e.g. California).
    const isPerfOnetrustEnabled = window.isUniformPlayground || (0, $gLm0b.isPerformanceOnetrustEnabled)(typeof window !== 'undefined' ? window.optanonConsentCookie : (0, $gLm0b.extractOptanonConsentCookie)(document.cookie), locationData);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    isPerfOnetrustEnabled && (0, $eQyIx.initUFO)(analyticsWebClient, path);
    const parsedClientCookies = document.cookie ? (0, $yhhhl.parse)(document.cookie) : {};
    const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : '';
    const { finalExperimentOverrides: finalExperimentOverrides, finalFeatureGateOverrides: finalFeatureGateOverrides } = (0, $idVA4.processExperimentAndFeatureGateOverrides)(parsedClientCookies, userAgent, isPerfOnetrustEnabled);
    // Below is for debugging edge - will be removed
    window.ssrAnonId = window.featureGateBootstrapValues.identifiers.analyticsAnonymousId;
    // We can't feature gate below code as this is done before initialization so just overriding for the path we are testing
    if ((0, $hp3ar.isEdgeCachingPath)(window.location)) {
        // Override for Edge Caching
        (0, $hp3ar.overrideAjsAnonIdFromCookie)();
        (0, $hp3ar.overrideCustomAttributes)();
    }
    (0, $hgaI1.initializeFeatureGatesClient)(window.featureGateBootstrapValues, {
        overrideValues: {
            experimentOverrides: finalExperimentOverrides,
            featureGateOverrides: finalFeatureGateOverrides
        },
        // if performance cookies are disabled, we will skip exposures
        localMode: !isPerfOnetrustEnabled
    }).then(async ()=>{
        try {
            await (0, $3H7QB.DynamicConfigClient).getInstance().initialize({
                bootstrapValues: window.featureGateBootstrapValues
            });
        } catch (error) {
            console.error('Failed to initialize DynamicConfigClient', error);
        }
        const canonicalBaseUrl = (0, $6r14Z.getCanonicalBaseUrl)(window.location.hostname, path);
        const pathForCanonical = path ? (0, $6r14Z.canonicalPathForHref)(canonicalBaseUrl, path) : undefined;
        const route = pathForCanonical === undefined ? '' : pathForCanonical === '' ? '' : `/${pathForCanonical}`;
        const page = /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $6gQvZ.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: [
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "canonical",
                    href: `${canonicalBaseUrl}${route}`
                }),
                isStatic && /*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                    rel: "alternate",
                    href: `${canonicalBaseUrl}${route}`,
                    hrefLang: "x-default"
                }),
                isStatic && $b6785f1d81c92020$var$SUPPORTED_LOCALES.map(({ hrefLang: hrefLang, langRoute: langRoute })=>/*#__PURE__*/ (0, $7VQPk.jsx)("link", {
                        rel: "alternate",
                        href: `${canonicalBaseUrl}/${langRoute}${route}`,
                        hrefLang: hrefLang
                    }, hrefLang)),
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7mHQv.PageWrapper), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    hasCloudSessionTokenCookie: window.hasCloudSessionTokenCookie,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    loggedInContext: window.loggedInContext,
                    loggedInContextStatus: window.loggedInContextStatus,
                    countryCode: window.countryCode,
                    templates: window.templates,
                    partnerTemplates: window.partnerTemplates,
                    collections: window.collections,
                    categories: window.categories,
                    composition: window._uniformPreloadedComposition,
                    compositionRegenerationMetadata: window._uniformRegenerationMetadata,
                    isUniformPlayground: window.isUniformPlayground,
                    isAllowPostMessage: window.isAllowPostMessage,
                    teamType: window.teamType,
                    keyword: window.keyword,
                    referrer: window.referrer,
                    mlTemplateIds: window.mlTemplateIds,
                    channel: window.channel,
                    track: window.track,
                    anchor: window.anchor,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    PageComponent: Component,
                    transactionAccounts: window.transactionAccounts,
                    userAgent: userAgent,
                    clusterTag: window.clusterTag
                })
            ]
        });
        if (isStatic) {
            // @ts-expect-error type
            const root = (0, $konOj.createRoot)(document.getElementById('wac'));
            root.render(page);
        } else // @ts-expect-error type
        (0, $konOj.hydrateRoot)(document.getElementById('wac-root'), page, {
            onRecoverableError: (error, errorInfo)=>{
                document.getElementById('wac-root')?.setAttribute('hydration-error', 'true');
            }
        });
    });
};

});

parcelRegister("8jRs5", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $60e98f83d791250d$export$2e2bcd8739ae039; });

var $f53LC = parcelRequire("f53LC");
function $60e98f83d791250d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $60e98f83d791250d$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $60e98f83d791250d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $60e98f83d791250d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});

parcelRegister("kUCSO", function(module, exports) {
$parcel$export(module.exports, "Reference", function () { return $f39732ff1e24afd6$export$e0be378c32fb70a7; });

var $1oC0p = parcelRequire("1oC0p");

var $at85i = parcelRequire("at85i");

var $8q4Jo = parcelRequire("8q4Jo");

var $elwQc = parcelRequire("elwQc");
function $f39732ff1e24afd6$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $1oC0p.useContext((0, $8q4Jo.ManagerReferenceNodeSetterContext));
    var refHandler = $1oC0p.useCallback(function(node) {
        (0, $elwQc.setRef)(innerRef, node);
        (0, $elwQc.safeInvoke)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $1oC0p.useEffect(function() {
        return function() {
            return (0, $elwQc.setRef)(innerRef, null);
        };
    }, []);
    $1oC0p.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($at85i)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $elwQc.unwrapArray)(children)({
        ref: refHandler
    });
}

});
parcelRegister("at85i", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $79f2e2331b9e0776$var$__DEV__ = false;
var $79f2e2331b9e0776$var$warning = function() {};
if ($79f2e2331b9e0776$var$__DEV__) {
    var $79f2e2331b9e0776$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $79f2e2331b9e0776$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $79f2e2331b9e0776$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $79f2e2331b9e0776$var$warning;

});


parcelRegister("4b05t", function(module, exports) {

var $jSt0M = parcelRequire("jSt0M");
var $30a841da5660bc0e$var$listeningFocusTrap = null;
function $30a841da5660bc0e$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $30a841da5660bc0e$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($30a841da5660bc0e$var$listeningFocusTrap) $30a841da5660bc0e$var$listeningFocusTrap.pause();
        $30a841da5660bc0e$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $30a841da5660bc0e$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $30a841da5660bc0e$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $30a841da5660bc0e$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $30a841da5660bc0e$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $30a841da5660bc0e$var$tryFocus(lastTabbableNode);
            return $30a841da5660bc0e$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $30a841da5660bc0e$var$tryFocus(firstTabbableNode);
        $30a841da5660bc0e$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $jSt0M(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $30a841da5660bc0e$var$tryFocus(lastTabbableNode);
        $30a841da5660bc0e$var$tryFocus(firstTabbableNode);
    }
}
function $30a841da5660bc0e$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $30a841da5660bc0e$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
module.exports = $30a841da5660bc0e$var$focusTrap;

});
parcelRegister("jSt0M", function(module, exports) {
module.exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $e78990932ff29185$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $e78990932ff29185$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}

});


parcelRegister("lP7A9", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $fe343e0b0e95d831$export$2e2bcd8739ae039; });


var $9aXvx = parcelRequire("9aXvx");

var $kk9vf = parcelRequire("kk9vf");

var $7t0tI = parcelRequire("7t0tI");
/**
 * Takes a dot-separated token name and an optional fallback, and returns the CSS custom property for the corresponding token.
 * This should be used to implement design decisions throughout your application.
 *
 * Note: With `@atlaskit/babel-plugin-tokens`, this function can be pre-compiled and a fallback value automatically inserted.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * <div
 *   css={{
 *     backgroundColor: token('elevation.surface.raised', N0),
 *     boxShadow: token('elevation.shadow.raised', `0 20px 32px -8px ${N50A}, 0 0 1px ${N60A}`),
 *     padding: token('spacing.scale.100', '8px'),
 *     fontWeight: token('font.weight.regular', '400'),
 *   }}
 * />
 * ```
 *
 */ function $fe343e0b0e95d831$var$token(path, fallback) {
    var token = (0, $9aXvx.default)[path];
    typeof $7t0tI;
    // if the token is not found - replacing it with variable name without any value, to avoid it being undefined which would result in invalid css
    if (!token) token = (0, $kk9vf.TOKEN_NOT_FOUND_CSS_VAR);
    var tokenCall = fallback ? "var(".concat(token, ", ").concat(fallback, ")") : "var(".concat(token, ")");
    return tokenCall;
}
var $fe343e0b0e95d831$export$2e2bcd8739ae039 = $fe343e0b0e95d831$var$token;

});
parcelRegister("9aXvx", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $6ae3353be2245a6b$export$2e2bcd8739ae039; });
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1f64d7a1e3392b669ad5c7bfd53c7403>>
 * @codegenCommand yarn build tokens
 */ var $6ae3353be2245a6b$var$tokens = {
    'motion.avatar.enter': '--ds-avatar-enter',
    'motion.avatar.exit': '--ds-avatar-exit',
    'motion.avatar.hovered': '--ds-avatar-hovered',
    'motion.blanket.enter': '--ds-blanket-enter',
    'motion.blanket.exit': '--ds-blanket-exit',
    'motion.duration.instant': '--ds-duration-instant',
    'motion.duration.long': '--ds-duration-long',
    'motion.duration.medium': '--ds-duration-medium',
    'motion.duration.short': '--ds-duration-short',
    'motion.duration.xlong': '--ds-duration-xlong',
    'motion.duration.xshort': '--ds-duration-xshort',
    'motion.duration.xxlong': '--ds-duration-xxlong',
    'motion.duration.xxshort': '--ds-duration-xxshort',
    'motion.easing.in.practical': '--ds-easing-in-practical',
    'motion.easing.inout.bold': '--ds-easing-inout-bold',
    'motion.easing.out.practical': '--ds-easing-out-practical',
    'motion.easing.out.bold': '--ds-easing-out-bold',
    'motion.easing.spring': '--ds-easing-spring',
    'motion.flag.enter': '--ds-flag-enter',
    'motion.flag.exit': '--ds-flag-exit',
    'motion.flag.reposition': '--ds-flag-reposition',
    'motion.keyframe.fade.in': '--ds-keyframe-fade-in',
    'motion.keyframe.fade.out': '--ds-keyframe-fade-out',
    'motion.keyframe.scale.in.medium': '--ds-keyframe-scale-in-medium',
    'motion.keyframe.scale.in.small': '--ds-keyframe-scale-in-small',
    'motion.keyframe.scale.out.medium': '--ds-keyframe-scale-out-medium',
    'motion.keyframe.scale.out.small': '--ds-keyframe-scale-out-small',
    'motion.keyframe.slide.in.bottom.short': '--ds-keyframe-slide-in-bottom-short',
    'motion.keyframe.slide.in.left.half': '--ds-keyframe-slide-in-left-half',
    'motion.keyframe.slide.in.left.short': '--ds-keyframe-slide-in-left-short',
    'motion.keyframe.slide.in.right.short': '--ds-keyframe-slide-in-right-short',
    'motion.keyframe.slide.in.top.short': '--ds-keyframe-slide-in-top-short',
    'motion.keyframe.slide.out.bottom.short': '--ds-keyframe-slide-out-bottom-short',
    'motion.keyframe.slide.out.left.half': '--ds-keyframe-slide-out-left-half',
    'motion.keyframe.slide.out.left.short': '--ds-keyframe-slide-out-left-short',
    'motion.keyframe.slide.out.right.short': '--ds-keyframe-slide-out-right-short',
    'motion.keyframe.slide.out.top.short': '--ds-keyframe-slide-out-top-short',
    'motion.modal.enter': '--ds-modal-enter',
    'motion.modal.exit': '--ds-modal-exit',
    'motion.popup.enter.bottom': '--ds-popup-enter-bottom',
    'motion.popup.enter.left': '--ds-popup-enter-left',
    'motion.popup.enter.right': '--ds-popup-enter-right',
    'motion.popup.enter.top': '--ds-popup-enter-top',
    'motion.popup.exit.bottom': '--ds-popup-exit-bottom',
    'motion.popup.exit.left': '--ds-popup-exit-left',
    'motion.popup.exit.right': '--ds-popup-exit-right',
    'motion.popup.exit.top': '--ds-popup-exit-top',
    'motion.spotlight.enter': '--ds-spotlight-enter',
    'motion.spotlight.exit': '--ds-spotlight-exit',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.subtler': '--ds-background-danger-subtler',
    'color.background.danger.subtler.hovered': '--ds-background-danger-subtler-hovered',
    'color.background.danger.subtler.pressed': '--ds-background-danger-subtler-pressed',
    'color.background.danger.subtle': '--ds-background-danger-subtle',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.subtler': '--ds-background-warning-subtler',
    'color.background.warning.subtler.hovered': '--ds-background-warning-subtler-hovered',
    'color.background.warning.subtler.pressed': '--ds-background-warning-subtler-pressed',
    'color.background.warning.subtle': '--ds-background-warning-subtle',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.subtler': '--ds-background-success-subtler',
    'color.background.success.subtler.hovered': '--ds-background-success-subtler-hovered',
    'color.background.success.subtler.pressed': '--ds-background-success-subtler-pressed',
    'color.background.success.subtle': '--ds-background-success-subtle',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.subtler': '--ds-background-discovery-subtler',
    'color.background.discovery.subtler.hovered': '--ds-background-discovery-subtler-hovered',
    'color.background.discovery.subtler.pressed': '--ds-background-discovery-subtler-pressed',
    'color.background.discovery.subtle': '--ds-background-discovery-subtle',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.subtler': '--ds-background-information-subtler',
    'color.background.information.subtler.hovered': '--ds-background-information-subtler-hovered',
    'color.background.information.subtler.pressed': '--ds-background-information-subtler-pressed',
    'color.background.information.subtle': '--ds-background-information-subtle',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.lime.subtle': '--ds-border-accent-lime-subtle',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.red.subtle': '--ds-border-accent-red-subtle',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.orange.subtle': '--ds-border-accent-orange-subtle',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.yellow.subtle': '--ds-border-accent-yellow-subtle',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.green.subtle': '--ds-border-accent-green-subtle',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.teal.subtle': '--ds-border-accent-teal-subtle',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.blue.subtle': '--ds-border-accent-blue-subtle',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.purple.subtle': '--ds-border-accent-purple-subtle',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.magenta.subtle': '--ds-border-accent-magenta-subtle',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.accent.gray.subtle': '--ds-border-accent-gray-subtle',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.danger.subtle': '--ds-border-danger-subtle',
    'color.border.warning': '--ds-border-warning',
    'color.border.warning.subtle': '--ds-border-warning-subtle',
    'color.border.success': '--ds-border-success',
    'color.border.success.subtle': '--ds-border-success-subtle',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.discovery.subtle': '--ds-border-discovery-subtle',
    'color.border.information': '--ds-border-information',
    'color.border.information.subtle': '--ds-border-information-subtle',
    'color.border.bold': '--ds-border-bold',
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.danger.bolder': '--ds-text-danger-bolder',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.warning.bolder': '--ds-text-warning-bolder',
    'color.text.success': '--ds-text-success',
    'color.text.success.bolder': '--ds-text-success-bolder',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.discovery.bolder': '--ds-text-discovery-bolder',
    'color.text.information': '--ds-text-information',
    'color.text.information.bolder': '--ds-text-information-bolder',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'color.rovo.background.brand.bold': '--ds-rovo-background-brand-bold',
    'color.rovo.background.brand.bold.hovered': '--ds-rovo-background-brand-bold-hovered',
    'color.rovo.background.brand.bold.pressed': '--ds-rovo-background-brand-bold-pressed',
    'color.rovo.border.lime': '--ds-rovo-border-lime',
    'color.rovo.border.saffron': '--ds-rovo-border-saffron',
    'color.rovo.border.blue': '--ds-rovo-border-blue',
    'color.rovo.border.purple': '--ds-rovo-border-purple',
    'color.rovo.icon.lime': '--ds-rovo-icon-lime',
    'color.rovo.icon.saffron': '--ds-rovo-icon-saffron',
    'color.rovo.icon.blue': '--ds-rovo-icon-blue',
    'color.rovo.icon.purple': '--ds-rovo-icon-purple',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.container': '--ds-surface-container',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.rovo.surface.overlay': '--ds-rovo-surface-overlay',
    'elevation.rovo.surface.overlay.hovered': '--ds-rovo-surface-overlay-hovered',
    'elevation.rovo.surface.overlay.pressed': '--ds-rovo-surface-overlay-pressed',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.metric.large': '--ds-font-metric-large',
    'font.metric.medium': '--ds-font-metric-medium',
    'font.metric.small': '--ds-font-metric-small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'radius.xsmall': '--ds-radius-xsmall',
    'radius.small': '--ds-radius-small',
    'radius.medium': '--ds-radius-medium',
    'radius.large': '--ds-radius-large',
    'radius.xlarge': '--ds-radius-xlarge',
    'radius.xxlarge': '--ds-radius-xxlarge',
    'radius.full': '--ds-radius-full',
    'radius.tile': '--ds-radius-tile',
    'border.width': '--ds-border-width',
    'border.width.selected': '--ds-border-width-selected',
    'border.width.focused': '--ds-border-width-focused'
};
var $6ae3353be2245a6b$export$2e2bcd8739ae039 = $6ae3353be2245a6b$var$tokens;

});

parcelRegister("kk9vf", function(module, exports) {
$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", function () { return $ecbd0c057ee21de6$export$4ef52930e33717cd; });
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", function () { return $ecbd0c057ee21de6$export$a00eac3f8684bcd0; });
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", function () { return $ecbd0c057ee21de6$export$dddac1532e822863; });
var $ecbd0c057ee21de6$export$4ef52930e33717cd = 'data-theme';
var $ecbd0c057ee21de6$export$cb374d25ded7f6ab = 'data-subtree-theme';
var $ecbd0c057ee21de6$export$a00eac3f8684bcd0 = 'data-color-mode';
var $ecbd0c057ee21de6$export$2112803007239c61 = 'data-contrast-mode';
var $ecbd0c057ee21de6$export$352e418ed5b6193a = 'data-custom-theme';
var $ecbd0c057ee21de6$export$6f0c6fb8c80fcc92 = 'ds';
var $ecbd0c057ee21de6$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border',
    'radius'
];
var $ecbd0c057ee21de6$export$dddac1532e822863 = "--".concat($ecbd0c057ee21de6$export$6f0c6fb8c80fcc92, "-token-not-found");
var $ecbd0c057ee21de6$export$9d7b58831ae93caa = "--".concat($ecbd0c057ee21de6$export$6f0c6fb8c80fcc92, "-elevation-surface-current");

});


parcelRegister("j9BEl", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $df1c100df26f3bb5$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");

var $7Zt4h = parcelRequire("7Zt4h");

var $kFuqb = parcelRequire("kFuqb");

var $3oV3g = parcelRequire("3oV3g");

var $7t0tI = parcelRequire("7t0tI");
var $df1c100df26f3bb5$var$ExportedAnalyticsContext = function ExportedAnalyticsContext(props) {
    var _process$env;
    var isModernContextEnabledEnv = typeof $7t0tI !== 'undefined' && $7t0tI !== null && ((_process$env = {}, _process$env === void 0) ? void 0 : _process$env['ANALYTICS_NEXT_MODERN_CONTEXT']);
    return isModernContextEnabledEnv || (0, $7Zt4h.getBooleanFF)('platform.analytics-next-use-modern-context_fqgbx') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $3oV3g.default), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $kFuqb.default), props);
};
var $df1c100df26f3bb5$export$2e2bcd8739ae039 = $df1c100df26f3bb5$var$ExportedAnalyticsContext;

});
parcelRegister("kFuqb", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $f0bf3c0a01f39e80$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $cTewU = parcelRequire("cTewU");

var $avOEA = parcelRequire("avOEA");

var $h4ELM = parcelRequire("h4ELM");

var $i7dvh = parcelRequire("i7dvh");

var $i3Ugd = parcelRequire("i3Ugd");

var $jlBwm = parcelRequire("jlBwm");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $4OgEb = parcelRequire("4OgEb");

var $bEiDG = parcelRequire("bEiDG");
function $f0bf3c0a01f39e80$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f0bf3c0a01f39e80$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $jlBwm.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $jlBwm.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $i3Ugd.default)(this, result);
    };
}
function $f0bf3c0a01f39e80$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($f0bf3c0a01f39e80$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $f0bf3c0a01f39e80$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($4OgEb))).func
};
var $f0bf3c0a01f39e80$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $f0bf3c0a01f39e80$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    (0, $i7dvh.default)(AnalyticsContext, _Component);
    var _super = $f0bf3c0a01f39e80$var$_createSuper(AnalyticsContext);
    function AnalyticsContext(props) {
        var _this;
        (0, $cTewU.default)(this, AnalyticsContext);
        _this = _super.call(this, props);
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $f0bf3c0a01f39e80$var$noop : _this$context$getAtla;
            return [].concat((0, $lFOXD.default)(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, $f53LC.default)((0, $h4ELM.default)(_this), "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $f0bf3c0a01f39e80$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, $avOEA.default)(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bEiDG.default).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsContext;
}((0, $1oC0p.Component));
(0, $f53LC.default)($f0bf3c0a01f39e80$var$AnalyticsContext, "contextTypes", $f0bf3c0a01f39e80$var$ContextTypes);
(0, $f53LC.default)($f0bf3c0a01f39e80$var$AnalyticsContext, "childContextTypes", $f0bf3c0a01f39e80$var$ContextTypes);
var $f0bf3c0a01f39e80$export$2e2bcd8739ae039 = $f0bf3c0a01f39e80$var$AnalyticsContext;

});

parcelRegister("3oV3g", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $279fde3eadf46ed4$export$2e2bcd8739ae039; });

var $lFOXD = parcelRequire("lFOXD");

var $1oC0p = parcelRequire("1oC0p");

var $bEiDG = parcelRequire("bEiDG");

var $e1T86 = parcelRequire("e1T86");

var $j10Ql = parcelRequire("j10Ql");
var $279fde3eadf46ed4$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $j10Ql.useTrackedRef)(data);
    var analyticsContext = (0, $e1T86.useAnalyticsContext)();
    var getAtlaskitAnalyticsContext = (0, $1oC0p.useCallback)(function() {
        return [].concat((0, $lFOXD.default)(analyticsContext.getAtlaskitAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        analyticsContext,
        dataRef
    ]);
    var value = (0, $1oC0p.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: analyticsContext.getAtlaskitAnalyticsEventHandlers
        };
    }, [
        analyticsContext,
        getAtlaskitAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $bEiDG.default).Provider, {
        value: value
    }, children);
};
var $279fde3eadf46ed4$export$2e2bcd8739ae039 = $279fde3eadf46ed4$var$AnalyticsContext;

});


parcelRegister("56Xlo", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3b8b8bc15be3f933$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $gnQ3X = parcelRequire("gnQ3X");

var $1oC0p = parcelRequire("1oC0p");

var $j9BEl = parcelRequire("j9BEl");
var $3b8b8bc15be3f933$var$_excluded = [
    "analyticsContext"
];
function $3b8b8bc15be3f933$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3b8b8bc15be3f933$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3b8b8bc15be3f933$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3b8b8bc15be3f933$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3b8b8bc15be3f933$var$withAnalyticsContext = function withAnalyticsContext(defaultData) {
    return function(WrappedComponent) {
        var WithAnalyticsContext = /*#__PURE__*/ (0, $1oC0p.forwardRef)(function(_ref, ref) {
            var analyticsContext = _ref.analyticsContext, rest = (0, $gnQ3X.default)(_ref, $3b8b8bc15be3f933$var$_excluded);
            var analyticsData = (0, $1oC0p.useMemo)(function() {
                return $3b8b8bc15be3f933$var$_objectSpread($3b8b8bc15be3f933$var$_objectSpread({}, defaultData), analyticsContext);
            }, [
                analyticsContext
            ]);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement((0, $j9BEl.default), {
                data: analyticsData
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement(WrappedComponent, (0, $c9bqK.default)({}, rest, {
                ref: ref
            })));
        });
        WithAnalyticsContext.displayName = "WithAnalyticsContext(".concat(WrappedComponent.displayName || WrappedComponent.name, ")");
        return WithAnalyticsContext;
    };
};
var $3b8b8bc15be3f933$export$2e2bcd8739ae039 = $3b8b8bc15be3f933$var$withAnalyticsContext;

});

parcelRegister("4jLK2", function(module, exports) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $324df84505b66cc8$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = $324df84505b66cc8$var$arrayPush;

});

parcelRegister("8E4Q5", function(module, exports) {

var $jjQDv = parcelRequire("jjQDv");

var $lhaWD = parcelRequire("lhaWD");
/** Used for built-in method references. */ var $64b5d013d9ba84e9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $64b5d013d9ba84e9$var$hasOwnProperty = $64b5d013d9ba84e9$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $64b5d013d9ba84e9$var$propertyIsEnumerable = $64b5d013d9ba84e9$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $64b5d013d9ba84e9$var$isArguments = $jjQDv(function() {
    return arguments;
}()) ? $jjQDv : function(value) {
    return $lhaWD(value) && $64b5d013d9ba84e9$var$hasOwnProperty.call(value, 'callee') && !$64b5d013d9ba84e9$var$propertyIsEnumerable.call(value, 'callee');
};
module.exports = $64b5d013d9ba84e9$var$isArguments;

});
parcelRegister("jjQDv", function(module, exports) {

var $2EKmr = parcelRequire("2EKmr");

var $lhaWD = parcelRequire("lhaWD");
/** `Object#toString` result references. */ var $e1089f2233a3dc7f$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $e1089f2233a3dc7f$var$baseIsArguments(value) {
    return $lhaWD(value) && $2EKmr(value) == $e1089f2233a3dc7f$var$argsTag;
}
module.exports = $e1089f2233a3dc7f$var$baseIsArguments;

});


parcelRegister("cTpmH", function(module, exports) {
/** Used as references for various `Number` constants. */ var $962e4c171a5f9227$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $962e4c171a5f9227$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $962e4c171a5f9227$var$MAX_SAFE_INTEGER;
}
module.exports = $962e4c171a5f9227$var$isLength;

});

parcelRegister("gHIMV", function(module, exports) {

var $24uwp = parcelRequire("24uwp");

var $7RbbL = parcelRequire("7RbbL");
/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */ function $c2936778f0bf11fd$var$capitalize(string) {
    return $7RbbL($24uwp(string).toLowerCase());
}
module.exports = $c2936778f0bf11fd$var$capitalize;

});
parcelRegister("7RbbL", function(module, exports) {

var $iBcGo = parcelRequire("iBcGo");
/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $5b86297e1fc1db25$var$upperFirst = $iBcGo('toUpperCase');
module.exports = $5b86297e1fc1db25$var$upperFirst;

});
parcelRegister("iBcGo", function(module, exports) {

var $ehULU = parcelRequire("ehULU");

var $ePM67 = parcelRequire("ePM67");

var $1GITV = parcelRequire("1GITV");

var $24uwp = parcelRequire("24uwp");
/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $d8a585375440fb5a$var$createCaseFirst(methodName) {
    return function(string) {
        string = $24uwp(string);
        var strSymbols = $ePM67(string) ? $1GITV(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $ehULU(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
module.exports = $d8a585375440fb5a$var$createCaseFirst;

});
parcelRegister("ehULU", function(module, exports) {

var $ezuzU = parcelRequire("ezuzU");
/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $a66eb0e6cce6b4e5$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $ezuzU(array, start, end);
}
module.exports = $a66eb0e6cce6b4e5$var$castSlice;

});
parcelRegister("ezuzU", function(module, exports) {
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $a9bc0dc53628b88a$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
module.exports = $a9bc0dc53628b88a$var$baseSlice;

});


parcelRegister("ePM67", function(module, exports) {
/** Used to compose unicode character classes. */ var $accb234eacd9a37f$var$rsAstralRange = '\\ud800-\\udfff', $accb234eacd9a37f$var$rsComboMarksRange = '\\u0300-\\u036f', $accb234eacd9a37f$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $accb234eacd9a37f$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $accb234eacd9a37f$var$rsComboRange = $accb234eacd9a37f$var$rsComboMarksRange + $accb234eacd9a37f$var$reComboHalfMarksRange + $accb234eacd9a37f$var$rsComboSymbolsRange, $accb234eacd9a37f$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $accb234eacd9a37f$var$rsZWJ = '\\u200d';
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $accb234eacd9a37f$var$reHasUnicode = RegExp('[' + $accb234eacd9a37f$var$rsZWJ + $accb234eacd9a37f$var$rsAstralRange + $accb234eacd9a37f$var$rsComboRange + $accb234eacd9a37f$var$rsVarRange + ']');
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $accb234eacd9a37f$var$hasUnicode(string) {
    return $accb234eacd9a37f$var$reHasUnicode.test(string);
}
module.exports = $accb234eacd9a37f$var$hasUnicode;

});

parcelRegister("1GITV", function(module, exports) {

var $3VH6A = parcelRequire("3VH6A");

var $ePM67 = parcelRequire("ePM67");

var $aYfG6 = parcelRequire("aYfG6");
/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $13ac8b161df780fb$var$stringToArray(string) {
    return $ePM67(string) ? $aYfG6(string) : $3VH6A(string);
}
module.exports = $13ac8b161df780fb$var$stringToArray;

});
parcelRegister("3VH6A", function(module, exports) {
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $2dc821c7632c8518$var$asciiToArray(string) {
    return string.split('');
}
module.exports = $2dc821c7632c8518$var$asciiToArray;

});

parcelRegister("aYfG6", function(module, exports) {
/** Used to compose unicode character classes. */ var $7fcbab4f0bbb188c$var$rsAstralRange = '\\ud800-\\udfff', $7fcbab4f0bbb188c$var$rsComboMarksRange = '\\u0300-\\u036f', $7fcbab4f0bbb188c$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $7fcbab4f0bbb188c$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $7fcbab4f0bbb188c$var$rsComboRange = $7fcbab4f0bbb188c$var$rsComboMarksRange + $7fcbab4f0bbb188c$var$reComboHalfMarksRange + $7fcbab4f0bbb188c$var$rsComboSymbolsRange, $7fcbab4f0bbb188c$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $7fcbab4f0bbb188c$var$rsAstral = '[' + $7fcbab4f0bbb188c$var$rsAstralRange + ']', $7fcbab4f0bbb188c$var$rsCombo = '[' + $7fcbab4f0bbb188c$var$rsComboRange + ']', $7fcbab4f0bbb188c$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $7fcbab4f0bbb188c$var$rsModifier = '(?:' + $7fcbab4f0bbb188c$var$rsCombo + '|' + $7fcbab4f0bbb188c$var$rsFitz + ')', $7fcbab4f0bbb188c$var$rsNonAstral = '[^' + $7fcbab4f0bbb188c$var$rsAstralRange + ']', $7fcbab4f0bbb188c$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $7fcbab4f0bbb188c$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $7fcbab4f0bbb188c$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $7fcbab4f0bbb188c$var$reOptMod = $7fcbab4f0bbb188c$var$rsModifier + '?', $7fcbab4f0bbb188c$var$rsOptVar = '[' + $7fcbab4f0bbb188c$var$rsVarRange + ']?', $7fcbab4f0bbb188c$var$rsOptJoin = '(?:' + $7fcbab4f0bbb188c$var$rsZWJ + '(?:' + [
    $7fcbab4f0bbb188c$var$rsNonAstral,
    $7fcbab4f0bbb188c$var$rsRegional,
    $7fcbab4f0bbb188c$var$rsSurrPair
].join('|') + ')' + $7fcbab4f0bbb188c$var$rsOptVar + $7fcbab4f0bbb188c$var$reOptMod + ')*', $7fcbab4f0bbb188c$var$rsSeq = $7fcbab4f0bbb188c$var$rsOptVar + $7fcbab4f0bbb188c$var$reOptMod + $7fcbab4f0bbb188c$var$rsOptJoin, $7fcbab4f0bbb188c$var$rsSymbol = '(?:' + [
    $7fcbab4f0bbb188c$var$rsNonAstral + $7fcbab4f0bbb188c$var$rsCombo + '?',
    $7fcbab4f0bbb188c$var$rsCombo,
    $7fcbab4f0bbb188c$var$rsRegional,
    $7fcbab4f0bbb188c$var$rsSurrPair,
    $7fcbab4f0bbb188c$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $7fcbab4f0bbb188c$var$reUnicode = RegExp($7fcbab4f0bbb188c$var$rsFitz + '(?=' + $7fcbab4f0bbb188c$var$rsFitz + ')|' + $7fcbab4f0bbb188c$var$rsSymbol + $7fcbab4f0bbb188c$var$rsSeq, 'g');
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $7fcbab4f0bbb188c$var$unicodeToArray(string) {
    return string.match($7fcbab4f0bbb188c$var$reUnicode) || [];
}
module.exports = $7fcbab4f0bbb188c$var$unicodeToArray;

});





parcelRegister("5AtlP", function(module, exports) {
$parcel$export(module.exports, "getFirstName", function () { return $f5b50bde618a4cd3$export$cf3a9fa4cebe2986; });
function $f5b50bde618a4cd3$export$cf3a9fa4cebe2986(fullName = '') {
    return fullName.trim().split(' ')[0] || '';
}

});

parcelRegister("jgdMW", function(module, exports) {
$parcel$export(module.exports, "RowGrid", function () { return $a79cb55f58fa05ed$export$29ae18f9ecc70243; });
/* row-grid.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
const $a79cb55f58fa05ed$export$29ae18f9ecc70243 = ({ children: children, numCols: numCols, colWidth: colWidth, numRows: numRows, rowHeight: rowHeight, rowGap: rowGap, columnGap: columnGap, paddingInline: paddingInline, paddingBlock: paddingBlock, marginInline: marginInline, marginBlock: marginBlock })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        style: {
            gridTemplateColumns: `${(colWidth ? `${colWidth} ` : '1fr ').repeat(numCols)}`,
            gridTemplateRows: `${numRows && (rowHeight ? `${rowHeight} ` : '1fr ').repeat(numRows)}`,
            rowGap: rowGap,
            columnGap: columnGap,
            paddingInline: paddingInline,
            paddingBlock: paddingBlock,
            marginInline: marginInline,
            marginBlock: marginBlock
        },
        className: (0, $2jatx.default)([
            "_1e0c11p5"
        ]),
        children: children
    });
};

});

parcelRegister("j2b52", function(module, exports) {
$parcel$export(module.exports, "ClientOnly", function () { return $1445362815fc2039$export$70f10949f62d7670; });
// @ts-ignore

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
let $1445362815fc2039$var$hydrating = true;
function $1445362815fc2039$export$1b590bd8f758497b() {
    const [hydrated, setHydrated] = (0, $1oC0p.useState)(()=>!$1445362815fc2039$var$hydrating);
    (0, $1oC0p.useEffect)(function hydrate() {
        $1445362815fc2039$var$hydrating = false;
        console.debug('hydrating:', $1445362815fc2039$var$hydrating);
        setHydrated(true);
    }, []);
    return hydrated;
}
const $1445362815fc2039$export$70f10949f62d7670 = ({ children: children })=>{
    return $1445362815fc2039$export$1b590bd8f758497b() ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: children
    }) : null;
};

});

parcelRegister("dTJrO", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a1e3aa5f77a45f5e$export$2e2bcd8739ae039; });

var $c9bqK = parcelRequire("c9bqK");

var $gnQ3X = parcelRequire("gnQ3X");

var $2qaZZ = parcelRequire("2qaZZ");

var $3dJ4i = parcelRequire("3dJ4i");

var $69vmd = parcelRequire("69vmd");

var $fr57R = parcelRequire("fr57R");

var $7t0tI = parcelRequire("7t0tI");
var $a1e3aa5f77a45f5e$var$_excluded = [
    "level",
    "size",
    "variant"
];
// https://atlassian.design/foundations/typography
var $a1e3aa5f77a45f5e$var$levelMap = {
    h900: 'h1',
    h800: 'h1',
    h700: 'h2',
    h600: 'h3',
    h500: 'h4',
    h400: 'h5',
    h300: 'h6',
    // NB: These two levels are not covered at all by the existing @atlaskit/css-reset
    h200: 'div',
    h100: 'div'
};
var $a1e3aa5f77a45f5e$var$headingResetStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text, #172B4D)",
    marginBlock: "var(--ds-space-0, 0px)"
});
var $a1e3aa5f77a45f5e$var$h900Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-600, 35px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: '-0.01em',
    lineHeight: "var(--ds-font-lineHeight-600, 40px)"
});
var $a1e3aa5f77a45f5e$var$h800Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-500, 29px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.01em',
    lineHeight: "var(--ds-font-lineHeight-500, 32px)"
});
var $a1e3aa5f77a45f5e$var$h700Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-400, 24px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: '-0.01em',
    lineHeight: "var(--ds-font-lineHeight-400, 28px)"
});
var $a1e3aa5f77a45f5e$var$h600Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-300, 20px)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    letterSpacing: '-0.008em',
    lineHeight: "var(--ds-font-lineHeight-300, 24px)"
});
var $a1e3aa5f77a45f5e$var$h500Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-200, 16px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.006em',
    lineHeight: "var(--ds-font-lineHeight-200, 20px)"
});
var $a1e3aa5f77a45f5e$var$h400Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-100, 14px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: '-0.003em',
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $a1e3aa5f77a45f5e$var$h300Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)",
    textTransform: 'uppercase'
});
var $a1e3aa5f77a45f5e$var$h200Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-075, 12px)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $a1e3aa5f77a45f5e$var$h100Styles = (0, $3dJ4i.css)({
    fontSize: "var(--ds-font-size-050, 11px)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    letterSpacing: 0,
    lineHeight: "var(--ds-font-lineHeight-100, 16px)"
});
var $a1e3aa5f77a45f5e$var$inverseStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-inverse, #FFF)"
});
var $a1e3aa5f77a45f5e$var$subtlestStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-subtlest, #6B778C)"
});
/**
 * __Heading__
 *
 * A heading is a typography component used to display text in different sizes and formats.
 *
 * @example
 *
 * ```jsx
 * import Heading from '@atlaskit/heading';
 *
 * const H100 = () => (
 *   <Heading level="h100">h100</Heading>
 * );
 * ```
 */ var $a1e3aa5f77a45f5e$var$Heading = function Heading(_ref) {
    var children = _ref.children, level = _ref.level, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? 'default' : _ref$color;
    typeof $7t0tI;
    var _useHeading = (0, $69vmd.useHeading)($a1e3aa5f77a45f5e$var$levelMap[level]), _useHeading2 = (0, $2qaZZ.default)(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Markup = as || inferredElement;
    var isSubtleHeading = level === 'h200' || level === 'h100';
    var needsAriaRole = Markup === 'div' && hLevel;
    return (0, $3dJ4i.jsx)(Markup, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $a1e3aa5f77a45f5e$var$headingResetStyles,
            level === 'h100' && $a1e3aa5f77a45f5e$var$h100Styles,
            level === 'h200' && $a1e3aa5f77a45f5e$var$h200Styles,
            level === 'h300' && $a1e3aa5f77a45f5e$var$h300Styles,
            level === 'h400' && $a1e3aa5f77a45f5e$var$h400Styles,
            level === 'h500' && $a1e3aa5f77a45f5e$var$h500Styles,
            level === 'h600' && $a1e3aa5f77a45f5e$var$h600Styles,
            level === 'h700' && $a1e3aa5f77a45f5e$var$h700Styles,
            level === 'h800' && $a1e3aa5f77a45f5e$var$h800Styles,
            level === 'h900' && $a1e3aa5f77a45f5e$var$h900Styles,
            color === 'inverse' && $a1e3aa5f77a45f5e$var$inverseStyles,
            color === 'default' && isSubtleHeading && $a1e3aa5f77a45f5e$var$subtlestStyles
        ]
    }, children);
};
var $a1e3aa5f77a45f5e$export$2e2bcd8739ae039 = function(_ref2) {
    var level = _ref2.level, size = _ref2.size, variant = _ref2.variant, props = (0, $gnQ3X.default)(_ref2, $a1e3aa5f77a45f5e$var$_excluded);
    return level ? // eslint-disable-next-line jsx-a11y/heading-has-content
    (0, $3dJ4i.jsx)($a1e3aa5f77a45f5e$var$Heading, (0, $c9bqK.default)({
        level: level
    }, props)) : // eslint-disable-next-line jsx-a11y/heading-has-content
    (0, $3dJ4i.jsx)((0, $fr57R.default), (0, $c9bqK.default)({
        variant: variant,
        size: size
    }, props));
};

});
parcelRegister("69vmd", function(module, exports) {
$parcel$export(module.exports, "useHeading", function () { return $47abe8463fa9d1c8$export$97a37b1befbbf9b1; });

var $1oC0p = parcelRequire("1oC0p");
// Allows support for heading levels 1-9 via aria-level
var $47abe8463fa9d1c8$var$HeadingLevelContext = /*#__PURE__*/ (0, $1oC0p.createContext)(0);
var $47abe8463fa9d1c8$export$6a64a1e2d0bbbf75 = function useHeadingLevel() {
    return (0, $1oC0p.useContext)($47abe8463fa9d1c8$var$HeadingLevelContext);
};
var $47abe8463fa9d1c8$export$97a37b1befbbf9b1 = function useHeading(fallback) {
    var hLevel = $47abe8463fa9d1c8$export$6a64a1e2d0bbbf75();
    /**
   * Order here is important, we for now apply
   * 1. inferred a11y level (this only applies if context is present)
   * 2. default final fallback
   */ return [
        hLevel,
        hLevel && (hLevel > 6 ? 'div' : "h".concat(hLevel)) || fallback
    ];
};
/**
 * __Heading level provider__
 *
 * The Heading level provider injects the heading level to all `Heading` components below it in the component tree.
 *
 * @example
 * ```tsx
 * // Will correctly infer the heading level
 * <HeadingContext value={1}>
 *  <Heading>H1</Heading>
 *  <HeadingContext>
 *    <Heading>H2</Heading>
 *  </HeadingContext>
 * </HeadingContext>
 * ```
 */ var $47abe8463fa9d1c8$var$HeadingLevelContextProvider = function HeadingLevelContextProvider(_ref) {
    var children = _ref.children, value = _ref.value;
    var parentHeadingLevel = $47abe8463fa9d1c8$export$6a64a1e2d0bbbf75();
    var headingLevel = parentHeadingLevel + 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).createElement($47abe8463fa9d1c8$var$HeadingLevelContext.Provider, {
        value: value || headingLevel
    }, children);
};
var $47abe8463fa9d1c8$export$2e2bcd8739ae039 = $47abe8463fa9d1c8$var$HeadingLevelContextProvider;

});

parcelRegister("fr57R", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $b3cd5a87ca909983$export$2e2bcd8739ae039; });

var $2qaZZ = parcelRequire("2qaZZ");

var $3dJ4i = parcelRequire("3dJ4i");

var $69vmd = parcelRequire("69vmd");

var $7t0tI = parcelRequire("7t0tI");
var $b3cd5a87ca909983$var$sizeTagMap = {
    xxlarge: 'h1',
    xlarge: 'h1',
    large: 'h2',
    medium: 'h3',
    small: 'h4',
    xsmall: 'h5',
    xxsmall: 'h6'
};
var $b3cd5a87ca909983$var$headingResetStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text, #172B4D)",
    letterSpacing: 'normal',
    marginBlock: 0,
    textTransform: 'none'
});
var $b3cd5a87ca909983$var$inverseStyles = (0, $3dJ4i.css)({
    color: "var(--ds-text-inverse, #FFF)"
});
/**
 * __Heading__
 *
 * Heading is a typography component used to display text in defined sizes and styles.
 *
 * @example
 *
 * ```jsx
 * <Heading size="xxlarge">Page title</Heading>
 * ```
 */ var $b3cd5a87ca909983$var$Heading = function Heading(_ref) {
    var children = _ref.children, size = _ref.size, variant = _ref.variant, id = _ref.id, testId = _ref.testId, as = _ref.as, _ref$color = _ref.color, color = _ref$color === void 0 ? 'default' : _ref$color;
    typeof $7t0tI;
    // TODO: Temporary to move variant over to size
    var localSize = variant || size;
    // Technically size can be undefined here due to how the types work.
    // Once removing the level prop this assertion can be removed since size will be a required prop.
    var _useHeading = (0, $69vmd.useHeading)($b3cd5a87ca909983$var$sizeTagMap[localSize]), _useHeading2 = (0, $2qaZZ.default)(_useHeading, 2), hLevel = _useHeading2[0], inferredElement = _useHeading2[1];
    var Component = as || inferredElement;
    var needsAriaRole = Component === 'div' && hLevel;
    return (0, $3dJ4i.jsx)(Component, {
        id: id,
        "data-testid": testId,
        role: needsAriaRole ? 'heading' : undefined,
        "aria-level": needsAriaRole ? hLevel : undefined,
        css: [
            $b3cd5a87ca909983$var$headingResetStyles,
            localSize && $b3cd5a87ca909983$var$headingSizeStylesMap[localSize],
            color === 'inverse' && $b3cd5a87ca909983$var$inverseStyles
        ]
    }, children);
};
/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::057c0fe2015c2071afe3d694c5afcc0e>>
 * @codegenId typography
 * @codegenCommand yarn workspace @atlaskit/heading codegen
 */ var $b3cd5a87ca909983$var$headingSizeStylesMap = {
    xxlarge: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-xxlarge, normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    xlarge: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-xlarge, normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    large: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-large, normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    medium: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    small: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-small, normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    xsmall: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-xsmall, normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    }),
    xxsmall: (0, $3dJ4i.css)({
        font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    })
};
var /**
 * @codegenEnd
 */ $b3cd5a87ca909983$export$2e2bcd8739ae039 = $b3cd5a87ca909983$var$Heading;

});


parcelRegister("kX9u3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dfe75e26330f86b48e811f0d520fc5e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f410ac9a9ac4f2f6$var$_react = $f410ac9a9ac4f2f6$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f410ac9a9ac4f2f6$var$_baseNew = $f410ac9a9ac4f2f6$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $f410ac9a9ac4f2f6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "OfficeBuilding".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: office in Atlas, company.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f410ac9a9ac4f2f6$var$OfficeBuildingIcon = (props)=>/*#__PURE__*/ $f410ac9a9ac4f2f6$var$_react.default.createElement($f410ac9a9ac4f2f6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12.5h1V16H1v-1.5h1zm1.5 12.5h2v-3.75a.75.75 0 0 1 .75-.75h3.5a.75.75 0 0 1 .75.75v3.75h2V2a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5zm5.5 0v-3H7v3zm-2-10H5V3h2zm4 0H9V3h2zM5 6h2v1.5H5zm4 0h2v1.5H9z" clip-rule="evenodd"/>`
    }, props));
$f410ac9a9ac4f2f6$var$OfficeBuildingIcon.displayName = 'OfficeBuildingIcon';
var $f410ac9a9ac4f2f6$var$_default = module.exports.default = $f410ac9a9ac4f2f6$var$OfficeBuildingIcon;

});

parcelRegister("hrBjL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2e29ae4526453fe67eff894ad5ac76ad>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cb31e7ce97688c96$var$_react = $cb31e7ce97688c96$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $cb31e7ce97688c96$var$_baseNew = $cb31e7ce97688c96$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $cb31e7ce97688c96$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: completed items, productivity emoji category. Completed task work type in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cb31e7ce97688c96$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $cb31e7ce97688c96$var$_react.default.createElement($cb31e7ce97688c96$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M14.5 8a6.5 6.5 0 1 0-13 0 6.5 6.5 0 0 0 13 0m-2.174-2.52-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308zM16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0"/>`
    }, props));
$cb31e7ce97688c96$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $cb31e7ce97688c96$var$_default = module.exports.default = $cb31e7ce97688c96$var$CheckCircleIcon;

});

parcelRegister("a9CD6", function(module, exports) {
$parcel$export(module.exports, "ConfluenceMarkBrand", function () { return $2ce451c25fbd45ca$export$c3c079c94b97bdde; });

var $7VQPk = parcelRequire("7VQPk");
const $2ce451c25fbd45ca$export$c3c079c94b97bdde = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M8.76706 32.3019C8.42806 32.8539 8.04306 33.5009 7.74406 34.0099C7.45606 34.5009 7.61106 35.1319 8.09606 35.4309L14.8901 39.6239C15.3881 39.9309 16.0401 39.7729 16.3371 39.2689C16.6071 38.8119 16.9571 38.2239 17.3391 37.5919C20.0321 33.1479 22.7401 33.6899 27.6191 36.0089L34.3571 39.2119C34.8881 39.4649 35.5231 39.2289 35.7621 38.6909L38.9981 31.3849C39.2281 30.8649 39.0021 30.2579 38.4881 30.0159C37.0651 29.3469 34.2371 28.0119 31.7051 26.7859C22.5051 22.3309 14.7201 22.6249 8.76806 32.3019H8.76706Z",
                fill: "url(#paint0_linear_818_553)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M39.233 15.6978C39.572 15.1458 39.957 14.4988 40.256 13.9898C40.544 13.4988 40.389 12.8678 39.904 12.5688L33.11 8.37583C32.612 8.06883 31.96 8.22683 31.663 8.73083C31.393 9.18783 31.043 9.77583 30.661 10.4078C27.968 14.8518 25.26 14.3098 20.381 11.9908L13.643 8.78783C13.112 8.53483 12.477 8.77083 12.238 9.30883L9.00202 16.6148C8.77202 17.1348 8.99802 17.7418 9.51202 17.9838C10.935 18.6528 13.763 19.9878 16.295 21.2138C25.495 25.6688 33.28 25.3748 39.232 15.6978H39.233Z",
                fill: "url(#paint1_linear_818_553)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint0_linear_818_553",
                        x1: "38.7961",
                        y1: "41.7759",
                        x2: "18.2371",
                        y2: "29.9619",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.972",
                                stopColor: "#1C78FA"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint1_linear_818_553",
                        x1: "9.20302",
                        y1: "6.22383",
                        x2: "29.763",
                        y2: "18.0378",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.972",
                                stopColor: "#1C78FA"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("1OyVz", function(module, exports) {
$parcel$export(module.exports, "JiraMarkBrand", function () { return $ac492e84be2f5dcc$export$2c53bf5b8775580d; });

var $7VQPk = parcelRequire("7VQPk");
const $ac492e84be2f5dcc$export$2c53bf5b8775580d = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M40.202 7.22998H22.124C22.124 11.736 25.777 15.388 30.282 15.388H33.611V18.601C33.611 23.107 37.264 26.759 41.769 26.759V8.79798C41.769 7.93198 41.067 7.22998 40.201 7.22998H40.202Z",
                fill: "#1D7AFC"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M31.255 16.2358H13.177C13.177 20.7418 16.83 24.3938 21.335 24.3938H24.664V27.6068C24.664 32.1128 28.317 35.7648 32.822 35.7648V17.8038C32.822 16.9378 32.12 16.2358 31.254 16.2358H31.255Z",
                fill: "url(#paint0_linear_818_567)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                d: "M22.308 25.2412H4.22998C4.22998 29.7472 7.88298 33.3992 12.388 33.3992H15.717V36.6122C15.717 41.1182 19.37 44.7702 23.875 44.7702V26.8092C23.875 25.9432 23.173 25.2412 22.307 25.2412H22.308Z",
                fill: "url(#paint1_linear_818_567)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint0_linear_818_567",
                        x1: "32.439",
                        y1: "16.2658",
                        x2: "24.749",
                        y2: "24.1958",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.176",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                        id: "paint1_linear_818_567",
                        x1: "24.003",
                        y1: "25.3252",
                        x2: "15.112",
                        y2: "33.9752",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "0.176",
                                stopColor: "#0055CC"
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                                offset: "1",
                                stopColor: "#1D7AFC"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});

parcelRegister("98rQm", function(module, exports) {
$parcel$export(module.exports, "TrelloMarkBrand", function () { return $af693e7b669a0669$export$f4e51c099e77aab7; });

var $7VQPk = parcelRequire("7VQPk");
const $af693e7b669a0669$export$f4e51c099e77aab7 = (props)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
        width: "48",
        height: "48",
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M36.429 7.69385H11.571C9.42997 7.69385 7.69397 9.42985 7.69397 11.5708V36.4288C7.69397 38.5698 9.42997 40.3058 11.571 40.3058H36.429C38.57 40.3058 40.306 38.5698 40.306 36.4288V11.5708C40.306 9.42985 38.57 7.69385 36.429 7.69385ZM21.742 31.1828C21.742 31.8948 21.165 32.4708 20.454 32.4708H15.003C14.291 32.4708 13.715 31.8938 13.715 31.1828V15.0028C13.715 14.2908 14.292 13.7148 15.003 13.7148H20.454C21.166 13.7148 21.742 14.2918 21.742 15.0028V31.1828ZM34.285 23.7548C34.285 24.4668 33.708 25.0428 32.997 25.0428H27.546C26.834 25.0428 26.258 24.4658 26.258 23.7548V15.0028C26.258 14.2908 26.835 13.7148 27.546 13.7148H32.997C33.709 13.7148 34.285 14.2918 34.285 15.0028V23.7548Z",
                fill: "url(#paint0_linear_818_512)"
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("defs", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("linearGradient", {
                    id: "paint0_linear_818_512",
                    x1: "24",
                    y1: "40.3058",
                    x2: "24",
                    y2: "7.69385",
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            stopColor: "#0055CC"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("stop", {
                            offset: "1",
                            stopColor: "#1D7AFC"
                        })
                    ]
                })
            })
        ]
    });

});

parcelRegister("2u2Jd", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $hxJDR = parcelRequire("hxJDR");
var $1cf07fdf0b6a767a$var$_extends3 = $1cf07fdf0b6a767a$var$_interopRequireDefault($hxJDR);

var $assfS = parcelRequire("assfS");
var $1cf07fdf0b6a767a$var$_getPrototypeOf2 = $1cf07fdf0b6a767a$var$_interopRequireDefault($assfS);

var $6hpgc = parcelRequire("6hpgc");
var $1cf07fdf0b6a767a$var$_classCallCheck3 = $1cf07fdf0b6a767a$var$_interopRequireDefault($6hpgc);

var $eoU9h = parcelRequire("eoU9h");
var $1cf07fdf0b6a767a$var$_createClass3 = $1cf07fdf0b6a767a$var$_interopRequireDefault($eoU9h);

var $arjX2 = parcelRequire("arjX2");
var $1cf07fdf0b6a767a$var$_possibleConstructorReturn3 = $1cf07fdf0b6a767a$var$_interopRequireDefault($arjX2);

var $fpmbk = parcelRequire("fpmbk");
var $1cf07fdf0b6a767a$var$_inherits3 = $1cf07fdf0b6a767a$var$_interopRequireDefault($fpmbk);

var $1oC0p = parcelRequire("1oC0p");
var $1cf07fdf0b6a767a$var$_react2 = $1cf07fdf0b6a767a$var$_interopRequireDefault($1oC0p);

var $4OgEb = parcelRequire("4OgEb");
var $1cf07fdf0b6a767a$var$_propTypes2 = $1cf07fdf0b6a767a$var$_interopRequireDefault($4OgEb);

var $lDo4H = parcelRequire("lDo4H");
var $1cf07fdf0b6a767a$var$_lottieWeb2 = $1cf07fdf0b6a767a$var$_interopRequireDefault($lDo4H);
function $1cf07fdf0b6a767a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $1cf07fdf0b6a767a$var$Lottie = function(_React$Component) {
    (0, $1cf07fdf0b6a767a$var$_inherits3.default)(Lottie, _React$Component);
    function Lottie() {
        var _ref;
        var _temp, _this, _ret;
        (0, $1cf07fdf0b6a767a$var$_classCallCheck3.default)(this, Lottie);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = (0, $1cf07fdf0b6a767a$var$_possibleConstructorReturn3.default)(this, (_ref = Lottie.__proto__ || (0, $1cf07fdf0b6a767a$var$_getPrototypeOf2.default)(Lottie)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.handleClickToPause = function() {
            // The pause() method is for handling pausing by passing a prop isPaused
            // This method is for handling the ability to pause by clicking on the animation
            if (_this.anim.isPaused) _this.anim.play();
            else _this.anim.pause();
        }, _temp), (0, $1cf07fdf0b6a767a$var$_possibleConstructorReturn3.default)(_this, _ret);
    }
    (0, $1cf07fdf0b6a767a$var$_createClass3.default)(Lottie, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _props = this.props, options = _props.options, eventListeners = _props.eventListeners;
                var loop = options.loop, autoplay = options.autoplay, animationData = options.animationData, rendererSettings = options.rendererSettings, segments = options.segments;
                this.options = {
                    container: this.el,
                    renderer: 'svg',
                    loop: loop !== false,
                    autoplay: autoplay !== false,
                    segments: segments !== false,
                    animationData: animationData,
                    rendererSettings: rendererSettings
                };
                this.options = (0, $1cf07fdf0b6a767a$var$_extends3.default)({}, this.options, options);
                this.anim = $1cf07fdf0b6a767a$var$_lottieWeb2.default.loadAnimation(this.options);
                this.registerEvents(eventListeners);
            }
        },
        {
            key: 'componentWillUpdate',
            value: function componentWillUpdate(nextProps /* , nextState */ ) {
                /* Recreate the animation handle if the data is changed */ if (this.options.animationData !== nextProps.options.animationData) {
                    this.deRegisterEvents(this.props.eventListeners);
                    this.destroy();
                    this.options = (0, $1cf07fdf0b6a767a$var$_extends3.default)({}, this.options, nextProps.options);
                    this.anim = $1cf07fdf0b6a767a$var$_lottieWeb2.default.loadAnimation(this.options);
                    this.registerEvents(nextProps.eventListeners);
                }
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate() {
                if (this.props.isStopped) this.stop();
                else if (this.props.segments) this.playSegments();
                else this.play();
                this.pause();
                this.setSpeed();
                this.setDirection();
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                this.deRegisterEvents(this.props.eventListeners);
                this.destroy();
                this.options.animationData = null;
                this.anim = null;
            }
        },
        {
            key: 'setSpeed',
            value: function setSpeed() {
                this.anim.setSpeed(this.props.speed);
            }
        },
        {
            key: 'setDirection',
            value: function setDirection() {
                this.anim.setDirection(this.props.direction);
            }
        },
        {
            key: 'play',
            value: function play() {
                this.anim.play();
            }
        },
        {
            key: 'playSegments',
            value: function playSegments() {
                this.anim.playSegments(this.props.segments);
            }
        },
        {
            key: 'stop',
            value: function stop() {
                this.anim.stop();
            }
        },
        {
            key: 'pause',
            value: function pause() {
                if (this.props.isPaused && !this.anim.isPaused) this.anim.pause();
                else if (!this.props.isPaused && this.anim.isPaused) this.anim.pause();
            }
        },
        {
            key: 'destroy',
            value: function destroy() {
                this.anim.destroy();
            }
        },
        {
            key: 'registerEvents',
            value: function registerEvents(eventListeners) {
                var _this2 = this;
                eventListeners.forEach(function(eventListener) {
                    _this2.anim.addEventListener(eventListener.eventName, eventListener.callback);
                });
            }
        },
        {
            key: 'deRegisterEvents',
            value: function deRegisterEvents(eventListeners) {
                var _this3 = this;
                eventListeners.forEach(function(eventListener) {
                    _this3.anim.removeEventListener(eventListener.eventName, eventListener.callback);
                });
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this4 = this;
                var _props2 = this.props, width = _props2.width, height = _props2.height, ariaRole = _props2.ariaRole, ariaLabel = _props2.ariaLabel, isClickToPauseDisabled = _props2.isClickToPauseDisabled, title = _props2.title;
                var getSize = function getSize(initial) {
                    var size = void 0;
                    if (typeof initial === 'number') size = initial + 'px';
                    else size = initial || '100%';
                    return size;
                };
                var lottieStyles = (0, $1cf07fdf0b6a767a$var$_extends3.default)({
                    width: getSize(width),
                    height: getSize(height),
                    overflow: 'hidden',
                    margin: '0 auto',
                    outline: 'none'
                }, this.props.style);
                var onClickHandler = isClickToPauseDisabled ? function() {
                    return null;
                } : this.handleClickToPause;
                return(// Bug with eslint rules https://github.com/airbnb/javascript/issues/1374
                // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                $1cf07fdf0b6a767a$var$_react2.default.createElement('div', {
                    ref: function ref(c) {
                        _this4.el = c;
                    },
                    style: lottieStyles,
                    onClick: onClickHandler,
                    title: title,
                    role: ariaRole,
                    'aria-label': ariaLabel,
                    tabIndex: '0'
                }));
            }
        }
    ]);
    return Lottie;
}($1cf07fdf0b6a767a$var$_react2.default.Component);
module.exports.default = $1cf07fdf0b6a767a$var$Lottie;
$1cf07fdf0b6a767a$var$Lottie.propTypes = {
    eventListeners: $1cf07fdf0b6a767a$var$_propTypes2.default.arrayOf($1cf07fdf0b6a767a$var$_propTypes2.default.object),
    options: $1cf07fdf0b6a767a$var$_propTypes2.default.object.isRequired,
    height: $1cf07fdf0b6a767a$var$_propTypes2.default.oneOfType([
        $1cf07fdf0b6a767a$var$_propTypes2.default.string,
        $1cf07fdf0b6a767a$var$_propTypes2.default.number
    ]),
    width: $1cf07fdf0b6a767a$var$_propTypes2.default.oneOfType([
        $1cf07fdf0b6a767a$var$_propTypes2.default.string,
        $1cf07fdf0b6a767a$var$_propTypes2.default.number
    ]),
    isStopped: $1cf07fdf0b6a767a$var$_propTypes2.default.bool,
    isPaused: $1cf07fdf0b6a767a$var$_propTypes2.default.bool,
    speed: $1cf07fdf0b6a767a$var$_propTypes2.default.number,
    segments: $1cf07fdf0b6a767a$var$_propTypes2.default.arrayOf($1cf07fdf0b6a767a$var$_propTypes2.default.number),
    direction: $1cf07fdf0b6a767a$var$_propTypes2.default.number,
    ariaRole: $1cf07fdf0b6a767a$var$_propTypes2.default.string,
    ariaLabel: $1cf07fdf0b6a767a$var$_propTypes2.default.string,
    isClickToPauseDisabled: $1cf07fdf0b6a767a$var$_propTypes2.default.bool,
    title: $1cf07fdf0b6a767a$var$_propTypes2.default.string,
    style: $1cf07fdf0b6a767a$var$_propTypes2.default.string
};
$1cf07fdf0b6a767a$var$Lottie.defaultProps = {
    eventListeners: [],
    isStopped: false,
    isPaused: false,
    speed: 1,
    ariaRole: 'button',
    ariaLabel: 'animation',
    isClickToPauseDisabled: false,
    title: ''
};

});
parcelRegister("hxJDR", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", function () { return $cc58ec3eb70ca8a9$export$1e511d4a378977f5; }, function (v) { return $cc58ec3eb70ca8a9$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $cc58ec3eb70ca8a9$export$2e2bcd8739ae039; }, function (v) { return $cc58ec3eb70ca8a9$export$2e2bcd8739ae039 = v; });
var $cc58ec3eb70ca8a9$export$1e511d4a378977f5;
var $cc58ec3eb70ca8a9$export$2e2bcd8739ae039;
"use strict";
$cc58ec3eb70ca8a9$export$1e511d4a378977f5 = true;

var $5Ibi5 = parcelRequire("5Ibi5");
var $cc58ec3eb70ca8a9$var$_assign2 = $cc58ec3eb70ca8a9$var$_interopRequireDefault($5Ibi5);
function $cc58ec3eb70ca8a9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$cc58ec3eb70ca8a9$export$2e2bcd8739ae039 = $cc58ec3eb70ca8a9$var$_assign2.default || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

});
parcelRegister("5Ibi5", function(module, exports) {

module.exports = {
    "default": (parcelRequire("3aJcb")),
    __esModule: true
};

});
parcelRegister("3aJcb", function(module, exports) {
parcelRequire("fsMh2");

module.exports = (parcelRequire("23f7N")).Object.assign;

});
parcelRegister("fsMh2", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $6TZmN = parcelRequire("6TZmN");

$6TZmN($6TZmN.S + $6TZmN.F, 'Object', {
    assign: (parcelRequire("cNTzW"))
});

});
parcelRegister("6TZmN", function(module, exports) {

var $4FFa4 = parcelRequire("4FFa4");

var $23f7N = parcelRequire("23f7N");

var $04VsN = parcelRequire("04VsN");

var $1XBAS = parcelRequire("1XBAS");

var $763mL = parcelRequire("763mL");
var $50677b4cdf98284c$var$PROTOTYPE = 'prototype';
var $50677b4cdf98284c$var$$export = function(type, name, source) {
    var IS_FORCED = type & $50677b4cdf98284c$var$$export.F;
    var IS_GLOBAL = type & $50677b4cdf98284c$var$$export.G;
    var IS_STATIC = type & $50677b4cdf98284c$var$$export.S;
    var IS_PROTO = type & $50677b4cdf98284c$var$$export.P;
    var IS_BIND = type & $50677b4cdf98284c$var$$export.B;
    var IS_WRAP = type & $50677b4cdf98284c$var$$export.W;
    var exports = IS_GLOBAL ? $23f7N : $23f7N[name] || ($23f7N[name] = {});
    var expProto = exports[$50677b4cdf98284c$var$PROTOTYPE];
    var target = IS_GLOBAL ? $4FFa4 : IS_STATIC ? $4FFa4[name] : ($4FFa4[name] || {})[$50677b4cdf98284c$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $763mL(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key] : IS_BIND && own ? $04VsN(out, $4FFa4) : IS_WRAP && target[key] == out ? function(C) {
            var F = function(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$50677b4cdf98284c$var$PROTOTYPE] = C[$50677b4cdf98284c$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == 'function' ? $04VsN(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $50677b4cdf98284c$var$$export.R && expProto && !expProto[key]) $1XBAS(expProto, key, out);
        }
    }
};
// type bitmap
$50677b4cdf98284c$var$$export.F = 1; // forced
$50677b4cdf98284c$var$$export.G = 2; // global
$50677b4cdf98284c$var$$export.S = 4; // static
$50677b4cdf98284c$var$$export.P = 8; // proto
$50677b4cdf98284c$var$$export.B = 16; // bind
$50677b4cdf98284c$var$$export.W = 32; // wrap
$50677b4cdf98284c$var$$export.U = 64; // safe
$50677b4cdf98284c$var$$export.R = 128; // real proto method for `library`
module.exports = $50677b4cdf98284c$var$$export;

});
parcelRegister("4FFa4", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $366aeb9262291f44$var$global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if (typeof __g == 'number') __g = $366aeb9262291f44$var$global; // eslint-disable-line no-undef

});

parcelRegister("23f7N", function(module, exports) {
var $17e7980f5bcf229c$var$core = module.exports = {
    version: '2.6.12'
};
if (typeof __e == 'number') __e = $17e7980f5bcf229c$var$core; // eslint-disable-line no-undef

});

parcelRegister("04VsN", function(module, exports) {
// optional / simple context binding

var $2045g = parcelRequire("2045g");
module.exports = function(fn, that, length) {
    $2045g(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("2045g", function(module, exports) {
module.exports = function(it) {
    if (typeof it != 'function') throw TypeError(it + ' is not a function!');
    return it;
};

});


parcelRegister("1XBAS", function(module, exports) {

var $19vSD = parcelRequire("19vSD");

var $kKJnZ = parcelRequire("kKJnZ");

module.exports = (parcelRequire("2PPTD")) ? function(object, key, value) {
    return $19vSD.f(object, key, $kKJnZ(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("19vSD", function(module, exports) {
$parcel$export(module.exports, "f", function () { return $0d6f5c78ac7c57a6$export$2d1720544b23b823; }, function (v) { return $0d6f5c78ac7c57a6$export$2d1720544b23b823 = v; });
var $0d6f5c78ac7c57a6$export$2d1720544b23b823;

var $5asEa = parcelRequire("5asEa");

var $1Vpr5 = parcelRequire("1Vpr5");

var $bIV2P = parcelRequire("bIV2P");
var $0d6f5c78ac7c57a6$var$dP = Object.defineProperty;

$0d6f5c78ac7c57a6$export$2d1720544b23b823 = (parcelRequire("2PPTD")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $5asEa(O);
    P = $bIV2P(P, true);
    $5asEa(Attributes);
    if ($1Vpr5) try {
        return $0d6f5c78ac7c57a6$var$dP(O, P, Attributes);
    } catch (e) {}
    if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
    if ('value' in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("5asEa", function(module, exports) {

var $7QZ8S = parcelRequire("7QZ8S");
module.exports = function(it) {
    if (!$7QZ8S(it)) throw TypeError(it + ' is not an object!');
    return it;
};

});
parcelRegister("7QZ8S", function(module, exports) {
module.exports = function(it) {
    return typeof it === 'object' ? it !== null : typeof it === 'function';
};

});


parcelRegister("1Vpr5", function(module, exports) {



module.exports = !(parcelRequire("2PPTD")) && !(parcelRequire("hs8hK"))(function() {
    return Object.defineProperty((parcelRequire("kjubI"))('div'), 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("2PPTD", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("hs8hK"))(function() {
    return Object.defineProperty({}, 'a', {
        get: function() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("hs8hK", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("kjubI", function(module, exports) {

var $7QZ8S = parcelRequire("7QZ8S");

var $4FFa4 = parcelRequire("4FFa4");
var $ec9cffabb69d468c$require$document = $4FFa4.document;
// typeof document.createElement is 'object' in old IE
var $ec9cffabb69d468c$var$is = $7QZ8S($ec9cffabb69d468c$require$document) && $7QZ8S($ec9cffabb69d468c$require$document.createElement);
module.exports = function(it) {
    return $ec9cffabb69d468c$var$is ? $ec9cffabb69d468c$require$document.createElement(it) : {};
};

});


parcelRegister("bIV2P", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $7QZ8S = parcelRequire("7QZ8S");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$7QZ8S(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == 'function' && !$7QZ8S(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == 'function' && !$7QZ8S(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == 'function' && !$7QZ8S(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("kKJnZ", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("763mL", function(module, exports) {
var $52abb468452e06ed$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $52abb468452e06ed$var$hasOwnProperty.call(it, key);
};

});


parcelRegister("cNTzW", function(module, exports) {
'use strict';

var $2PPTD = parcelRequire("2PPTD");

var $E0yCE = parcelRequire("E0yCE");

var $jBejz = parcelRequire("jBejz");

var $gGh3r = parcelRequire("gGh3r");

var $7tWaA = parcelRequire("7tWaA");

var $kMWzF = parcelRequire("kMWzF");
var $95252c6fd67bc852$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$95252c6fd67bc852$var$$assign || (parcelRequire("hs8hK"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = 'abcdefghijklmnopqrst';
    A[S] = 7;
    K.split('').forEach(function(k) {
        B[k] = k;
    });
    return $95252c6fd67bc852$var$$assign({}, A)[S] != 7 || Object.keys($95252c6fd67bc852$var$$assign({}, B)).join('') != K;
}) ? function assign(target, source) {
    var T = $7tWaA(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $jBejz.f;
    var isEnum = $gGh3r.f;
    while(aLen > index){
        var S = $kMWzF(arguments[index++]);
        var keys = getSymbols ? $E0yCE(S).concat(getSymbols(S)) : $E0yCE(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$2PPTD || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $95252c6fd67bc852$var$$assign;

});
parcelRegister("E0yCE", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $64rCp = parcelRequire("64rCp");

var $f5whe = parcelRequire("f5whe");
module.exports = Object.keys || function keys(O) {
    return $64rCp(O, $f5whe);
};

});
parcelRegister("64rCp", function(module, exports) {

var $763mL = parcelRequire("763mL");

var $2hx6g = parcelRequire("2hx6g");

var $46b88a3ecfad9eac$var$arrayIndexOf = (parcelRequire("5sIDY"))(false);

var $46b88a3ecfad9eac$var$IE_PROTO = (parcelRequire("9gke3"))('IE_PROTO');
module.exports = function(object, names) {
    var O = $2hx6g(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $46b88a3ecfad9eac$var$IE_PROTO) $763mL(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($763mL(O, key = names[i++])) ~$46b88a3ecfad9eac$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("2hx6g", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $kMWzF = parcelRequire("kMWzF");

var $bwTK5 = parcelRequire("bwTK5");
module.exports = function(it) {
    return $kMWzF($bwTK5(it));
};

});
parcelRegister("kMWzF", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $gNg6c = parcelRequire("gNg6c");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it) {
    return $gNg6c(it) == 'String' ? it.split('') : Object(it);
};

});
parcelRegister("gNg6c", function(module, exports) {
var $c39db5dd98abd16e$var$toString = {}.toString;
module.exports = function(it) {
    return $c39db5dd98abd16e$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("bwTK5", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("5sIDY", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $2hx6g = parcelRequire("2hx6g");

var $f0lw7 = parcelRequire("f0lw7");

var $6AE42 = parcelRequire("6AE42");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $2hx6g($this);
        var length = $f0lw7(O.length);
        var index = $6AE42(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("f0lw7", function(module, exports) {
// 7.1.15 ToLength

var $3ylxK = parcelRequire("3ylxK");
var $aec78bf4e7ec90d9$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $aec78bf4e7ec90d9$var$min($3ylxK(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("3ylxK", function(module, exports) {
// 7.1.4 ToInteger
var $2965421f6a410d04$var$ceil = Math.ceil;
var $2965421f6a410d04$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $2965421f6a410d04$var$floor : $2965421f6a410d04$var$ceil)(it);
};

});


parcelRegister("6AE42", function(module, exports) {

var $3ylxK = parcelRequire("3ylxK");
var $4cc52ebfd89326d3$var$max = Math.max;
var $4cc52ebfd89326d3$var$min = Math.min;
module.exports = function(index, length) {
    index = $3ylxK(index);
    return index < 0 ? $4cc52ebfd89326d3$var$max(index + length, 0) : $4cc52ebfd89326d3$var$min(index, length);
};

});


parcelRegister("9gke3", function(module, exports) {

var $6be54c1617561861$var$shared = (parcelRequire("izZ3Q"))('keys');

var $hoAgo = parcelRequire("hoAgo");
module.exports = function(key) {
    return $6be54c1617561861$var$shared[key] || ($6be54c1617561861$var$shared[key] = $hoAgo(key));
};

});
parcelRegister("izZ3Q", function(module, exports) {

var $23f7N = parcelRequire("23f7N");

var $4FFa4 = parcelRequire("4FFa4");
var $d86adc506cb5ba45$var$SHARED = '__core-js_shared__';
var $d86adc506cb5ba45$var$store = $4FFa4[$d86adc506cb5ba45$var$SHARED] || ($4FFa4[$d86adc506cb5ba45$var$SHARED] = {});

(module.exports = function(key, value) {
    return $d86adc506cb5ba45$var$store[key] || ($d86adc506cb5ba45$var$store[key] = value !== undefined ? value : {});
})('versions', []).push({
    version: $23f7N.version,
    mode: (parcelRequire("jHsIx")) ? 'pure' : 'global',
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("jHsIx", function(module, exports) {
module.exports = true;

});


parcelRegister("hoAgo", function(module, exports) {
var $caa0ceb2324f08b0$var$id = 0;
var $caa0ceb2324f08b0$var$px = Math.random();
module.exports = function(key) {
    return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++$caa0ceb2324f08b0$var$id + $caa0ceb2324f08b0$var$px).toString(36));
};

});



parcelRegister("f5whe", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');

});


parcelRegister("jBejz", function(module, exports) {
$parcel$export(module.exports, "f", function () { return $e44c939e5b5d76a8$export$2d1720544b23b823; }, function (v) { return $e44c939e5b5d76a8$export$2d1720544b23b823 = v; });
var $e44c939e5b5d76a8$export$2d1720544b23b823;
$e44c939e5b5d76a8$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("gGh3r", function(module, exports) {
$parcel$export(module.exports, "f", function () { return $c24dcc42a8b9bb86$export$2d1720544b23b823; }, function (v) { return $c24dcc42a8b9bb86$export$2d1720544b23b823 = v; });
var $c24dcc42a8b9bb86$export$2d1720544b23b823;
$c24dcc42a8b9bb86$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});

parcelRegister("7tWaA", function(module, exports) {
// 7.1.13 ToObject(argument)

var $bwTK5 = parcelRequire("bwTK5");
module.exports = function(it) {
    return Object($bwTK5(it));
};

});






parcelRegister("assfS", function(module, exports) {

module.exports = {
    "default": (parcelRequire("5rUW5")),
    __esModule: true
};

});
parcelRegister("5rUW5", function(module, exports) {
parcelRequire("iULCI");

module.exports = (parcelRequire("23f7N")).Object.getPrototypeOf;

});
parcelRegister("iULCI", function(module, exports) {
// 19.1.2.9 Object.getPrototypeOf(O)

var $7tWaA = parcelRequire("7tWaA");

var $kxvda = parcelRequire("kxvda");

(parcelRequire("bcSMG"))('getPrototypeOf', function() {
    return function getPrototypeOf(it) {
        return $kxvda($7tWaA(it));
    };
});

});
parcelRegister("kxvda", function(module, exports) {
// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)

var $763mL = parcelRequire("763mL");

var $7tWaA = parcelRequire("7tWaA");

var $ef3f19ab31140719$var$IE_PROTO = (parcelRequire("9gke3"))('IE_PROTO');
var $ef3f19ab31140719$var$ObjectProto = Object.prototype;
module.exports = Object.getPrototypeOf || function(O) {
    O = $7tWaA(O);
    if ($763mL(O, $ef3f19ab31140719$var$IE_PROTO)) return O[$ef3f19ab31140719$var$IE_PROTO];
    if (typeof O.constructor == 'function' && O instanceof O.constructor) return O.constructor.prototype;
    return O instanceof Object ? $ef3f19ab31140719$var$ObjectProto : null;
};

});

parcelRegister("bcSMG", function(module, exports) {
// most Object methods by ES6 should accept primitives

var $6TZmN = parcelRequire("6TZmN");

var $23f7N = parcelRequire("23f7N");

var $hs8hK = parcelRequire("hs8hK");
module.exports = function(KEY, exec) {
    var fn = ($23f7N.Object || {})[KEY] || Object[KEY];
    var exp = {};
    exp[KEY] = exec(fn);
    $6TZmN($6TZmN.S + $6TZmN.F * $hs8hK(function() {
        fn(1);
    }), 'Object', exp);
};

});




parcelRegister("6hpgc", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", function () { return $4927ecc8d63b2fec$export$1e511d4a378977f5; }, function (v) { return $4927ecc8d63b2fec$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $4927ecc8d63b2fec$export$2e2bcd8739ae039; }, function (v) { return $4927ecc8d63b2fec$export$2e2bcd8739ae039 = v; });
var $4927ecc8d63b2fec$export$1e511d4a378977f5;
var $4927ecc8d63b2fec$export$2e2bcd8739ae039;
"use strict";
$4927ecc8d63b2fec$export$1e511d4a378977f5 = true;
$4927ecc8d63b2fec$export$2e2bcd8739ae039 = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};

});

parcelRegister("eoU9h", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", function () { return $a7bedc85ff7818cc$export$1e511d4a378977f5; }, function (v) { return $a7bedc85ff7818cc$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $a7bedc85ff7818cc$export$2e2bcd8739ae039; }, function (v) { return $a7bedc85ff7818cc$export$2e2bcd8739ae039 = v; });
var $a7bedc85ff7818cc$export$1e511d4a378977f5;
var $a7bedc85ff7818cc$export$2e2bcd8739ae039;
"use strict";
$a7bedc85ff7818cc$export$1e511d4a378977f5 = true;

var $eYaOS = parcelRequire("eYaOS");
var $a7bedc85ff7818cc$var$_defineProperty2 = $a7bedc85ff7818cc$var$_interopRequireDefault($eYaOS);
function $a7bedc85ff7818cc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$a7bedc85ff7818cc$export$2e2bcd8739ae039 = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            (0, $a7bedc85ff7818cc$var$_defineProperty2.default)(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

});
parcelRegister("eYaOS", function(module, exports) {

module.exports = {
    "default": (parcelRequire("kxJeH")),
    __esModule: true
};

});
parcelRegister("kxJeH", function(module, exports) {
parcelRequire("hlCNl");

var $23f7N = parcelRequire("23f7N");
var $ef49faa80d2c2f9b$require$$Object = $23f7N.Object;
module.exports = function defineProperty(it, key, desc) {
    return $ef49faa80d2c2f9b$require$$Object.defineProperty(it, key, desc);
};

});
parcelRegister("hlCNl", function(module, exports) {

var $6TZmN = parcelRequire("6TZmN");


// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$6TZmN($6TZmN.S + $6TZmN.F * !(parcelRequire("2PPTD")), 'Object', {
    defineProperty: (parcelRequire("19vSD")).f
});

});




parcelRegister("arjX2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", function () { return $799be6e526c9d7f5$export$1e511d4a378977f5; }, function (v) { return $799be6e526c9d7f5$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $799be6e526c9d7f5$export$2e2bcd8739ae039; }, function (v) { return $799be6e526c9d7f5$export$2e2bcd8739ae039 = v; });
var $799be6e526c9d7f5$export$1e511d4a378977f5;
var $799be6e526c9d7f5$export$2e2bcd8739ae039;
"use strict";
$799be6e526c9d7f5$export$1e511d4a378977f5 = true;

var $frdl0 = parcelRequire("frdl0");
var $799be6e526c9d7f5$var$_typeof3 = $799be6e526c9d7f5$var$_interopRequireDefault($frdl0);
function $799be6e526c9d7f5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$799be6e526c9d7f5$export$2e2bcd8739ae039 = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && ((typeof call === "undefined" ? "undefined" : (0, $799be6e526c9d7f5$var$_typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

});
parcelRegister("frdl0", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", function () { return $b3d3b93c2659cce8$export$1e511d4a378977f5; }, function (v) { return $b3d3b93c2659cce8$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $b3d3b93c2659cce8$export$2e2bcd8739ae039; }, function (v) { return $b3d3b93c2659cce8$export$2e2bcd8739ae039 = v; });
var $b3d3b93c2659cce8$export$1e511d4a378977f5;
var $b3d3b93c2659cce8$export$2e2bcd8739ae039;
"use strict";
$b3d3b93c2659cce8$export$1e511d4a378977f5 = true;

var $73CEX = parcelRequire("73CEX");
var $b3d3b93c2659cce8$var$_iterator2 = $b3d3b93c2659cce8$var$_interopRequireDefault($73CEX);

var $7xVAR = parcelRequire("7xVAR");
var $b3d3b93c2659cce8$var$_symbol2 = $b3d3b93c2659cce8$var$_interopRequireDefault($7xVAR);
var $b3d3b93c2659cce8$var$_typeof = typeof $b3d3b93c2659cce8$var$_symbol2.default === "function" && typeof $b3d3b93c2659cce8$var$_iterator2.default === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof $b3d3b93c2659cce8$var$_symbol2.default === "function" && obj.constructor === $b3d3b93c2659cce8$var$_symbol2.default && obj !== $b3d3b93c2659cce8$var$_symbol2.default.prototype ? "symbol" : typeof obj;
};
function $b3d3b93c2659cce8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$b3d3b93c2659cce8$export$2e2bcd8739ae039 = typeof $b3d3b93c2659cce8$var$_symbol2.default === "function" && $b3d3b93c2659cce8$var$_typeof($b3d3b93c2659cce8$var$_iterator2.default) === "symbol" ? function(obj) {
    return typeof obj === "undefined" ? "undefined" : $b3d3b93c2659cce8$var$_typeof(obj);
} : function(obj) {
    return obj && typeof $b3d3b93c2659cce8$var$_symbol2.default === "function" && obj.constructor === $b3d3b93c2659cce8$var$_symbol2.default && obj !== $b3d3b93c2659cce8$var$_symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : $b3d3b93c2659cce8$var$_typeof(obj);
};

});
parcelRegister("73CEX", function(module, exports) {

module.exports = {
    "default": (parcelRequire("kX62j")),
    __esModule: true
};

});
parcelRegister("kX62j", function(module, exports) {
parcelRequire("kvp0v");
parcelRequire("a6Pd3");

module.exports = (parcelRequire("iY0Fa")).f('iterator');

});
parcelRegister("kvp0v", function(module, exports) {
'use strict';

var $eeda19c7512e8b4e$var$$at = (parcelRequire("evNBk"))(true);

// 21.1.3.27 String.prototype[@@iterator]()
(parcelRequire("1MYRJ"))(String, 'String', function(iterated) {
    this._t = String(iterated); // target
    this._i = 0; // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var index = this._i;
    var point;
    if (index >= O.length) return {
        value: undefined,
        done: true
    };
    point = $eeda19c7512e8b4e$var$$at(O, index);
    this._i += point.length;
    return {
        value: point,
        done: false
    };
});

});
parcelRegister("evNBk", function(module, exports) {

var $3ylxK = parcelRequire("3ylxK");

var $bwTK5 = parcelRequire("bwTK5");
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING) {
    return function(that, pos) {
        var s = String($bwTK5(that));
        var i = $3ylxK(pos);
        var l = s.length;
        var a, b;
        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
        a = s.charCodeAt(i);
        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
    };
};

});

parcelRegister("1MYRJ", function(module, exports) {
'use strict';

var $jHsIx = parcelRequire("jHsIx");

var $6TZmN = parcelRequire("6TZmN");

var $aDsEo = parcelRequire("aDsEo");

var $1XBAS = parcelRequire("1XBAS");

var $aODcA = parcelRequire("aODcA");

var $gRPe6 = parcelRequire("gRPe6");

var $jr22O = parcelRequire("jr22O");

var $kxvda = parcelRequire("kxvda");

var $14d97ccfd41e5645$var$ITERATOR = (parcelRequire("9xDAg"))('iterator');
var $14d97ccfd41e5645$var$BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var $14d97ccfd41e5645$var$FF_ITERATOR = '@@iterator';
var $14d97ccfd41e5645$var$KEYS = 'keys';
var $14d97ccfd41e5645$var$VALUES = 'values';
var $14d97ccfd41e5645$var$returnThis = function() {
    return this;
};
module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
    $gRPe6(Constructor, NAME, next);
    var getMethod = function(kind) {
        if (!$14d97ccfd41e5645$var$BUGGY && kind in proto) return proto[kind];
        switch(kind){
            case $14d97ccfd41e5645$var$KEYS:
                return function keys() {
                    return new Constructor(this, kind);
                };
            case $14d97ccfd41e5645$var$VALUES:
                return function values() {
                    return new Constructor(this, kind);
                };
        }
        return function entries() {
            return new Constructor(this, kind);
        };
    };
    var TAG = NAME + ' Iterator';
    var DEF_VALUES = DEFAULT == $14d97ccfd41e5645$var$VALUES;
    var VALUES_BUG = false;
    var proto = Base.prototype;
    var $native = proto[$14d97ccfd41e5645$var$ITERATOR] || proto[$14d97ccfd41e5645$var$FF_ITERATOR] || DEFAULT && proto[DEFAULT];
    var $default = $native || getMethod(DEFAULT);
    var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
    var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
    var methods, key, IteratorPrototype;
    // Fix native
    if ($anyNative) {
        IteratorPrototype = $kxvda($anyNative.call(new Base()));
        if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
            // Set @@toStringTag to native iterators
            $jr22O(IteratorPrototype, TAG, true);
            // fix for some old engines
            if (!$jHsIx && typeof IteratorPrototype[$14d97ccfd41e5645$var$ITERATOR] != 'function') $1XBAS(IteratorPrototype, $14d97ccfd41e5645$var$ITERATOR, $14d97ccfd41e5645$var$returnThis);
        }
    }
    // fix Array#{values, @@iterator}.name in V8 / FF
    if (DEF_VALUES && $native && $native.name !== $14d97ccfd41e5645$var$VALUES) {
        VALUES_BUG = true;
        $default = function values() {
            return $native.call(this);
        };
    }
    // Define iterator
    if ((!$jHsIx || FORCED) && ($14d97ccfd41e5645$var$BUGGY || VALUES_BUG || !proto[$14d97ccfd41e5645$var$ITERATOR])) $1XBAS(proto, $14d97ccfd41e5645$var$ITERATOR, $default);
    // Plug for library
    $aODcA[NAME] = $default;
    $aODcA[TAG] = $14d97ccfd41e5645$var$returnThis;
    if (DEFAULT) {
        methods = {
            values: DEF_VALUES ? $default : getMethod($14d97ccfd41e5645$var$VALUES),
            keys: IS_SET ? $default : getMethod($14d97ccfd41e5645$var$KEYS),
            entries: $entries
        };
        if (FORCED) {
            for(key in methods)if (!(key in proto)) $aDsEo(proto, key, methods[key]);
        } else $6TZmN($6TZmN.P + $6TZmN.F * ($14d97ccfd41e5645$var$BUGGY || VALUES_BUG), NAME, methods);
    }
    return methods;
};

});
parcelRegister("aDsEo", function(module, exports) {

module.exports = (parcelRequire("1XBAS"));

});

parcelRegister("aODcA", function(module, exports) {
module.exports = {};

});

parcelRegister("gRPe6", function(module, exports) {
'use strict';

var $lmUsf = parcelRequire("lmUsf");

var $kKJnZ = parcelRequire("kKJnZ");

var $jr22O = parcelRequire("jr22O");
var $c4795519cce9da72$var$IteratorPrototype = {};


// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
(parcelRequire("1XBAS"))($c4795519cce9da72$var$IteratorPrototype, (parcelRequire("9xDAg"))('iterator'), function() {
    return this;
});
module.exports = function(Constructor, NAME, next) {
    Constructor.prototype = $lmUsf($c4795519cce9da72$var$IteratorPrototype, {
        next: $kKJnZ(1, next)
    });
    $jr22O(Constructor, NAME + ' Iterator');
};

});
parcelRegister("lmUsf", function(module, exports) {
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])

var $5asEa = parcelRequire("5asEa");

var $6Gg6R = parcelRequire("6Gg6R");

var $f5whe = parcelRequire("f5whe");

var $f8e771c717e03d19$var$IE_PROTO = (parcelRequire("9gke3"))('IE_PROTO');
var $f8e771c717e03d19$var$Empty = function() {};
var $f8e771c717e03d19$var$PROTOTYPE = 'prototype';


// Create object with fake `null` prototype: use iframe Object with cleared prototype
var $f8e771c717e03d19$var$createDict = function() {
    // Thrash, waste and sodomy: IE GC bug
    var iframe = (parcelRequire("kjubI"))('iframe');
    var i = $f5whe.length;
    var lt = '<';
    var gt = '>';
    var iframeDocument;
    iframe.style.display = 'none';
    (parcelRequire("h3ZDN")).appendChild(iframe);
    iframe.src = 'javascript:'; // eslint-disable-line no-script-url
    // createDict = iframe.contentWindow.Object;
    // html.removeChild(iframe);
    iframeDocument = iframe.contentWindow.document;
    iframeDocument.open();
    iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
    iframeDocument.close();
    $f8e771c717e03d19$var$createDict = iframeDocument.F;
    while(i--)delete $f8e771c717e03d19$var$createDict[$f8e771c717e03d19$var$PROTOTYPE][$f5whe[i]];
    return $f8e771c717e03d19$var$createDict();
};
module.exports = Object.create || function create(O, Properties) {
    var result;
    if (O !== null) {
        $f8e771c717e03d19$var$Empty[$f8e771c717e03d19$var$PROTOTYPE] = $5asEa(O);
        result = new $f8e771c717e03d19$var$Empty();
        $f8e771c717e03d19$var$Empty[$f8e771c717e03d19$var$PROTOTYPE] = null;
        // add "__proto__" for Object.getPrototypeOf polyfill
        result[$f8e771c717e03d19$var$IE_PROTO] = O;
    } else result = $f8e771c717e03d19$var$createDict();
    return Properties === undefined ? result : $6Gg6R(result, Properties);
};

});
parcelRegister("6Gg6R", function(module, exports) {

var $19vSD = parcelRequire("19vSD");

var $5asEa = parcelRequire("5asEa");

var $E0yCE = parcelRequire("E0yCE");

module.exports = (parcelRequire("2PPTD")) ? Object.defineProperties : function defineProperties(O, Properties) {
    $5asEa(O);
    var keys = $E0yCE(Properties);
    var length = keys.length;
    var i = 0;
    var P;
    while(length > i)$19vSD.f(O, P = keys[i++], Properties[P]);
    return O;
};

});

parcelRegister("h3ZDN", function(module, exports) {

var $4FFa4 = parcelRequire("4FFa4");
var $c6c2880f85f59af4$require$document = $4FFa4.document;
module.exports = $c6c2880f85f59af4$require$document && $c6c2880f85f59af4$require$document.documentElement;

});


parcelRegister("jr22O", function(module, exports) {

var $19vSD = parcelRequire("19vSD");
var $e2621feb5510ea07$require$def = $19vSD.f;

var $763mL = parcelRequire("763mL");

var $e2621feb5510ea07$var$TAG = (parcelRequire("9xDAg"))('toStringTag');
module.exports = function(it, tag, stat) {
    if (it && !$763mL(it = stat ? it : it.prototype, $e2621feb5510ea07$var$TAG)) $e2621feb5510ea07$require$def(it, $e2621feb5510ea07$var$TAG, {
        configurable: true,
        value: tag
    });
};

});
parcelRegister("9xDAg", function(module, exports) {

var $6f25e6afc0784b1a$var$store = (parcelRequire("izZ3Q"))('wks');

var $hoAgo = parcelRequire("hoAgo");

var $4FFa4 = parcelRequire("4FFa4");
var $6f25e6afc0784b1a$require$Symbol = $4FFa4.Symbol;
var $6f25e6afc0784b1a$var$USE_SYMBOL = typeof $6f25e6afc0784b1a$require$Symbol == 'function';
var $6f25e6afc0784b1a$var$$exports = module.exports = function(name) {
    return $6f25e6afc0784b1a$var$store[name] || ($6f25e6afc0784b1a$var$store[name] = $6f25e6afc0784b1a$var$USE_SYMBOL && $6f25e6afc0784b1a$require$Symbol[name] || ($6f25e6afc0784b1a$var$USE_SYMBOL ? $6f25e6afc0784b1a$require$Symbol : $hoAgo)('Symbol.' + name));
};
$6f25e6afc0784b1a$var$$exports.store = $6f25e6afc0784b1a$var$store;

});





parcelRegister("a6Pd3", function(module, exports) {
parcelRequire("lP6GC");

var $4FFa4 = parcelRequire("4FFa4");

var $1XBAS = parcelRequire("1XBAS");

var $aODcA = parcelRequire("aODcA");

var $75c23011e1e94f01$var$TO_STRING_TAG = (parcelRequire("9xDAg"))('toStringTag');
var $75c23011e1e94f01$var$DOMIterables = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(',');
for(var $75c23011e1e94f01$var$i = 0; $75c23011e1e94f01$var$i < $75c23011e1e94f01$var$DOMIterables.length; $75c23011e1e94f01$var$i++){
    var $75c23011e1e94f01$var$NAME = $75c23011e1e94f01$var$DOMIterables[$75c23011e1e94f01$var$i];
    var $75c23011e1e94f01$var$Collection = $4FFa4[$75c23011e1e94f01$var$NAME];
    var $75c23011e1e94f01$var$proto = $75c23011e1e94f01$var$Collection && $75c23011e1e94f01$var$Collection.prototype;
    if ($75c23011e1e94f01$var$proto && !$75c23011e1e94f01$var$proto[$75c23011e1e94f01$var$TO_STRING_TAG]) $1XBAS($75c23011e1e94f01$var$proto, $75c23011e1e94f01$var$TO_STRING_TAG, $75c23011e1e94f01$var$NAME);
    $aODcA[$75c23011e1e94f01$var$NAME] = $aODcA.Array;
}

});
parcelRegister("lP6GC", function(module, exports) {
'use strict';

var $aWD6E = parcelRequire("aWD6E");

var $1Kz5Q = parcelRequire("1Kz5Q");

var $aODcA = parcelRequire("aODcA");

var $2hx6g = parcelRequire("2hx6g");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = (parcelRequire("1MYRJ"))(Array, 'Array', function(iterated, kind) {
    this._t = $2hx6g(iterated); // target
    this._i = 0; // next index
    this._k = kind; // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function() {
    var O = this._t;
    var kind = this._k;
    var index = this._i++;
    if (!O || index >= O.length) {
        this._t = undefined;
        return $1Kz5Q(1);
    }
    if (kind == 'keys') return $1Kz5Q(0, index);
    if (kind == 'values') return $1Kz5Q(0, O[index]);
    return $1Kz5Q(0, [
        index,
        O[index]
    ]);
}, 'values');
// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
$aODcA.Arguments = $aODcA.Array;
$aWD6E('keys');
$aWD6E('values');
$aWD6E('entries');

});
parcelRegister("aWD6E", function(module, exports) {
module.exports = function() {};

});

parcelRegister("1Kz5Q", function(module, exports) {
module.exports = function(done, value) {
    return {
        value: value,
        done: !!done
    };
};

});



parcelRegister("iY0Fa", function(module, exports) {
$parcel$export(module.exports, "f", function () { return $dcee583f97a923c0$export$2d1720544b23b823; }, function (v) { return $dcee583f97a923c0$export$2d1720544b23b823 = v; });
var $dcee583f97a923c0$export$2d1720544b23b823;

$dcee583f97a923c0$export$2d1720544b23b823 = (parcelRequire("9xDAg"));

});



parcelRegister("7xVAR", function(module, exports) {

module.exports = {
    "default": (parcelRequire("iI7gd")),
    __esModule: true
};

});
parcelRegister("iI7gd", function(module, exports) {
parcelRequire("99gPT");
parcelRequire("cPEqH");
parcelRequire("9qJRy");
parcelRequire("lm1z6");

module.exports = (parcelRequire("23f7N")).Symbol;

});
parcelRegister("99gPT", function(module, exports) {
'use strict';

var $4FFa4 = parcelRequire("4FFa4");

var $763mL = parcelRequire("763mL");

var $2PPTD = parcelRequire("2PPTD");

var $6TZmN = parcelRequire("6TZmN");

var $aDsEo = parcelRequire("aDsEo");

var $cj3Wz = parcelRequire("cj3Wz");
var $6a920393d90de711$require$META = $cj3Wz.KEY;

var $hs8hK = parcelRequire("hs8hK");

var $izZ3Q = parcelRequire("izZ3Q");

var $jr22O = parcelRequire("jr22O");

var $hoAgo = parcelRequire("hoAgo");

var $9xDAg = parcelRequire("9xDAg");

var $iY0Fa = parcelRequire("iY0Fa");

var $9PxVb = parcelRequire("9PxVb");

var $8x7zY = parcelRequire("8x7zY");

var $lap9z = parcelRequire("lap9z");

var $5asEa = parcelRequire("5asEa");

var $7QZ8S = parcelRequire("7QZ8S");

var $7tWaA = parcelRequire("7tWaA");

var $2hx6g = parcelRequire("2hx6g");

var $bIV2P = parcelRequire("bIV2P");

var $kKJnZ = parcelRequire("kKJnZ");

var $lmUsf = parcelRequire("lmUsf");

var $76OH6 = parcelRequire("76OH6");

var $k9HHU = parcelRequire("k9HHU");

var $jBejz = parcelRequire("jBejz");

var $19vSD = parcelRequire("19vSD");

var $E0yCE = parcelRequire("E0yCE");
var $6a920393d90de711$var$gOPD = $k9HHU.f;
var $6a920393d90de711$var$dP = $19vSD.f;
var $6a920393d90de711$var$gOPN = $76OH6.f;
var $6a920393d90de711$var$$Symbol = $4FFa4.Symbol;
var $6a920393d90de711$var$$JSON = $4FFa4.JSON;
var $6a920393d90de711$var$_stringify = $6a920393d90de711$var$$JSON && $6a920393d90de711$var$$JSON.stringify;
var $6a920393d90de711$var$PROTOTYPE = 'prototype';
var $6a920393d90de711$var$HIDDEN = $9xDAg('_hidden');
var $6a920393d90de711$var$TO_PRIMITIVE = $9xDAg('toPrimitive');
var $6a920393d90de711$var$isEnum = {}.propertyIsEnumerable;
var $6a920393d90de711$var$SymbolRegistry = $izZ3Q('symbol-registry');
var $6a920393d90de711$var$AllSymbols = $izZ3Q('symbols');
var $6a920393d90de711$var$OPSymbols = $izZ3Q('op-symbols');
var $6a920393d90de711$var$ObjectProto = Object[$6a920393d90de711$var$PROTOTYPE];
var $6a920393d90de711$var$USE_NATIVE = typeof $6a920393d90de711$var$$Symbol == 'function' && !!$jBejz.f;
var $6a920393d90de711$var$QObject = $4FFa4.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var $6a920393d90de711$var$setter = !$6a920393d90de711$var$QObject || !$6a920393d90de711$var$QObject[$6a920393d90de711$var$PROTOTYPE] || !$6a920393d90de711$var$QObject[$6a920393d90de711$var$PROTOTYPE].findChild;
// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var $6a920393d90de711$var$setSymbolDesc = $2PPTD && $hs8hK(function() {
    return $lmUsf($6a920393d90de711$var$dP({}, 'a', {
        get: function() {
            return $6a920393d90de711$var$dP(this, 'a', {
                value: 7
            }).a;
        }
    })).a != 7;
}) ? function(it, key, D) {
    var protoDesc = $6a920393d90de711$var$gOPD($6a920393d90de711$var$ObjectProto, key);
    if (protoDesc) delete $6a920393d90de711$var$ObjectProto[key];
    $6a920393d90de711$var$dP(it, key, D);
    if (protoDesc && it !== $6a920393d90de711$var$ObjectProto) $6a920393d90de711$var$dP($6a920393d90de711$var$ObjectProto, key, protoDesc);
} : $6a920393d90de711$var$dP;
var $6a920393d90de711$var$wrap = function(tag) {
    var sym = $6a920393d90de711$var$AllSymbols[tag] = $lmUsf($6a920393d90de711$var$$Symbol[$6a920393d90de711$var$PROTOTYPE]);
    sym._k = tag;
    return sym;
};
var $6a920393d90de711$var$isSymbol = $6a920393d90de711$var$USE_NATIVE && typeof $6a920393d90de711$var$$Symbol.iterator == 'symbol' ? function(it) {
    return typeof it == 'symbol';
} : function(it) {
    return it instanceof $6a920393d90de711$var$$Symbol;
};
var $6a920393d90de711$var$$defineProperty = function defineProperty(it, key, D) {
    if (it === $6a920393d90de711$var$ObjectProto) $6a920393d90de711$var$$defineProperty($6a920393d90de711$var$OPSymbols, key, D);
    $5asEa(it);
    key = $bIV2P(key, true);
    $5asEa(D);
    if ($763mL($6a920393d90de711$var$AllSymbols, key)) {
        if (!D.enumerable) {
            if (!$763mL(it, $6a920393d90de711$var$HIDDEN)) $6a920393d90de711$var$dP(it, $6a920393d90de711$var$HIDDEN, $kKJnZ(1, {}));
            it[$6a920393d90de711$var$HIDDEN][key] = true;
        } else {
            if ($763mL(it, $6a920393d90de711$var$HIDDEN) && it[$6a920393d90de711$var$HIDDEN][key]) it[$6a920393d90de711$var$HIDDEN][key] = false;
            D = $lmUsf(D, {
                enumerable: $kKJnZ(0, false)
            });
        }
        return $6a920393d90de711$var$setSymbolDesc(it, key, D);
    }
    return $6a920393d90de711$var$dP(it, key, D);
};
var $6a920393d90de711$var$$defineProperties = function defineProperties(it, P) {
    $5asEa(it);
    var keys = $8x7zY(P = $2hx6g(P));
    var i = 0;
    var l = keys.length;
    var key;
    while(l > i)$6a920393d90de711$var$$defineProperty(it, key = keys[i++], P[key]);
    return it;
};
var $6a920393d90de711$var$$create = function create(it, P) {
    return P === undefined ? $lmUsf(it) : $6a920393d90de711$var$$defineProperties($lmUsf(it), P);
};
var $6a920393d90de711$var$$propertyIsEnumerable = function propertyIsEnumerable(key) {
    var E = $6a920393d90de711$var$isEnum.call(this, key = $bIV2P(key, true));
    if (this === $6a920393d90de711$var$ObjectProto && $763mL($6a920393d90de711$var$AllSymbols, key) && !$763mL($6a920393d90de711$var$OPSymbols, key)) return false;
    return E || !$763mL(this, key) || !$763mL($6a920393d90de711$var$AllSymbols, key) || $763mL(this, $6a920393d90de711$var$HIDDEN) && this[$6a920393d90de711$var$HIDDEN][key] ? E : true;
};
var $6a920393d90de711$var$$getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
    it = $2hx6g(it);
    key = $bIV2P(key, true);
    if (it === $6a920393d90de711$var$ObjectProto && $763mL($6a920393d90de711$var$AllSymbols, key) && !$763mL($6a920393d90de711$var$OPSymbols, key)) return;
    var D = $6a920393d90de711$var$gOPD(it, key);
    if (D && $763mL($6a920393d90de711$var$AllSymbols, key) && !($763mL(it, $6a920393d90de711$var$HIDDEN) && it[$6a920393d90de711$var$HIDDEN][key])) D.enumerable = true;
    return D;
};
var $6a920393d90de711$var$$getOwnPropertyNames = function getOwnPropertyNames(it) {
    var names = $6a920393d90de711$var$gOPN($2hx6g(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if (!$763mL($6a920393d90de711$var$AllSymbols, key = names[i++]) && key != $6a920393d90de711$var$HIDDEN && key != $6a920393d90de711$require$META) result.push(key);
    return result;
};
var $6a920393d90de711$var$$getOwnPropertySymbols = function getOwnPropertySymbols(it) {
    var IS_OP = it === $6a920393d90de711$var$ObjectProto;
    var names = $6a920393d90de711$var$gOPN(IS_OP ? $6a920393d90de711$var$OPSymbols : $2hx6g(it));
    var result = [];
    var i = 0;
    var key;
    while(names.length > i)if ($763mL($6a920393d90de711$var$AllSymbols, key = names[i++]) && (IS_OP ? $763mL($6a920393d90de711$var$ObjectProto, key) : true)) result.push($6a920393d90de711$var$AllSymbols[key]);
    return result;
};



// 19.4.1.1 Symbol([description])
if (!$6a920393d90de711$var$USE_NATIVE) {
    $6a920393d90de711$var$$Symbol = function Symbol() {
        if (this instanceof $6a920393d90de711$var$$Symbol) throw TypeError('Symbol is not a constructor!');
        var tag = $hoAgo(arguments.length > 0 ? arguments[0] : undefined);
        var $set = function(value) {
            if (this === $6a920393d90de711$var$ObjectProto) $set.call($6a920393d90de711$var$OPSymbols, value);
            if ($763mL(this, $6a920393d90de711$var$HIDDEN) && $763mL(this[$6a920393d90de711$var$HIDDEN], tag)) this[$6a920393d90de711$var$HIDDEN][tag] = false;
            $6a920393d90de711$var$setSymbolDesc(this, tag, $kKJnZ(1, value));
        };
        if ($2PPTD && $6a920393d90de711$var$setter) $6a920393d90de711$var$setSymbolDesc($6a920393d90de711$var$ObjectProto, tag, {
            configurable: true,
            set: $set
        });
        return $6a920393d90de711$var$wrap(tag);
    };
    $aDsEo($6a920393d90de711$var$$Symbol[$6a920393d90de711$var$PROTOTYPE], 'toString', function toString() {
        return this._k;
    });
    $k9HHU.f = $6a920393d90de711$var$$getOwnPropertyDescriptor;
    $19vSD.f = $6a920393d90de711$var$$defineProperty;
    (parcelRequire("bZLYs")).f = $76OH6.f = $6a920393d90de711$var$$getOwnPropertyNames;
    (parcelRequire("gGh3r")).f = $6a920393d90de711$var$$propertyIsEnumerable;
    $jBejz.f = $6a920393d90de711$var$$getOwnPropertySymbols;
    if ($2PPTD && !(parcelRequire("jHsIx"))) $aDsEo($6a920393d90de711$var$ObjectProto, 'propertyIsEnumerable', $6a920393d90de711$var$$propertyIsEnumerable, true);
    $iY0Fa.f = function(name) {
        return $6a920393d90de711$var$wrap($9xDAg(name));
    };
}
$6TZmN($6TZmN.G + $6TZmN.W + $6TZmN.F * !$6a920393d90de711$var$USE_NATIVE, {
    Symbol: $6a920393d90de711$var$$Symbol
});
for(var $6a920393d90de711$var$es6Symbols = // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), $6a920393d90de711$var$j = 0; $6a920393d90de711$var$es6Symbols.length > $6a920393d90de711$var$j;)$9xDAg($6a920393d90de711$var$es6Symbols[$6a920393d90de711$var$j++]);
for(var $6a920393d90de711$var$wellKnownSymbols = $E0yCE($9xDAg.store), $6a920393d90de711$var$k = 0; $6a920393d90de711$var$wellKnownSymbols.length > $6a920393d90de711$var$k;)$9PxVb($6a920393d90de711$var$wellKnownSymbols[$6a920393d90de711$var$k++]);
$6TZmN($6TZmN.S + $6TZmN.F * !$6a920393d90de711$var$USE_NATIVE, 'Symbol', {
    // 19.4.2.1 Symbol.for(key)
    'for': function(key) {
        return $763mL($6a920393d90de711$var$SymbolRegistry, key += '') ? $6a920393d90de711$var$SymbolRegistry[key] : $6a920393d90de711$var$SymbolRegistry[key] = $6a920393d90de711$var$$Symbol(key);
    },
    // 19.4.2.5 Symbol.keyFor(sym)
    keyFor: function keyFor(sym) {
        if (!$6a920393d90de711$var$isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
        for(var key in $6a920393d90de711$var$SymbolRegistry)if ($6a920393d90de711$var$SymbolRegistry[key] === sym) return key;
    },
    useSetter: function() {
        $6a920393d90de711$var$setter = true;
    },
    useSimple: function() {
        $6a920393d90de711$var$setter = false;
    }
});
$6TZmN($6TZmN.S + $6TZmN.F * !$6a920393d90de711$var$USE_NATIVE, 'Object', {
    // 19.1.2.2 Object.create(O [, Properties])
    create: $6a920393d90de711$var$$create,
    // 19.1.2.4 Object.defineProperty(O, P, Attributes)
    defineProperty: $6a920393d90de711$var$$defineProperty,
    // 19.1.2.3 Object.defineProperties(O, Properties)
    defineProperties: $6a920393d90de711$var$$defineProperties,
    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
    getOwnPropertyDescriptor: $6a920393d90de711$var$$getOwnPropertyDescriptor,
    // 19.1.2.7 Object.getOwnPropertyNames(O)
    getOwnPropertyNames: $6a920393d90de711$var$$getOwnPropertyNames,
    // 19.1.2.8 Object.getOwnPropertySymbols(O)
    getOwnPropertySymbols: $6a920393d90de711$var$$getOwnPropertySymbols
});
// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var $6a920393d90de711$var$FAILS_ON_PRIMITIVES = $hs8hK(function() {
    $jBejz.f(1);
});
$6TZmN($6TZmN.S + $6TZmN.F * $6a920393d90de711$var$FAILS_ON_PRIMITIVES, 'Object', {
    getOwnPropertySymbols: function getOwnPropertySymbols(it) {
        return $jBejz.f($7tWaA(it));
    }
});
// 24.3.2 JSON.stringify(value [, replacer [, space]])
$6a920393d90de711$var$$JSON && $6TZmN($6TZmN.S + $6TZmN.F * (!$6a920393d90de711$var$USE_NATIVE || $hs8hK(function() {
    var S = $6a920393d90de711$var$$Symbol();
    // MS Edge converts symbol values to JSON as {}
    // WebKit converts symbol values to JSON as null
    // V8 throws on boxed symbols
    return $6a920393d90de711$var$_stringify([
        S
    ]) != '[null]' || $6a920393d90de711$var$_stringify({
        a: S
    }) != '{}' || $6a920393d90de711$var$_stringify(Object(S)) != '{}';
})), 'JSON', {
    stringify: function stringify(it) {
        var args = [
            it
        ];
        var i = 1;
        var replacer, $replacer;
        while(arguments.length > i)args.push(arguments[i++]);
        $replacer = replacer = args[1];
        if (!$7QZ8S(replacer) && it === undefined || $6a920393d90de711$var$isSymbol(it)) return; // IE8 returns string on undefined
        if (!$lap9z(replacer)) replacer = function(key, value) {
            if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
            if (!$6a920393d90de711$var$isSymbol(value)) return value;
        };
        args[1] = replacer;
        return $6a920393d90de711$var$_stringify.apply($6a920393d90de711$var$$JSON, args);
    }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$6a920393d90de711$var$$Symbol[$6a920393d90de711$var$PROTOTYPE][$6a920393d90de711$var$TO_PRIMITIVE] || (parcelRequire("1XBAS"))($6a920393d90de711$var$$Symbol[$6a920393d90de711$var$PROTOTYPE], $6a920393d90de711$var$TO_PRIMITIVE, $6a920393d90de711$var$$Symbol[$6a920393d90de711$var$PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
$jr22O($6a920393d90de711$var$$Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
$jr22O(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
$jr22O($4FFa4.JSON, 'JSON', true);

});
parcelRegister("cj3Wz", function(module, exports) {

var $8f5a5183b2bf41cd$var$META = (parcelRequire("hoAgo"))('meta');

var $7QZ8S = parcelRequire("7QZ8S");

var $763mL = parcelRequire("763mL");

var $19vSD = parcelRequire("19vSD");
var $8f5a5183b2bf41cd$require$setDesc = $19vSD.f;
var $8f5a5183b2bf41cd$var$id = 0;
var $8f5a5183b2bf41cd$var$isExtensible = Object.isExtensible || function() {
    return true;
};

var $8f5a5183b2bf41cd$var$FREEZE = !(parcelRequire("hs8hK"))(function() {
    return $8f5a5183b2bf41cd$var$isExtensible(Object.preventExtensions({}));
});
var $8f5a5183b2bf41cd$var$setMeta = function(it) {
    $8f5a5183b2bf41cd$require$setDesc(it, $8f5a5183b2bf41cd$var$META, {
        value: {
            i: 'O' + ++$8f5a5183b2bf41cd$var$id,
            w: {} // weak collections IDs
        }
    });
};
var $8f5a5183b2bf41cd$var$fastKey = function(it, create) {
    // return primitive with prefix
    if (!$7QZ8S(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
    if (!$763mL(it, $8f5a5183b2bf41cd$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$8f5a5183b2bf41cd$var$isExtensible(it)) return 'F';
        // not necessary to add metadata
        if (!create) return 'E';
        // add missing metadata
        $8f5a5183b2bf41cd$var$setMeta(it);
    // return object ID
    }
    return it[$8f5a5183b2bf41cd$var$META].i;
};
var $8f5a5183b2bf41cd$var$getWeak = function(it, create) {
    if (!$763mL(it, $8f5a5183b2bf41cd$var$META)) {
        // can't set metadata to uncaught frozen object
        if (!$8f5a5183b2bf41cd$var$isExtensible(it)) return true;
        // not necessary to add metadata
        if (!create) return false;
        // add missing metadata
        $8f5a5183b2bf41cd$var$setMeta(it);
    // return hash weak collections IDs
    }
    return it[$8f5a5183b2bf41cd$var$META].w;
};
// add metadata on freeze-family methods calling
var $8f5a5183b2bf41cd$var$onFreeze = function(it) {
    if ($8f5a5183b2bf41cd$var$FREEZE && $8f5a5183b2bf41cd$var$meta.NEED && $8f5a5183b2bf41cd$var$isExtensible(it) && !$763mL(it, $8f5a5183b2bf41cd$var$META)) $8f5a5183b2bf41cd$var$setMeta(it);
    return it;
};
var $8f5a5183b2bf41cd$var$meta = module.exports = {
    KEY: $8f5a5183b2bf41cd$var$META,
    NEED: false,
    fastKey: $8f5a5183b2bf41cd$var$fastKey,
    getWeak: $8f5a5183b2bf41cd$var$getWeak,
    onFreeze: $8f5a5183b2bf41cd$var$onFreeze
};

});

parcelRegister("9PxVb", function(module, exports) {

var $4FFa4 = parcelRequire("4FFa4");

var $23f7N = parcelRequire("23f7N");

var $jHsIx = parcelRequire("jHsIx");

var $iY0Fa = parcelRequire("iY0Fa");

var $19vSD = parcelRequire("19vSD");
var $72833089d3e03b7a$require$defineProperty = $19vSD.f;
module.exports = function(name) {
    var $Symbol = $23f7N.Symbol || ($23f7N.Symbol = $jHsIx ? {} : $4FFa4.Symbol || {});
    if (name.charAt(0) != '_' && !(name in $Symbol)) $72833089d3e03b7a$require$defineProperty($Symbol, name, {
        value: $iY0Fa.f(name)
    });
};

});

parcelRegister("8x7zY", function(module, exports) {
// all enumerable object keys, includes symbols

var $E0yCE = parcelRequire("E0yCE");

var $jBejz = parcelRequire("jBejz");

var $gGh3r = parcelRequire("gGh3r");
module.exports = function(it) {
    var result = $E0yCE(it);
    var getSymbols = $jBejz.f;
    if (getSymbols) {
        var symbols = getSymbols(it);
        var isEnum = $gGh3r.f;
        var i = 0;
        var key;
        while(symbols.length > i)if (isEnum.call(it, key = symbols[i++])) result.push(key);
    }
    return result;
};

});

parcelRegister("lap9z", function(module, exports) {
// 7.2.2 IsArray(argument)

var $gNg6c = parcelRequire("gNg6c");
module.exports = Array.isArray || function isArray(arg) {
    return $gNg6c(arg) == 'Array';
};

});

parcelRegister("76OH6", function(module, exports) {
$parcel$export(module.exports, "f", function () { return $52d06ac0be21d279$export$2d1720544b23b823; }, function (v) { return $52d06ac0be21d279$export$2d1720544b23b823 = v; });
// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var $52d06ac0be21d279$export$2d1720544b23b823;

var $2hx6g = parcelRequire("2hx6g");

var $bZLYs = parcelRequire("bZLYs");
var $52d06ac0be21d279$require$gOPN = $bZLYs.f;
var $52d06ac0be21d279$var$toString = {}.toString;
var $52d06ac0be21d279$var$windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
var $52d06ac0be21d279$var$getWindowNames = function(it) {
    try {
        return $52d06ac0be21d279$require$gOPN(it);
    } catch (e) {
        return $52d06ac0be21d279$var$windowNames.slice();
    }
};
$52d06ac0be21d279$export$2d1720544b23b823 = function getOwnPropertyNames(it) {
    return $52d06ac0be21d279$var$windowNames && $52d06ac0be21d279$var$toString.call(it) == '[object Window]' ? $52d06ac0be21d279$var$getWindowNames(it) : $52d06ac0be21d279$require$gOPN($2hx6g(it));
};

});
parcelRegister("bZLYs", function(module, exports) {
$parcel$export(module.exports, "f", function () { return $8bba9ae47cc7daf1$export$2d1720544b23b823; }, function (v) { return $8bba9ae47cc7daf1$export$2d1720544b23b823 = v; });
// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $8bba9ae47cc7daf1$export$2d1720544b23b823;

var $64rCp = parcelRequire("64rCp");

var $8bba9ae47cc7daf1$var$hiddenKeys = (parcelRequire("f5whe")).concat('length', 'prototype');
$8bba9ae47cc7daf1$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $64rCp(O, $8bba9ae47cc7daf1$var$hiddenKeys);
};

});


parcelRegister("k9HHU", function(module, exports) {
$parcel$export(module.exports, "f", function () { return $eac68d442f70e4ee$export$2d1720544b23b823; }, function (v) { return $eac68d442f70e4ee$export$2d1720544b23b823 = v; });
var $eac68d442f70e4ee$export$2d1720544b23b823;

var $gGh3r = parcelRequire("gGh3r");

var $kKJnZ = parcelRequire("kKJnZ");

var $2hx6g = parcelRequire("2hx6g");

var $bIV2P = parcelRequire("bIV2P");

var $763mL = parcelRequire("763mL");

var $1Vpr5 = parcelRequire("1Vpr5");
var $eac68d442f70e4ee$var$gOPD = Object.getOwnPropertyDescriptor;

$eac68d442f70e4ee$export$2d1720544b23b823 = (parcelRequire("2PPTD")) ? $eac68d442f70e4ee$var$gOPD : function getOwnPropertyDescriptor(O, P) {
    O = $2hx6g(O);
    P = $bIV2P(P, true);
    if ($1Vpr5) try {
        return $eac68d442f70e4ee$var$gOPD(O, P);
    } catch (e) {}
    if ($763mL(O, P)) return $kKJnZ(!$gGh3r.f.call(O, P), O[P]);
};

});


parcelRegister("cPEqH", function(module, exports) {

});

parcelRegister("9qJRy", function(module, exports) {

(parcelRequire("9PxVb"))('asyncIterator');

});

parcelRegister("lm1z6", function(module, exports) {

(parcelRequire("9PxVb"))('observable');

});





parcelRegister("fpmbk", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "__esModule", function () { return $b37a659efa5f0475$export$1e511d4a378977f5; }, function (v) { return $b37a659efa5f0475$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $b37a659efa5f0475$export$2e2bcd8739ae039; }, function (v) { return $b37a659efa5f0475$export$2e2bcd8739ae039 = v; });
var $b37a659efa5f0475$export$1e511d4a378977f5;
var $b37a659efa5f0475$export$2e2bcd8739ae039;
"use strict";
$b37a659efa5f0475$export$1e511d4a378977f5 = true;

var $iwWa6 = parcelRequire("iwWa6");
var $b37a659efa5f0475$var$_setPrototypeOf2 = $b37a659efa5f0475$var$_interopRequireDefault($iwWa6);

var $eTqtS = parcelRequire("eTqtS");
var $b37a659efa5f0475$var$_create2 = $b37a659efa5f0475$var$_interopRequireDefault($eTqtS);

var $frdl0 = parcelRequire("frdl0");
var $b37a659efa5f0475$var$_typeof3 = $b37a659efa5f0475$var$_interopRequireDefault($frdl0);
function $b37a659efa5f0475$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$b37a659efa5f0475$export$2e2bcd8739ae039 = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, $b37a659efa5f0475$var$_typeof3.default)(superClass)));
    subClass.prototype = (0, $b37a659efa5f0475$var$_create2.default)(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $b37a659efa5f0475$var$_setPrototypeOf2.default ? (0, $b37a659efa5f0475$var$_setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

});
parcelRegister("iwWa6", function(module, exports) {

module.exports = {
    "default": (parcelRequire("13ZIY")),
    __esModule: true
};

});
parcelRegister("13ZIY", function(module, exports) {
parcelRequire("asvPg");

module.exports = (parcelRequire("23f7N")).Object.setPrototypeOf;

});
parcelRegister("asvPg", function(module, exports) {
// 19.1.3.19 Object.setPrototypeOf(O, proto)

var $6TZmN = parcelRequire("6TZmN");

$6TZmN($6TZmN.S, 'Object', {
    setPrototypeOf: (parcelRequire("5BFbR")).set
});

});
parcelRegister("5BFbR", function(module, exports) {
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */ 
var $7QZ8S = parcelRequire("7QZ8S");

var $5asEa = parcelRequire("5asEa");
var $41505bfbff01f966$var$check = function(O, proto) {
    $5asEa(O);
    if (!$7QZ8S(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};


module.exports = {
    set: Object.setPrototypeOf || ('__proto__' in {} ? function(test, buggy, set) {
        try {
            set = (parcelRequire("04VsN"))(Function.call, (parcelRequire("k9HHU")).f(Object.prototype, '__proto__').set, 2);
            set(test, []);
            buggy = !(test instanceof Array);
        } catch (e) {
            buggy = true;
        }
        return function setPrototypeOf(O, proto) {
            $41505bfbff01f966$var$check(O, proto);
            if (buggy) O.__proto__ = proto;
            else set(O, proto);
            return O;
        };
    }({}, false) : undefined),
    check: $41505bfbff01f966$var$check
};

});




parcelRegister("eTqtS", function(module, exports) {

module.exports = {
    "default": (parcelRequire("cFZmJ")),
    __esModule: true
};

});
parcelRegister("cFZmJ", function(module, exports) {
parcelRequire("fj7wp");

var $23f7N = parcelRequire("23f7N");
var $93a8ea4cff4cea96$require$$Object = $23f7N.Object;
module.exports = function create(P, D) {
    return $93a8ea4cff4cea96$require$$Object.create(P, D);
};

});
parcelRegister("fj7wp", function(module, exports) {

var $6TZmN = parcelRequire("6TZmN");

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$6TZmN($6TZmN.S, 'Object', {
    create: (parcelRequire("lmUsf"))
});

});





parcelRegister("61pdb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e5437a6fa40a6a5e2291c258b3bd34ef>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $46266490593ddb94$var$_react = $46266490593ddb94$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $46266490593ddb94$var$_baseNew = $46266490593ddb94$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $46266490593ddb94$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $46266490593ddb94$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $46266490593ddb94$var$_react.default.createElement($46266490593ddb94$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m13.959 3.97-7.25 9a.75.75 0 0 1-1.163.007l-3.5-4.25 1.158-.954 2.914 3.539 6.673-8.283z"/>`
    }, props));
$46266490593ddb94$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $46266490593ddb94$var$_default = module.exports.default = $46266490593ddb94$var$CheckMarkIcon;

});

parcelRegister("53VCz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3af9ede7fd56ccc9$var$_react = $3af9ede7fd56ccc9$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3af9ede7fd56ccc9$var$_baseNew = $3af9ede7fd56ccc9$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $3af9ede7fd56ccc9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3af9ede7fd56ccc9$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $3af9ede7fd56ccc9$var$_react.default.createElement($3af9ede7fd56ccc9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$3af9ede7fd56ccc9$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $3af9ede7fd56ccc9$var$_default = module.exports.default = $3af9ede7fd56ccc9$var$ArrowRightIcon;

});

parcelRegister("bIY3n", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e570c2c471e9f2c44e5e57e4d5245eb9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8892631fc819236e$var$_react = $8892631fc819236e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $8892631fc819236e$var$_baseNew = $8892631fc819236e$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $8892631fc819236e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Add".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for creating and adding an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8892631fc819236e$var$AddIcon = (props)=>/*#__PURE__*/ $8892631fc819236e$var$_react.default.createElement($8892631fc819236e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 8.75V15h1.5V8.75H15v-1.5H8.75V1h-1.5v6.25H1v1.5z" clip-rule="evenodd"/>`
    }, props));
$8892631fc819236e$var$AddIcon.displayName = 'AddIcon';
var $8892631fc819236e$var$_default = module.exports.default = $8892631fc819236e$var$AddIcon;

});

parcelRegister("4jcRW", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3232eb4c0efd91e0$export$2e2bcd8739ae039; });
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $c9bqK = parcelRequire("c9bqK");

var $f53LC = parcelRequire("f53LC");

var $1oC0p = parcelRequire("1oC0p");

var $7DAIH = parcelRequire("7DAIH");
var $dtlzK = parcelRequire("dtlzK");
function $3232eb4c0efd91e0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3232eb4c0efd91e0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3232eb4c0efd91e0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $f53LC.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3232eb4c0efd91e0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3232eb4c0efd91e0$var$shimmerKeyframes = null;
var $3232eb4c0efd91e0$var$skeletonStyles = null;
var $3232eb4c0efd91e0$var$activeShimmerStyles = null;
/**
 * __Skeleton__
 *
 * A skeleton acts as a placeholder for content, usually while the content loads.
 *
 * - [Examples](https://atlassian.design/components/skeleton/examples)
 * - [Code](https://atlassian.design/components/skeleton/code)
 */ var $3232eb4c0efd91e0$var$Skeleton = function Skeleton(_ref) {
    var width = _ref.width, height = _ref.height, _ref$borderRadius = _ref.borderRadius, borderRadius = _ref$borderRadius === void 0 ? "var(--ds-radius-small, 4px)" : _ref$borderRadius, color = _ref.color, ShimmeringEndColor = _ref.ShimmeringEndColor, _ref$isShimmering = _ref.isShimmering, isShimmering = _ref$isShimmering === void 0 ? false : _ref$isShimmering, groupName = _ref.groupName, testId = _ref.testId;
    var groupDataAttribute = groupName && "data-".concat(groupName);
    return /*#__PURE__*/ $1oC0p.createElement("div", (0, $c9bqK.default)({
        "data-testid": testId
    }, groupDataAttribute && (0, $f53LC.default)({}, groupDataAttribute, 'true'), {
        className: (0, $7DAIH.default)([
            "_7hjf1yy8 _5sag12o8 _tip812c5 _1pglp3kn _bfhkn82g",
            isShimmering && "",
            isShimmering && "_j7hq586c"
        ]),
        style: $3232eb4c0efd91e0$var$_objectSpread($3232eb4c0efd91e0$var$_objectSpread({}, {
            width: width,
            height: height,
            borderRadius: borderRadius,
            backgroundColor: color,
            // Override the keyframes if both colors are provided, otherwise use the CSS variable fallbacks in our keyframes
            '--ds-skeleton-from-color': color && ShimmeringEndColor ? color : undefined,
            '--ds-skeleton-to-color': color && ShimmeringEndColor ? ShimmeringEndColor : undefined
        }), {}, {
            "--_wenvhl": (0, $dtlzK.default)("var(--ds-skeleton-from-color, ".concat("var(--ds-skeleton, #091E420F)", ")")),
            "--_1soe2er": (0, $dtlzK.default)("var(--ds-skeleton-to-color, ".concat("var(--ds-skeleton-subtle, #091E4208)", ")"))
        })
    }));
};
var $3232eb4c0efd91e0$export$2e2bcd8739ae039 = $3232eb4c0efd91e0$var$Skeleton;

});
parcelRegister("7DAIH", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $58f8a8b7a32ab166$export$2e2bcd8739ae039; });
/**
 * This length includes the underscore,
 * e.g. `"_1s4A"` would be a valid atomic group hash.
 */ const $58f8a8b7a32ab166$var$ATOMIC_GROUP_LENGTH = 5;
function $58f8a8b7a32ab166$export$2e2bcd8739ae039(classNames) {
    // Shortcut: nothing to do
    if (!classNames.length) return;
    // Shortcut: don't need to do anything if we only have a single classname
    if (classNames.length === 1 && classNames[0] && // checking to see if `classNames[0]` is a string that contains other classnames
    !classNames[0].includes(' ')) return classNames[0];
    // Using an object rather than a `Map` as it performed better in our benchmarks.
    // Would be happy to move to `Map` if it proved to be better under real conditions.
    const map = {};
    // Note: using loops to minimize iterations over the collection
    for (const value of classNames){
        // Exclude all falsy values, which leaves us with populated strings
        if (!value) continue;
        // a `value` can contain multiple classnames
        const list = value.split(' ');
        for (const className of list){
            /**
             * For atomic style classnames: the `key` is the `group`
             *
             * - Later atomic classnames with the same `group` will override earlier ones
             *   (which is what we want).
             * - Assumes atomic classnames are the only things that start with `_`
             * - Could use a regex to ensure that atomic classnames are structured how we expect,
             *   but did not add that for now as it did slow things down a bit.
             *
             * For other classnames: the `key` is the whole classname
             * - Okay to remove duplicates as doing so does not impact specificity
             *
             * */ const key = className.startsWith('_') ? className.slice(0, $58f8a8b7a32ab166$var$ATOMIC_GROUP_LENGTH) : className;
            map[key] = className;
        }
    }
    /**
     * We are converting the `map` into a string.
     *
     * The simple way to do this would be `Object.values(map).join(' ')`.
     * However, the approach below performs 10%-20% better in benchmarks.
     *
     * For `ax()` it feels right to squeeze as much runtime performance out as we can.
     */ let result = '';
    for(const key in map)result += map[key] + ' ';
    // If we have an empty string, then our `map` was empty.
    if (!result) return;
    // remove last " " from the result (we added " " at the end of every value)
    return result.trimEnd();
}

});

parcelRegister("dtlzK", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $9ceeb844cdd8c978$export$2e2bcd8739ae039; });
/**
 * Returns a CSS custom property value with an optional suffix & prefix.
 * Prefix will only be added if there is a suffix.
 * If the value is undefined a fallback value will be returned to prevent children inheriting parent values.
 *
 * @param value
 * @param suffix
 * @param prefix
 */ function $9ceeb844cdd8c978$export$2e2bcd8739ae039(value, suffix, prefix) {
    if (value != undefined) {
        if (suffix) {
            if (prefix) return prefix + value + suffix;
            return value + suffix;
        }
        return value;
    }
    // Currently React trims these values so we can't use a space " " to block the value.
    // Instead we use a CSS variable that doesn't exist which falls back to " ".
    // Bug raised here: https://github.com/facebook/react/issues/20497
    return 'var(--c-, )';
}

});


parcelRegister("l5ucJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::55c6484ab5ceb86b7f950bb9205e88a3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f5a17e8d4d565048$var$_react = $f5a17e8d4d565048$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f5a17e8d4d565048$var$_baseNew = $f5a17e8d4d565048$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $f5a17e8d4d565048$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDown".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Do not use 16px chevrons within buttons, icon buttons, or dropdowns to maintain visual cohesion with ADS which uses 12px chevrons.
Known uses: Open dropdown menu, expanded tree item, collapse tree item
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f5a17e8d4d565048$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $f5a17e8d4d565048$var$_react.default.createElement($f5a17e8d4d565048$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m14.53 6.03-6 6a.75.75 0 0 1-1.004.052l-.056-.052-6-6 1.06-1.06L8 10.44l5.47-5.47z"/>`
    }, props));
$f5a17e8d4d565048$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $f5a17e8d4d565048$var$_default = module.exports.default = $f5a17e8d4d565048$var$ChevronDownIcon;

});

parcelRegister("97j0t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bfc058bc597636775f186a66702ef9b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6a3382d00f416b95$var$_react = $6a3382d00f416b95$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6a3382d00f416b95$var$_baseNew = $6a3382d00f416b95$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $6a3382d00f416b95$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Board".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for boards in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6a3382d00f416b95$var$BoardIcon = (props)=>/*#__PURE__*/ $6a3382d00f416b95$var$_react.default.createElement($6a3382d00f416b95$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h2.833v-9zm4.333 0v9h3.334v-9zm4.834 0v9H14a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$6a3382d00f416b95$var$BoardIcon.displayName = 'BoardIcon';
var $6a3382d00f416b95$var$_default = module.exports.default = $6a3382d00f416b95$var$BoardIcon;

});

parcelRegister("auF8s", function(module, exports) {

var $4jLK2 = parcelRequire("4jLK2");

var $e06LX = parcelRequire("e06LX");
/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $7a3c9d6218c43abc$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $e06LX);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $7a3c9d6218c43abc$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $4jLK2(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
module.exports = $7a3c9d6218c43abc$var$baseFlatten;

});
parcelRegister("e06LX", function(module, exports) {

var $3MHuE = parcelRequire("3MHuE");

var $8E4Q5 = parcelRequire("8E4Q5");

var $lPKNl = parcelRequire("lPKNl");
/** Built-in value references. */ var $a31651a1aa52b9f5$var$spreadableSymbol = $3MHuE ? $3MHuE.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $a31651a1aa52b9f5$var$isFlattenable(value) {
    return $lPKNl(value) || $8E4Q5(value) || !!($a31651a1aa52b9f5$var$spreadableSymbol && value && value[$a31651a1aa52b9f5$var$spreadableSymbol]);
}
module.exports = $a31651a1aa52b9f5$var$isFlattenable;

});


parcelRegister("5oMeU", function(module, exports) {

var $hLLeA = parcelRequire("hLLeA");

var $119FI = parcelRequire("119FI");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $3ee49cf968a053d8$var$baseGet(object, path) {
    path = $hLLeA(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$119FI(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = $3ee49cf968a053d8$var$baseGet;

});

parcelRegister("4EAwS", function(module, exports) {

var $5oMeU = parcelRequire("5oMeU");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $36373bd43f9f4b21$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $5oMeU(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = $36373bd43f9f4b21$var$get;

});

parcelRegister("8avIg", function(module, exports) {

var $90xK9 = parcelRequire("90xK9");

var $eW6W4 = parcelRequire("eW6W4");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $5f27db6f2fb2ce7d$var$hasIn(object, path) {
    return object != null && $eW6W4(object, path, $90xK9);
}
module.exports = $5f27db6f2fb2ce7d$var$hasIn;

});
parcelRegister("90xK9", function(module, exports) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $68ee49e62966a7ed$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = $68ee49e62966a7ed$var$baseHasIn;

});

parcelRegister("eW6W4", function(module, exports) {

var $hLLeA = parcelRequire("hLLeA");

var $8E4Q5 = parcelRequire("8E4Q5");

var $lPKNl = parcelRequire("lPKNl");

var $f6osf = parcelRequire("f6osf");

var $cTpmH = parcelRequire("cTpmH");

var $119FI = parcelRequire("119FI");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $adfbdcbd1c5e47b6$var$hasPath(object, path, hasFunc) {
    path = $hLLeA(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $119FI(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $cTpmH(length) && $f6osf(key, length) && ($lPKNl(object) || $8E4Q5(object));
}
module.exports = $adfbdcbd1c5e47b6$var$hasPath;

});


parcelRegister("1f5iV", function(module, exports) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $0e7b4e76421e80bb$var$identity(value) {
    return value;
}
module.exports = $0e7b4e76421e80bb$var$identity;

});

parcelRegister("axmYb", function(module, exports) {

var $3ls0q = parcelRequire("3ls0q");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7abecdc323c478eb$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $7abecdc323c478eb$var$overRest(func, start, transform) {
    start = $7abecdc323c478eb$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $7abecdc323c478eb$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $3ls0q(func, this, otherArgs);
    };
}
module.exports = $7abecdc323c478eb$var$overRest;

});
parcelRegister("3ls0q", function(module, exports) {
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $26f90e9ed1e087a4$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
module.exports = $26f90e9ed1e087a4$var$apply;

});


parcelRegister("jj29P", function(module, exports) {

var $j199U = parcelRequire("j199U");

var $i9M4A = parcelRequire("i9M4A");
/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $e0e17718533c241f$var$setToString = $i9M4A($j199U);
module.exports = $e0e17718533c241f$var$setToString;

});
parcelRegister("j199U", function(module, exports) {

var $3Kt5H = parcelRequire("3Kt5H");

var $cmtMX = parcelRequire("cmtMX");

var $1f5iV = parcelRequire("1f5iV");
/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $dd85370c1f08aaa6$var$baseSetToString = !$cmtMX ? $1f5iV : function(func, string) {
    return $cmtMX(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': $3Kt5H(string),
        'writable': true
    });
};
module.exports = $dd85370c1f08aaa6$var$baseSetToString;

});
parcelRegister("3Kt5H", function(module, exports) {
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $2bac3bd7f8fc3bd7$var$constant(value) {
    return function() {
        return value;
    };
}
module.exports = $2bac3bd7f8fc3bd7$var$constant;

});


parcelRegister("i9M4A", function(module, exports) {
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $d37e5b869faf8491$var$HOT_COUNT = 800, $d37e5b869faf8491$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d37e5b869faf8491$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $d37e5b869faf8491$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $d37e5b869faf8491$var$nativeNow(), remaining = $d37e5b869faf8491$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $d37e5b869faf8491$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
module.exports = $d37e5b869faf8491$var$shortOut;

});


parcelRegister("l23yj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::69f4e6f87c1306b0b7d1107d65930cc1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f4fc8a53b23a3baa$var$_react = $f4fc8a53b23a3baa$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f4fc8a53b23a3baa$var$_baseNew = $f4fc8a53b23a3baa$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $f4fc8a53b23a3baa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Person".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a person or user, owner, contributor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f4fc8a53b23a3baa$var$PersonIcon = (props)=>/*#__PURE__*/ $f4fc8a53b23a3baa$var$_react.default.createElement($f4fc8a53b23a3baa$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m-2 9a3.75 3.75 0 0 1 3.75-3.75h4.5A3.75 3.75 0 0 1 14 13v2h-1.5v-2a2.25 2.25 0 0 0-2.25-2.25h-4.5A2.25 2.25 0 0 0 3.5 13v2H2z" clip-rule="evenodd"/>`
    }, props));
$f4fc8a53b23a3baa$var$PersonIcon.displayName = 'PersonIcon';
var $f4fc8a53b23a3baa$var$_default = module.exports.default = $f4fc8a53b23a3baa$var$PersonIcon;

});

parcelRegister("muyyw", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efa63c6a59a6ee993a0458e40fc93a18>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0439c20b3d5f0b35$var$_react = $0439c20b3d5f0b35$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $0439c20b3d5f0b35$var$_baseNew = $0439c20b3d5f0b35$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $0439c20b3d5f0b35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0439c20b3d5f0b35$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $0439c20b3d5f0b35$var$_react.default.createElement($0439c20b3d5f0b35$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m1.22 7.47 5-5 1.06 1.06-3.72 3.72H15v1.5H3.56l3.72 3.72-1.06 1.06-5-5a.75.75 0 0 1 0-1.06" clip-rule="evenodd"/>`
    }, props));
$0439c20b3d5f0b35$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $0439c20b3d5f0b35$var$_default = module.exports.default = $0439c20b3d5f0b35$var$ArrowLeftIcon;

});

parcelRegister("56bcs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3b66335b7827c74c$var$_react = $3b66335b7827c74c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3b66335b7827c74c$var$_baseNew = $3b66335b7827c74c$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $3b66335b7827c74c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3b66335b7827c74c$var$CalendarIcon = (props)=>/*#__PURE__*/ $3b66335b7827c74c$var$_react.default.createElement($3b66335b7827c74c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$3b66335b7827c74c$var$CalendarIcon.displayName = 'CalendarIcon';
var $3b66335b7827c74c$var$_default = module.exports.default = $3b66335b7827c74c$var$CalendarIcon;

});

parcelRegister("gta0F", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::481d1ea8ad85e9d7b0bddff8ba9b16d1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfd71e82ab0194f9$var$_react = $bfd71e82ab0194f9$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $bfd71e82ab0194f9$var$_baseNew = $bfd71e82ab0194f9$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $bfd71e82ab0194f9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListChecklist".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known usages: Checklist, 'Requirement' work type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bfd71e82ab0194f9$var$ListChecklistIcon = (props)=>/*#__PURE__*/ $bfd71e82ab0194f9$var$_react.default.createElement($bfd71e82ab0194f9$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m5.59 9.97-3 3.75a.75.75 0 0 1-1.16.01l-.05-.07-1.37-2.12 1.26-.81.81 1.25 2.33-2.95zm0-7.5-3 3.75a.75.75 0 0 1-1.16.01l-.05-.07L.01 4.04l1.26-.81.81 1.25 2.33-2.95zM16 11v1.5H7V11zm0-7.5V5H7V3.5z"/>`
    }, props));
$bfd71e82ab0194f9$var$ListChecklistIcon.displayName = 'ListChecklistIcon';
var $bfd71e82ab0194f9$var$_default = module.exports.default = $bfd71e82ab0194f9$var$ListChecklistIcon;

});

parcelRegister("bTseT", function(module, exports) {
$parcel$export(module.exports, "IntercomProvider", function () { return $d787a990cb9c57de$export$5091c5023e5c7eba; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $6GqRO = parcelRequire("6GqRO");

var $5Ntyw = parcelRequire("5Ntyw");

var $cIXzQ = parcelRequire("cIXzQ");
const $d787a990cb9c57de$var$isWindowExist = typeof window !== 'undefined';
const $d787a990cb9c57de$export$e578ca56db818a8e = /*#__PURE__*/ $1oC0p.createContext(undefined);
const $d787a990cb9c57de$export$5091c5023e5c7eba = ({ appId: appId, triggerBoot: triggerBoot = false, children: children })=>{
    const isBooted = $1oC0p.useRef(false);
    const isInit = $1oC0p.useRef(false);
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const initIntercomInstance = $1oC0p.useCallback(()=>{
        if (!isInit.current) {
            (0, $cIXzQ.default)(appId);
            isInit.current = true;
        }
    }, [
        appId
    ]);
    // Ensure DOM is fully ready and stable before Intercom initialization
    const ensureDOMReady = $1oC0p.useCallback(()=>{
        return new Promise((resolve)=>{
            if (document.readyState === 'complete') // DOM is ready, but add buffer time for iframe stability
            setTimeout(resolve, 500);
            else {
                // Wait for DOM completion, then add buffer time
                const cleanup = ()=>{
                    document.removeEventListener('DOMContentLoaded', handleLoad);
                    window.removeEventListener('load', handleLoad);
                };
                const handleLoad = ()=>{
                    cleanup();
                    clearTimeout(safetyTimeout);
                    setTimeout(resolve, 500);
                };
                // Add event listeners for DOM ready
                document.addEventListener('DOMContentLoaded', handleLoad);
                window.addEventListener('load', handleLoad);
                // Safety timeout: resolve after 10 seconds even if events don't fire
                const safetyTimeout = setTimeout(()=>{
                    cleanup();
                    console.error('Intercom: DOM ready timeout reached, proceeding anyway');
                    resolve();
                }, 10000);
            }
        });
    }, []);
    const boot = $1oC0p.useCallback(async ()=>{
        if ($d787a990cb9c57de$var$isWindowExist && isInit.current && !isBooted.current) {
            const intercomSettings = window.intercomSettings ?? {
                app_id: appId
            };
            try {
                // Wait for DOM to be fully ready and stable
                await ensureDOMReady();
                window.Intercom?.('boot', {
                    alignment: 'right',
                    horizontal_padding: 20,
                    vertical_padding: 20,
                    custom_launcher_selector: '#intercomLauncher',
                    ...intercomSettings
                });
                window.Intercom?.('trackEvent', 'widget-loaded');
            } catch (error) {
                console.warn('Intercom boot failed:', error);
            } finally{
                isBooted.current = true; // Set value as true to enable functionality of show/hide methods
            }
        }
    }, [
        appId,
        ensureDOMReady
    ]);
    const shutdown = $1oC0p.useCallback(()=>{
        if (!isBooted.current) return;
        if ($d787a990cb9c57de$var$isWindowExist) {
            window.Intercom?.('shutdown');
            delete window.intercomSettings;
            isBooted.current = false;
        }
    }, []);
    const show = $1oC0p.useCallback(()=>{
        if ($d787a990cb9c57de$var$isWindowExist && isBooted.current) window.Intercom?.('show');
    }, []);
    const hide = $1oC0p.useCallback(()=>{
        if ($d787a990cb9c57de$var$isWindowExist && isBooted.current) window.Intercom?.('hide');
    }, []);
    $1oC0p.useEffect(()=>{
        if ($d787a990cb9c57de$var$isWindowExist && triggerBoot) (async function() {
            const intercomSettingsObj = {
                app_id: appId
            };
            const anonId = (0, $6GqRO.default).get('ajs_anonymous_id') || '';
            if (anonId) intercomSettingsObj['anonymousId'] = anonId;
            const getwayApiMeGetResponse = await stargateClient.me({}).catch(()=>null);
            if (getwayApiMeGetResponse) {
                intercomSettingsObj['name'] = getwayApiMeGetResponse.name;
                intercomSettingsObj['email'] = getwayApiMeGetResponse.email;
            }
            if ($d787a990cb9c57de$var$isWindowExist) window.intercomSettings = intercomSettingsObj;
            if (!isInit.current) initIntercomInstance();
            if (isInit.current && !isBooted.current) boot();
        })();
        // clean up code
        return ()=>{
            if (isInit.current) shutdown();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        triggerBoot,
        stargateClient
    ]);
    const providerValue = $1oC0p.useMemo(()=>{
        return {
            initIntercomInstance: initIntercomInstance,
            boot: boot,
            shutdown: shutdown,
            show: show,
            hide: hide
        };
    }, [
        initIntercomInstance,
        boot,
        shutdown,
        show,
        hide
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($d787a990cb9c57de$export$e578ca56db818a8e.Provider, {
        value: providerValue,
        children: children
    });
};
const $d787a990cb9c57de$export$28418e623d2470bc = ()=>{
    const context = $1oC0p.useContext($d787a990cb9c57de$export$e578ca56db818a8e);
    if (context === undefined) throw new Error('This hook must be used within IntercomProvider');
    return context;
};

});
parcelRegister("cIXzQ", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $578d2b441e63143c$export$2e2bcd8739ae039; });
function $578d2b441e63143c$var$isIELikeWindow(w) {
    return Object.prototype.hasOwnProperty.call(w, 'attachEvent');
}
// Function per instruction here: https://developers.intercom.com/installing-intercom/web/installation/
const $578d2b441e63143c$var$initializeIntercomInstance = (appId)=>{
    const w = window;
    const ic = w.Intercom;
    if (typeof ic === 'function') {
        ic('reattach_activator');
        ic('update', w.intercomSettings);
    } else {
        const d = document;
        const i = function() {
            i.c(arguments);
        };
        i.q = [];
        i.c = function(args) {
            i.q.push(args);
        };
        w.Intercom = i;
        const l = function() {
            const s = d.createElement('script');
            s.type = 'text/javascript';
            s.async = true;
            s.src = 'https://widget.intercom.io/widget/' + appId;
            const x = d.getElementsByTagName('script')[0];
            x?.parentNode?.insertBefore(s, x);
        };
        if (document.readyState === 'complete') l();
        else if ($578d2b441e63143c$var$isIELikeWindow(w)) w.attachEvent('onload', l);
        else w.addEventListener('load', l, false);
    }
};
var $578d2b441e63143c$export$2e2bcd8739ae039 = $578d2b441e63143c$var$initializeIntercomInstance;

});


parcelRegister("NtjLk", function(module, exports) {
$parcel$export(module.exports, "Card", function () { return $2da6ff99551ef1ce$export$60332b2344f7fe41; });
/* card.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $iVyKn = parcelRequire("iVyKn");

var $cNOwN = parcelRequire("cNOwN");

var $5kbMC = parcelRequire("5kbMC");

var $FapDU = parcelRequire("FapDU");

var $hnmMQ = parcelRequire("hnmMQ");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");

var $8cYSw = parcelRequire("8cYSw");

var $21L8z = parcelRequire("21L8z");

var $eOIix = parcelRequire("eOIix");

var $6iX8D = parcelRequire("6iX8D");

var $iPPTB = parcelRequire("iPPTB");
const $2da6ff99551ef1ce$export$3c868f5963107f89 = {
    atlassian: 'https://dam-cdn.atl.orangelogic.com/AssetLink/25o68v5s8lr856c06p606q47s76rs10f.svg',
    guard: 'https://dam-cdn.atl.orangelogic.com/AssetLink/8j5d41rmb7q4himg4r42k3e84hvoo07i.svg'
};
const $2da6ff99551ef1ce$export$60332b2344f7fe41 = ({ align: align = 'start', orientation: // we currently do not support a horizontal orientation card with an image
// the outstanding issue is that the the image has a requirement of an aspect ratio of 16:9
// and the card text is unbounded (so prioritizing the image would make the text potentially
// overflow), and prioritizing the text would make the image potentially have undesired
// white space at the end
orientation = 'vertical', columns: columns, background: background = 'light', eyebrow: eyebrow, logo: logo, title: title, body: body, image: image, imageAspectRatio: imageAspectRatio = '16 / 9', icon: icon, icons: icons, callToAction: callToAction, spotIllustration: spotIllustration, videoSrc: videoSrc, ...props })=>{
    // hedge against the value being passed in as a string (the options in uniform can only be string values)
    // which would subsequently fail a string vs number check ie 10 === "10" is false
    const numColumns = Number(columns);
    const { titleAs: TitleComponent = 'h3', containerType: Container = 'div' } = props;
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    const isDark = background === 'dark' || isDarkTheme;
    const isLinkableCard = !!callToAction;
    const cardIcons = icons?.length ? icons : icon ? [
        icon
    ] : [];
    // React's useId() returns strings like ":R0:" which contain colons — colons are valid
    // in HTML id attributes but invalid in CSS id selectors without escaping. Compiled CSS
    // generates :has() selectors that reference elements by their id, and jsdom's nwsapi
    // cannot parse unescaped colons in generated selectors. Sanitize by replacing colons
    // with hyphens to produce CSS-safe ids like "-R0-".
    const uniqueId = (0, $1oC0p.useId)().replace(/:/g, '-');
    const titleId = `card-title-${uniqueId}`;
    const callToActionId = `card-cta-${uniqueId}`;
    const [isVideoOverlayOpen, setIsVideoOverlayOpen] = (0, $1oC0p.useState)(false);
    const bodyElement = typeof body === 'string' ? /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3"
        ]),
        children: body
    }) : body;
    const openVideoOverlay = (event)=>{
        event.preventDefault();
        setIsVideoOverlayOpen(true);
    };
    const videoOverlay = videoSrc ? isVideoOverlayOpen && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5kbMC.default), {
        onClose: ()=>setIsVideoOverlayOpen(false),
        label: typeof title === 'string' ? title : callToAction?.text,
        width: "x-large",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iX8D.EmbeddedVideo), {
                    embedUrl: videoSrc,
                    title: typeof title === 'string' ? title : callToAction?.text,
                    autoPlay: true
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                    type: "button",
                    onClick: ()=>setIsVideoOverlayOpen(false),
                    className: (0, $2jatx.default)([
                        "_4cvr1h6o _11q7vkha _19itidpf _2rko1ssb _syaz1afi _80omtlke _1e0c1txw _152tu2gc _rjxpu2gc _1yt412x7 _kqswstnw _1pbykb7n _1ygb14ak _1ah3yh40"
                    ]),
                    style: {
                        "--_1mehvmr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark200')),
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cNOwN))), {
                            label: "",
                            color: "currentColor"
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $FapDU.default), {
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
                                id: "card.video.close",
                                defaultMessage: "Close video"
                            })
                        })
                    ]
                })
            ]
        })
    }) : null;
    const card = /*#__PURE__*/ (0, $7VQPk.jsxs)(Container, {
        className: (0, $2jatx.default)([
            "_2rko1ylz _1e0c1txw _yyhy10md",
            align === 'center' && "_4cvr1h6o _y3gn1h6o",
            isDark ? "_11q7vkha _19itxb7o _1qgo1afi _q3s11afi" : "_11q71afi _19itkze7 _1qgo1pfd _q3s11pfd",
            orientation === 'vertical' && "_2lx21bp4",
            orientation === 'horizontal' && "_2lx2vrvc _4t3i1osq _1bsb1osq _14q21bp4",
            isLinkableCard && "_kqswh2mm _13whb3bt _ykcxidpf _1heustnw _1w8ikb7n _1piy1vf8 _q7ne1vf8",
            isLinkableCard && !isDark && "_v564mnji _1ni61kw8 _a7on1kw8 _clok130s _1v69130s"
        ]),
        style: {
            "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
            "--_1mehvmr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark200')),
            "--_19gw9o2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark100')),
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400')),
            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
        },
        children: [
            spotIllustration ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1pfhxy5q _ahbqxy5q _12l2xy5q _6rthu2gc",
                    orientation === 'horizontal' && "_12l2u2gc _1ob9xy5q",
                    "spotIllustrationContainer"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    src: spotIllustration.src,
                    alt: spotIllustration.alt ?? '',
                    style: {
                        height: spotIllustration.height ?? (orientation === 'vertical' ? (0, $21L8z.SPOT_ILLUSTRATION_MAX_HEIGHT) : 'auto'),
                        maxHeight: orientation === 'vertical' ? (0, $21L8z.SPOT_ILLUSTRATION_MAX_HEIGHT) : 'auto',
                        width: orientation === 'horizontal' && !spotIllustration.height ? (0, $21L8z.SPOT_ILLUSTRATION_WIDTH_ON_HORIZONTAL_CARD) : 'auto',
                        maxWidth: orientation === 'horizontal' && spotIllustration.height ? 'auto' : '100%'
                    }
                })
            }) : image && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1reozryt _18m9zryt _1e0c1txw _1bah1h6o _4cvr1h6o",
                    orientation === 'vertical' && "_1s1g1ylz _5fbc1ylz _1o9zidpf _kqswh2mm _1bsb1osq",
                    orientation === 'vertical' && imageAspectRatio === '1 / 1' && "_1h1t1ekt",
                    orientation === 'vertical' && imageAspectRatio !== '1 / 1' && "_1h1tcq2i",
                    orientation === 'horizontal' && "_1s1g1ylz _1yxn1ylz _4t3i1osq _1bsb1osq _1e0c1txw",
                    videoSrc && "_kqswh2mm _1hfkvkha _aetrb3bt _9v7aidpf _1peqnh7s _11fnglyw _18postnw",
                    `cardImageContainer${videoSrc ? ' videoCardImageContainer' : ''}`
                ]),
                style: {
                    "--_6td02k": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('corner.radius.card')),
                    "--_1mehvmr": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark200'))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                        ...image,
                        src: image.src,
                        alt: image.alt,
                        className: (0, $2jatx.default)([
                            "_4t3i1osq _1bsb1osq _1e0c1txw",
                            orientation === 'vertical' && "_1r04idpf _5ral1dfr _kqswstnw",
                            orientation === 'horizontal' && "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _5ral1f51",
                            videoSrc && "_4t3i1osq _5ral1dfr _t9ec1h7a _8hrzaqso _v5648pnm"
                        ])
                    }),
                    videoSrc && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iX8D.PlayIcon), {})
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1yt41ejb _1e0c1txw _2lx21bp4 _zulpu2gc",
                    orientation === 'vertical' && "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                    orientation === 'horizontal' && "_1bsb1osq _4t3i1osq _1q51xy5q"
                ]),
                children: [
                    logo && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                            image: {
                                src: $2da6ff99551ef1ce$export$3c868f5963107f89[logo],
                                alt: '',
                                height: 24
                            }
                        })
                    }),
                    cardIcons.length > 0 && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_4cvr1h6o _1e0c1txw _zulpu2gc _6rthpxbi",
                            align === 'center' && "_1bah1h6o",
                            "cardIconRow"
                        ]),
                        children: cardIcons.map((cardIcon, index)=>{
                            const { linkedIcon: linkedIcon, iconComponent: iconComponent } = cardIcon;
                            const iconUrl = linkedIcon?.url;
                            const iconSize = linkedIcon?.size ?? 'medium';
                            const paddingIncluded = linkedIcon?.paddingIncluded ?? false;
                            return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw"
                                ]),
                                children: [
                                    iconUrl && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                                        src: iconUrl,
                                        alt: '',
                                        style: {
                                            width: `${(0, $8cYSw.iconSizesPaddingIncluded)[iconSize]}px`,
                                            height: `${(0, $8cYSw.iconSizesPaddingIncluded)[iconSize]}px`,
                                            aspectRatio: '1',
                                            padding: `${paddingIncluded ? 0 : ((0, $8cYSw.iconSizesPaddingIncluded)[iconSize] - (0, $8cYSw.iconSizesPaddingExcluded)[iconSize]) / 2}px`,
                                            objectPosition: 'center'
                                        }
                                    }),
                                    iconComponent
                                ]
                            }, iconUrl ?? index);
                        })
                    }),
                    eyebrow && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                        className: (0, $2jatx.default)([
                            "_19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3",
                            "eyebrow-md"
                        ]),
                        children: eyebrow
                    }),
                    title && /*#__PURE__*/ (0, $7VQPk.jsx)(TitleComponent, {
                        className: (0, $2jatx.default)([
                            "_19pkgrf3 _2hwxgrf3 _otyrgrf3 _18u0grf3",
                            "card-title"
                        ]),
                        id: titleId,
                        children: title
                    }),
                    body && bodyElement,
                    isLinkableCard && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            orientation === 'vertical' && "_1pfh1wug",
                            "_1q51pxbi"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                            id: callToActionId,
                            ariaLabelledby: `${callToActionId} ${titleId}`,
                            type: videoSrc ? 'video' : 'primary',
                            ...callToAction,
                            href: videoSrc ?? callToAction.href,
                            anchorProps: videoSrc ? {
                                onClick: openVideoOverlay
                            } : callToAction.anchorProps,
                            className: `full-card ${callToAction?.className ?? ''}`,
                            bgColor: isDark ? 'bgBlackBlue' : 'bgWhite',
                            "aria-label": callToAction.text
                        })
                    })
                ]
            })
        ]
    });
    const fullWidthGridStyles = null;
    if (numColumns && orientation === 'horizontal') return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            videoOverlay,
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_195g1wug _p12f1osq _1bsb1osq _13ltwklj _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _1j8bcx6w _1vsw1vi7 _d2ik1wqb _exxm1wqb _10jxzqdx _1e0c11p5 _vchhusvi _zulp14hz _1dsl1tcg _1qnyaw08 _n6am13k5"
                    ]),
                    style: {
                        "--_18qdfwk": (0, $6ZVlx.default)(numColumns === 10 ? 2 : 1),
                        "--_1xniuc0": (0, $6ZVlx.default)(numColumns === 10 ? 10 : 12)
                    },
                    children: card
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            videoOverlay,
            card
        ]
    });
};
const $2da6ff99551ef1ce$var$cardContainer = null;
const $2da6ff99551ef1ce$var$cardContainerLight = null;
const $2da6ff99551ef1ce$var$cardContainerDark = null;
const $2da6ff99551ef1ce$var$illustrationContainer = null;
const $2da6ff99551ef1ce$var$horizontalIllustrationContainer = null;
const $2da6ff99551ef1ce$var$verticalOrientation = null;
const $2da6ff99551ef1ce$var$horizontalOrientation = null;
const $2da6ff99551ef1ce$var$centeredCardContainer = null;
const $2da6ff99551ef1ce$var$linkableCardContainer = null;
const $2da6ff99551ef1ce$var$linkableCardHoverShadow = null;
const $2da6ff99551ef1ce$var$cardImageContainer = null;
const $2da6ff99551ef1ce$var$horizontalImageContainer = null;
const $2da6ff99551ef1ce$var$verticalImageContainer = null;
const $2da6ff99551ef1ce$var$widescreenImageAspectRatio = null;
const $2da6ff99551ef1ce$var$squareImageAspectRatio = null;
const $2da6ff99551ef1ce$var$imageStyle = null;
const $2da6ff99551ef1ce$var$verticalImageStyle = null;
const $2da6ff99551ef1ce$var$horizontalImageStyle = null;
const $2da6ff99551ef1ce$var$videoThumbnailContainer = null;
const $2da6ff99551ef1ce$var$videoThumbnailImageStyle = null;
const $2da6ff99551ef1ce$var$verticalBodyContainer = null;
const $2da6ff99551ef1ce$var$horizontalBodyContainer = null;
const $2da6ff99551ef1ce$var$cardBodyContainer = null;
const $2da6ff99551ef1ce$var$resetMargin = null;
const $2da6ff99551ef1ce$var$iconContainer = null;
const $2da6ff99551ef1ce$var$iconRow = null;
const $2da6ff99551ef1ce$var$centeredIconRow = null;
const $2da6ff99551ef1ce$var$linkContainer = null;
const $2da6ff99551ef1ce$var$verticalLinkContainer = null;
const $2da6ff99551ef1ce$var$videoOverlayContent = null;
const $2da6ff99551ef1ce$var$videoOverlayCloseButton = null;

});
parcelRegister("6iX8D", function(module, exports) {
$parcel$export(module.exports, "PlayIcon", function () { return $41efe20f21d8b288$export$a6630b90defda83f; });
$parcel$export(module.exports, "EmbeddedVideo", function () { return $41efe20f21d8b288$export$e71032fcfd2bdb71; });
/* embedded-video.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $kbpa7 = parcelRequire("kbpa7");
const $41efe20f21d8b288$export$a6630b90defda83f = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        "aria-hidden": "true",
        className: (0, $2jatx.default)([
            "_lswu1afi _tzy4q80t _kqswstnw _1e02idpf _rjxpidpf _152tidpf _u7coidpf _19pk1wug _2hwx1wug _otyr1wug _18u01wug _lcxvglyw _2rko1osq _1pbykb7n",
            "play-icon"
        ]),
        width: "70px",
        height: "70px",
        viewBox: "0 0 32 32",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
            d: "M16,0 C7.163444,-5.41083001e-16 1.082166e-15,7.163444 0,16 C-1.082166e-15,24.836556 7.163444,32 16,32 C24.836556,32 32,24.836556 32,16 C32,11.7565362 30.3142906,7.68687356 27.3137085,4.6862915 C24.3131264,1.68570945 20.2434638,2.5983722e-16 16,0 Z M11.1288889,22.2222222 L11.1288889,9.77777778 L23.6533333,16 L11.1288889,22.2222222 Z"
        })
    });
};
const $41efe20f21d8b288$export$c233dcaeaeace6e8 = (url)=>{
    const normalizedUrl = url.toLowerCase();
    if (normalizedUrl.includes('loom.com')) return 'loom';
    if (normalizedUrl.endsWith('.mp4') || normalizedUrl.includes('video/mp4')) return 'mp4';
    return 'youtube';
};
/**
 * Normalizes a Loom URL to its embed format.
 * Converts share URLs (loom.com/share/ID) to embed URLs (loom.com/embed/ID).
 */ const $41efe20f21d8b288$var$normalizeLoomUrl = (url)=>{
    return url.replace('/share/', '/embed/');
};
/**
 * Normalizes a YouTube URL to its embed format.
 */ const $41efe20f21d8b288$var$normalizeYoutubeUrl = (url)=>{
    return url.replace('youtu.be/', 'youtube.com/embed/').replace('watch?v=', 'embed/').replace('https://youtube.com', 'https://www.youtube.com');
};
const $41efe20f21d8b288$export$e71032fcfd2bdb71 = ({ embedUrl: embedUrl, title: title, thumbnail: thumbnail, dataEventProps: dataEventProps, videoType: videoType, autoPlay: autoPlay = false })=>{
    const [isPlaying, setIsPlaying] = (0, $1oC0p.useState)(autoPlay);
    const videoRef = (0, $1oC0p.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const resolvedVideoType = videoType ?? $41efe20f21d8b288$export$c233dcaeaeace6e8(embedUrl);
    const videoOverlayCss = null;
    const iFrameCss = null;
    const mp4VideoCss = null;
    const handleClick = (e)=>{
        e.preventDefault();
        setIsPlaying(true);
        createAnalyticsEvent({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'embeddedVideoPlay',
            source: dataEventProps?.['data-event-container'] ?? 'embeddedVideo',
            attributes: {
                ...dataEventProps?.['data-product-key'] && {
                    productKey: dataEventProps['data-product-key']
                },
                ...dataEventProps?.['data-label'] && {
                    label: dataEventProps['data-label']
                },
                videoType: resolvedVideoType
            }
        }).fire();
    };
    // needs to be defined outside of css
    const bgImage = `url("${thumbnail?.src}")`;
    const intl = (0, $8e22h.default)();
    const renderPlayingContent = ()=>{
        switch(resolvedVideoType){
            case 'mp4':
                return /*#__PURE__*/ (0, $7VQPk.jsxs)("video", {
                    ref: videoRef,
                    src: embedUrl,
                    title: title,
                    controls: true,
                    autoPlay: true,
                    playsInline: true,
                    "aria-label": title ?? '',
                    className: (0, $2jatx.default)([
                        "_1e0c1ule _1h1tbb7n _1bsb1osq _4t3i1wug _bfhk1pfd"
                    ]),
                    style: {
                        "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("track", {
                            kind: "captions"
                        }),
                        intl.formatMessage({
                            id: 'embeddedVideo.videoNotSupported',
                            defaultMessage: 'Video not supported.'
                        })
                    ]
                });
            case 'youtube':
            default:
                {
                    const youtubeUrl = $41efe20f21d8b288$var$normalizeYoutubeUrl(embedUrl);
                    if (youtubeUrl.includes('iframe')) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        dangerouslySetInnerHTML: {
                            __html: youtubeUrl
                        },
                        className: (0, $2jatx.default)([
                            "_digdyfq0 _11av1ule _1stxbb7n _i01y1osq _91ut1wug _mi22p5ev"
                        ])
                    });
                    return /*#__PURE__*/ (0, $7VQPk.jsx)("iframe", {
                        width: "100%",
                        height: "auto",
                        src: `${youtubeUrl}${youtubeUrl.includes('?') ? '&' : '?'}autoplay=1`,
                        title: title,
                        allow: "accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; autoplay;",
                        allowFullScreen: true,
                        "data-gtm-yt-inspected-12": "true",
                        className: (0, $2jatx.default)([
                            "_s7n4yfq0 _1e0c1ule _1h1tbb7n _1bsb1osq _4t3i1wug _3y3kp5ev _19itglyw"
                        ])
                    });
                }
        }
    };
    if (resolvedVideoType === 'loom') {
        const loomUrl = $41efe20f21d8b288$var$normalizeLoomUrl(embedUrl);
        return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("iframe", {
                width: "100%",
                height: "auto",
                src: loomUrl,
                title: title,
                allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen",
                allowFullScreen: true,
                className: (0, $2jatx.default)([
                    "_s7n4yfq0 _1e0c1ule _1h1tbb7n _1bsb1osq _4t3i1wug _3y3kp5ev _19itglyw"
                ])
            })
        });
    }
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            !isPlaying && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1tke1osq _1bsb1osq _kqswh2mm _19itidpf _80omtlke _1e0c1txw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                    type: "button",
                    className: (0, $2jatx.default)([
                        "_1e0c1ule _1bsb1osq _1tke1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1reo15vq _18m915vq _80omtlke _ul7n1qgu _e6731y44 _8zzh1afi _12lu1vf8 _15l81afi _18y71vf8",
                        "play-trigger"
                    ]),
                    "aria-label": intl.formatMessage({
                        id: 'embeddedVideo.playTriggerButton.ariaLabel',
                        defaultMessage: 'Play Video'
                    }),
                    onClick: handleClick,
                    style: {
                        "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue')),
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                    },
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
                            className: (0, $2jatx.default)([
                                "_p12f1osq _1bsb1osq _4t3i1wug _8hrzaqso _t9ec1h7a _v5648pnm _1itk1n01 _1lrw1dfr _ouxl1ssb _bfhkygj1 _11q31n0t _s7n4yfq0 _lcxvglyw",
                                "video-thumbnail"
                            ]),
                            src: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAYAAAA7KqwyAAAAAXNSR0IArs4c6QAAAAlwSFlzAAALEwAACxMBAJqcGAAAAVlpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IlhNUCBDb3JlIDUuNC4wIj4KICAgPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICAgICAgPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8dGlmZjpPcmllbnRhdGlvbj4xPC90aWZmOk9yaWVudGF0aW9uPgogICAgICA8L3JkZjpEZXNjcmlwdGlvbj4KICAgPC9yZGY6UkRGPgo8L3g6eG1wbWV0YT4KTMInWQAAABFJREFUKBVjYBgFoyFAhRAAAAJJAAFEkgypAAAAAElFTkSuQmCC',
                            alt: thumbnail?.alt ?? '',
                            style: {
                                "--_um3idz": (0, $6ZVlx.default)(bgImage)
                            }
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($41efe20f21d8b288$export$a6630b90defda83f, {})
                    ]
                })
            }),
            isPlaying && renderPlayingContent()
        ]
    });
};

});


parcelRegister("hrGO1", function(module, exports) {
$parcel$export(module.exports, "TRACKING_EVENT_NAMES", function () { return $37d29093f218a0c9$export$9a56b303ccc53008; });
$parcel$export(module.exports, "DEFAULT_COUNTRY_ISO_CODE", function () { return $37d29093f218a0c9$export$b1f75679747bdf24; });
$parcel$export(module.exports, "DEFAULT_CURRENCY_ISO_CODE", function () { return $37d29093f218a0c9$export$427ae666c2c86a64; });
$parcel$export(module.exports, "SpecialPlanNames", function () { return $37d29093f218a0c9$export$3f5e519890ec420; });
$parcel$export(module.exports, "CloudOfferingsWithSkus", function () { return $37d29093f218a0c9$export$49640008eae271a8; });
$parcel$export(module.exports, "SpecialProductKeys", function () { return $37d29093f218a0c9$export$9bb4a98475a54313; });
$parcel$export(module.exports, "DefaultPlanLimits", function () { return $37d29093f218a0c9$export$dcfb07a55b760b78; });
$parcel$export(module.exports, "PricingStrategy", function () { return $37d29093f218a0c9$export$d5367d5d99549333; });
$parcel$export(module.exports, "parsePricingStrategy", function () { return $37d29093f218a0c9$export$b136e5eb1cbda98a; });
$parcel$export(module.exports, "TRELLO_CTA_URL", function () { return $37d29093f218a0c9$export$3d9423ec9a4e8352; });
$parcel$export(module.exports, "SIGNUP_CTA_URL", function () { return $37d29093f218a0c9$export$3c460f2e36dca740; });
$parcel$export(module.exports, "CONTACT_CTA_URL", function () { return $37d29093f218a0c9$export$cee779d81c7e245b; });
$parcel$export(module.exports, "CtaBtnText", function () { return $37d29093f218a0c9$export$7f370599117a54aa; });
$parcel$export(module.exports, "Edition", function () { return $37d29093f218a0c9$export$6f4a0f769e61929; });
$parcel$export(module.exports, "PRICE_FINDER_CONTAINER", function () { return $37d29093f218a0c9$export$c5526af38120e3f; });
$parcel$export(module.exports, "COMPARE_FEATURES_CONTAINER", function () { return $37d29093f218a0c9$export$67b29c0af8205db6; });
const $37d29093f218a0c9$export$bd7123388de718a2 = {
    desktop: `@media (min-width: 1024px)`,
    tablet: `@media (max-width: 1023px)`,
    mobile: `@media (max-width: 768px)`,
    extraSmall: `@media (max-width: 360px)`
};
const $37d29093f218a0c9$export$9a56b303ccc53008 = {
    unitTierBox: 'pricing_page_unit_tier_box',
    unitDescriptionTooltipTriggered: 'unit-description-tooltip-triggered',
    billingCycleChanged: 'billing-cycle-changed',
    planCardCTAButtonClicked: 'edition-table-button-clicked',
    unitBreachModalDecision: 'unit-breach-modal-decision',
    unitLimitBreachModal: 'unit-limit-breach-modal',
    userTierTooltipTriggered: 'user-tier-tooltip-triggered',
    showPricingExampleTriggered: 'show-pricing-example-triggered',
    hidePricingExampleTriggered: 'hide-pricing-example-triggered',
    pricingExampleBillingCycleChanged: 'pricing-example-billing-cycle-changed',
    promoCardCTAButtonClicked: 'promo-card-button-clicked'
};
const $37d29093f218a0c9$export$803d5f8ee4072798 = {
    users: 'users',
    agents: 'agents'
};
const $37d29093f218a0c9$export$b1f75679747bdf24 = 'US';
const $37d29093f218a0c9$export$427ae666c2c86a64 = 'USD';
const $37d29093f218a0c9$export$3f5e519890ec420 = {
    FREE: 'Free',
    STARTER: 'Starter',
    STANDARD: 'Standard',
    PREMIUM: 'Premium',
    ENTERPRISE: 'Enterprise'
};
const $37d29093f218a0c9$export$c6264333cd6ce1a4 = {
    confluence: 'pricingplan.confluence.ondemand',
    jiraSoftware: 'jira-software.ondemand',
    jiraServiceDesk: 'jira-servicedesk.ondemand',
    jiraServiceManagement: 'jira-servicedesk.ondemand',
    bitbucket: 'com.atlassian.bitbucket.manual',
    atlassianGuard: 'com.atlassian.identity-manager',
    compass: 'compass.ondemand',
    jiraProductDiscovery: 'jira-product-discovery.ondemand',
    rovo: 'rovo',
    trello: 'trello',
    loom: 'loom',
    teamworkCollection: 'teamwork-collection',
    strategyCollection: 'strategy-collection'
};
const $37d29093f218a0c9$export$49640008eae271a8 = {
    confluence: 'confluence',
    jiraSoftware: 'jira-software',
    jiraServiceDesk: 'jira-servicedesk',
    jiraServiceManagement: 'jira-servicedesk',
    atlassianGuard: 'atlassian-access',
    compass: 'compass',
    jiraProductDiscovery: 'jira-product-discovery',
    rovo: 'rovo-org-purchase-sku',
    trello: 'trello',
    loom: 'loom'
};
const $37d29093f218a0c9$export$2766faac8d5287ee = {
    confluence: 'pricingplan.confluence-data-center',
    jiraSoftware: 'jira-software.data-center',
    jiraServiceDesk: 'jira-servicedesk.data-center',
    jiraServiceManagement: 'jira-servicedesk.data-center',
    bitbucket: 'pricingplan.stash-data-center'
};
const $37d29093f218a0c9$export$9bb4a98475a54313 = {
    JSM: 'jira-servicedesk.ondemand',
    BITBUCKET: 'com.atlassian.bitbucket.manual'
};
const $37d29093f218a0c9$export$dcfb07a55b760b78 = {
    UNIT_LIMIT_FREE: 10,
    UNIT_LIMIT: 150000,
    UNIT_MIN_ENTERPRISE: 801
};
const $37d29093f218a0c9$export$d5367d5d99549333 = {
    FIXED_COST: 'FIXED_COST',
    MARGINAL_PER_UNIT: 'MARGINAL_PER_UNIT',
    PER_UNIT: 'PER_UNIT'
};
function $37d29093f218a0c9$export$a97d19165664aecc(value) {
    switch(value){
        case $37d29093f218a0c9$export$d5367d5d99549333.FIXED_COST:
        case $37d29093f218a0c9$export$d5367d5d99549333.MARGINAL_PER_UNIT:
        case $37d29093f218a0c9$export$d5367d5d99549333.PER_UNIT:
            return true;
        default:
            return false;
    }
}
function $37d29093f218a0c9$export$b136e5eb1cbda98a(value) {
    if ($37d29093f218a0c9$export$a97d19165664aecc(value)) return value;
    else throw new SyntaxError(`${value} is not a valid PricingStrategy`);
}
const $37d29093f218a0c9$export$3d9423ec9a4e8352 = 'https://id.atlassian.com/signup?application=trello&continue=https%3A%2F%2Ftrello.com%2Fauth%2Fatlassian%2Fcallback%3Fdisplay%3DeyJ2ZXJpZmljYXRpb25TdHJhdGVneSI6InNvZnQifQ%253D%253D&display=eyJ2ZXJpZmljYXRpb25TdHJhdGVneSI6InNvZnQifQ%3D%3D';
const $37d29093f218a0c9$export$3c460f2e36dca740 = '/try/cloud/signup';
const $37d29093f218a0c9$export$cee779d81c7e245b = '/enterprise/contact?formType=pricing-quotes';
const $37d29093f218a0c9$export$7f370599117a54aa = {
    GET_IT_NOW: 'Get it now',
    START_FREE_TRIAL: 'Start free trial',
    CONTACT_SALES: 'Contact sales',
    JOIN_WAITLIST: 'Join waitlist'
};
const $37d29093f218a0c9$export$6f4a0f769e61929 = {
    FREE: 'free',
    STANDARD: 'standard',
    PREMIUM: 'premium',
    ENTERPRISE: 'enterprise'
};
const $37d29093f218a0c9$export$c2f12bc66b1c3231 = 67;
const $37d29093f218a0c9$export$e528a8f1399647be = 210;
const $37d29093f218a0c9$export$27ed77542911fb0e = 1024;
const $37d29093f218a0c9$export$c5526af38120e3f = 'priceBlock';
const $37d29093f218a0c9$export$67b29c0af8205db6 = 'priceFeaturesTable';

});

parcelRegister("lOlsU", function(module, exports) {
$parcel$export(module.exports, "useFirePricingPlanCtaEvent", function () { return $94595cb38e128ae6$export$7f90eaa475fc1c9f; });

var $fuLgT = parcelRequire("fuLgT");

var $eY3N6 = parcelRequire("eY3N6");
function $94595cb38e128ae6$export$7f90eaa475fc1c9f(props) {
    const { edition: edition, productKey: productKey, containerId: containerId } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const createPayload = ()=>({
            eventType: 'ui',
            action: 'clicked',
            actionSubject: 'linkButton',
            containerId: containerId,
            actionSubjectId: 'pricingPlanCta',
            attributes: {
                migrationExperimentCta: true,
                pricingEventId: (0, $fuLgT.default)(),
                productKey: productKey,
                edition: edition
            }
        });
    return ()=>createAnalyticsEvent(createPayload()).fire();
}

});

parcelRegister("dkcYJ", function(module, exports) {
$parcel$export(module.exports, "ProductCatalogClient", function () { return $44efc64b5afbeaf3$export$103ea0adeef74210; });
$parcel$export(module.exports, "useCCPPriceFinderData", function () { return $44efc64b5afbeaf3$export$cd96e69292b0829; });
$parcel$export(module.exports, "useHAMSPriceData", function () { return $44efc64b5afbeaf3$export$487b53c25dfbddc8; });

var $1oC0p = parcelRequire("1oC0p");

var $hrGO1 = parcelRequire("hrGO1");

var $g7Jsj = parcelRequire("g7Jsj");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
var $44efc64b5afbeaf3$var$EDITION_SUFFIXES = /*#__PURE__*/ function(EDITION_SUFFIXES) {
    EDITION_SUFFIXES["FREE"] = ".free";
    EDITION_SUFFIXES["STANDARD"] = "";
    EDITION_SUFFIXES["PREMIUM"] = ".premium";
    EDITION_SUFFIXES["ENTERPRISE"] = ".enterprise";
    return EDITION_SUFFIXES;
}($44efc64b5afbeaf3$var$EDITION_SUFFIXES || {});
const $44efc64b5afbeaf3$var$NON_STANDARD_EDITION_SUFFIXES = [
    ".free",
    ".premium",
    ".enterprise"
];
class $44efc64b5afbeaf3$export$103ea0adeef74210 {
    constructor(accessToken, space, environment = 'master'){
        this.accessToken = accessToken;
        this.space = space;
        this.environment = environment;
    }
    getUrl() {
        return `https://cdn.contentful.com/spaces/${this.space}/environments/${this.environment}`;
    }
    async getEntries(queryParams) {
        const url = this.getUrl();
        const response = await fetch(`${url}/entries?access_token=${this.accessToken}&${queryParams}`);
        if (response.ok) return response.json();
        throw new (0, $g7Jsj.UnsuccessfulFetchError)({
            message: 'Unable to fetch prices',
            response: response
        });
    }
    /**
   *
   * @param key the `key` property of the HAMS Product
   * @returns Monthly prices for each headcount bucket for the free, standard and premium tiers
   */ //TODO: Update to accept CCP Offering Sku
    async getLocalizedPriceBlockPrices(key) {
        const pricingQuery = `content_type=product&select=fields.key%2Cfields.defaultStdPricingPlanMonthly%2Cfields.defaultPremiumPricingPlanMonthly%2Cfields.defaultFreePricingPlanMonthly%2Cfields.defaultEnterprisePricingPlanMonthly%2Csys.id%2Csys.type&fields.key%5Bin%5D=${key}&include=2`;
        const { includes: includes, items: items } = await this.getEntries(pricingQuery);
        if (!items.length) throw new Error('No pricing plans match this key');
        const parentPricingPlan = items[0];
        const freeMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultFreePricingPlanMonthly?.sys.id);
        const standardMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultStdPricingPlanMonthly?.sys.id);
        const premiumMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultPremiumPricingPlanMonthly?.sys.id);
        return {
            free: freeMonthly?.fields.configuration,
            standard: standardMonthly?.fields.configuration,
            premium: premiumMonthly?.fields.configuration
        };
    }
    async getLocalizedPriceBlockDropdown(key) {
        const pricingQuery = `content_type=product&select=fields.key%2Cfields.defaultStdPricingPlanMonthly%2Cfields.defaultStdPricingPlanYearly%2Cfields.defaultPremiumPricingPlanMonthly%2Cfields.defaultPremiumPricingPlanYearly%2Cfields.defaultFreePricingPlanMonthly%2Cfields.defaultEnterprisePricingPlanMonthly%2Cfields.defaultEnterprisePricingPlanYearly%2Csys.id%2Csys.type&fields.key%5Bin%5D=${key}`;
        const { includes: includes, items: items } = await this.getEntries(pricingQuery);
        if (!items.length || !includes) throw new Error('No pricing plans match this key');
        const fields = includes.Entry[0]?.fields.configuration;
        return fields;
    }
    /**
   *
   * @param key the `key` property of the HAMS Product
   * @returns Monthly prices for each headcount bucket for the free, standard and premium tiers
   */ async getHAMSPrices(key) {
        const pricingQuery = `content_type=product&select=fields.key%2Cfields.defaultStdPricingPlanMonthly%2Cfields.defaultStdPricingPlanYearly%2Cfields.defaultPremiumPricingPlanMonthly%2Cfields.defaultPremiumPricingPlanYearly%2Cfields.defaultFreePricingPlanMonthly%2Cfields.defaultEnterprisePricingPlanMonthly%2Cfields.defaultEnterprisePricingPlanYearly%2Csys.id%2Csys.type&fields.key%5Bin%5D=${key}`;
        const { includes: includes, items: items } = await this.getEntries(pricingQuery);
        if (!items.length) throw new Error(`No HAMS plans match this key: ${key}`);
        const productKeys = [
            key + ".free",
            key,
            key + ".premium",
            key + ".enterprise"
        ];
        const removeEditionSuffix = (productKey)=>productKey.replace(new RegExp($44efc64b5afbeaf3$var$NON_STANDARD_EDITION_SUFFIXES.map((suffix)=>`\\${suffix}`).join('|') + '$'), '');
        const getPricingPlansForEditionSuffixedKey = (editionSuffixedProductKey)=>{
            const matchedEditionSuffix = $44efc64b5afbeaf3$var$NON_STANDARD_EDITION_SUFFIXES.reduce((matchingEditionSuffix, editionSuffix)=>editionSuffixedProductKey.endsWith(editionSuffix) ? editionSuffix : matchingEditionSuffix, "");
            const parentPricingPlan = items[0];
            const freeMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultFreePricingPlanMonthly?.sys.id);
            const freeAnnual = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultFreePricingPlanYearly?.sys.id);
            const standardMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultStdPricingPlanMonthly?.sys.id);
            const premiumMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultPremiumPricingPlanMonthly?.sys.id);
            const enterpriseMonthly = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultEnterprisePricingPlanMonthly?.sys.id);
            const standardAnnual = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultStdPricingPlanYearly?.sys.id);
            const premiumAnnual = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultPremiumPricingPlanYearly?.sys.id);
            const enterpriseAnnual = includes.Entry.find((entry)=>entry.sys.id === parentPricingPlan.fields.defaultEnterprisePricingPlanYearly?.sys.id);
            let monthly = undefined;
            let annual = undefined;
            switch(matchedEditionSuffix){
                case ".free":
                    monthly = freeMonthly?.fields.configuration;
                    annual = freeAnnual?.fields.configuration;
                    break;
                case "":
                    monthly = standardMonthly?.fields.configuration;
                    annual = standardAnnual?.fields.configuration;
                    break;
                case ".premium":
                    monthly = premiumMonthly?.fields.configuration;
                    annual = premiumAnnual?.fields.configuration;
                    break;
                case ".enterprise":
                    monthly = enterpriseMonthly?.fields.configuration;
                    annual = enterpriseAnnual?.fields.configuration;
                    break;
            }
            return {
                monthly: monthly?.map($44efc64b5afbeaf3$var$mapPricingPlanToPricingTier),
                annual: annual?.map($44efc64b5afbeaf3$var$mapPricingPlanToPricingTier)
            };
        };
        let ret = {};
        for (const productKey of productKeys){
            const editionlessKey = removeEditionSuffix(productKey);
            const entry = items.find(({ fields: { key: key } })=>key === editionlessKey);
            if (entry) ret = {
                ...ret,
                [productKey]: getPricingPlansForEditionSuffixedKey(productKey)
            };
        }
        return ret;
    }
    /**
   *
   * @param offeringSKUs the `key` property of the CCP Product
   * @returns A map of offeringSkus to their respective product plan content
   */ async getCCPPricingData(offeringSKUs) {
        const mappedOfferings = offeringSKUs.map((offeringSku, idx)=>{
            if (idx > 0) return `%2C${offeringSku}`;
            else return `=${offeringSku}`;
        }).join('');
        const ccpPricingDataQuery = `content_type=31uDFGQ9rMyZpBgP4oexja&fields.sku%5Bin%5D${mappedOfferings}`;
        const { items: items, includes: includes } = await this.getEntries(ccpPricingDataQuery);
        if (!items.length) throw new Error('No offerings match this key');
        const ret = {};
        // Match plans to their offering by offeringKey, not offeringName:
        // the name is just the edition label ("Standard", "Premium", …) and
        // is shared across products, so a name match pulls in every product's
        // plans for that edition when multiple products are fetched in one call.
        const matchPlansByOfferingKey = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp12437MatchPricingPlansByOfferingKey);
        for (const offeringSKU of offeringSKUs){
            const entry = items.find(({ fields: { sku: sku } })=>sku === offeringSKU);
            const contentfulOffering = entry?.fields;
            const pricingPlans = includes.Entry.map((includedEntry)=>{
                const isMatch = matchPlansByOfferingKey ? includedEntry.fields.offeringKey === contentfulOffering?.key : includedEntry.fields.offeringName === contentfulOffering?.name;
                if (isMatch) return includedEntry.fields;
                else return undefined;
            }).filter(Boolean);
            contentfulOffering?.defaultPricingPlans?.splice(0, contentfulOffering.defaultPricingPlans.length, ...pricingPlans);
            ret[offeringSKU] = contentfulOffering;
        }
        return ret;
    }
}
function $44efc64b5afbeaf3$export$cd96e69292b0829(offeringSKUs, accessToken, space, environment) {
    const offeringSKUsCount = offeringSKUs.length;
    const [status, setStatus] = (0, $1oC0p.useState)('idle');
    const [prices, setPrices] = (0, $1oC0p.useState)();
    const client = (0, $1oC0p.useRef)(new $44efc64b5afbeaf3$export$103ea0adeef74210(accessToken, space, environment)).current;
    const fetchData = (0, $1oC0p.useCallback)(async ()=>{
        if (offeringSKUsCount) {
            setStatus('fetching');
            const retrievedPrices = await client.getCCPPricingData(offeringSKUs);
            setPrices(retrievedPrices);
            setStatus('complete');
        } else {
            setStatus('complete');
            setPrices({});
        }
    }, [
        offeringSKUsCount
    ]);
    return {
        status: status,
        prices: prices,
        fetchData: fetchData
    };
}
function $44efc64b5afbeaf3$export$487b53c25dfbddc8(key, accessToken, space, environment) {
    const [status, setStatus] = (0, $1oC0p.useState)('idle');
    const [prices, setPrices] = (0, $1oC0p.useState)();
    const client = new $44efc64b5afbeaf3$export$103ea0adeef74210(accessToken, space, environment);
    (0, $1oC0p.useEffect)(()=>{
        const fetchData = async ()=>{
            setStatus('fetching');
            const retrievedPrices = await client.getHAMSPrices(key);
            setPrices(retrievedPrices);
            setStatus('complete');
        };
        if (key) fetchData();
        else {
            setStatus('complete');
            setPrices({});
        }
    }, [
        key
    ]);
    return {
        status: status,
        prices: prices
    };
}
function $44efc64b5afbeaf3$export$cee963e0757fb89b(key, accessToken, space, environment) {
    const [status, setStatus] = (0, $1oC0p.useState)('idle');
    const [prices, setPrices] = (0, $1oC0p.useState)();
    const client = new $44efc64b5afbeaf3$export$103ea0adeef74210(accessToken, space, environment);
    (0, $1oC0p.useEffect)(()=>{
        const fetchData = async ()=>{
            setStatus('fetching');
            const retrievedPrices = await client.getLocalizedPriceBlockPrices(key);
            setPrices(retrievedPrices);
            setStatus('complete');
        };
        fetchData();
    }, []);
    return {
        status: status,
        prices: prices
    };
}
//TODO: Do we need this? Can we just use the types already declared and reuse them?
function $44efc64b5afbeaf3$var$mapPricingPlanToPricingTier({ pricing_strategy: pricing_strategy, unit_description: unit_description, unit_limit_lower: unit_limit_lower, unit_limit_upper: unit_limit_upper, prices: prices }) {
    return {
        pricingStrategy: (0, $hrGO1.parsePricingStrategy)(pricing_strategy),
        unitDescription: unit_description,
        unitLimitLower: unit_limit_lower,
        unitLimitUpper: unit_limit_upper,
        prices: prices.map($44efc64b5afbeaf3$var$mapPricingPlanPricesItemPriceToPricingTierPrice)
    };
}
function $44efc64b5afbeaf3$var$mapPricingPlanPricesItemPriceToPricingTierPrice({ currency: currency, unit_price: unit_price }) {
    return {
        currency: currency,
        unitPrice: unit_price
    };
}
function $44efc64b5afbeaf3$export$9e1397dbc82e4578(key, accessToken, space, environment) {
    const [status, setStatus] = (0, $1oC0p.useState)('idle');
    const [prices, setPrices] = (0, $1oC0p.useState)();
    const client = new $44efc64b5afbeaf3$export$103ea0adeef74210(accessToken, space, environment);
    (0, $1oC0p.useEffect)(()=>{
        const fetchData = async ()=>{
            setStatus('fetching');
            const retrievedPrices = await client.getLocalizedPriceBlockDropdown(key);
            setPrices(retrievedPrices);
            setStatus('complete');
        };
        fetchData();
    }, []);
    return {
        status: status,
        prices: prices
    };
}

});

parcelRegister("1RK9J", function(module, exports) {
$parcel$export(module.exports, "getFreePriceCalc", function () { return $9f9b50f36097439e$export$cb6f0dbb8c9b28d2; });
$parcel$export(module.exports, "usePriceFinderRequests", function () { return $9f9b50f36097439e$export$e1ef037d62746bfa; });
$parcel$export(module.exports, "usePricing", function () { return $9f9b50f36097439e$export$2bd1dff4b72a4894; });

var $1oC0p = parcelRequire("1oC0p");

var $hrGO1 = parcelRequire("hrGO1");

var $ieLA0 = parcelRequire("ieLA0");

var $69Lp1 = parcelRequire("69Lp1");

var $8dsKS = parcelRequire("8dsKS");
const $9f9b50f36097439e$export$cb6f0dbb8c9b28d2 = (currencyISOCode)=>{
    const zeroPrice = (0, $ieLA0.getFormattedPrice)(currencyISOCode, 0);
    return {
        totalPrice: 0,
        avgPerUnitPrice: 0,
        avgPerUnitPriceWithDiscount: 0,
        formattedTotalPrice: zeroPrice,
        formattedAvgPerUnitPrice: zeroPrice,
        formattedAvgPerUnitPriceWithDiscount: zeroPrice,
        formattedTotalPriceWithDiscount: zeroPrice,
        hasFlatRateFirstTier: true,
        breakdown: [
            {
                unitsInTier: 0,
                unitsAvailableInTier: 0,
                unitLimitLower: 0,
                unitLimitUpper: 0,
                totalPriceForTier: 0,
                avgPerUnitPriceForTier: 0
            }
        ],
        formattedBreakdown: [
            {
                formattedUnitsInTier: '0',
                formattedUnitsAvailableInTier: '0',
                formattedUnitLimitLower: '0',
                formattedUnitLimitUpper: '0',
                formattedTotalPriceForTier: zeroPrice,
                formattedAvgPerUnitPriceForTier: zeroPrice
            }
        ]
    };
};
const $9f9b50f36097439e$export$e1ef037d62746bfa = (productKey, productPlans, unitMinEnterprise, unitCount, billingCycle)=>{
    return (0, $1oC0p.useMemo)(()=>{
        const getNumUnits = (planName, signupUnitLimit)=>{
            let adjNumUnits = 0;
            // following scenarios do not have pricing and should send a zero unit count,
            // the zero pricing will not be displayed and is needed only to retain the
            // correct array order of the pricing requests/responses
            // Free plan has no pricing
            const isFree = planName === (0, $hrGO1.SpecialPlanNames).FREE;
            // Enterprise plans do not have monthly pricing
            const isMonthlyEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && billingCycle === 'MONTHLY';
            // Enterprise plans have a minimum unit count
            const isUnmetUnitCountEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && unitCount < unitMinEnterprise;
            const isOverSignupUnitLimit = unitCount > signupUnitLimit;
            if (![
                isFree,
                isMonthlyEnterprise,
                isUnmetUnitCountEnterprise,
                isOverSignupUnitLimit
            ].includes(true)) adjNumUnits = unitCount;
            // keep unit count to general maximum limit
            return Math.min(adjNumUnits, signupUnitLimit);
        };
        const planPriceReqs = productPlans.map(({ offeringSku: offeringSku, planName: planName, signupLimit: signupLimit })=>({
                ccpOfferingSKU: offeringSku,
                hamsProductKey: productKey + (planName === (0, $hrGO1.SpecialPlanNames).STANDARD ? '' : `.${planName.toLowerCase()}`),
                numUnits: getNumUnits(planName, signupLimit || (0, $hrGO1.DefaultPlanLimits).UNIT_LIMIT),
                period: billingCycle
            }));
        return planPriceReqs;
    }, [
        productPlans,
        productKey,
        billingCycle,
        unitCount,
        unitMinEnterprise
    ]);
};
const $9f9b50f36097439e$export$2bd1dff4b72a4894 = (ccpPricingData, hamsPricingData, getPriceRequests, currencyISOCode, localeISOCode)=>{
    const priceCalculations = [];
    for (const { ccpOfferingSKU: ccpOfferingSKU, hamsProductKey: hamsProductKey, numUnits: numUnits, period: period } of getPriceRequests)if (numUnits === 0) priceCalculations.push($9f9b50f36097439e$export$cb6f0dbb8c9b28d2(currencyISOCode));
    else {
        const pricingTiers = (0, $69Lp1.extractPricingTiersFromEntry)(ccpPricingData, hamsPricingData, period, currencyISOCode, ccpOfferingSKU, hamsProductKey);
        if (!pricingTiers) {
            console.log(`Pricing tiers not found for ${period}.`);
            priceCalculations.push($9f9b50f36097439e$export$cb6f0dbb8c9b28d2(currencyISOCode));
        } else priceCalculations.push((0, $8dsKS.calculatePrice)(numUnits, pricingTiers, currencyISOCode, period, localeISOCode));
    }
    return priceCalculations;
};

});
parcelRegister("ieLA0", function(module, exports) {
$parcel$export(module.exports, "getFormattedPrice", function () { return $db8d9502e3c15040$export$1b80ff309ec5fcb1; });
$parcel$export(module.exports, "getTwoDigitFormattedPrice", function () { return $db8d9502e3c15040$export$716b461c5fe22c57; });
$parcel$export(module.exports, "getFormattedUnitAmount", function () { return $db8d9502e3c15040$export$4f6f7f43804883a5; });
const $db8d9502e3c15040$export$93b318a4d10f1db1 = (value)=>{
    if (value !== null && value !== undefined && !Number.isNaN(value)) return Number.isInteger(+value) ? 0 : 2;
    else return 0;
};
const $db8d9502e3c15040$var$fmtCurrencyValue = (currencyISOCode, value, useTwoDigits)=>{
    const isJPY = currencyISOCode === 'JPY';
    const adjVal = isJPY ? Math.ceil(value || 0) : value;
    return new Intl.NumberFormat(isJPY ? 'ja-JP' : 'en-US', {
        style: 'currency',
        currency: currencyISOCode,
        // Note: JPY does not use decimals
        minimumFractionDigits: useTwoDigits && !isJPY ? 2 : $db8d9502e3c15040$export$93b318a4d10f1db1(adjVal),
        maximumFractionDigits: useTwoDigits && !isJPY ? 2 : $db8d9502e3c15040$export$93b318a4d10f1db1(adjVal)
    }).format(adjVal || 0);
};
const $db8d9502e3c15040$export$1b80ff309ec5fcb1 = (currencyISOCode, value)=>$db8d9502e3c15040$var$fmtCurrencyValue(currencyISOCode, value, false);
const $db8d9502e3c15040$export$716b461c5fe22c57 = (currencyISOCode, value)=>$db8d9502e3c15040$var$fmtCurrencyValue(currencyISOCode, value, true);
const $db8d9502e3c15040$export$4f6f7f43804883a5 = (localeISOCode, value)=>new Intl.NumberFormat(localeISOCode).format(value || 0);

});

parcelRegister("69Lp1", function(module, exports) {
$parcel$export(module.exports, "extractPricingTiersFromEntry", function () { return $eeff08f2d55148ea$export$99b3bd15b49bca3d; });

var $6AKYt = parcelRequire("6AKYt");
const $eeff08f2d55148ea$export$99b3bd15b49bca3d = (ccpOfferingsBySKU, hamsPricingPlansByKey, period, currencyISOCode, ccpOfferingSKU, hamsProductKey, getCcpTiers)=>{
    let pricingPlans;
    let pricingTiers;
    if (ccpOfferingSKU) {
        const offering = ccpOfferingsBySKU[ccpOfferingSKU];
        pricingPlans = offering?.defaultPricingPlans;
        if (!pricingPlans) {
            console.log(`Offering empty of pricing plan data for: ${ccpOfferingSKU}`);
            return undefined;
        }
        const convertedTiers = (0, $6AKYt.convertCCPPricingPlansToHAMS)(pricingPlans, currencyISOCode, getCcpTiers);
        if (period === 'MONTHLY' && convertedTiers.monthly) pricingTiers = convertedTiers.monthly.slice();
        else if (period === 'ANNUAL' && convertedTiers.annual) pricingTiers = convertedTiers.annual.slice();
        else {
            console.log(`Found neither monthly or annual pricing tiers for CCP Offering SKU: ${ccpOfferingSKU}`);
            return undefined;
        }
    } else {
        if (hamsProductKey === undefined) {
            console.log(`HAMS product key was undefined for price request!`);
            return undefined;
        }
        pricingPlans = hamsPricingPlansByKey[hamsProductKey];
        if (pricingPlans === undefined) {
            console.log(`No ${period} pricing plans found for HAMS product key: ${hamsProductKey}`);
            return undefined;
        }
        if (period === 'MONTHLY' && pricingPlans.monthly) pricingTiers = pricingPlans.monthly.slice();
        else if (period === 'ANNUAL' && pricingPlans.annual) pricingTiers = pricingPlans.annual.slice();
        else {
            console.log(`Found neither monthly or annual (period is ${period}) pricing tiers for HAMS product key: ${hamsProductKey}`);
            return undefined;
        }
    }
    return pricingTiers;
};

});
parcelRegister("6AKYt", function(module, exports) {
$parcel$export(module.exports, "convertCCPPricingPlansToHAMS", function () { return $ba494f9c4080e515$export$1fb00d50ed2ce89c; });

var $hrGO1 = parcelRequire("hrGO1");
// CCP Amounts are stored in cents - Note: JPY needs no conversion
const $ba494f9c4080e515$var$formatCentsToDollars = (value, currency)=>{
    if (currency === 'USD' && value) return value / 100;
    return value;
};
const $ba494f9c4080e515$var$convertCCPTiersToHAMS = (ccpTiers, chargeElement, currency)=>ccpTiers.map((ccpTier)=>{
        let pricingStrategy = (0, $hrGO1.PricingStrategy).MARGINAL_PER_UNIT;
        let unitPrice = ccpTier.unitAmount;
        if (ccpTier.flatAmount) {
            pricingStrategy = (0, $hrGO1.PricingStrategy).FIXED_COST;
            unitPrice = ccpTier.flatAmount;
        }
        return {
            starter: false,
            pricingStrategy: pricingStrategy,
            unitDescription: chargeElement,
            unitLimitLower: ccpTier.floor,
            unitLimitUpper: ccpTier.ceiling,
            prices: [
                {
                    currency: currency,
                    unitPrice: $ba494f9c4080e515$var$formatCentsToDollars(unitPrice, currency)
                }
            ]
        };
    });
const $ba494f9c4080e515$export$1fb00d50ed2ce89c = (pricingPlans, currencyISOCode, getCcpTiers)=>{
    const [monthlyCCP, annualCCP] = [
        'MONTH',
        'YEAR'
    ].map((primaryCycle)=>// Per CCP Team: We need to filter by COMMERCIAL, DEFAULT_PRICING
        pricingPlans.find((pricingPlan)=>pricingPlan.primaryCycle_interval === primaryCycle && pricingPlan.type === 'COMMERCIAL' && pricingPlan.activatedWithReason === 'DEFAULT_PRICING' && // We filter by currencyISOCode as we need both USD & JPY Pricing for Pricing Pages
            // If needed, can filter by USD only which we will pass in directly in those components
            pricingPlan.currency === currencyISOCode));
    const [monthly, annual] = [
        monthlyCCP,
        annualCCP
    ].map((ccpContent)=>{
        if (!ccpContent) return undefined;
        const ccpTiers = getCcpTiers ? getCcpTiers(ccpContent) : ccpContent.items[0];
        const { tiers: tiers, chargeElement: chargeElement } = ccpTiers;
        return $ba494f9c4080e515$var$convertCCPTiersToHAMS(tiers, chargeElement, ccpContent.currency);
    });
    return {
        monthly: monthly,
        annual: annual
    };
};

});


parcelRegister("8dsKS", function(module, exports) {
$parcel$export(module.exports, "calculatePrice", function () { return $9c8fafac440a889f$export$8f857d3e1dbdf9cf; });

var $hrGO1 = parcelRequire("hrGO1");

var $ieLA0 = parcelRequire("ieLA0");

var $cuq2S = parcelRequire("cuq2S");

var $fmcUV = parcelRequire("fmcUV");
const $9c8fafac440a889f$var$getTierIdxForNumUnits = (numUnits, tiers)=>tiers.findIndex(({ unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper })=>numUnits >= (unitLimitLower || 0) && numUnits <= (unitLimitUpper || Math.pow(10, 1000)));
function $9c8fafac440a889f$export$8f857d3e1dbdf9cf(numUnits, tiers, currencyISOCode, period, localeISOCode = 'en-US') {
    if (!Number.isInteger(numUnits) || numUnits < 1) throw new Error(`Number of units must be a positive non-zero integer, got ${numUnits}.`);
    if (!tiers || tiers.length === 0) throw new Error(`Price tiers must not be null, undefined or an empty array, got ${tiers}.`);
    tiers.sort((a, b)=>{
        return (a.unitLimitLower ?? 0) - (b.unitLimitLower ?? 0);
    });
    let matchingTierIdx = $9c8fafac440a889f$var$getTierIdxForNumUnits(numUnits, tiers);
    const matchingTier = tiers[matchingTierIdx];
    const finalTier = tiers[tiers.length - 1];
    let adjustedNumberOfUnits = numUnits;
    let calcFunc;
    if (matchingTier !== undefined) {
        const tierPricingStrategy = matchingTier.pricingStrategy;
        calcFunc = period === 'MONTHLY' || tierPricingStrategy === (0, $hrGO1.PricingStrategy).MARGINAL_PER_UNIT ? (0, $fmcUV.default) : (0, $cuq2S.default);
    } else if (finalTier && finalTier.pricingStrategy === (0, $hrGO1.PricingStrategy).MARGINAL_PER_UNIT) calcFunc = (0, $fmcUV.default);
    else {
        /*
     * When a user input is greater than the max tier limit
     * we will reset the number of users to max tier limit
     * of that product and perform price calculations.
     * */ adjustedNumberOfUnits = finalTier?.unitLimitUpper || 0;
        matchingTierIdx = $9c8fafac440a889f$var$getTierIdxForNumUnits(adjustedNumberOfUnits, tiers);
        calcFunc = (0, $cuq2S.default);
    }
    const fmtUnit = (amount)=>(0, $ieLA0.getFormattedUnitAmount)(localeISOCode, amount);
    const fmtPrice = (price)=>(0, $ieLA0.getFormattedPrice)(currencyISOCode, price);
    const { totalPrice: totalPrice, avgPerUnitPrice: avgPerUnitPrice, hasFlatRateFirstTier: hasFlatRateFirstTier, breakdown: breakdown } = calcFunc(adjustedNumberOfUnits, matchingTierIdx, tiers, currencyISOCode);
    const avgPerUnitPriceWithDiscount = (0, $cuq2S.calculateDiscountedPrice)(0.75, avgPerUnitPrice);
    const totalPriceWithDiscount = (0, $cuq2S.calculateDiscountedPrice)(0.75, totalPrice);
    return {
        totalPrice: totalPrice,
        avgPerUnitPriceWithDiscount: avgPerUnitPriceWithDiscount,
        formattedTotalPrice: fmtPrice(totalPrice),
        formattedAvgPerUnitPriceWithDiscount: fmtPrice(avgPerUnitPriceWithDiscount),
        formattedTotalPriceWithDiscount: fmtPrice(totalPriceWithDiscount),
        avgPerUnitPrice: avgPerUnitPrice,
        formattedAvgPerUnitPrice: fmtPrice(avgPerUnitPrice),
        breakdown: breakdown,
        hasFlatRateFirstTier: hasFlatRateFirstTier,
        formattedBreakdown: breakdown.map(({ unitsInTier: unitsInTier, unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper, unitsAvailableInTier: unitsAvailableInTier, totalPriceForTier: totalPriceForTier, avgPerUnitPriceForTier: avgPerUnitPriceForTier })=>({
                formattedUnitsInTier: fmtUnit(unitsInTier),
                formattedUnitsAvailableInTier: fmtUnit(unitsAvailableInTier),
                formattedUnitLimitLower: fmtUnit(unitLimitLower),
                formattedUnitLimitUpper: fmtUnit(unitLimitUpper),
                formattedTotalPriceForTier: (0, $ieLA0.getTwoDigitFormattedPrice)(currencyISOCode, totalPriceForTier),
                formattedAvgPerUnitPriceForTier: (0, $ieLA0.getTwoDigitFormattedPrice)(currencyISOCode, avgPerUnitPriceForTier)
            }))
    };
}

});
parcelRegister("cuq2S", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $20e5665ddc9d914c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "calculateDiscountedPrice", function () { return $20e5665ddc9d914c$export$3a875854e1248ca4; });

var $8q2jX = parcelRequire("8q2jX");
function $20e5665ddc9d914c$export$2e2bcd8739ae039(numUnits, matchingTierIdx, tiers, currencyISOCode) {
    const matchingTier = tiers[matchingTierIdx];
    if (!matchingTier) throw new Error(`Matching price tier not found for ${numUnits}.`);
    const { prices: prices, unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper } = matchingTier;
    const totalPrice = (0, $8q2jX.getLocalUnitPrice)(currencyISOCode, prices.slice());
    const avgPerUnitPrice = totalPrice / numUnits;
    return {
        totalPrice: totalPrice,
        avgPerUnitPrice: avgPerUnitPrice,
        hasFlatRateFirstTier: true,
        breakdown: [
            {
                unitsInTier: numUnits,
                unitsAvailableInTier: (unitLimitUpper || 0) - numUnits,
                unitLimitLower: unitLimitLower || 1,
                unitLimitUpper: unitLimitUpper || 0,
                totalPriceForTier: totalPrice,
                avgPerUnitPriceForTier: totalPrice / numUnits
            }
        ]
    };
}
const $20e5665ddc9d914c$export$3a875854e1248ca4 = (discountRate, price)=>price * (1 - discountRate);

});
parcelRegister("8q2jX", function(module, exports) {
$parcel$export(module.exports, "getLocalUnitPrice", function () { return $032de19fb775a510$export$e4a3f0ac75d6f09; });
const $032de19fb775a510$export$e4a3f0ac75d6f09 = (currencyISOCode, prices)=>prices.find(({ currency: currency })=>currency === currencyISOCode)?.unitPrice || 0;

});


parcelRegister("fmcUV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $e064390e0d1f8ae6$export$2e2bcd8739ae039; });

var $hrGO1 = parcelRequire("hrGO1");

var $8q2jX = parcelRequire("8q2jX");
function $e064390e0d1f8ae6$export$2e2bcd8739ae039(numUnits, matchingTierIdx, tiers, currencyISOCode) {
    let totalPrice = 0;
    let price = 0;
    const breakdown = [];
    const getUnitPrice = (prices)=>(0, $8q2jX.getLocalUnitPrice)(currencyISOCode, prices);
    // if no matching tier then default to highest (last) tier
    if (matchingTierIdx === -1) matchingTierIdx = tiers.length - 1;
    let idx = 0;
    for (const tier of tiers){
        const { unitLimitLower: unitLimitLower, unitLimitUpper: unitLimitUpper } = tier;
        const adjUnitLimitLower = Math.max((unitLimitLower || 0) - 1, 0);
        // the upper unit limit can't be undefined so we can just set it to
        // one million units as an upper bound
        const adjUnitLimitUpper = unitLimitUpper || 1000000;
        const unitsInTier = idx === matchingTierIdx ? numUnits - adjUnitLimitLower : adjUnitLimitUpper - adjUnitLimitLower;
        if (tier.pricingStrategy === (0, $hrGO1.PricingStrategy).FIXED_COST) price = getUnitPrice(tier.prices.slice());
        else {
            const finalTier = tiers[Math.min(idx, tiers.length - 1)];
            price = getUnitPrice(finalTier.prices.slice());
        }
        const totalPriceForTier = tier.pricingStrategy === (0, $hrGO1.PricingStrategy).FIXED_COST ? price : unitsInTier * price;
        totalPrice += totalPriceForTier;
        breakdown.push({
            unitsInTier: unitsInTier,
            unitsAvailableInTier: adjUnitLimitUpper - unitsInTier,
            unitLimitLower: adjUnitLimitLower || 1,
            unitLimitUpper: adjUnitLimitUpper,
            totalPriceForTier: totalPriceForTier,
            avgPerUnitPriceForTier: price
        });
        if (++idx > matchingTierIdx) break;
    }
    const avgPerUnitPrice = totalPrice / numUnits;
    return {
        totalPrice: totalPrice,
        avgPerUnitPrice: avgPerUnitPrice,
        hasFlatRateFirstTier: tiers[0]?.pricingStrategy === (0, $hrGO1.PricingStrategy).FIXED_COST,
        breakdown: breakdown
    };
}

});



parcelRegister("cwszX", function(module, exports) {
$parcel$export(module.exports, "InfoIcon", function () { return $a32037f0fe1c069c$export$2957fc44b3d2481; });

var $7VQPk = parcelRequire("7VQPk");

var $3c7rQ = parcelRequire("3c7rQ");

var $kbpa7 = parcelRequire("kbpa7");
const $a32037f0fe1c069c$export$2957fc44b3d2481 = ({ size: size = 'small' })=>/*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
        width: size === 'small' ? '14' : '22',
        height: size === 'small' ? '14' : '22',
        viewBox: "0 0 24 24",
        role: "presentation",
        "aria-hidden": "true",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                    fill: (0, $kbpa7.wacToken)('color.primary.black'),
                    cx: "12",
                    cy: "12",
                    r: "10"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("circle", {
                    fill: (0, $3c7rQ.N0),
                    cx: "12",
                    cy: "18",
                    r: "1"
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                    d: "M15.89 9.05a3.975 3.975 0 00-2.957-2.942C10.321 5.514 8.017 7.446 8 9.95l.005.147a.992.992 0 00.982.904c.552 0 1-.447 1.002-.998a2.004 2.004 0 014.007-.002c0 1.102-.898 2-2.003 2H12a1 1 0 00-1 .987v2.014a1.001 1.001 0 002.004 0v-.782c0-.217.145-.399.35-.472A3.99 3.99 0 0015.89 9.05",
                    fill: (0, $3c7rQ.N0)
                })
            ]
        })
    });

});

parcelRegister("eUwCn", function(module, exports) {
$parcel$export(module.exports, "Adg4Skeleton", function () { return $a7f43d28d2add36d$export$e754784845e8828d; });

var $7VQPk = parcelRequire("7VQPk");

var $4jcRW = parcelRequire("4jcRW");

var $lP7A9 = parcelRequire("lP7A9");

var $kbpa7 = parcelRequire("kbpa7");
const $a7f43d28d2add36d$export$e754784845e8828d = ({ width: width, height: height, groupName: groupName, testId: testId, ...props })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4jcRW.default), {
        width: width,
        height: height,
        groupName: groupName,
        testId: testId,
        isShimmering: true,
        borderRadius: (0, $lP7A9.default)('space.100'),
        color: (0, $kbpa7.wacToken)('color.neutral.light200'),
        ShimmeringEndColor: (0, $kbpa7.wacToken)('color.neutral.light300'),
        ...props
    });
};

});

parcelRegister("6KUQg", function(module, exports) {
$parcel$export(module.exports, "AccountCreation", function () { return $42aa4ee4b4afed63$export$b841b541bc741e79; });

var $7VQPk = parcelRequire("7VQPk");

var $7u4F3 = parcelRequire("7u4F3");

var $cGEBM = parcelRequire("cGEBM");
const $42aa4ee4b4afed63$export$b841b541bc741e79 = ({ getContinueUrl: getContinueUrl, identityCobranding: identityCobranding, templateId: templateId, ...props })=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $cGEBM.AccountCreationContextProvider), {
        getContinueUrl: getContinueUrl,
        identityCobranding: identityCobranding,
        templateId: templateId,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7u4F3.Content), {
            ...props
        })
    });

});
parcelRegister("7u4F3", function(module, exports) {
$parcel$export(module.exports, "Content", function () { return $6cc2293976038b02$export$7c6e2c02157bb7d2; });

var $7VQPk = parcelRequire("7VQPk");

var $lX14w = parcelRequire("lX14w");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");

var $cGEBM = parcelRequire("cGEBM");

var $mG5bv = parcelRequire("mG5bv");

var $irRyj = parcelRequire("irRyj");

var $lJMiD = parcelRequire("lJMiD");

var $4qMMD = parcelRequire("4qMMD");

var $32ARy = parcelRequire("32ARy");

var $l7G9R = parcelRequire("l7G9R");

var $8K1Jw = parcelRequire("8K1Jw");
const $6cc2293976038b02$export$7c6e2c02157bb7d2 = ({ Submit: Submit = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $l7G9R.Submit), {}), Input: Input = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $irRyj.Input), {}), Social: Social = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $32ARy.Social), {}), Separator: Separator = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $4qMMD.Separator), {}), Error: Error = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $mG5bv.Error), {}), Login: Login = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lJMiD.Login), {}), TermsAndConditions: TermsAndConditions })=>{
    const { onSubmit: onSubmit } = (0, $cGEBM.useAccountCreationContext)();
    if (TermsAndConditions === undefined && (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).accountCreationTermsAndConditions)) TermsAndConditions = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8K1Jw.TermsAndConditions), {});
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lX14w.default), {
                onSubmit: onSubmit,
                isDisabled: false,
                children: ({ formProps: formProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("form", {
                        ...formProps,
                        autoComplete: "off",
                        "data-testid": "account-creation",
                        children: [
                            Input,
                            TermsAndConditions,
                            Submit
                        ]
                    })
            }),
            Error,
            Separator,
            Social,
            Login
        ]
    });
};

});
parcelRegister("cGEBM", function(module, exports) {
$parcel$export(module.exports, "useAccountCreationContext", function () { return $835e146085c3a79b$export$30b295205cfae694; });
$parcel$export(module.exports, "AccountCreationContextProvider", function () { return $835e146085c3a79b$export$b0a1b3550379fc78; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $eY3N6 = parcelRequire("eY3N6");

var $buVH1 = parcelRequire("buVH1");

var $fFzjl = parcelRequire("fFzjl");

var $gPKCY = parcelRequire("gPKCY");

var $gZgIU = parcelRequire("gZgIU");

var $gfjAv = parcelRequire("gfjAv");

var $7GVWk = parcelRequire("7GVWk");

var $hZy36 = parcelRequire("hZy36");

var $8bsd2 = parcelRequire("8bsd2");

var $1ka2O = parcelRequire("1ka2O");

var $iSeHD = parcelRequire("iSeHD");
const $835e146085c3a79b$export$52bc2238e0ff8657 = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $835e146085c3a79b$export$30b295205cfae694 = ()=>{
    const context = (0, $1oC0p.useContext)($835e146085c3a79b$export$52bc2238e0ff8657);
    if (!context) throw new Error('useAccountCreationContext must be used within a AccountCreationContextProvider');
    return context;
};
const $835e146085c3a79b$export$b0a1b3550379fc78 = ({ getContinueUrl: getContinueUrl, identityCobranding: identityCobranding = 'wac', templateId: templateId, children: children })=>{
    const location = (0, $1ka2O.useLocation)();
    const isEmbedded = !location.pathname.endsWith('/try/cloud/signup');
    const { product: product, edition: edition } = (0, $7GVWk.useUserContext)();
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $eY3N6.useAnalyticsEvents)();
    const intl = (0, $8e22h.default)();
    const [isEmailValid, setIsEmailValid] = (0, $1oC0p.useState)(false);
    const [hasSubmitted, setHasSubmitted] = (0, $1oC0p.useState)(false);
    const [isReadyForInvalid, setIsReadyForInvalid] = (0, $1oC0p.useState)(false);
    const [isSubmitting, setIsSubmitting] = (0, $1oC0p.useState)(false);
    const [formError, setFormError] = (0, $1oC0p.useState)(false);
    const [typeAheadEmail, setTypeAheadEmail] = (0, $1oC0p.useState)('');
    const [tryIntentAnalyticsEventHasFired, setTryIntentAnalyticsEventHasFired] = (0, $1oC0p.useState)(false);
    const localePath = (0, $gZgIU.getLocalePath)(intl.locale);
    const continueParam = (0, $gZgIU.getContinueParam)(location);
    const dataFoundationsActionSubjectId = !!isEmbedded ? 'embedded' : 'standalone';
    // default experiment params
    if (product && identityCobranding === 'wac') {
        if (product.name === 'confluence') identityCobranding = 'wac--otp-confluence';
        else if (product.name === 'jira') identityCobranding = 'wac--otp-jira';
        else if (product.name === 'loom') identityCobranding = 'wac--loom';
        else if (product.name === 'jira-product-discovery') identityCobranding = 'wac--jpd';
        else if (product.name === 'jira-servicedesk') identityCobranding = 'wac--jsm';
        else if (product.name === 'service-collection') identityCobranding = 'wac--service-collection';
        else if (product.name === 'teamwork-collection') identityCobranding = 'wac--teamwork-collection';
    }
    const defaultContinueUrl = (0, $1oC0p.useCallback)(()=>continueParam ? continueParam : (0, $gZgIU.getNameYourSiteRedirectUrl)({
            bundle: product?.bundle,
            edition: edition,
            localePath: localePath,
            templateId: templateId,
            application: identityCobranding,
            isEmbedded: isEmbedded
        }), [
        continueParam,
        product,
        edition,
        localePath,
        templateId,
        identityCobranding
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if (!analyticsClient) return;
        (0, $buVH1.trackDataFoundationsAccountCreationComponent)(createAnalyticsEvent, {
            actionSubjectId: dataFoundationsActionSubjectId,
            productKey: product?.key,
            edition: edition
        });
        (0, $gPKCY.ufoEventSignupFormLoad).success({
            customData: {
                webPlatform: 'bxp-ui',
                reactComponent: 'DefaultSignupForm',
                isLoggedIn: false
            }
        });
        (0, $buVH1.trackSignFormLoad)(createAnalyticsEvent);
        (0, $buVH1.trackTimeToFormReady)(createAnalyticsEvent, performance.now());
    }, [
        createAnalyticsEvent,
        edition,
        product?.key,
        dataFoundationsActionSubjectId,
        analyticsClient
    ]);
    const onSubmit = (0, $1oC0p.useCallback)(async ({ email: email })=>{
        setIsReadyForInvalid(true);
        if (!email || !isEmailValid) {
            (0, $buVH1.trackInvalidEmail)(createAnalyticsEvent);
            return;
        }
        (0, $buVH1.trackFormSubmit)(createAnalyticsEvent, product?.key, edition);
        setIsSubmitting(true);
        let continueUrl;
        if (getContinueUrl) continueUrl = getContinueUrl();
        if (!continueUrl) continueUrl = defaultContinueUrl();
        try {
            const castleToken = await (0, $hZy36.getCastleRequestToken)();
            // check identity interstitial redirect experiments for enrollment
            const url = (0, $gZgIU.getIdentityInterstitialUrl)(email, continueUrl, identityCobranding, castleToken);
            createAnalyticsEvent({
                eventType: 'ui',
                action: 'succeeded',
                actionSubject: 'accountCreationInterstitialRedirect',
                containerId: 'bxp-ui-signup',
                attributes: {
                    productKey: product?.key,
                    edition: edition
                }
            }).fire();
            (0, $8bsd2.trackCastleSignupAttempt)({
                href: url,
                email: email,
                productKey: product?.key
            });
            window.location.assign(url);
            return;
        } catch  {
            setHasSubmitted(true);
            setFormError(true);
            setIsSubmitting(false);
            createAnalyticsEvent({
                eventType: 'ui',
                action: 'errored',
                actionSubject: 'accountCreationInterstitialRedirect',
                containerId: 'bxp-ui-signup',
                attributes: {
                    productKey: product?.key,
                    edition: edition
                }
            }).fire();
        }
    }, [
        createAnalyticsEvent,
        defaultContinueUrl,
        edition,
        getContinueUrl,
        identityCobranding,
        isEmailValid,
        product
    ]);
    const onClickSocialButton = (provider)=>{
        (0, $buVH1.trackContinueWithSocialSignups)(createAnalyticsEvent, provider, product?.key, edition);
        let continueUrl;
        if (getContinueUrl) continueUrl = getContinueUrl();
        if (!continueUrl) continueUrl = defaultContinueUrl();
        const socialRedirectUrl = (0, $fFzjl.getSocialButtonUrl)({
            redirectTo: continueUrl,
            identityCobranding: identityCobranding,
            provider: provider
        });
        // Note: no Castle event here. Social signups don't go through the email
        // form, so we have no user-entered email to correlate against — and
        // Castle is only valuable with an email-to-fingerprint correlation.
        window.location.assign(socialRedirectUrl);
    };
    const onClickSubmitButton = ()=>(0, $buVH1.trackSubmitButtonClick)(createAnalyticsEvent);
    return /*#__PURE__*/ (0, $7VQPk.jsx)($835e146085c3a79b$export$52bc2238e0ff8657.Provider, {
        value: {
            dataFoundationsActionSubjectId: dataFoundationsActionSubjectId,
            edition: edition,
            formError: formError,
            hasSubmitted: hasSubmitted,
            identityCobranding: identityCobranding,
            isReadyForInvalid: isReadyForInvalid,
            isSubmitting: isSubmitting,
            onClickSocialButton: onClickSocialButton,
            onClickSubmitButton: onClickSubmitButton,
            onSubmit: onSubmit,
            product: product,
            setIsEmailValid: setIsEmailValid,
            setIsReadyForInvalid: setIsReadyForInvalid,
            setTypeAheadEmail: setTypeAheadEmail,
            typeAheadEmail: typeAheadEmail,
            tryIntentAnalyticsEventHasFired: tryIntentAnalyticsEventHasFired
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gfjAv.default), {
            edition: edition,
            intentType: "form",
            productKey: product?.key,
            onAnalyticsEventFired: ()=>!tryIntentAnalyticsEventHasFired && setTryIntentAnalyticsEventHasFired(true),
            children: children
        })
    });
};

});
parcelRegister("8bsd2", function(module, exports) {
$parcel$export(module.exports, "trackCastleSignupAttempt", function () { return $cc4df0ecef4c9b53$export$5b4bab8f0582c91c; });

var $hZy36 = parcelRequire("hZy36");
const $cc4df0ecef4c9b53$export$3aef6f37ef107ada = 'WAC Signup Attempted';
const $cc4df0ecef4c9b53$var$MAX_PATH_SEGMENT_LENGTH = 48;
const $cc4df0ecef4c9b53$var$SAFE_QUERY_PARAM_NAMES = new Set([
    'bundle',
    'edition',
    'product',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_content',
    'utm_term'
]);
const $cc4df0ecef4c9b53$var$getUrl = (href)=>{
    try {
        return new URL(href, window.location.origin);
    } catch  {
        return undefined;
    }
};
const $cc4df0ecef4c9b53$var$getSafeSearchParams = (url)=>{
    const safe = new URLSearchParams();
    url.searchParams.forEach((value, name)=>{
        if ($cc4df0ecef4c9b53$var$SAFE_QUERY_PARAM_NAMES.has(name)) safe.append(name, value);
    });
    return safe.toString();
};
const $cc4df0ecef4c9b53$var$sanitizePathSegment = (segment)=>{
    if (segment.length > $cc4df0ecef4c9b53$var$MAX_PATH_SEGMENT_LENGTH) return '[redacted]';
    return segment;
};
const $cc4df0ecef4c9b53$var$getSanitizedPath = (pathname)=>{
    return pathname.split('/').map((segment)=>$cc4df0ecef4c9b53$var$sanitizePathSegment(segment)).join('/');
};
const $cc4df0ecef4c9b53$var$getSanitizedHref = (url)=>{
    const safeParams = $cc4df0ecef4c9b53$var$getSafeSearchParams(url);
    const safePath = $cc4df0ecef4c9b53$var$getSanitizedPath(url.pathname);
    const base = `${url.origin}${safePath}`;
    return safeParams ? `${base}?${safeParams}` : base;
};
const $cc4df0ecef4c9b53$var$getSanitizedPagePath = ()=>$cc4df0ecef4c9b53$var$getSanitizedPath(window.location.pathname);
const $cc4df0ecef4c9b53$export$5b4bab8f0582c91c = ({ href: href, email: email, productKey: productKey })=>{
    const url = $cc4df0ecef4c9b53$var$getUrl(href);
    if (!url) return;
    (0, $hZy36.sendCastleCustomEvent)({
        name: $cc4df0ecef4c9b53$export$3aef6f37ef107ada,
        properties: {
            wac_href: $cc4df0ecef4c9b53$var$getSanitizedHref(url),
            wac_pagePath: $cc4df0ecef4c9b53$var$getSanitizedPagePath(),
            wac_eventType: 'signup',
            ...productKey ? {
                wac_productKey: productKey
            } : {}
        },
        email: email
    });
};

});


parcelRegister("mG5bv", function(module, exports) {
$parcel$export(module.exports, "Error", function () { return $d2f561c370fddce6$export$edf27be85e5f6da0; });
/* error.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $cGEBM = parcelRequire("cGEBM");

var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");
const $d2f561c370fddce6$export$edf27be85e5f6da0 = ({ errorText: errorText })=>{
    const { formatMessage: formatMessage, locale: locale } = (0, $8e22h.default)();
    const { formError: formError } = (0, $cGEBM.useAccountCreationContext)();
    if (!formError) return null;
    if (errorText === undefined) errorText = locale === 'en' // temporary fix until translation is available
     ? formatMessage({
        id: 'AccountCreation.userSignupError',
        defaultMessage: `It's taking longer than expected to get you started. Please refresh and try again or <contactUsLink>contact us</contactUsLink>.`
    }, {
        contactUsLink: $d2f561c370fddce6$var$contactUsLink
    }) : formatMessage({
        id: 'BxpUiSignup.SignupForm.formError',
        defaultMessage: "It's taking longer than expected to get you started. Please check your inbox to see if the order has completed successfully, or <contactUsLink>contact us</contactUsLink>."
    }, {
        contactUsLink: $d2f561c370fddce6$var$contactUsLink
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        role: "alert",
        className: (0, $2jatx.default)([
            "_syaz1cjc _19pk1j6v _2hwxidpf _otyr1j6v _18u0idpf _3fcw150s"
        ]),
        children: errorText
    });
};
const $d2f561c370fddce6$var$contactUsLink = (text)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        text: text,
        "aria-label": text,
        type: "inline",
        href: "/company/contact",
        className: "linkText"
    });
const $d2f561c370fddce6$var$errorCss = null;

});

parcelRegister("irRyj", function(module, exports) {
$parcel$export(module.exports, "Input", function () { return $5190fd2e8a96a930$export$f5b8910cec6cf069; });
/* input.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $igGC3 = parcelRequire("igGC3");

var $8KJ2x = parcelRequire("8KJ2x");

var $gM7M2 = parcelRequire("gM7M2");

var $iTHVN = parcelRequire("iTHVN");

var $bNzAT = parcelRequire("bNzAT");

var $eOIix = parcelRequire("eOIix");

var $cGEBM = parcelRequire("cGEBM");

var $6nMZs = parcelRequire("6nMZs");
const $5190fd2e8a96a930$var$HELP_TEXT_ID = 'account_creation_email_help_text';
const $5190fd2e8a96a930$export$f5b8910cec6cf069 = ({ helpText: helpText, errorMessageText: errorMessageText, labelText: labelText, placeholderText: placeholderText })=>{
    const { isReadyForInvalid: isReadyForInvalid, setIsEmailValid: setIsEmailValid, setIsReadyForInvalid: setIsReadyForInvalid, setTypeAheadEmail: setTypeAheadEmail, typeAheadEmail: typeAheadEmail } = (0, $cGEBM.useAccountCreationContext)();
    const [email, setEmail] = (0, $1oC0p.useState)(typeAheadEmail);
    const [isValid, setValid] = (0, $1oC0p.useState)();
    const intl = (0, $8e22h.default)();
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    if (helpText === undefined) helpText = intl.formatMessage({
        id: 'signupForm.accountCreation.helperText',
        defaultMessage: 'Using a work email helps find teammates and boost collaboration.'
    });
    if (errorMessageText === undefined) errorMessageText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.invalidEmail',
        defaultMessage: 'Please enter a valid email address.'
    });
    if (labelText === undefined) labelText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.workEmail',
        defaultMessage: 'Work email'
    });
    if (placeholderText === undefined) placeholderText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.emailPlaceholder',
        defaultMessage: 'you@company.com'
    });
    (0, $1oC0p.useEffect)(()=>{
        const isValid = (0, $gM7M2.emailIsValid)(email);
        // wait to show invalid state if the user is not finished typing
        if (!isValid && !isReadyForInvalid) {
            setValid(undefined);
            return;
        }
        setValid(isValid);
        setIsEmailValid(isValid);
    }, [
        email,
        setIsEmailValid,
        isReadyForInvalid
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_6rth7vkz _1rwquftu _1heu1kw7 _125x1syg _62vcmccc _1d6jidpf _1t2q1kw7 _17rn1kw7 _1q9pbfng _d78pglyw _1osle4h9 _tx14t94y _1bjadkaa _kj1xidpf",
            isDarkTheme && "_1mi9rttd _1rwqrttd _psgk1afi _1t2q1afi"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.light0')),
            "--_1jvo4a6": (0, $6ZVlx.default)((0, $iTHVN.fontSize).md),
            "--_1mehvmr": (0, $6ZVlx.default)((0, $bNzAT.default)('color.neutral.dark200'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $igGC3.default), {
            "aria-required": true,
            isRequired: true,
            label: labelText,
            name: "email",
            children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_7hwb183y",
                        isValid === true && "_olzhaf4m _1osldkaa _tx14idpf",
                        isValid === false && "_olzh1wfy _1osldkaa _tx14idpf"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8KJ2x.default), {
                            ...fieldProps,
                            autoComplete: "email",
                            "aria-describedby": $5190fd2e8a96a930$var$HELP_TEXT_ID,
                            elemAfterInput: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6nMZs.InputIcon), {
                                valid: isValid
                            }),
                            onBlur: ()=>setIsReadyForInvalid(true),
                            onChange: (e)=>{
                                setEmail(e.target.value);
                                setTypeAheadEmail(e.target.value);
                                fieldProps.onChange(e);
                            },
                            placeholder: placeholderText,
                            testId: "email_field",
                            type: "email",
                            value: email
                        }),
                        isValid === false ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            id: $5190fd2e8a96a930$var$HELP_TEXT_ID,
                            role: "alert",
                            className: (0, $2jatx.default)([
                                "_syaz1tmw _1wybepq8 _vwz4bs82 _1pfhi2wt",
                                isDarkTheme && "_syaz1366"
                            ]),
                            style: {
                                "--_1h1y5xv": (0, $6ZVlx.default)((0, $iTHVN.fontSize).xs)
                            },
                            children: errorMessageText
                        }) : helpText ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            id: $5190fd2e8a96a930$var$HELP_TEXT_ID,
                            className: (0, $2jatx.default)([
                                "_1wybepq8 _vwz4bs82 _syazl3em _1pfhi2wt"
                            ]),
                            style: {
                                "--_1h1y5xv": (0, $6ZVlx.default)((0, $iTHVN.fontSize).xs)
                            },
                            children: helpText
                        }) : null
                    ]
                })
        })
    });
};
const $5190fd2e8a96a930$var$errorMessageCss = null;
const $5190fd2e8a96a930$var$darkThemeErrorMessageCss = null;
const $5190fd2e8a96a930$var$helpTextCss = null;
const $5190fd2e8a96a930$var$fieldCss = null;
const $5190fd2e8a96a930$var$darkThemeFieldCss = null;
const $5190fd2e8a96a930$var$inputCss = null;
const $5190fd2e8a96a930$var$inputInvalidCss = null;
const $5190fd2e8a96a930$var$inputValidCss = null;

});
parcelRegister("6nMZs", function(module, exports) {
$parcel$export(module.exports, "InputIcon", function () { return $f28bd5fc1ae39550$export$f8fea9f50a4bfae6; });
/* input-icon.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $hrBjL = parcelRequire("hrBjL");

var $5J9KJ = parcelRequire("5J9KJ");

var $iTHVN = parcelRequire("iTHVN");

var $kbpa7 = parcelRequire("kbpa7");
const $f28bd5fc1ae39550$export$f8fea9f50a4bfae6 = ({ valid: valid })=>{
    const { formatMessage: formatMessage } = (0, $8e22h.default)();
    const validMessage = formatMessage({
        id: 'signupForm.accountCreation.validEmailIcon',
        defaultMessage: 'Success'
    });
    const invalidMessage = formatMessage({
        id: 'signupForm.accountCreation.invalidEmailIconError',
        defaultMessage: 'Error'
    });
    if (valid === undefined) return null;
    return valid ? /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _lswu1afi _1wyb1syg _y4ti19bv _w8l5gktf _1752gktf",
            "_syaz81oq"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_1jvo4a6": (0, $6ZVlx.default)((0, $iTHVN.fontSize).md),
            "--_12jscdq": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.lime600'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hrBjL))), {
            label: validMessage
        })
    }) : /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_4cvr1h6o _1e0c1txw _lswu1afi _1wyb1syg _y4ti19bv _w8l5gktf _1752gktf",
            "_syaz1bqt"
        ]),
        style: {
            "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0')),
            "--_1jvo4a6": (0, $6ZVlx.default)((0, $iTHVN.fontSize).md)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5J9KJ))), {
            label: invalidMessage
        })
    });
};
const $f28bd5fc1ae39550$var$iconWrapperCss = null;
const $f28bd5fc1ae39550$var$iconValidCss = null;
const $f28bd5fc1ae39550$var$iconInvalidCss = null;

});


parcelRegister("lJMiD", function(module, exports) {
$parcel$export(module.exports, "Login", function () { return $50db90a6da99c80d$export$21a94553ffa41578; });
/* login.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $iTHVN = parcelRequire("iTHVN");

var $gZgIU = parcelRequire("gZgIU");

var $iPPTB = parcelRequire("iPPTB");

var $1ka2O = parcelRequire("1ka2O");

var $cGEBM = parcelRequire("cGEBM");
const $50db90a6da99c80d$export$21a94553ffa41578 = ({ loginText: loginText })=>{
    const intl = (0, $8e22h.default)();
    const location = (0, $1ka2O.useLocation)();
    const { product: product } = (0, $cGEBM.useAccountCreationContext)();
    if (loginText === undefined) loginText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.existingProduct',
        defaultMessage: 'Already have {product}? <logInLink>Log in</logInLink>'
    }, {
        product: product?.description,
        logInLink: (text)=>$50db90a6da99c80d$var$logInLink(text, location)
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        className: (0, $2jatx.default)([
            "_1wyb8oy7 _19pk14b4 _2hwxgrf3 _otyrgrf3 _18u0grf3 _y3gn1h6o"
        ]),
        style: {
            "--_djwknj": (0, $6ZVlx.default)((0, $iTHVN.fontSize).sm)
        },
        children: loginText
    });
};
const $50db90a6da99c80d$var$logInLink = (text, location)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        text: text,
        "aria-label": text,
        type: "inline",
        href: (0, $gZgIU.getLoginUrl)(location)
    });
const $50db90a6da99c80d$var$existingProductCss = null;

});

parcelRegister("32ARy", function(module, exports) {
$parcel$export(module.exports, "Social", function () { return $4e2e5c1067955974$export$9a0fadb2797ac9a5; });
/* social.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jUqeL = parcelRequire("jUqeL");

var $lHKk6 = parcelRequire("lHKk6");

var $cGEBM = parcelRequire("cGEBM");

var $8e22h = parcelRequire("8e22h");
const $4e2e5c1067955974$export$9a0fadb2797ac9a5 = ({ providers: providers })=>{
    const intl = (0, $8e22h.default)();
    const { onClickSocialButton: onClickSocialButton } = (0, $cGEBM.useAccountCreationContext)();
    if (providers === undefined) providers = {
        google: 'Google',
        microsoft: 'Microsoft',
        apple: 'Apple',
        slack: 'Slack'
    };
    const buttons = Object.entries(providers);
    // when there are 3 buttons, we display in a single row and visually hide the text labels
    const rowStyle = buttons.length === 3;
    /* added role="list" to ul for safari https://developer.mozilla.org/en-US/docs/Web/CSS/list-style#accessibility  */ return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
        role: "list",
        className: (0, $2jatx.default)([
            "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            buttons.length > 1 && !rowStyle && "_1e0c11p5 _zulp7vkz _yv0efsjm",
            rowStyle && "_1e0c11p5 _zulp7vkz _wij21bp4"
        ]),
        children: buttons.map(([provider, label])=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $lHKk6.LogoButton), {
                    "aria-label": intl.formatMessage({
                        id: 'social.label.signup',
                        defaultMessage: 'sign up with {provider}'
                    }, {
                        provider: label
                    }),
                    onClick: ()=>onClickSocialButton(provider),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jUqeL.ProviderLogo), {
                            logo: provider
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                rowStyle && "_kqswstnw _1e021cib _152t1wug _1bsbt94y _4t3it94y _1reo15vq _18m915vq _ogtohxbz _o5721q9c"
                            ]),
                            children: label
                        })
                    ]
                })
            }, provider))
    });
};
const $4e2e5c1067955974$var$buttonGridCss = null;
const $4e2e5c1067955974$var$buttonListCss = null;
const $4e2e5c1067955974$var$buttonRowCss = null;
const $4e2e5c1067955974$var$srOnlyCss = null;

});

parcelRegister("l7G9R", function(module, exports) {
$parcel$export(module.exports, "Submit", function () { return $9e3c42c7c44204a7$export$2c4cf1f7b42ef78c; });
/* submit.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $lqyi6 = parcelRequire("lqyi6");

var $cGEBM = parcelRequire("cGEBM");
const $9e3c42c7c44204a7$export$2c4cf1f7b42ef78c = ({ buttonText: buttonText })=>{
    const intl = (0, $8e22h.default)();
    const { isSubmitting: isSubmitting, hasSubmitted: hasSubmitted, formError: formError, onClickSubmitButton: onClickSubmitButton } = (0, $cGEBM.useAccountCreationContext)();
    if (buttonText === undefined) buttonText = intl.formatMessage({
        id: 'BxpUiSignup.SignupForm.submit',
        defaultMessage: 'Sign up'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
        type: "submit",
        isDisabled: isSubmitting || hasSubmitted && !formError,
        isLoading: isSubmitting || hasSubmitted && !formError,
        onClick: onClickSubmitButton,
        className: (0, $2jatx.default)([
            "_ect41kw7 _1wyb7vkz _p12f1wug _1rjcftgi _1bsb1osq"
        ]),
        children: buttonText
    });
};
const $9e3c42c7c44204a7$var$buttonCss = null;

});

parcelRegister("8K1Jw", function(module, exports) {
$parcel$export(module.exports, "TermsAndConditions", function () { return $44792323d2da14c0$export$71c56c718a357b5; });
/* terms-and-conditions.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $iVyKn = parcelRequire("iVyKn");

var $iPPTB = parcelRequire("iPPTB");

var $jQ0cd = parcelRequire("jQ0cd");
const $44792323d2da14c0$export$71c56c718a357b5 = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("p", {
        "data-testid": "terms-and-conditions",
        className: (0, $2jatx.default)([
            "_1wyboqnp _vwz41k92 _1mou1j6v"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iVyKn.default), {
            id: "BxpUiSignup.SignupForm.termsAndConditions",
            defaultMessage: "I agree to the <termsOfServiceLink>Atlassian Customer Agreement</termsOfServiceLink>, which incorporates by reference the <aiTermsLink>AI Product-Specific Terms</aiTermsLink>, and acknowledge the <privacyPolicyLink>Privacy Policy</privacyPolicyLink>.",
            values: {
                termsOfServiceLink: $44792323d2da14c0$var$TermsOfServiceLink,
                aiTermsLink: $44792323d2da14c0$var$AiTermsLink,
                privacyPolicyLink: $44792323d2da14c0$var$PrivacyPolicyLink
            }
        })
    });
const $44792323d2da14c0$var$AiTermsLink = (text)=>{
    const aiTermsLinkHref = (0, $jQ0cd.useLocalizedHref)('/legal/product-specific-terms#atlassian-intelligence-specific-terms');
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        "aria-label": text,
        href: aiTermsLinkHref,
        text: text,
        type: "inline"
    });
};
const $44792323d2da14c0$var$PrivacyPolicyLink = (text)=>{
    const privacyPolicyLinkHref = (0, $jQ0cd.useLocalizedHref)('/legal/privacy-policy#what-this-policy-covers');
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        "aria-label": text,
        href: privacyPolicyLinkHref,
        text: text,
        type: "inline"
    });
};
const $44792323d2da14c0$var$TermsOfServiceLink = (text)=>{
    const termsOfServiceLinkHref = (0, $jQ0cd.useLocalizedHref)('/legal/cloud-terms-of-service');
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        "aria-label": text,
        href: termsOfServiceLinkHref,
        text: text,
        type: "inline"
    });
};
const $44792323d2da14c0$var$termsAndConditionsCss = null;

});



parcelRegister("9D78w", function(module, exports) {
$parcel$export(module.exports, "ProductNavBar", function () { return $b545d9db2ee66805$export$6bfdc568e00f9e3d; });
/* product-navbar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $l5ucJ = parcelRequire("l5ucJ");

var $kbpa7 = parcelRequire("kbpa7");

var $aHkxS = parcelRequire("aHkxS");

var $2Df35 = parcelRequire("2Df35");

var $80kL5 = parcelRequire("80kL5");

var $1ka2O = parcelRequire("1ka2O");

var $ldrV1 = parcelRequire("ldrV1");
const $b545d9db2ee66805$var$navigationWrapperCss = null;
const $b545d9db2ee66805$var$navigationBarWrapperCss = null;
const $b545d9db2ee66805$var$navigationBarCss = null;
const $b545d9db2ee66805$var$logoAndLinksCss = null;
const $b545d9db2ee66805$var$keyframeChevron = null;
const $b545d9db2ee66805$var$removeKeyframeChevron = null;
const $b545d9db2ee66805$var$dropdownSlideInAnimation = null;
const $b545d9db2ee66805$var$dropdownSlideOutAnimation = null;
const $b545d9db2ee66805$var$listItemCss = null;
const $b545d9db2ee66805$var$buttonWrapper = null;
const $b545d9db2ee66805$var$linkAndButtonWrapper = null;
const $b545d9db2ee66805$var$buttonStyle = null;
const $b545d9db2ee66805$var$contactSalesButtonStyle = null;
const $b545d9db2ee66805$var$logoDimensions = {
    confluence: 157,
    jiraservicemanagement: 280,
    jira: 80,
    jirasoftware: 80
};
const $b545d9db2ee66805$export$6bfdc568e00f9e3d = (props)=>{
    const intl = (0, $8e22h.default)();
    const isShowFreeHrefButton = props.showFreeHrefButton ?? true;
    const isShowContactSalesHrefButton = props.showContactSalesHrefButton ?? false;
    const showTextWithoutLogo = props.showTextWithoutLogo ?? false;
    const [activeDropdown, setActive] = (0, $1oC0p.useState)(null);
    const [buttonType, setButtonType] = (0, $1oC0p.useState)('secondary');
    const location = (0, $1ka2O.useLocation)();
    (0, $1oC0p.useEffect)(()=>{
        window.addEventListener('scroll', handleScroll);
    }, []);
    (0, $1oC0p.useEffect)(()=>{
        (0, $aHkxS.Initializer).autoTrack();
    }, [
        activeDropdown,
        props.showFreeHrefButton
    ]);
    const handleScroll = ()=>{
        setButtonType(window.scrollY > 56 ? 'primary' : 'secondary');
    };
    const getItFreeText = intl.formatMessage({
        id: 'productNavBar.get-it-free-button',
        defaultMessage: 'Get it free'
    });
    const getContactSalesText = intl.formatMessage({
        id: 'productNavBar.contact-sales-button',
        defaultMessage: 'Contact sales'
    });
    const dropdownCss = [
        null,
        !activeDropdown && null,
        activeDropdown && null
    ];
    const mobileCategoriesWrapperCss = [
        null,
        activeDropdown === null && null,
        activeDropdown && null,
        !activeDropdown && null
    ];
    const renderSelectionItems = (isMobile)=>{
        const categoriesWrapperCss = [
            !isMobile && null
        ];
        return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
            className: (0, $2jatx.default)([
                !isMobile && "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _2lx2vrvc _qtt8glyw _18s8119w _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1mjbglyw"
            ]),
            children: props.children && (0, $1oC0p.Children).map(props.children, (child, index)=>child ? /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm"
                    ]),
                    children: /*#__PURE__*/ (0, $1oC0p.cloneElement)(child, {
                        isSelected: child.props.isSelected || (0, $80kL5.isEqualUnlocalizedPathname)(child.props.href, location.pathname),
                        isMobile: isMobile
                    })
                }, index) : null)
        });
    };
    const renderDropdownButton = ()=>{
        if (props.children) return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
            onClick: ()=>setActive(!activeDropdown),
            className: (0, $2jatx.default)([
                "_1e0cglyw _80omtlke _bfhk1j28 _19itglyw _syazftjs _1q5112x7 _1752xy5q _w8l5xy5q _48hmq7pw _1mjb1ule",
                !activeDropdown && "",
                !activeDropdown && "_1px117db",
                activeDropdown && "",
                activeDropdown && "_1px11vwh"
            ]),
            style: {
                "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($l5ucJ))), {
                label: ""
            })
        });
        return null;
    };
    const logoWrapperCss = [
        props.logoLinkWrapperWidth && props.logoLinkWrapperWidth === '' && null,
        null
    ];
    const textWrapperCss = null;
    const textCss = null;
    const boxShadowCss = props.productName !== 'confluence' && props.productName !== 'jira' && null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqsw1n9t _1bsb1osq _152tidpf _1pby11wp"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4cvr1y6m _11q71afi _1e0c1txw _2lx2vrvc _1bah1h6o",
                    props.productName !== 'confluence' && props.productName !== 'jira' && "_16qsg1bn"
                ]),
                style: {
                    "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_4cvr1h6o _1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _1bah1yb4 _165t1wqb _10jx1fra _1yag119w _1vkh8vuz _13zno7np _em6nh2mm _4ik0kb7n _1gdevrvc _navj1g80 _tnru1wug _15tx119w",
                        "productNavBar"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw"
                            ]),
                            children: [
                                showTextWithoutLogo ? /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                    href: props.productHref,
                                    "aria-label": props.ariaLabel,
                                    className: (0, $2jatx.default)([
                                        "_4t3i12am _syazkhc1 _4cvr1h6o _1e0c1txw _2lx2vrvc"
                                    ]),
                                    style: {
                                        "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000'))
                                    },
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_1wyb166g _k48pbfng"
                                        ]),
                                        children: props.ariaLabel
                                    })
                                }) : /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                    href: props.productHref,
                                    "aria-label": props.ariaLabel,
                                    className: (0, $2jatx.default)([
                                        props.logoLinkWrapperWidth && props.logoLinkWrapperWidth === '' && "_1bsb2lms",
                                        "_4cvr1h6o _1e0c1txw"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
                                        brand: props.productName,
                                        type: "logo",
                                        appearance: "brand",
                                        height: '48',
                                        width: $b545d9db2ee66805$var$logoDimensions[props.productName]
                                    })
                                }),
                                renderDropdownButton(),
                                renderSelectionItems(false)
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o"
                            ]),
                            children: [
                                isShowFreeHrefButton && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c1txw _ca0qo7ao _u5f3idpf _n3tdo7ao _19bvidpf",
                                        "showFreeHrefButton"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ldrV1.Button), {
                                        text: getItFreeText,
                                        url: props.freeHref,
                                        type: buttonType,
                                        "aria-label": getItFreeText,
                                        dataEventProps: {
                                            'data-event-container': 'navbar',
                                            'data-event': 'clicked',
                                            'data-event-component': 'linkButton',
                                            'data-label': getItFreeText,
                                            'data-label-english': 'Get it free',
                                            'data-product-key': props.dataProductKey,
                                            'data-track-event': `${props.dataProductKey}.get-it-free-button-clicked`
                                        },
                                        onClick: props.onClick,
                                        className: (0, $2jatx.default)([
                                            "_1wyb1j6v _k48pbfng _4t3iviql _1bsb1wug _1aaxusic _v5647x7w _3fcw1q9c _13zmh2mm _1rfm1wug _1gdevrvc _navj1g80 _1l7dn7od"
                                        ])
                                    })
                                }),
                                isShowContactSalesHrefButton && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: "showContactSalesHrefButton",
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ldrV1.Button), {
                                        text: getContactSalesText,
                                        color: "yellow",
                                        url: props.freeHref,
                                        type: buttonType,
                                        "aria-label": getContactSalesText,
                                        dataEventProps: {
                                            'data-event-container': 'navbar',
                                            'data-event': 'clicked',
                                            'data-event-component': 'linkButton',
                                            'data-label': getContactSalesText,
                                            'data-product-key': props.dataProductKey
                                        },
                                        onClick: props.onClick,
                                        className: (0, $2jatx.default)([
                                            "_1wyb1j6v _k48pbfng _4t3iviql _11q71uly _1bsb1wug _1aaxusic _v5647x7w _3fcw1q9c _13zmh2mm _1rfm1wug _1gdevrvc _navj1g80 _1l7dn7od"
                                        ]),
                                        style: {
                                            "--_1p38jlt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.saffron400'))
                                        }
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_16jlkb7n _1o9zkb7n _i0dlf1ug _16qsg1bn _c71lidpf _1reo15vq _18m91wug _kqswstnw _1bsb1osq _bfhkg7ng _179rn5xp _102oidpf _1kvxidpf _1ysjidpf _17d4idpf _1hzio7ao _3n4midpf _ltofo7ao _k7zy1ul9 _1hmtglyw _163ro7ao _dm25glyw",
                    activeDropdown === null && "_1h6d6u2e _mqm2n5xp",
                    activeDropdown && "",
                    activeDropdown && "_c71l8stt _y44vuhag _1h6dkhc1 _mqm2kze7",
                    !activeDropdown && "",
                    !activeDropdown && "_y44v1ovr _1h6d6u2e _mqm2kze7",
                    "mobileCategoriesWrapper"
                ]),
                style: {
                    "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100')),
                    "--_qtmnbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light300')),
                    "--_n0ignx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue1000')),
                    "--_1xfz4lx": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light400'))
                },
                children: renderSelectionItems(true)
            })
        ]
    });
};
var $b545d9db2ee66805$export$2e2bcd8739ae039 = $b545d9db2ee66805$export$6bfdc568e00f9e3d;

});

parcelRegister("hBYvx", function(module, exports) {
$parcel$export(module.exports, "Video", function () { return $5a5d9245727e1968$export$ae01dedf5c052bb; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");
const $5a5d9245727e1968$var$videoStyle = (ratio)=>{
    const aspectRatioCSS = ratio && ratio !== 'none' ? {
        aspectRatio: ratio,
        objectFit: 'cover'
    } : {};
    return {
        maxWidth: '100%',
        ...aspectRatioCSS
    };
};
const $5a5d9245727e1968$export$ae01dedf5c052bb = ({ videoLink: videoLink, videoType: videoType, videoPreviewImage: videoPreviewImage, loop: loop = true, muted: muted = true, aspectRatio: aspectRatio, alternativeSources: alternativeSources, className: className, fallbackText: fallbackText, onEnded: onEnded, children: children })=>{
    const videoRef = (0, $1oC0p.useRef)(null);
    // reload video player if video source prop changes dynamically
    (0, $1oC0p.useEffect)(()=>{
        videoRef.current?.load();
    }, [
        videoLink
    ]);
    return(// eslint-disable-next-line jsx-a11y/media-has-caption
    /*#__PURE__*/ (0, $7VQPk.jsxs)("video", {
        playsInline: true,
        muted: muted,
        preload: "auto",
        poster: videoPreviewImage,
        autoPlay: true,
        className: className,
        style: $5a5d9245727e1968$var$videoStyle(aspectRatio),
        loop: loop,
        ref: videoRef,
        onEnded: onEnded,
        children: [
            fallbackText,
            /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                src: videoLink,
                type: `video/${videoType ? videoType : 'mp4'}`
            }),
            alternativeSources ? alternativeSources.map((source, index)=>{
                return /*#__PURE__*/ (0, $7VQPk.jsx)("source", {
                    src: source.videoLink,
                    type: `video/${source.videoType ? source.videoType : 'mp4'}`
                }, index);
            }) : null,
            children
        ]
    }));
};

});

parcelRegister("hGQNn", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $ce0f4ff86b3b368a$export$2e2bcd8739ae039; });

var $1oC0p = parcelRequire("1oC0p");
var $ce0f4ff86b3b368a$var$interactionContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
var $ce0f4ff86b3b368a$export$2e2bcd8739ae039 = $ce0f4ff86b3b368a$var$interactionContext;

});

parcelRegister("dYPjn", function(module, exports) {
$parcel$export(module.exports, "useModal", function () { return $a2d8ae5ca7d76b71$export$33ffd74ebf07f060; });

var $1oC0p = parcelRequire("1oC0p");

var $bgW5X = parcelRequire("bgW5X");
var $a2d8ae5ca7d76b71$export$33ffd74ebf07f060 = function useModal() {
    var modalContext = (0, $1oC0p.useContext)((0, $bgW5X.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};

});

parcelRegister("ilkqI", function(module, exports) {
$parcel$export(module.exports, "Adg4TabPanel", function () { return $640ef6c57a5f1486$export$34e8382484247e57; });
/* tab-panel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lTkkF = parcelRequire("lTkkF");

var $6jJHH = parcelRequire("6jJHH");

var $iyOcM = parcelRequire("iyOcM");
const $640ef6c57a5f1486$var$hidePanelStyle = null;
/**
 * @deprecated - Please use @/libraries/design/patterns/tabs instead
 */ const $640ef6c57a5f1486$export$34e8382484247e57 = ({ forceRender: forceRender, keepInDom: keepInDom, children: children, panelIndex: panelIndex, id: id, hideTabPanelRole: hideTabPanelRole, ...props })=>{
    const { isCurrentTab: isCurrentTab } = (0, $iyOcM.useAdg4TabsContext)();
    const isTabSelected = isCurrentTab(panelIndex);
    const activeClass = isTabSelected ? 'active-panel' : '';
    const originalChildrenCount = (0, $1oC0p.Children).count(children);
    const shouldHideRole = hideTabPanelRole !== undefined ? hideTabPanelRole : originalChildrenCount === 0;
    children = forceRender || isTabSelected || keepInDom ? children : null;
    const { panelId: panelId, tabId: tabId } = (0, $lTkkF.generateSafeIds)(id, panelIndex);
    const { css: existingCss, ...propsWithoutCss } = props;
    const filteredProps = Object.fromEntries(Object.entries(propsWithoutCss).filter(([key])=>!key.startsWith('aria-') && key !== 'role'));
    if (!shouldHideRole) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ...filteredProps,
        id: panelId,
        "aria-labelledby": tabId,
        "aria-hidden": !isTabSelected,
        role: "tabpanel",
        className: (0, $2jatx.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                'tab-panel',
                activeClass
            ].join(' ')
        ]),
        children: (0, $1oC0p.Children).map(children, (child)=>{
            return (0, $6jJHH.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    });
    const cssProp = [
        !isTabSelected && !forceRender && $640ef6c57a5f1486$var$hidePanelStyle
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        id: panelId,
        className: (0, $2jatx.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                'tab-panel',
                activeClass
            ].join(' ')
        ]),
        "aria-labelledby": undefined,
        "aria-hidden": undefined,
        role: undefined,
        children: (0, $1oC0p.Children).map(children, (child)=>{
            return (0, $6jJHH.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    });
};
$640ef6c57a5f1486$export$34e8382484247e57.tabsRole = 'Adg4TabPanel';

});

parcelRegister("a7Xqx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::471b5e5cdc883753bc3e3b52ee5ae2e2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75f8a7cd1e999c53$var$_react = $75f8a7cd1e999c53$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $75f8a7cd1e999c53$var$_baseNew = $75f8a7cd1e999c53$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $75f8a7cd1e999c53$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Backlog".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for backlogs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75f8a7cd1e999c53$var$BacklogIcon = (props)=>/*#__PURE__*/ $75f8a7cd1e999c53$var$_react.default.createElement($75f8a7cd1e999c53$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v2.167h11V3a.5.5 0 0 0-.5-.5zm10.5 4.167h-11v2.666h11zm0 4.166h-11V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5z" clip-rule="evenodd"/>`
    }, props));
$75f8a7cd1e999c53$var$BacklogIcon.displayName = 'BacklogIcon';
var $75f8a7cd1e999c53$var$_default = module.exports.default = $75f8a7cd1e999c53$var$BacklogIcon;

});

parcelRegister("aVTcD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::83cc862a6ce0fb1f7d8883d625af8c63>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f5a0c5cabda2415$var$_react = $7f5a0c5cabda2415$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $7f5a0c5cabda2415$var$_baseNew = $7f5a0c5cabda2415$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $7f5a0c5cabda2415$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BookWithBookmark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: knowledge bases, articles, and other representations of books or info.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f5a0c5cabda2415$var$BookWithBookmarkIcon = (props)=>/*#__PURE__*/ $7f5a0c5cabda2415$var$_react.default.createElement($7f5a0c5cabda2415$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 2.875A2.875 2.875 0 0 1 4.875 0h8.375a.75.75 0 0 1 .75.75V9.5a.75.75 0 0 1-.75.75V13H14v1.5h-3.5V13h1.25v-2.75H4.875a1.375 1.375 0 1 0 0 2.75H5.5v1.5h-.625A2.875 2.875 0 0 1 2 11.625zM3.5 9.1a2.86 2.86 0 0 1 1.375-.35H12.5V1.5H4.875c-.76 0-1.375.616-1.375 1.375z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.5 15.564V11.5h3v4.064a.25.25 0 0 1-.441.16L8 14.465l-1.059 1.26a.25.25 0 0 1-.441-.16"/>`
    }, props));
$7f5a0c5cabda2415$var$BookWithBookmarkIcon.displayName = 'BookWithBookmarkIcon';
var $7f5a0c5cabda2415$var$_default = module.exports.default = $7f5a0c5cabda2415$var$BookWithBookmarkIcon;

});

parcelRegister("5II9n", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35a8ca9f503841cffe12f1ff6d6bb3be>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42a34f1e2299b39e$var$_react = $42a34f1e2299b39e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $42a34f1e2299b39e$var$_baseNew = $42a34f1e2299b39e$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $42a34f1e2299b39e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Camera".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: upload photo in Trello, photos.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42a34f1e2299b39e$var$CameraIcon = (props)=>/*#__PURE__*/ $42a34f1e2299b39e$var$_react.default.createElement($42a34f1e2299b39e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.4.8A.75.75 0 0 1 6 .5h4a.75.75 0 0 1 .6.3l1.275 1.7h1.375A2.75 2.75 0 0 1 16 5.25V12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V5.25A2.75 2.75 0 0 1 2.75 2.5h1.375zM6.375 2 5.1 3.7a.75.75 0 0 1-.6.3H2.75c-.69 0-1.25.56-1.25 1.25V12a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V5.25c0-.69-.56-1.25-1.25-1.25H11.5a.75.75 0 0 1-.6-.3L9.625 2zM8 6.5A1.75 1.75 0 1 0 8 10a1.75 1.75 0 0 0 0-3.5M4.75 8.25a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0" clip-rule="evenodd"/>`
    }, props));
$42a34f1e2299b39e$var$CameraIcon.displayName = 'CameraIcon';
var $42a34f1e2299b39e$var$_default = module.exports.default = $42a34f1e2299b39e$var$CameraIcon;

});

parcelRegister("6e3tU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::451c857042316b193f6451d1ac5153c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4886c0393fe869b5$var$_react = $4886c0393fe869b5$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4886c0393fe869b5$var$_baseNew = $4886c0393fe869b5$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $4886c0393fe869b5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Comment".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for comments on objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4886c0393fe869b5$var$CommentIcon = (props)=>/*#__PURE__*/ $4886c0393fe869b5$var$_react.default.createElement($4886c0393fe869b5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 3.125A2.625 2.625 0 0 1 2.625.5h10.75A2.625 2.625 0 0 1 16 3.125v8.25A2.625 2.625 0 0 1 13.375 14H4.449l-3.327 1.901A.75.75 0 0 1 0 15.25zM2.625 2C2.004 2 1.5 2.504 1.5 3.125v10.833L4.05 12.5h9.325c.621 0 1.125-.504 1.125-1.125v-8.25C14.5 2.504 13.996 2 13.375 2zM12 6.5H4V5h8zm-3 3H4V8h5z" clip-rule="evenodd"/>`
    }, props));
$4886c0393fe869b5$var$CommentIcon.displayName = 'CommentIcon';
var $4886c0393fe869b5$var$_default = module.exports.default = $4886c0393fe869b5$var$CommentIcon;

});

parcelRegister("dO8Do", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::be0b9c9537e0b69b1d3c8d2587861fe5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a0d6a48064846045$var$_react = $a0d6a48064846045$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a0d6a48064846045$var$_baseNew = $a0d6a48064846045$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $a0d6a48064846045$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Decision".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for decisions.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a0d6a48064846045$var$DecisionIcon = (props)=>/*#__PURE__*/ $a0d6a48064846045$var$_react.default.createElement($a0d6a48064846045$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m13.97.97-4.5 4.5 1.06 1.06 4.5-4.5zM3.56 2.5H8V1H1.75a.75.75 0 0 0-.75.75V8h1.5V3.56l4.604 4.604a.5.5 0 0 1 .146.354V15h1.5V8.518a2 2 0 0 0-.586-1.414z" clip-rule="evenodd"/>`
    }, props));
$a0d6a48064846045$var$DecisionIcon.displayName = 'DecisionIcon';
var $a0d6a48064846045$var$_default = module.exports.default = $a0d6a48064846045$var$DecisionIcon;

});

parcelRegister("3FUL0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84a07eff465bcaaea8db49f0fc7877da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ad13a3cc41068cb$var$_react = $2ad13a3cc41068cb$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $2ad13a3cc41068cb$var$_baseNew = $2ad13a3cc41068cb$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $2ad13a3cc41068cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Department".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for departments, reporting lines, or other tree chart representations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2ad13a3cc41068cb$var$DepartmentIcon = (props)=>/*#__PURE__*/ $2ad13a3cc41068cb$var$_react.default.createElement($2ad13a3cc41068cb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.5.75A.75.75 0 0 1 6.25 0h3.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-1v2.25h3.125c.76 0 1.375.616 1.375 1.375V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.75h-7.5V11h1a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-.75.75h-3.5a.75.75 0 0 1-.75-.75v-3.5a.75.75 0 0 1 .75-.75h1V8.625c0-.76.616-1.375 1.375-1.375H7.25V5h-1a.75.75 0 0 1-.75-.75zM7 1.5v2h2v-2zm-4.5 11v2h2v-2zm9 0v2h2v-2z" clip-rule="evenodd"/>`
    }, props));
$2ad13a3cc41068cb$var$DepartmentIcon.displayName = 'DepartmentIcon';
var $2ad13a3cc41068cb$var$_default = module.exports.default = $2ad13a3cc41068cb$var$DepartmentIcon;

});

parcelRegister("3OOxO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e8b466fb905db85ecf24180397d24c4f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2c7d3fa40e32f890$var$_react = $2c7d3fa40e32f890$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $2c7d3fa40e32f890$var$_baseNew = $2c7d3fa40e32f890$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $2c7d3fa40e32f890$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2c7d3fa40e32f890$var$EditIcon = (props)=>/*#__PURE__*/ $2c7d3fa40e32f890$var$_react.default.createElement($2c7d3fa40e32f890$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.708zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.216l-.54 1.891 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V10H15v3.001a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$2c7d3fa40e32f890$var$EditIcon.displayName = 'EditIcon';
var $2c7d3fa40e32f890$var$_default = module.exports.default = $2c7d3fa40e32f890$var$EditIcon;

});

parcelRegister("2JPM3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ed0744cae5af6a1635a1b9234b867386>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1fe7f200582e6f72$var$_react = $1fe7f200582e6f72$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $1fe7f200582e6f72$var$_baseNew = $1fe7f200582e6f72$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $1fe7f200582e6f72$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Emoji".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for Editor as a category for Emoji's.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1fe7f200582e6f72$var$EmojiIcon = (props)=>/*#__PURE__*/ $1fe7f200582e6f72$var$_react.default.createElement($1fe7f200582e6f72$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m4.5-1.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m4.5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0m-2.915 3.783c.486.378 1.14.717 1.915.717s1.43-.34 1.915-.717a4.4 4.4 0 0 0 .721-.714l.005-.007-.001.002.61.436.61.436-.001.002-.002.003-.006.007-.016.023-.056.071q-.07.091-.2.235c-.17.189-.42.439-.744.69-.64.497-1.61 1.033-2.835 1.033s-2.196-.536-2.835-1.033a6 6 0 0 1-.944-.925l-.056-.071-.016-.023-.006-.007-.002-.003v-.001s-.001-.001.609-.437l.61-.436-.001-.002.005.007.03.04q.045.056.139.161c.126.14.313.327.552.513" clip-rule="evenodd"/>`
    }, props));
$1fe7f200582e6f72$var$EmojiIcon.displayName = 'EmojiIcon';
var $1fe7f200582e6f72$var$_default = module.exports.default = $1fe7f200582e6f72$var$EmojiIcon;

});

parcelRegister("6pmKv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7831691c1245bdf104acebfc690a968c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4aa6b95fb2f2f167$var$_react = $4aa6b95fb2f2f167$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4aa6b95fb2f2f167$var$_baseNew = $4aa6b95fb2f2f167$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $4aa6b95fb2f2f167$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "EyeOpen".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: watch page in Confluence, show password in text field, and following in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4aa6b95fb2f2f167$var$EyeOpenIcon = (props)=>/*#__PURE__*/ $4aa6b95fb2f2f167$var$_react.default.createElement($4aa6b95fb2f2f167$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3.5c-2.943 0-5.49 1.845-6.424 4.396a.3.3 0 0 0 0 .208C2.509 10.655 5.057 12.5 8 12.5s5.49-1.845 6.424-4.396a.3.3 0 0 0 0-.208C13.491 5.345 10.943 3.5 8 3.5M.167 7.38C1.32 4.232 4.433 2 8 2c3.566 0 6.681 2.232 7.833 5.38.146.4.146.84 0 1.24C14.68 11.768 11.566 14 8 14 4.433 14 1.319 11.768.167 8.62a1.8 1.8 0 0 1 0-1.24M8 6.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M5 8a3 3 0 1 1 6 0 3 3 0 0 1-6 0" clip-rule="evenodd"/>`
    }, props));
$4aa6b95fb2f2f167$var$EyeOpenIcon.displayName = 'EyeOpenIcon';
var $4aa6b95fb2f2f167$var$_default = module.exports.default = $4aa6b95fb2f2f167$var$EyeOpenIcon;

});

parcelRegister("6j91P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238518c984ab5d0530bd2cff7eccbeb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $497b855083b7f301$var$_react = $497b855083b7f301$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $497b855083b7f301$var$_baseNew = $497b855083b7f301$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $497b855083b7f301$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $497b855083b7f301$var$FeedbackIcon = (props)=>/*#__PURE__*/ $497b855083b7f301$var$_react.default.createElement($497b855083b7f301$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$497b855083b7f301$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $497b855083b7f301$var$_default = module.exports.default = $497b855083b7f301$var$FeedbackIcon;

});

parcelRegister("2RA08", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ac12335f661fcbcd071a3693f0f2aa2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $215c7517353ffee6$var$_react = $215c7517353ffee6$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $215c7517353ffee6$var$_baseNew = $215c7517353ffee6$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $215c7517353ffee6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "File".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: document, file. Do not use to represent a page — use the dedicated 'Page' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $215c7517353ffee6$var$FileIcon = (props)=>/*#__PURE__*/ $215c7517353ffee6$var$_react.default.createElement($215c7517353ffee6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V5.25c0-.52-.206-1.017-.573-1.384L10.134.573A1.96 1.96 0 0 0 8.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h4v3.75c0 .414.336.75.75.75h3.75v8a.5.5 0 0 1-.5.5zm7.94-10H9.5V2.06z" clip-rule="evenodd"/>`
    }, props));
$215c7517353ffee6$var$FileIcon.displayName = 'FileIcon';
var $215c7517353ffee6$var$_default = module.exports.default = $215c7517353ffee6$var$FileIcon;

});

parcelRegister("9A47Z", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b192fbc7db5453924997563ea93d01df>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6f9aad8d62c1233e$var$_react = $6f9aad8d62c1233e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6f9aad8d62c1233e$var$_baseNew = $6f9aad8d62c1233e$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $6f9aad8d62c1233e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Files".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: documents, files. Do not use to represent pages — use the dedicated 'Pages' icon instead.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6f9aad8d62c1233e$var$FilesIcon = (props)=>/*#__PURE__*/ $6f9aad8d62c1233e$var$_react.default.createElement($6f9aad8d62c1233e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 11a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4.25c0-.52-.208-1.02-.578-1.385L9.072.543A1.88 1.88 0 0 0 7.75 0H4a2 2 0 0 0-2 2zm2 .5a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h3v2.75c0 .414.336.75.75.75h2.75v6a.5.5 0 0 1-.5.5zm5.93-8H8.5V2.087z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7 16h4.75A3.25 3.25 0 0 0 15 12.75V5h-1.5v7.75a1.75 1.75 0 0 1-1.75 1.75H7z" clip-rule="evenodd"/>`
    }, props));
$6f9aad8d62c1233e$var$FilesIcon.displayName = 'FilesIcon';
var $6f9aad8d62c1233e$var$_default = module.exports.default = $6f9aad8d62c1233e$var$FilesIcon;

});

parcelRegister("cNamI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5f93e34be6622a1cb8208e9984b09a45>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $950219ff5e98641d$var$_react = $950219ff5e98641d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $950219ff5e98641d$var$_baseNew = $950219ff5e98641d$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $950219ff5e98641d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Lightbulb".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: learnings in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $950219ff5e98641d$var$LightbulbIcon = (props)=>/*#__PURE__*/ $950219ff5e98641d$var$_react.default.createElement($950219ff5e98641d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M10 12.5H6V14a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5zm-2-11c-3.022 0-4.935 3.243-3.473 5.888L5.535 9.21c.303.548.463 1.164.465 1.79h4a3.7 3.7 0 0 1 .465-1.79l1.008-1.822C12.935 4.743 11.022 1.5 8 1.5M11.5 14a2 2 0 0 1-2 2h-3a2 2 0 0 1-2-2v-2.988a2.2 2.2 0 0 0-.277-1.075L3.215 8.114C1.2 4.47 3.835 0 8 0c4.164 0 6.8 4.47 4.785 8.114l-1.008 1.823a2.2 2.2 0 0 0-.277 1.075z"/>`
    }, props));
$950219ff5e98641d$var$LightbulbIcon.displayName = 'LightbulbIcon';
var $950219ff5e98641d$var$_default = module.exports.default = $950219ff5e98641d$var$LightbulbIcon;

});

parcelRegister("eAAXu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c464a7d95484e897372db9f1fff872cb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9f118b18787d1b2$var$_react = $a9f118b18787d1b2$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a9f118b18787d1b2$var$_baseNew = $a9f118b18787d1b2$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $a9f118b18787d1b2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ListBulleted".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: bulleted lists, view all.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a9f118b18787d1b2$var$ListBulletedIcon = (props)=>/*#__PURE__*/ $a9f118b18787d1b2$var$_react.default.createElement($a9f118b18787d1b2$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.5 4.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m0 7.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M16 5H6V3.5h10zm0 7.5H6V11h10z" clip-rule="evenodd"/>`
    }, props));
$a9f118b18787d1b2$var$ListBulletedIcon.displayName = 'ListBulletedIcon';
var $a9f118b18787d1b2$var$_default = module.exports.default = $a9f118b18787d1b2$var$ListBulletedIcon;

});

parcelRegister("6hGO6", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8bbccaea74398c387e69395dfeae5f34>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4935892ffc4dede5$var$_react = $4935892ffc4dede5$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4935892ffc4dede5$var$_baseNew = $4935892ffc4dede5$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $4935892ffc4dede5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PeopleGroup".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: representing a group or collection of people or users.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4935892ffc4dede5$var$PeopleGroupIcon = (props)=>/*#__PURE__*/ $4935892ffc4dede5$var$_react.default.createElement($4935892ffc4dede5$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9 4.5a2 2 0 1 1 4 0 2 2 0 0 1-4 0M11 1a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7M3 5.5a1 1 0 1 1 2 0 1 1 0 0 1-2 0M4 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M2.625 9A2.625 2.625 0 0 0 0 11.625V13h1.5v-1.375c0-.621.504-1.125 1.125-1.125H5V9zM6 12.5A3.5 3.5 0 0 1 9.5 9h3a3.5 3.5 0 0 1 3.5 3.5V14h-1.5v-1.5a2 2 0 0 0-2-2h-3a2 2 0 0 0-2 2V14H6z" clip-rule="evenodd"/>`
    }, props));
$4935892ffc4dede5$var$PeopleGroupIcon.displayName = 'PeopleGroupIcon';
var $4935892ffc4dede5$var$_default = module.exports.default = $4935892ffc4dede5$var$PeopleGroupIcon;

});

parcelRegister("gHoFv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1e0a5e9b0b4b1b954a0d2b89a777fbfe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c283cc1eb873ea6d$var$_react = $c283cc1eb873ea6d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $c283cc1eb873ea6d$var$_baseNew = $c283cc1eb873ea6d$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $c283cc1eb873ea6d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Roadmap".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for roadmaps in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c283cc1eb873ea6d$var$RoadmapIcon = (props)=>/*#__PURE__*/ $c283cc1eb873ea6d$var$_react.default.createElement($c283cc1eb873ea6d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zM3 11a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z" clip-rule="evenodd"/>`
    }, props));
$c283cc1eb873ea6d$var$RoadmapIcon.displayName = 'RoadmapIcon';
var $c283cc1eb873ea6d$var$_default = module.exports.default = $c283cc1eb873ea6d$var$RoadmapIcon;

});

parcelRegister("5R44a", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::045b0e6f318b6cb40cf896c360eca820>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $44350e76e967080f$var$_react = $44350e76e967080f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $44350e76e967080f$var$_baseNew = $44350e76e967080f$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $44350e76e967080f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Teams".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for teams in Atlassian.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $44350e76e967080f$var$TeamsIcon = (props)=>/*#__PURE__*/ $44350e76e967080f$var$_react.default.createElement($44350e76e967080f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 2.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M1 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0m11-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M9 4a3 3 0 1 1 6 0 3 3 0 0 1-6 0M3.75 9.5a2.25 2.25 0 0 0-2.25 2.25V13a.5.5 0 0 0 .5.5h4V15H2a2 2 0 0 1-2-2v-1.25A3.75 3.75 0 0 1 3.75 8h1.149a3.75 3.75 0 0 1 3.524 2.469l.564 1.55A2.25 2.25 0 0 0 11.1 13.5H14a.5.5 0 0 0 .5-.5v-1.25a2.25 2.25 0 0 0-2.25-2.25H12c-.775 0-1.258.06-1.531.112-.137.026-.22.05-.26.062l-.027.01.007-.003.01-.004.005-.003.003-.002h.002c.001-.001.001-.001-.334-.672l-.335-.671h.001l.002-.002.004-.001.008-.004.018-.008a1 1 0 0 1 .174-.066q.156-.053.44-.11C10.572 8.065 11.15 8 12 8h.25A3.75 3.75 0 0 1 16 11.75V13a2 2 0 0 1-2 2h-2.899a3.75 3.75 0 0 1-3.524-2.469l-.564-1.55A2.25 2.25 0 0 0 4.9 9.5z" clip-rule="evenodd"/>`
    }, props));
$44350e76e967080f$var$TeamsIcon.displayName = 'TeamsIcon';
var $44350e76e967080f$var$_default = module.exports.default = $44350e76e967080f$var$TeamsIcon;

});

parcelRegister("i1SI4", function(module, exports) {
$parcel$export(module.exports, "CustomerTestimonials", function () { return $82b7f8eaea519598$export$ff99f9acc73d9931; });
/* customer-testimonials.tsx generated by @compiled/babel-plugin v0.28.8 */ // Initial changes from ADG4CustomerTestimonials
// Removed scroll Ref and inview tracker, since there is no longer an automatic transition to new tabs
// Removed className since it was not in use
// Removed testimonialCta since that is a non standard usage in the Confluence Product Tour and clouds the core Design Pattern
// Removed Blue as an option for backgrounds for now since that is not spec
// Removed h2 heading (that should be included as a Content Block separately going forward)
// Removed TypographyStyles wrapper for consistency with other components/patterns
// Cleaned up unused classnames within the component

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $9s3Hk = parcelRequire("9s3Hk");

var $90TSV = parcelRequire("90TSV");

var $ilkqI = parcelRequire("ilkqI");

var $iyOcM = parcelRequire("iyOcM");

var $ftgEA = parcelRequire("ftgEA");

var $bSVv5 = parcelRequire("bSVv5");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $hfzfc = parcelRequire("hfzfc");
// Not able to use wacToken function with cssMap. Need to refactor this in the future to use dynamic functions
const $82b7f8eaea519598$var$backgroundColorStyleMap = {
    black: "_bfhkr3uz",
    white: "_bfhku67f"
};
const $82b7f8eaea519598$var$backgroundShape = null;
const $82b7f8eaea519598$var$fontColorStyleMap = {
    'dark-bg': "_syaz12cp",
    'white-bg': "_syazn7od"
};
const $82b7f8eaea519598$var$topLineStyleMap = {
    black: "_bfhku67f",
    white: "_bfhkr3uz"
};
const $82b7f8eaea519598$var$logoOptionStyleMap = {
    'dark-bg': "_d4ksu67f _i862u67f _1uiy16sm",
    'white-bg': "_d4ksr3uz _i862r3uz"
};
const $82b7f8eaea519598$var$justifyContentStyleMap = {
    'dark-bg': "_1bahh9n0",
    'white-bg': "_1bah1h6o"
};
const $82b7f8eaea519598$export$ff99f9acc73d9931 = ({ bgColor: bgColor = 'black', testimonials: testimonials, productKey: productKey, secondaryCta: secondaryCta })=>{
    const bgTheme = bgColor === 'black' ? 'dark-bg' : 'white-bg';
    const renderTestimonials = (showSecondaryCta)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $iyOcM.Adg4Tabs), {
            loop: true,
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswh2mm _1pbykb7n _6rth1jfw",
                        $82b7f8eaea519598$var$fontColorStyleMap[bgTheme]
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                        layout: "12",
                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_kqswstnw _1r04idpf _1bsb1lk2 _p12fklux _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1rfm1osq",
                                        $82b7f8eaea519598$var$backgroundColorStyleMap[bgColor],
                                        bgColor === 'black' && "_mkrzq8qa _kxoh75ra"
                                    ])
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1e0c11p5 _yv0ehkll _2z05hkll _1ir7idpf _bhknkb7n _1rrs1txw _s9hn1ekt _16l7kb7n _w53ccs5v"
                                    ]),
                                    children: testimonials.map((testimonial, index)=>{
                                        return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ilkqI.Adg4TabPanel), {
                                            id: `${index}`,
                                            panelIndex: index,
                                            forceRender: true,
                                            hideTabPanelRole: testimonials.length === 1,
                                            children: /*#__PURE__*/ (0, $7VQPk.jsx)($82b7f8eaea519598$var$TopRowContent, {
                                                testimonial: testimonial,
                                                index: index,
                                                bgTheme: bgTheme,
                                                bgColor: bgColor,
                                                productKey: productKey,
                                                secondaryCta: secondaryCta,
                                                showSecondaryCta: showSecondaryCta
                                            })
                                        }, index);
                                    })
                                }),
                                testimonials.length > 1 && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_kqswh2mm _1e0c1txw _1p57pxbi _1n261g80 _4cvr1fhb _1gde1bp4 _xsmr1h6o"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1reo15vq _18m915vq _1bsb1osq _1bah1yb4 _1v611bp4 _476dgktf"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $90TSV.Adg4DraggableTabList), {
                                            rowGap: "32px",
                                            className: (0, $2jatx.default)([
                                                "_6rth1fu0 _1q511aa3 _qtt8agmp"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                    className: (0, $2jatx.default)([
                                                        "_kqswstnw _152tt94y _1e02idpf _rjxpidpf _4t3it94y _2rkoyh40 _tzy4105o _xaej183y",
                                                        $82b7f8eaea519598$var$topLineStyleMap[bgColor]
                                                    ])
                                                }),
                                                testimonials.map((testimonial, index)=>{
                                                    return testimonial.logo ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9s3Hk.Adg4DraggableTab), {
                                                        as: "li",
                                                        tabIndex: index,
                                                        dataEventProps: {
                                                            'data-product-key': productKey,
                                                            'data-event-component': 'tab',
                                                            'data-event-container': 'testimonialsSection',
                                                            'data-event': 'clicked',
                                                            'data-label-english': testimonial.label
                                                        },
                                                        label: testimonial.label,
                                                        className: (0, $2jatx.default)([
                                                            $82b7f8eaea519598$var$logoOptionStyleMap[bgTheme],
                                                            "_1e0c1txw _1bah1fhb _4cvr1fhb _kqswh2mm _1atpidpf"
                                                        ]),
                                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)($82b7f8eaea519598$var$LogoTabContent, {
                                                            testimonialLogo: testimonial.logo
                                                        })
                                                    }, index) : null;
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        });
    // Hoist the experiment check to the section level so exposure fires exactly
    // once per page view. Rendering ExperimentView inside the per-testimonial
    // loop would fire one exposure per card and corrupt the experiment metrics.
    if (secondaryCta) return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hfzfc.ExperimentView), {
        experiment: secondaryCta.experiment,
        render: (isEnabled)=>renderTestimonials(isEnabled)
    });
    return renderTestimonials(false);
};
const $82b7f8eaea519598$var$TopRowContent = ({ testimonial: testimonial, index: index, bgTheme: bgTheme, bgColor: bgColor, isPanelActive: isPanelActive, productKey: productKey, secondaryCta: secondaryCta, showSecondaryCta: showSecondaryCta = false })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c1txw _1p57pxbi _1n261g80 _4cvr1fhb _1gde1bp4 _xsmr1h6o",
            "_6rth1ylp _1e0c11p5 _yv0ewxkt _gy1pzwfg _tzy4idpf _1pbykb7n _1ph4hkll",
            isPanelActive && "_tzy4kb7n _1pbycs5v"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _i0dlhwvj _1e0c1txw _1bah1h6o _4cvresu3 _16xt1ssb _1rfm1vuk _q5ugidpf _7tld1wug _14adidpf _4uro1wug _7bcc1n8h _18jmidpf _qji61wug _ms0lidpf _v5we1wug"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bna7ng7t _1jtm1c95 _1fhe1c95 _1cwsdlvw _mezj1wug _rtys1osq _1jpx1f51 _v4pn1ule",
                        isPanelActive && "_m3691nt4"
                    ]),
                    children: typeof testimonial.image !== 'string' && 'contentType' in testimonial.image ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ftgEA.ContentPlatformImage), {
                        ...testimonial.image
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                        src: testimonial.image,
                        alt: ""
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_i0dl1nrf _1reo15vq _18m915vq _bozg1b66 _85i51b66 _1a8l1ssb"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4t3i1osq _2rkogktf _kqswh2mm _19pkidpf _2hwx1wug _otyridpf _18u01wug _26vxys9h _12rr1e9y _1rfm1osq",
                        $82b7f8eaea519598$var$justifyContentStyleMap[bgTheme]
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_v5641pn7 _1e0c1txw _2lx21bp4 _zulp1tcg",
                            isPanelActive && "_y44v13sw _11vozap6"
                        ]),
                        children: [
                            testimonial.eyebrow && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    $82b7f8eaea519598$var$fontColorStyleMap[bgTheme],
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "eyebrow-md"
                                ]),
                                children: testimonial.eyebrow
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("blockquote", {
                                className: (0, $2jatx.default)([
                                    $82b7f8eaea519598$var$fontColorStyleMap[bgTheme],
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "callout"
                                ]),
                                children: [
                                    "\u201C",
                                    testimonial.quote,
                                    "\u201D"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            $82b7f8eaea519598$var$fontColorStyleMap[bgTheme],
                                            "eyebrow-lg"
                                        ]),
                                        children: testimonial.name
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            $82b7f8eaea519598$var$fontColorStyleMap[bgTheme],
                                            "body-md title"
                                        ]),
                                        children: testimonial.title
                                    })
                                ]
                            }),
                            testimonial.link || secondaryCta && showSecondaryCta ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1n261g80 _4cvr1h6o _gy1p1tcg _1p57ftgi"
                                ]),
                                children: [
                                    testimonial.link ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                        anchorProps: {
                                            tabIndex: isPanelActive ? 0 : -1
                                        },
                                        text: testimonial.link.text,
                                        href: testimonial.link.url,
                                        type: testimonial.link.type ?? 'primary',
                                        bgColor: bgColor === 'black' ? 'bgBlackBlue' : 'bgWhite',
                                        "aria-label": testimonial.link.text,
                                        dataEventProps: testimonial.link.dataEventProps ?? {
                                            'data-product-key': productKey,
                                            'data-event-component': 'linkButton',
                                            'data-event-container': 'testimonialsSection',
                                            'data-event': 'clicked'
                                        }
                                    }) : null,
                                    secondaryCta && showSecondaryCta ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                        anchorProps: {
                                            tabIndex: isPanelActive ? 0 : -1
                                        },
                                        text: secondaryCta.text,
                                        href: secondaryCta.href,
                                        type: "primary",
                                        bgColor: bgColor === 'black' ? 'bgBlackBlue' : 'bgWhite',
                                        "aria-label": secondaryCta.text,
                                        showArrow: true,
                                        dataEventProps: // The `customerStoryCard` container is only valid in the
                                        // DataEventProps union variant keyed to the 'customers'
                                        // product key, so this fallback is intentionally
                                        // surface-specific. Callers on other surfaces should pass
                                        // their own `secondaryCta.dataEventProps`.
                                        secondaryCta.dataEventProps ?? {
                                            'data-product-key': 'customers',
                                            'data-event-component': 'link',
                                            'data-event-container': 'customerStoryCard',
                                            'data-event': 'clicked'
                                        }
                                    }) : null
                                ]
                            }) : null
                        ]
                    }, index)
                })
            })
        ]
    });
};
const $82b7f8eaea519598$var$topRowActiveStyle = null;
const $82b7f8eaea519598$var$customerImagesImgActiveStyle = null;
const $82b7f8eaea519598$var$quoteContainerActiveStyle = null;
const $82b7f8eaea519598$var$LogoTabContent = ({ testimonialLogo: testimonialLogo, isSelected: isSelected = false })=>{
    const isContentfulImage = 'contentType' in testimonialLogo;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_tzy4kb7n _kqswstnw _152tj39m _1e02idpf _rjxpidpf _4t3i14y2 _2rkoyh40",
                    "top-marker"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_11q7glyw _19itidpf _r06hglyw _1q51gktf _80omtlke _kqswh2mm"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_tzy4105o _v5641bs3 _16l4kb7n",
                        "_4t3i1u1b _1e0c1txw _4cvr1h6o",
                        isSelected && "_tzy4kb7n"
                    ]),
                    children: isContentfulImage ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ftgEA.ContentPlatformImage), {
                        ...testimonialLogo,
                        width: "140",
                        height: "34",
                        style: {
                            objectFit: 'contain',
                            objectPosition: 'center center'
                        },
                        className: "tab-logo",
                        draggable: "false"
                    }) : testimonialLogo
                })
            })
        ]
    });
};
// LogoTabContent styles
const $82b7f8eaea519598$var$logoImgStyle = null;
const $82b7f8eaea519598$var$logoImgSelectedStyle = null;
const $82b7f8eaea519598$var$logoButtonStyle = null;
const $82b7f8eaea519598$var$topMarkerStyle = null;
const $82b7f8eaea519598$var$logoImgContainerStyle = null;
// ADG4CustomerTestimonials styles
const $82b7f8eaea519598$var$topLineStyles = null;
const $82b7f8eaea519598$var$testimonialKeyframeStyles = null;
const $82b7f8eaea519598$var$rowWidthStyle = null;
const $82b7f8eaea519598$var$topRowStyle = null;
const $82b7f8eaea519598$var$bgShapeStyle = null;
const $82b7f8eaea519598$var$customerImagesSectionStyles = null;
const $82b7f8eaea519598$var$customerImagesSectionImageStyles = null;
const $82b7f8eaea519598$var$customerQuotesSectionStyle = null;
const $82b7f8eaea519598$var$testimonialQuotesSectionStyle = null;
const $82b7f8eaea519598$var$quoteContainerStyle = null;
// Lays the primary "Read customer story" link and the experiment-gated
// "Try it free" secondary CTA inline (side by side), matching the poster's
// "inline to the right of the existing CTA" treatment spec. Wraps on narrow
// viewports so the card layout stays intact.
const $82b7f8eaea519598$var$ctaRowStyle = null;
const $82b7f8eaea519598$var$quoteContainerPStyle = null;
const $82b7f8eaea519598$var$logosContainerBaseStyle = null;
const $82b7f8eaea519598$var$logosStyle = null;
const $82b7f8eaea519598$var$logoOptionStyle = null;
const $82b7f8eaea519598$var$testimonialStyles = null;
const $82b7f8eaea519598$var$tabPanelWrapperStyles = null;

});
parcelRegister("ftgEA", function(module, exports) {
$parcel$export(module.exports, "ContentPlatformImage", function () { return $93bafa18ccb06246$export$f8e4eb6f7b9af79c; });

var $7VQPk = parcelRequire("7VQPk");

var $hnmMQ = parcelRequire("hnmMQ");
const $93bafa18ccb06246$export$f8e4eb6f7b9af79c = ({ contentType: contentType, src: src, alt: alt, baseWidth: baseWidth, ...rest })=>{
    const queryPairs = [];
    let srcSet = [];
    if (contentType === 'image/png') {
        queryPairs.push('fm=webp');
        if (baseWidth) {
            srcSet = (0, $hnmMQ.getSrcSet)(src, baseWidth, queryPairs, 'w');
            queryPairs.push(`w=${baseWidth}`);
        }
    }
    const queryString = queryPairs.length > 0 ? `?${queryPairs.join('&')}` : '';
    return(// eslint-disable-next-line no-restricted-syntax
    /*#__PURE__*/ (0, $7VQPk.jsx)("img", {
        loading: "lazy",
        ...rest,
        src: `${src}${queryString}`,
        srcSet: srcSet.length > 0 ? srcSet.join(',') : undefined,
        alt: alt
    }));
};

});


parcelRegister("4Fnxt", function(module, exports) {
$parcel$export(module.exports, "AnimateCount", function () { return $cac0a62c179e6d20$export$b0e73e8bb50a1e4a; });
$parcel$export(module.exports, "Stats", function () { return $cac0a62c179e6d20$export$3cdec2bba15e3523; });
/* stats.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $6iKF0 = parcelRequire("6iKF0");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");
const $cac0a62c179e6d20$var$earthStyles = null;
const $cac0a62c179e6d20$export$cc52242338d2406f = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_kqswstnw _1e02idpf _152txard _bna71wug _rtys1osq _t9ec1u9r _1h1t1ekt _tnru1wug _1rfm12eq _xaejlc6t _1eg616tw _95u51a2f"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
            image: {
                src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/435e558616x6e3c2jvth65jiq2vusf20.webp',
                alt: '',
                width: 700,
                height: 700
            }
        })
    });
};
const $cac0a62c179e6d20$var$easeOutQuad = (t)=>t * (2 - t);
const $cac0a62c179e6d20$var$frameDuration = 1000 / 60;
const $cac0a62c179e6d20$export$b0e73e8bb50a1e4a = ({ children: children = '0', duration: duration = 2000 })=>{
    const countTo = parseInt(children, 10);
    const [count, setCount] = (0, $1oC0p.useState)(0);
    (0, $1oC0p.useEffect)(()=>{
        let frame = 0;
        const totalFrames = Math.round(duration / $cac0a62c179e6d20$var$frameDuration);
        const counter = setInterval(()=>{
            frame++;
            const progress = $cac0a62c179e6d20$var$easeOutQuad(frame / totalFrames);
            setCount(countTo * progress);
            if (frame === totalFrames) clearInterval(counter);
        }, $cac0a62c179e6d20$var$frameDuration);
        return ()=>clearInterval(counter);
    }, [
        countTo,
        duration
    ]);
    return Math.floor(count).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
const $cac0a62c179e6d20$export$3cdec2bba15e3523 = (statsProps)=>{
    const { ref: scrollRef, inView: sectionIsVisible } = (0, $jKShK.useInView)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: scrollRef,
        className: (0, $2jatx.default)([
            "_p12f1git _19pkidpf _2hwx1wug _otyridpf _18u01wug _kqswh2mm _1pbykb7n _ca0qymf6 _u5f3idpf _n3td53f4 _19bvidpf _1reo15vq _18m915vq _11q7g7ng _mkrz13pj _1vth1g58 _1kmxidpf _1ggmidpf _1ykzidpf _1maeidpf _srwz1ylp"
        ]),
        style: {
            "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
            layout: "12",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1q51gktf _85i5gktf _1gde1bp4",
                    "wrapper"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1q511ul9 _p12f1osq _1e0c1txw _4cvr1y6m _zulp1ylp _kqswh2mm _1t19idpf _p7vbidpf _1rhg1w8u _19wggktf _1gde1bp4 _1u2q1wqb",
                            "text-wrapper"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_16jlkb7n _1o9zkb7n _i0dl1ssb _1fe7kb7n _12ihkb7n _1a1xf1ug _1rfm1osq",
                                    "fifty"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                        className: (0, $2jatx.default)([
                                            "_1wyb8pqr _vwz4cjiy _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: statsProps.headerText
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                        className: (0, $2jatx.default)([
                                            "_ect41sko _vwz4zg3v _k48p53lb _19pk19bv _2hwxidpf _otyrftgi _18u0idpf _kqswh2mm _syaz5hrz",
                                            "_1wyb1qf2 _g4miqd8k _1lzo1bc9",
                                            "big-stat"
                                        ]),
                                        style: {
                                            "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display')),
                                            "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                                className: (0, $2jatx.default)([
                                                    "_syazaktq",
                                                    "big-stat"
                                                ]),
                                                style: {
                                                    "--_ne49vm": (0, $6ZVlx.default)(statsProps.bigStat.statColor ? statsProps.bigStat.statColor : (0, $kbpa7.wacToken)('color.primary.black'))
                                                },
                                                children: [
                                                    ' ',
                                                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iKF0.default), {
                                                        fallback: null,
                                                        children: sectionIsVisible ? /*#__PURE__*/ (0, $7VQPk.jsx)($cac0a62c179e6d20$export$b0e73e8bb50a1e4a, {
                                                            children: statsProps.bigStat.stat
                                                        }) : statsProps.bigStat.stat
                                                    })
                                                ]
                                            }),
                                            statsProps.bigStat.statSymbol && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                className: (0, $2jatx.default)([
                                                    "_syaz3hme"
                                                ]),
                                                style: {
                                                    "--_1fkywrn": (0, $6ZVlx.default)(statsProps.bigStat.statSymbol?.symbolCharacterColor ? statsProps.bigStat.statSymbol.symbolCharacterColor : (0, $kbpa7.wacToken)('color.primary.black'))
                                                },
                                                children: statsProps.bigStat.statSymbol?.symbolCharacter
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                        className: (0, $2jatx.default)([
                                            "_1wyb1j6v _k48pl8b6 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                        ]),
                                        children: statsProps.bigStat.statText
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_16jlkb7n _1o9zkb7n _i0dl1r5k _1e0c1txw _zulpgktf _2lx21bp4 _y4ti1ylp _1fe7kb7n _12ihkb7n _1a1xf1ug _chtuidpf",
                                    "thirty"
                                ]),
                                children: statsProps.littleStats.map((statObj, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                        className: (0, $2jatx.default)([
                                            "_kqswh2mm _bozggktf",
                                            "stat-wrapper"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_kqswstnw _4t3i1osq _11q71pfd _1bsbyh40 _1e02idpf"
                                                ]),
                                                style: {
                                                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black'))
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                className: (0, $2jatx.default)([
                                                    "_ect41sko _vwz4zg3v _k48p53lb _19pk19bv _2hwxidpf _otyrftgi _18u0idpf _kqswh2mm _syaz5hrz",
                                                    "_1wybxxch",
                                                    "little-stat"
                                                ]),
                                                style: {
                                                    "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display')),
                                                    "--_c47zot": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.blue'))
                                                },
                                                children: /*#__PURE__*/ (0, $7VQPk.jsxs)("span", {
                                                    className: (0, $2jatx.default)([
                                                        "_syaz1ymr"
                                                    ]),
                                                    style: {
                                                        "--_1bdhz6v": (0, $6ZVlx.default)(statObj.statColor ? statObj.statColor : (0, $kbpa7.wacToken)('color.primary.black'))
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6iKF0.default), {
                                                            fallback: null,
                                                            children: sectionIsVisible ? /*#__PURE__*/ (0, $7VQPk.jsx)($cac0a62c179e6d20$export$b0e73e8bb50a1e4a, {
                                                                children: statObj.stat
                                                            }) : statObj.stat
                                                        }),
                                                        statObj.statSymbol && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                                            className: (0, $2jatx.default)([
                                                                "_syazo46c"
                                                            ]),
                                                            style: {
                                                                "--_hlkh7k": (0, $6ZVlx.default)(statObj.statSymbol?.symbolCharacterColor ? statObj.statSymbol.symbolCharacterColor : (0, $kbpa7.wacToken)('color.primary.black'))
                                                            },
                                                            children: statObj.statSymbol?.symbolCharacter
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                                className: (0, $2jatx.default)([
                                                    "_1wyb1j6v _k48pl8b6 _19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                                ]),
                                                children: statObj.statText
                                            })
                                        ]
                                    }, index))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1h1tgbua _kqswh2mm _rjxpidpf _u7coidpf _152tidpf _4t3i1osq _1e0c1txw _1bah1h6o _mmgkgktf _1rfm1osq _tnru68cl _srwzidpf _476d1ylp _1t06idpf _1jc21gwv _10jx1gwv",
                            "earth-contents"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)($cac0a62c179e6d20$export$cc52242338d2406f, {}),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("svg", {
                                className: (0, $2jatx.default)([
                                    "_kqswstnw _152tidpf _1o2w1n0t _rjxp3ll0 _p5ce1x96 _1l7d176h _xaej15qf _1rfm68cl _tnru1wug",
                                    "blob"
                                ]),
                                width: "102",
                                height: "95",
                                "aria-hidden": "true",
                                viewBox: "0 0 102 95",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("g", {
                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                        d: "M97.6377 58.2134C98.2297 54.8868 98.5329 51.356 98.5329 47.6063C98.5329 43.8566 98.2152 40.2236 97.6233 36.8533C94.057 16.8063 80.2829 4.44834 60.9645 1.28226C57.6726 0.742421 54.2074 0.46521 50.6123 0.46521C47.0172 0.46521 43.2632 0.771614 39.8414 1.34063C20.5085 4.60885 6.74887 16.923 3.18262 36.8533C2.57621 40.2236 2.27301 43.7982 2.27301 47.6063C2.27301 51.4143 2.57621 54.8868 3.16818 58.2134C6.70555 78.1144 20.4797 90.4578 39.8414 93.726C43.2632 94.3096 46.8728 94.6014 50.6123 94.6014C54.3518 94.6014 57.6726 94.3242 60.9645 93.7844C80.3118 90.6037 94.1148 78.2312 97.6521 58.2134H97.6377Z",
                                        fill: "#FCA700"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("svg", {
                                className: (0, $2jatx.default)([
                                    "_1bsbutna _4t3i1wug _kqswstnw _1e021nh5 _u7co1228 _sugaglyw",
                                    "lightning"
                                ]),
                                width: "131",
                                height: "139",
                                "aria-hidden": "true",
                                viewBox: "0 0 131 139",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                        d: "M20.4793 61.2896C11.5228 63.9778 10.6462 63.8696 8.14861 74.6224C5.48565 77.7767 3.98043 82.2375 2.50009 87.7471C1.52422 89.9276 8.05758 89.112 4.36913 89.8361C6.75918 90.66 13.6813 90.2023 14.4338 91.2343C10.9604 99.0243 8.42147 107.638 6.13066 115.911C6.18028 130.151 27.1036 98.5582 29.5102 96.5941C30.7176 93.1152 44.2806 78.484 38.1442 78.1761C29.196 76.6947 23.4234 81.4636 30.1387 69.8369C30.2793 69.3875 33.3061 62.3049 32.6197 60.1909C28.0133 62.1883 27.0788 70.1864 24.2752 74.5474C19.5778 80.881 28.6253 81.9463 32.6114 81.3554C32.5618 82.2875 36.1345 80.7562 35.2909 82.7037C30.1718 90.2606 12.9866 112.723 13.028 112.765C11.7296 115.611 9.81084 116.752 9.33117 115.861C9.04172 115.328 18.2546 92.6159 19.5117 89.6947C20.5289 86.1243 14.2436 86.9482 14.2436 86.9482C14.2436 86.9482 14.897 87.2727 16.7578 87.3226C14.8143 87.8969 9.87707 87.1396 6.51115 86.8733C7.08179 81.7382 13.7061 65.3676 13.7061 65.3676C13.7061 65.3676 27.7817 64.2191 31.3378 59.9662C28.7245 59.7415 24.3001 61.0649 20.471 61.2979L20.4793 61.2896Z",
                                        fill: "#101214"
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("path", {
                                        d: "M128.71 53.5661L129.636 51.8599C129.934 51.294 130.314 50.7031 130.413 50.1954C130.537 49.6877 130.521 49.2633 130.488 48.9138C130.48 48.8139 130.488 48.7556 130.438 48.6391C130.397 48.5225 130.306 48.3894 130.248 48.3395C130.116 48.2313 129.983 48.1147 129.818 47.9982C129.487 47.7735 129.065 47.5322 128.47 47.424C127.858 47.3408 127.205 47.2908 126.576 47.2159C123.392 46.8913 120.216 46.5667 117.082 46.2505C114.138 45.9425 111.227 45.6346 108.341 45.335C105.76 45.052 103.205 44.7774 100.691 44.5027C100.492 44.4528 100.178 44.5193 100.137 44.253C100.153 44.0283 100.31 43.8369 100.393 43.6455C100.972 42.3971 101.543 41.1571 102.113 39.9336C103.395 37.1955 104.644 34.5239 105.86 31.9189C108.316 26.7256 110.689 21.8236 112.972 17.2878L112.699 17.5541C112.889 17.2295 113.303 16.1393 113.576 15.9479C113.923 14.9075 114.436 13.4843 115.039 11.9113C115.345 11.129 115.66 10.3051 115.982 9.47285L116.47 8.22446C116.76 7.53368 117.041 6.85116 117.322 6.17702C117.653 5.36141 117.702 4.6707 117.653 4.06315C117.587 3.43063 117.347 2.78144 116.958 2.27376C116.189 1.21679 114.948 0.800607 114.088 0.867188C113.063 1.14183 112.219 1.35825 111.632 1.51638C111.326 1.63289 111.086 1.7245 110.913 1.78276C110.789 1.82437 110.731 1.8493 110.731 1.8493C106.794 3.33905 102.626 4.49591 98.4578 5.61114C98.4578 5.61114 97.0768 5.87744 94.8769 6.31021C93.7687 6.5266 92.462 6.78464 91.0065 7.07593C90.2787 7.22574 89.5096 7.39216 88.7157 7.55861C88.3187 7.64184 87.9052 7.74169 87.4834 7.84988C87.0865 7.94975 86.6896 8.05795 86.2843 8.16614C83.0673 8.99008 79.4202 9.78077 76.1535 11.1124C74.5243 11.7699 73.0026 12.5771 71.729 13.4843C70.4472 14.3915 69.4216 15.4152 68.6939 16.3473C66.6181 18.4696 65.0798 21.008 63.8228 23.613C62.5575 26.2263 61.5733 28.9228 60.5974 31.5943C59.6464 34.2826 58.6292 36.8626 57.5458 39.5008L54.3536 47.3907C54.3536 47.3907 49.4163 60.7236 48.4156 64.9348C48.0931 66.2831 47.8864 67.4066 47.7871 68.2472C48.1841 68.2139 48.7382 68.1889 49.4328 68.1806C50.6899 65.9085 52.6582 61.3311 55.4452 53.7408C55.5527 53.5993 55.8008 53.1084 55.8918 53.0668C57.0744 49.6378 58.3315 46.2838 59.6465 42.9547C60.3163 41.2985 60.9862 39.6424 61.656 37.9862C62.3507 36.2967 62.9958 34.5821 63.6243 32.9176C64.8896 29.5886 66.1467 26.3178 67.7842 23.4132C68.6029 21.9651 69.5126 20.6085 70.5546 19.4267C71.5967 18.2365 72.7297 17.2711 74.086 16.4389C73.8213 16.3224 74.086 15.9145 74.4995 15.8479L74.5243 16.1808C76.3189 14.999 78.2789 14.2666 80.181 13.6924C82.0914 13.1181 83.9853 12.7103 85.8874 12.2609L87.3181 11.9113L88.7157 11.5452C89.6254 11.3205 90.5352 11.0957 91.4697 10.871C93.3801 10.3966 95.3814 9.84733 97.5233 9.11493C97.5068 9.12326 96.6053 9.71416 96.5888 9.7308C100.037 8.97344 103.627 8.15785 107.398 7.15081C108.341 6.88448 109.292 6.62649 110.259 6.32688C110.739 6.18539 111.227 6.03554 111.715 5.86909L112.145 5.72767L112.236 5.69435C112.352 5.64441 112.509 5.57783 112.616 5.69435C112.732 5.80254 112.658 5.96065 112.6 6.08549C109.813 12.3025 106.877 18.869 103.883 25.5521C102.32 29.0476 100.74 32.5681 99.1691 36.0969C98.3834 37.8613 97.5978 39.6257 96.8121 41.3818L95.8527 43.5206C95.6625 43.9284 95.4971 44.3446 95.431 44.7275C95.3648 45.1103 95.3649 45.4515 95.3897 45.7595C95.4145 46.3587 95.828 47.1993 96.3408 47.6321C96.5806 47.8484 96.837 47.9983 97.1595 48.1647C97.4903 48.3145 97.879 48.4394 98.3173 48.4893C105.239 49.1801 111.988 49.8542 118.521 50.5117C120.068 50.6615 121.598 50.8113 123.119 50.9528L124.252 51.061L124.74 51.1026H124.839L125.269 51.1275C125.327 51.1442 125.451 51.0943 125.46 51.1858L125.377 51.3689L125.195 51.76C124.906 52.3177 124.608 52.867 124.318 53.4246C123.979 54.0654 123.648 54.7063 123.293 55.3305L123.417 55.2056V55.2888C123.649 54.9726 123.963 54.5066 124.327 53.9073C124.674 53.3497 125.087 52.6838 125.534 51.9515C125.724 51.6851 125.956 51.3606 126.212 50.9778C126.262 50.8779 126.378 50.7947 126.378 50.6782C126.328 50.5866 126.204 50.6199 126.121 50.5783C125.915 50.5367 125.716 50.4951 125.517 50.4618C125.294 50.4202 125.071 50.3785 124.864 50.3369C124.393 50.2703 123.938 50.2038 123.5 50.1455C122.59 50.0207 121.763 49.9041 121.052 49.8126C119.638 49.6212 118.72 49.4963 118.72 49.4963C120.109 49.4547 121.523 49.463 122.946 49.5046C123.64 49.5379 124.343 49.5629 125.046 49.5962C125.592 49.6212 126.163 49.6544 126.742 49.6961L127.618 49.7709C127.693 49.7792 127.767 49.771 127.833 49.7959C127.899 49.8209 127.949 49.8958 127.932 49.9707C127.874 50.1038 127.8 50.2287 127.734 50.3536C127.453 50.8613 127.172 51.3772 126.882 51.8932C126.551 52.4758 126.212 53.0667 125.873 53.6493C125.501 54.2985 125.129 54.9476 124.732 55.5884C123.136 58.1352 121.564 60.7152 119.886 63.212C119.067 64.477 118.248 65.7338 117.438 66.9822C116.611 68.2222 115.8 69.4623 115.023 70.7107L114.742 70.4277C117.512 66.1749 119.629 62.1717 120.44 60.5571C115.593 68.2639 108.068 79.6908 99.8224 90.4602C95.7453 95.8783 91.4531 101.105 87.5 105.816C85.5069 108.154 83.6213 110.393 81.8185 112.399C80.9253 113.414 80.0735 114.388 79.263 115.312C78.4443 116.227 77.6669 117.093 76.9391 117.9C77.2037 117.842 78.1548 116.718 79.2382 115.578C80.3133 114.429 81.4959 113.223 82.3229 113.056C81.5786 113.888 80.8261 114.721 80.0818 115.545C79.3292 116.36 78.5684 117.176 77.8241 117.983C77.0715 118.79 76.3271 119.589 75.5911 120.38C74.8468 121.162 74.086 121.92 73.3416 122.661C72.8951 122.211 74.7641 120.646 75.0205 120.222C74.3093 120.788 72.1094 122.952 68.7187 126.114C67.0151 127.687 65.055 129.552 62.789 131.541C62.5161 131.782 62.2432 132.024 61.9703 132.273L61.7718 132.44C61.6312 132.531 61.532 132.681 61.3666 132.714C61.2012 132.739 61.0275 132.631 60.9614 132.465C60.8869 132.29 60.9944 132.115 61.0358 131.948C61.6395 129.901 62.268 127.754 62.9131 125.54C63.6822 122.96 64.4927 120.305 65.3446 117.6C67.0482 112.191 68.9006 106.573 70.8606 100.963C72.8124 95.3539 74.8716 89.7445 76.9474 84.3348C77.9811 81.63 79.0232 78.975 80.0569 76.395L80.4374 75.4296L80.6276 74.9469C80.6607 74.8636 80.6938 74.8054 80.7186 74.6889L80.8013 74.3227C81.0246 73.3406 81.2479 72.3668 81.4712 71.4014C81.5787 70.9187 81.6944 70.436 81.8019 69.9616L81.9674 69.2459L82.0501 68.8881C82.0583 68.8298 82.0914 68.7632 82.0832 68.7216C82.0584 68.6633 82.0087 68.6633 81.9591 68.6384C81.2313 68.3471 80.5036 68.0557 79.7841 67.7644C77.7 67.8477 75.6656 67.9226 73.6807 67.9975C72.2418 68.0391 70.8359 68.0724 69.4796 68.1057C66.767 68.1639 64.2198 68.1889 61.8959 68.1889C57.2398 68.1723 53.4522 68.164 50.8719 68.1557C50.3426 68.1557 49.8794 68.1557 49.4494 68.1557C49.2757 68.4719 49.1186 68.7382 48.9698 68.9629C49.8216 69.1128 50.9545 69.2792 52.4266 69.4789L51.5086 69.7619C56.082 70.0698 60.2584 70.253 64.501 70.4194C66.6181 70.4943 68.7517 70.5692 70.9516 70.6525C72.0515 70.6858 73.168 70.7274 74.3093 70.769C74.8799 70.7856 75.4588 70.8106 76.0377 70.8272C76.4512 70.8522 76.8647 70.8771 77.2865 70.9021C77.394 70.8938 77.4932 70.8855 77.5759 70.8772C78.2706 70.8189 78.3451 70.8355 78.6759 70.5276C79.0067 70.461 79.6517 70.3445 79.7261 70.203C79.8502 70.1031 79.9991 70.0116 80.1645 69.9367C80.2141 69.9201 80.3299 69.8785 80.3299 69.9367C80.3299 69.97 80.3299 70.0199 80.3216 70.0781C80.2803 70.3029 80.1645 70.6857 80.0074 71.1268C79.6931 72.0173 79.2217 73.0743 78.9819 73.7235C78.1549 72.5416 75.2273 79.3828 72.5809 87.1395C69.8931 94.8712 67.5443 103.469 66.8331 105.433C65.452 105.832 64.2198 113.214 63.0289 115.461C63.0372 115.278 63.1116 114.13 63.1281 113.98C62.7891 114.463 61.9538 117.026 60.9945 120.48C60.5148 122.203 59.9937 124.15 59.4727 126.156C58.9352 128.295 58.3811 130.5 57.8518 132.606C57.703 133.255 57.6368 133.821 57.6202 134.346C57.612 134.878 57.8105 135.427 58.1744 135.844C58.8773 136.709 60.1427 136.925 60.9779 136.501C61.7553 136.06 62.4582 135.394 63.0867 134.795C63.6491 134.271 64.1453 133.813 64.5588 133.438C66.0971 132.048 66.4692 131.907 64.7408 133.987C71.4147 128.528 78.742 121.678 86.1437 113.705C93.5702 105.757 100.972 96.6024 108.035 86.79C115.081 76.961 121.688 66.3996 127.61 55.6551L128.743 53.5661H128.71Z",
                                        fill: "#101214"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
const $cac0a62c179e6d20$var$wrapperStyle = null;
const $cac0a62c179e6d20$var$earthContents = null;
const $cac0a62c179e6d20$var$blobStyles = null;
const $cac0a62c179e6d20$var$lightningStyles = null;
const $cac0a62c179e6d20$var$TextWrapperStyles = null;
const $cac0a62c179e6d20$var$fiftyStyles = null;
const $cac0a62c179e6d20$var$h2Styles = null;
const $cac0a62c179e6d20$var$statStyles = null;
const $cac0a62c179e6d20$var$bigStatStyles = null;
const $cac0a62c179e6d20$var$littleStatStyles = null;
const $cac0a62c179e6d20$var$statTextStyles = null;
const $cac0a62c179e6d20$var$thirtyStyles = null;
const $cac0a62c179e6d20$var$statWrapperStyles = null;
const $cac0a62c179e6d20$var$dividerStyles = null;
const $cac0a62c179e6d20$var$statsStyles = null;

});

parcelRegister("6VSBC", function(module, exports) {
$parcel$export(module.exports, "EnterprisePageProductNav", function () { return $3872cd7d84b2ef7a$export$e36ad2737327f9c; });
$parcel$export(module.exports, "default", function () { return $3872cd7d84b2ef7a$export$2e2bcd8739ae039; });
/* enterprise-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $jQ0cd = parcelRequire("jQ0cd");

var $5uYpV = parcelRequire("5uYpV");

var $iOXki = parcelRequire("iOXki");
const $3872cd7d84b2ef7a$var$logoWrapperStyles = null;
const $3872cd7d84b2ef7a$var$EnterpriseLogo = ()=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1q51v77o _4t3i1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $5uYpV.Logo), {
            brand: "enterprise",
            type: "logo",
            appearance: "brand"
        })
    });
const $3872cd7d84b2ef7a$export$e36ad2737327f9c = ({ isActive: isActive })=>{
    const intl = (0, $8e22h.default)();
    const ctaButtonText = intl.formatMessage({
        id: 'EnterpriseLandingPage.navbar.cta',
        defaultMessage: 'Contact sales'
    });
    const mobileCtaButtonText = intl.formatMessage({
        id: 'EnterpriseLandingPage.navbar.mobile.cta',
        defaultMessage: 'Contact sales'
    });
    const links = [
        {
            globalLinksKey: 'overview',
            linkText: intl.formatMessage({
                id: 'EnterpriseLandingPage.navbar.overview',
                defaultMessage: 'Overview'
            }),
            hasSubnav: false,
            isActive: isActive === 'overview',
            productKey: 'enterprise',
            href: (0, $jQ0cd.useLocalizedHref)('/enterprise')
        },
        {
            globalLinksKey: 'success',
            linkText: intl.formatMessage({
                id: 'EnterpriseLandingPage.navbar.success',
                defaultMessage: 'Success'
            }),
            hasSubnav: false,
            isActive: isActive === 'success',
            productKey: 'enterprise',
            href: (0, $jQ0cd.useLocalizedHref)('/enterprise/success')
        },
        {
            globalLinksKey: 'resources',
            linkText: intl.formatMessage({
                id: 'EnterpriseLandingPage.navbar.resources',
                defaultMessage: 'Resources'
            }),
            hasSubnav: false,
            isActive: isActive === 'resources',
            productKey: 'enterprise',
            href: (0, $jQ0cd.useLocalizedHref)('/enterprise/resources')
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "enterprise-page-product-navigation",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
            productLogoUrl: (0, $jQ0cd.useLocalizedHref)('/enterprise'),
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($3872cd7d84b2ef7a$var$EnterpriseLogo, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: 'EnterpriseLandingPage.label',
                defaultMessage: 'Enterprise'
            }),
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($3872cd7d84b2ef7a$var$EnterpriseLogo, {}),
            productPageNavLinks: links,
            mobileLinksSections: [
                {
                    mobileLinkKey: 'mobile-enterprise',
                    mobileLinksProps: links
                }
            ],
            navigationTrynowCtaText: ctaButtonText,
            navigationTrynowCtaUrl: (0, $jQ0cd.useLocalizedHref)('/enterprise/contact?formType=product-features'),
            mobileCtaText: mobileCtaButtonText,
            mobileCtaUrl: (0, $jQ0cd.useLocalizedHref)('/enterprise/contact?formType=product-features')
        })
    });
};
var $3872cd7d84b2ef7a$export$2e2bcd8739ae039 = $3872cd7d84b2ef7a$export$e36ad2737327f9c;

});

parcelRegister("hhv63", function(module, exports) {
$parcel$export(module.exports, "updatePreferences", function () { return $a62f11770126afae$export$7bb3e177c1a1e841; });
$parcel$export(module.exports, "ConsentHubClientConfigProvider", function () { return $a62f11770126afae$export$4f1d572ab3f4c2e6; });
$parcel$export(module.exports, "useConsentHubClientConfig", function () { return $a62f11770126afae$export$ef2475d0eafefa1b; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $5Ntyw = parcelRequire("5Ntyw");
const $a62f11770126afae$var$requiredProps = [
    'email',
    'site',
    'locale',
    'formUrl'
];
const $a62f11770126afae$var$defaultLocaleConfig = {
    locale: 'UNKNOWN',
    localeRequiresMarketingCommunicationOptIn: true
};
const $a62f11770126afae$export$ff156a5e09be2a6a = async (stargateClient)=>{
    return await stargateClient.getConsentConfig().then((response)=>response, ()=>$a62f11770126afae$var$defaultLocaleConfig);
};
const $a62f11770126afae$export$7bb3e177c1a1e841 = async (stargateClient, params, localeConfig)=>{
    const paramsLocale = params.paramsLocale ? params.paramsLocale : 'UNKNOWN';
    const postData = {
        locale: localeConfig?.locale || paramsLocale,
        ...params
    };
    if (!$a62f11770126afae$var$requiredProps.every((prop)=>postData.hasOwnProperty(prop))) throw `Invalid parameters. Required: {${$a62f11770126afae$var$requiredProps.toString()}}`;
    const updateConsentPreferencesResponseStatus = await stargateClient.updateConsentPreferences(postData);
    return updateConsentPreferencesResponseStatus;
};
const $a62f11770126afae$var$useGetConsentConfig = ()=>{
    const stargateClient = (0, $5Ntyw.useBxpWebStargateClient)();
    const [localeConfig, setLocaleConfig] = (0, $1oC0p.useState)($a62f11770126afae$var$defaultLocaleConfig);
    (0, $1oC0p.useEffect)(()=>{
        const fetchConfigData = async ()=>{
            const consentHubConfig = await $a62f11770126afae$export$ff156a5e09be2a6a(stargateClient);
            if (consentHubConfig) setLocaleConfig(consentHubConfig);
        };
        fetchConfigData().catch((err)=>console.log(err));
    }, [
        stargateClient
    ]);
    return localeConfig;
};
const $a62f11770126afae$export$6ccd5662e539f2b6 = /*#__PURE__*/ (0, $1oC0p.createContext)($a62f11770126afae$var$defaultLocaleConfig);
const $a62f11770126afae$export$4f1d572ab3f4c2e6 = ({ children: children })=>{
    const localeConfig = $a62f11770126afae$var$useGetConsentConfig();
    return /*#__PURE__*/ (0, $7VQPk.jsx)($a62f11770126afae$export$6ccd5662e539f2b6.Provider, {
        value: localeConfig,
        children: children
    });
};
const $a62f11770126afae$export$ef2475d0eafefa1b = ()=>{
    const context = (0, $1oC0p.useContext)($a62f11770126afae$export$6ccd5662e539f2b6);
    if (!context) throw new Error('useConsentHubClientConfig must be used within a ConsentHubClientConfigProvider');
    return context;
};

});

parcelRegister("8kWtd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4df587d0c3f1832e97f8caba30d1552>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $611d8beea2f13157$var$_react = $611d8beea2f13157$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $611d8beea2f13157$var$_baseNew = $611d8beea2f13157$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $611d8beea2f13157$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AiGenerativeTextSummary".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for summarizing content with Atlassian Intelligence & Loom
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $611d8beea2f13157$var$AiGenerativeTextSummaryIcon = (props)=>/*#__PURE__*/ $611d8beea2f13157$var$_react.default.createElement($611d8beea2f13157$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h14v1.5H1zm0 4.166h14v1.5H1zm10.796 4.328a.75.75 0 0 1 1.41 0l.615 1.687 1.686.615a.75.75 0 0 1 0 1.41l-1.686.615-.615 1.686a.75.75 0 0 1-1.41 0l-.615-1.686-1.687-.615a.75.75 0 0 1 0-1.41l1.687-.615zM1 9.333h7v1.5H1zm0 4.166h5v1.5H1z" clip-rule="evenodd"/>`
    }, props));
$611d8beea2f13157$var$AiGenerativeTextSummaryIcon.displayName = 'AiGenerativeTextSummaryIcon';
var $611d8beea2f13157$var$_default = module.exports.default = $611d8beea2f13157$var$AiGenerativeTextSummaryIcon;

});

parcelRegister("d6iWh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a02f6f2bebc5924b5c7f92f48f61953>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $02761af2cf514ed8$var$_react = $02761af2cf514ed8$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $02761af2cf514ed8$var$_baseNew = $02761af2cf514ed8$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $02761af2cf514ed8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "InformationCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $02761af2cf514ed8$var$InformationCircleIcon = (props)=>/*#__PURE__*/ $02761af2cf514ed8$var$_react.default.createElement($02761af2cf514ed8$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25.25H6.5v-1.5H8a.75.75 0 0 1 .75.75v5h-1.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$02761af2cf514ed8$var$InformationCircleIcon.displayName = 'InformationCircleIcon';
var $02761af2cf514ed8$var$_default = module.exports.default = $02761af2cf514ed8$var$InformationCircleIcon;

});

parcelRegister("dTPlE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f5f2152e50a3b99db24df80b6d3e591d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1e83e1969f37e79$var$_react = $a1e83e1969f37e79$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a1e83e1969f37e79$var$_baseNew = $a1e83e1969f37e79$var$_interopRequireDefault((parcelRequire("jcI35")));
function $a1e83e1969f37e79$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a1e83e1969f37e79$var$PageLiveDocIcon = (props)=>/*#__PURE__*/ $a1e83e1969f37e79$var$_react.default.createElement($a1e83e1969f37e79$var$_baseNew.default, Object.assign({
        name: "PageLiveDocIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm-9 5H1V7h5zM6 14H1v-1.5h5zm2.72-6.78a.75.75 0 0 1 .79-.17l6 2.25a.75.75 0 0 1-.08 1.43l-2.56.64-.64 2.56a.75.75 0 0 1-1.43.08l-2.25-6a.75.75 0 0 1 .17-.79" clip-rule="evenodd"/>`
    }, props));
$a1e83e1969f37e79$var$PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var $a1e83e1969f37e79$var$_default = module.exports.default = $a1e83e1969f37e79$var$PageLiveDocIcon;

});

parcelRegister("5QRrh", function(module, exports) {
/*! @license DOMPurify 2.5.8 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.8/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'fedropshadow',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]+$/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '2.5.8';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                content = stringReplace(content, ERB_EXPR$1, ' ');
                content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes || _isClobbered(currentNode)) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === 'value' ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                    value = stringReplace(value, ERB_EXPR$1, ' ');
                    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ _sanitizeElements(shadowNode);
                /* Check attributes next */ _sanitizeAttributes(shadowNode);
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                    if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ _sanitizeElements(currentNode);
                /* Check attributes next */ _sanitizeAttributes(currentNode);
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});

parcelRegister("hpDnm", function(module, exports) {

var $kp5nV = parcelRequire("kp5nV");

var $1frIC = parcelRequire("1frIC");
/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $cad350b3a4d1e4e2$var$pick = $1frIC(function(object, paths) {
    return object == null ? {} : $kp5nV(object, paths);
});
module.exports = $cad350b3a4d1e4e2$var$pick;

});
parcelRegister("kp5nV", function(module, exports) {

var $fqptw = parcelRequire("fqptw");

var $8avIg = parcelRequire("8avIg");
/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $edaa51c779a6741c$var$basePick(object, paths) {
    return $fqptw(object, paths, function(value, path) {
        return $8avIg(object, path);
    });
}
module.exports = $edaa51c779a6741c$var$basePick;

});
parcelRegister("fqptw", function(module, exports) {

var $5oMeU = parcelRequire("5oMeU");

var $brerY = parcelRequire("brerY");

var $hLLeA = parcelRequire("hLLeA");
/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $b3ad0b8a3c96db41$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = $5oMeU(object, path);
        if (predicate(value, path)) $brerY(result, $hLLeA(path, object), value);
    }
    return result;
}
module.exports = $b3ad0b8a3c96db41$var$basePickBy;

});


parcelRegister("1frIC", function(module, exports) {

var $Euo5O = parcelRequire("Euo5O");

var $axmYb = parcelRequire("axmYb");

var $jj29P = parcelRequire("jj29P");
/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $0e8cb184d6489cc8$var$flatRest(func) {
    return $jj29P($axmYb(func, undefined, $Euo5O), func + '');
}
module.exports = $0e8cb184d6489cc8$var$flatRest;

});
parcelRegister("Euo5O", function(module, exports) {

var $auF8s = parcelRequire("auF8s");
/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $079b4ee268152e61$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? $auF8s(array, 1) : [];
}
module.exports = $079b4ee268152e61$var$flatten;

});



parcelRegister("hGxEi", function(module, exports) {

var $iCQu6 = parcelRequire("iCQu6");

var $24uwp = parcelRequire("24uwp");
/** Used to match Latin Unicode letters (excluding mathematical operators). */ var $ce0075e69d454d18$var$reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
/** Used to compose unicode character classes. */ var $ce0075e69d454d18$var$rsComboMarksRange = '\\u0300-\\u036f', $ce0075e69d454d18$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $ce0075e69d454d18$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $ce0075e69d454d18$var$rsComboRange = $ce0075e69d454d18$var$rsComboMarksRange + $ce0075e69d454d18$var$reComboHalfMarksRange + $ce0075e69d454d18$var$rsComboSymbolsRange;
/** Used to compose unicode capture groups. */ var $ce0075e69d454d18$var$rsCombo = '[' + $ce0075e69d454d18$var$rsComboRange + ']';
/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */ var $ce0075e69d454d18$var$reComboMark = RegExp($ce0075e69d454d18$var$rsCombo, 'g');
/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */ function $ce0075e69d454d18$var$deburr(string) {
    string = $24uwp(string);
    return string && string.replace($ce0075e69d454d18$var$reLatin, $iCQu6).replace($ce0075e69d454d18$var$reComboMark, '');
}
module.exports = $ce0075e69d454d18$var$deburr;

});
parcelRegister("iCQu6", function(module, exports) {

var $6V9cT = parcelRequire("6V9cT");
/** Used to map Latin Unicode letters to basic Latin letters. */ var $037fd0776303ae37$var$deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',
    '\u0102': 'A',
    '\u0104': 'A',
    '\u0101': 'a',
    '\u0103': 'a',
    '\u0105': 'a',
    '\u0106': 'C',
    '\u0108': 'C',
    '\u010a': 'C',
    '\u010c': 'C',
    '\u0107': 'c',
    '\u0109': 'c',
    '\u010b': 'c',
    '\u010d': 'c',
    '\u010e': 'D',
    '\u0110': 'D',
    '\u010f': 'd',
    '\u0111': 'd',
    '\u0112': 'E',
    '\u0114': 'E',
    '\u0116': 'E',
    '\u0118': 'E',
    '\u011a': 'E',
    '\u0113': 'e',
    '\u0115': 'e',
    '\u0117': 'e',
    '\u0119': 'e',
    '\u011b': 'e',
    '\u011c': 'G',
    '\u011e': 'G',
    '\u0120': 'G',
    '\u0122': 'G',
    '\u011d': 'g',
    '\u011f': 'g',
    '\u0121': 'g',
    '\u0123': 'g',
    '\u0124': 'H',
    '\u0126': 'H',
    '\u0125': 'h',
    '\u0127': 'h',
    '\u0128': 'I',
    '\u012a': 'I',
    '\u012c': 'I',
    '\u012e': 'I',
    '\u0130': 'I',
    '\u0129': 'i',
    '\u012b': 'i',
    '\u012d': 'i',
    '\u012f': 'i',
    '\u0131': 'i',
    '\u0134': 'J',
    '\u0135': 'j',
    '\u0136': 'K',
    '\u0137': 'k',
    '\u0138': 'k',
    '\u0139': 'L',
    '\u013b': 'L',
    '\u013d': 'L',
    '\u013f': 'L',
    '\u0141': 'L',
    '\u013a': 'l',
    '\u013c': 'l',
    '\u013e': 'l',
    '\u0140': 'l',
    '\u0142': 'l',
    '\u0143': 'N',
    '\u0145': 'N',
    '\u0147': 'N',
    '\u014a': 'N',
    '\u0144': 'n',
    '\u0146': 'n',
    '\u0148': 'n',
    '\u014b': 'n',
    '\u014c': 'O',
    '\u014e': 'O',
    '\u0150': 'O',
    '\u014d': 'o',
    '\u014f': 'o',
    '\u0151': 'o',
    '\u0154': 'R',
    '\u0156': 'R',
    '\u0158': 'R',
    '\u0155': 'r',
    '\u0157': 'r',
    '\u0159': 'r',
    '\u015a': 'S',
    '\u015c': 'S',
    '\u015e': 'S',
    '\u0160': 'S',
    '\u015b': 's',
    '\u015d': 's',
    '\u015f': 's',
    '\u0161': 's',
    '\u0162': 'T',
    '\u0164': 'T',
    '\u0166': 'T',
    '\u0163': 't',
    '\u0165': 't',
    '\u0167': 't',
    '\u0168': 'U',
    '\u016a': 'U',
    '\u016c': 'U',
    '\u016e': 'U',
    '\u0170': 'U',
    '\u0172': 'U',
    '\u0169': 'u',
    '\u016b': 'u',
    '\u016d': 'u',
    '\u016f': 'u',
    '\u0171': 'u',
    '\u0173': 'u',
    '\u0174': 'W',
    '\u0175': 'w',
    '\u0176': 'Y',
    '\u0177': 'y',
    '\u0178': 'Y',
    '\u0179': 'Z',
    '\u017b': 'Z',
    '\u017d': 'Z',
    '\u017a': 'z',
    '\u017c': 'z',
    '\u017e': 'z',
    '\u0132': 'IJ',
    '\u0133': 'ij',
    '\u0152': 'Oe',
    '\u0153': 'oe',
    '\u0149': "'n",
    '\u017f': 's'
};
/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */ var $037fd0776303ae37$var$deburrLetter = $6V9cT($037fd0776303ae37$var$deburredLetters);
module.exports = $037fd0776303ae37$var$deburrLetter;

});
parcelRegister("6V9cT", function(module, exports) {
/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */ function $509f35426b22b824$var$basePropertyOf(object) {
    return function(key) {
        return object == null ? undefined : object[key];
    };
}
module.exports = $509f35426b22b824$var$basePropertyOf;

});



parcelRegister("lXgpb", function(module, exports) {

var $gHIMV = parcelRequire("gHIMV");

var $dNNx2 = parcelRequire("dNNx2");
/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */ var $ffbbd5682208087f$var$camelCase = $dNNx2(function(result, word, index) {
    word = word.toLowerCase();
    return result + (index ? $gHIMV(word) : word);
});
module.exports = $ffbbd5682208087f$var$camelCase;

});
parcelRegister("dNNx2", function(module, exports) {

var $5r99q = parcelRequire("5r99q");

var $hGxEi = parcelRequire("hGxEi");

var $cGaAm = parcelRequire("cGaAm");
/** Used to compose unicode capture groups. */ var $a0c645f3644bc61c$var$rsApos = "['\u2019]";
/** Used to match apostrophes. */ var $a0c645f3644bc61c$var$reApos = RegExp($a0c645f3644bc61c$var$rsApos, 'g');
/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */ function $a0c645f3644bc61c$var$createCompounder(callback) {
    return function(string) {
        return $5r99q($cGaAm($hGxEi(string).replace($a0c645f3644bc61c$var$reApos, '')), callback, '');
    };
}
module.exports = $a0c645f3644bc61c$var$createCompounder;

});
parcelRegister("5r99q", function(module, exports) {
/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */ function $3f56928ff1fa1456$var$arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1, length = array == null ? 0 : array.length;
    if (initAccum && length) accumulator = array[++index];
    while(++index < length)accumulator = iteratee(accumulator, array[index], index, array);
    return accumulator;
}
module.exports = $3f56928ff1fa1456$var$arrayReduce;

});

parcelRegister("cGaAm", function(module, exports) {

var $agIzJ = parcelRequire("agIzJ");

var $2fyoH = parcelRequire("2fyoH");

var $24uwp = parcelRequire("24uwp");

var $51QbK = parcelRequire("51QbK");
/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */ function $93b19e4fcd969484$var$words(string, pattern, guard) {
    string = $24uwp(string);
    pattern = guard ? undefined : pattern;
    if (pattern === undefined) return $2fyoH(string) ? $51QbK(string) : $agIzJ(string);
    return string.match(pattern) || [];
}
module.exports = $93b19e4fcd969484$var$words;

});
parcelRegister("agIzJ", function(module, exports) {
/** Used to match words composed of alphanumeric characters. */ var $779df9bff564b02d$var$reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $779df9bff564b02d$var$asciiWords(string) {
    return string.match($779df9bff564b02d$var$reAsciiWord) || [];
}
module.exports = $779df9bff564b02d$var$asciiWords;

});

parcelRegister("2fyoH", function(module, exports) {
/** Used to detect strings that need a more robust regexp to match words. */ var $1a37aa184b5f841b$var$reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */ function $1a37aa184b5f841b$var$hasUnicodeWord(string) {
    return $1a37aa184b5f841b$var$reHasUnicodeWord.test(string);
}
module.exports = $1a37aa184b5f841b$var$hasUnicodeWord;

});

parcelRegister("51QbK", function(module, exports) {
/** Used to compose unicode character classes. */ var $3a9587500dbb7d28$var$rsAstralRange = '\\ud800-\\udfff', $3a9587500dbb7d28$var$rsComboMarksRange = '\\u0300-\\u036f', $3a9587500dbb7d28$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $3a9587500dbb7d28$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $3a9587500dbb7d28$var$rsComboRange = $3a9587500dbb7d28$var$rsComboMarksRange + $3a9587500dbb7d28$var$reComboHalfMarksRange + $3a9587500dbb7d28$var$rsComboSymbolsRange, $3a9587500dbb7d28$var$rsDingbatRange = '\\u2700-\\u27bf', $3a9587500dbb7d28$var$rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff', $3a9587500dbb7d28$var$rsMathOpRange = '\\xac\\xb1\\xd7\\xf7', $3a9587500dbb7d28$var$rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf', $3a9587500dbb7d28$var$rsPunctuationRange = '\\u2000-\\u206f', $3a9587500dbb7d28$var$rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000', $3a9587500dbb7d28$var$rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde', $3a9587500dbb7d28$var$rsVarRange = '\\ufe0e\\ufe0f', $3a9587500dbb7d28$var$rsBreakRange = $3a9587500dbb7d28$var$rsMathOpRange + $3a9587500dbb7d28$var$rsNonCharRange + $3a9587500dbb7d28$var$rsPunctuationRange + $3a9587500dbb7d28$var$rsSpaceRange;
/** Used to compose unicode capture groups. */ var $3a9587500dbb7d28$var$rsApos = "['\u2019]", $3a9587500dbb7d28$var$rsBreak = '[' + $3a9587500dbb7d28$var$rsBreakRange + ']', $3a9587500dbb7d28$var$rsCombo = '[' + $3a9587500dbb7d28$var$rsComboRange + ']', $3a9587500dbb7d28$var$rsDigits = '\\d+', $3a9587500dbb7d28$var$rsDingbat = '[' + $3a9587500dbb7d28$var$rsDingbatRange + ']', $3a9587500dbb7d28$var$rsLower = '[' + $3a9587500dbb7d28$var$rsLowerRange + ']', $3a9587500dbb7d28$var$rsMisc = '[^' + $3a9587500dbb7d28$var$rsAstralRange + $3a9587500dbb7d28$var$rsBreakRange + $3a9587500dbb7d28$var$rsDigits + $3a9587500dbb7d28$var$rsDingbatRange + $3a9587500dbb7d28$var$rsLowerRange + $3a9587500dbb7d28$var$rsUpperRange + ']', $3a9587500dbb7d28$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $3a9587500dbb7d28$var$rsModifier = '(?:' + $3a9587500dbb7d28$var$rsCombo + '|' + $3a9587500dbb7d28$var$rsFitz + ')', $3a9587500dbb7d28$var$rsNonAstral = '[^' + $3a9587500dbb7d28$var$rsAstralRange + ']', $3a9587500dbb7d28$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $3a9587500dbb7d28$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $3a9587500dbb7d28$var$rsUpper = '[' + $3a9587500dbb7d28$var$rsUpperRange + ']', $3a9587500dbb7d28$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $3a9587500dbb7d28$var$rsMiscLower = '(?:' + $3a9587500dbb7d28$var$rsLower + '|' + $3a9587500dbb7d28$var$rsMisc + ')', $3a9587500dbb7d28$var$rsMiscUpper = '(?:' + $3a9587500dbb7d28$var$rsUpper + '|' + $3a9587500dbb7d28$var$rsMisc + ')', $3a9587500dbb7d28$var$rsOptContrLower = '(?:' + $3a9587500dbb7d28$var$rsApos + '(?:d|ll|m|re|s|t|ve))?', $3a9587500dbb7d28$var$rsOptContrUpper = '(?:' + $3a9587500dbb7d28$var$rsApos + '(?:D|LL|M|RE|S|T|VE))?', $3a9587500dbb7d28$var$reOptMod = $3a9587500dbb7d28$var$rsModifier + '?', $3a9587500dbb7d28$var$rsOptVar = '[' + $3a9587500dbb7d28$var$rsVarRange + ']?', $3a9587500dbb7d28$var$rsOptJoin = '(?:' + $3a9587500dbb7d28$var$rsZWJ + '(?:' + [
    $3a9587500dbb7d28$var$rsNonAstral,
    $3a9587500dbb7d28$var$rsRegional,
    $3a9587500dbb7d28$var$rsSurrPair
].join('|') + ')' + $3a9587500dbb7d28$var$rsOptVar + $3a9587500dbb7d28$var$reOptMod + ')*', $3a9587500dbb7d28$var$rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])', $3a9587500dbb7d28$var$rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])', $3a9587500dbb7d28$var$rsSeq = $3a9587500dbb7d28$var$rsOptVar + $3a9587500dbb7d28$var$reOptMod + $3a9587500dbb7d28$var$rsOptJoin, $3a9587500dbb7d28$var$rsEmoji = '(?:' + [
    $3a9587500dbb7d28$var$rsDingbat,
    $3a9587500dbb7d28$var$rsRegional,
    $3a9587500dbb7d28$var$rsSurrPair
].join('|') + ')' + $3a9587500dbb7d28$var$rsSeq;
/** Used to match complex or compound words. */ var $3a9587500dbb7d28$var$reUnicodeWord = RegExp([
    $3a9587500dbb7d28$var$rsUpper + '?' + $3a9587500dbb7d28$var$rsLower + '+' + $3a9587500dbb7d28$var$rsOptContrLower + '(?=' + [
        $3a9587500dbb7d28$var$rsBreak,
        $3a9587500dbb7d28$var$rsUpper,
        '$'
    ].join('|') + ')',
    $3a9587500dbb7d28$var$rsMiscUpper + '+' + $3a9587500dbb7d28$var$rsOptContrUpper + '(?=' + [
        $3a9587500dbb7d28$var$rsBreak,
        $3a9587500dbb7d28$var$rsUpper + $3a9587500dbb7d28$var$rsMiscLower,
        '$'
    ].join('|') + ')',
    $3a9587500dbb7d28$var$rsUpper + '?' + $3a9587500dbb7d28$var$rsMiscLower + '+' + $3a9587500dbb7d28$var$rsOptContrLower,
    $3a9587500dbb7d28$var$rsUpper + '+' + $3a9587500dbb7d28$var$rsOptContrUpper,
    $3a9587500dbb7d28$var$rsOrdUpper,
    $3a9587500dbb7d28$var$rsOrdLower,
    $3a9587500dbb7d28$var$rsDigits,
    $3a9587500dbb7d28$var$rsEmoji
].join('|'), 'g');
/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */ function $3a9587500dbb7d28$var$unicodeWords(string) {
    return string.match($3a9587500dbb7d28$var$reUnicodeWord) || [];
}
module.exports = $3a9587500dbb7d28$var$unicodeWords;

});




parcelRegister("atyps", function(module, exports) {
$parcel$export(module.exports, "BitbucketNav", function () { return $46b40aa87e150696$export$374e7235418bdbdb; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $asbmK = parcelRequire("asbmK");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $iOXki = parcelRequire("iOXki");

var $fv5hW = parcelRequire("fv5hW");
const $46b40aa87e150696$var$BitbucketLogoComponent = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "bitbucket",
        type: "logo",
        appearance: "brand",
        lightMode: isDarkTheme
    });
};
const $46b40aa87e150696$export$374e7235418bdbdb = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=bitbucket&edition=free');
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).BITBUCKET,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const dataCenterHref = (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/enterprise/data-center');
    const pricingHref = (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/pricing');
    const links = [
        {
            globalLinksKey: 'whyBitbucket',
            linkText: intl.formatMessage({
                id: 'BitbucketPageTemplate.navbar.whyBitbucket',
                defaultMessage: 'Why Bitbucket'
            }),
            productKey: 'bitbucket',
            hasSubnav: true,
            dropdownType: 'why-bitbucket'
        },
        {
            globalLinksKey: 'self-hosted',
            linkText: intl.formatMessage({
                id: 'BitbucketPageTemplate.navbar.selfhosted',
                defaultMessage: 'Self-Hosted'
            }),
            hasSubnav: false,
            productKey: 'bitbucket',
            href: dataCenterHref
        },
        {
            globalLinksKey: 'pricing',
            linkText: intl.formatMessage({
                id: 'BitbucketPageTemplate.navbar.pricing',
                defaultMessage: 'Pricing'
            }),
            hasSubnav: false,
            productKey: 'bitbucket',
            href: pricingHref
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-BitbucketNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
            productKey: 'bitbucket',
            productLogoUrl: "/software/bitbucket",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($46b40aa87e150696$var$BitbucketLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: 'BitbucketPageTemplate.navbar.bitbucket-logo',
                defaultMessage: 'Bitbucket logo'
            }),
            mobileCtaText: intl.formatMessage({
                id: 'BitbucketPageTemplate.navbar.getitfree',
                defaultMessage: 'Get it Free'
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: 'BitbucketPageTemplate.navbar.getitfree',
                defaultMessage: 'Get it Free'
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($46b40aa87e150696$var$BitbucketLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: 'whyBitbucket',
                    linkText: intl.formatMessage({
                        id: 'BitbucketPageTemplate.navbar.whyBitbucket',
                        defaultMessage: 'Why Bitbucket'
                    }),
                    containerStyles: {
                        width: 'fit-content',
                        margin: 0
                    },
                    hasSubnav: true,
                    content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $fv5hW.WhyBitbucketSubnav), {
                        productKey: 'bitbucket'
                    })
                },
                {
                    globalLinksKey: 'self-hosted',
                    linkText: intl.formatMessage({
                        id: 'BitbucketPageTemplate.navbar.selfhosted',
                        defaultMessage: 'Self-Hosted'
                    }),
                    hasSubnav: false,
                    productKey: 'bitbucket',
                    href: dataCenterHref
                },
                {
                    globalLinksKey: 'pricing',
                    linkText: intl.formatMessage({
                        id: 'BitbucketPageTemplate.navbar.pricing',
                        defaultMessage: 'Pricing'
                    }),
                    hasSubnav: false,
                    productKey: 'bitbucket',
                    href: pricingHref
                }
            ],
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: 'mobile-bitbucket',
                    mobileLinksProps: links
                }
            ]
        })
    });
};

});
parcelRegister("fv5hW", function(module, exports) {
$parcel$export(module.exports, "WhyBitbucketSubnav", function () { return $e0ef30a4e223c9fa$export$7b115720fff1fb0d; });
/* why-bitbucket-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $jsxHL = parcelRequire("jsxHL");

var $8nFt2 = parcelRequire("8nFt2");

var $jgdMW = parcelRequire("jgdMW");

var $dfBhn = parcelRequire("dfBhn");

var $9KOR3 = parcelRequire("9KOR3");
function $e0ef30a4e223c9fa$var$useWhyBitbucketLinks() {
    return {
        features: {
            id: 'solution',
            title: (0, $fnHPc.defineMessage)({
                id: 'bitbucketnav.subnav.whybitbucket.links.solution',
                defaultMessage: 'Solution'
            }),
            items: [
                {
                    id: 'ci-cd',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'bitbucketnav.subnav.whybitbucket.links.work-management',
                        defaultMessage: 'CI/CD'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/features/pipelines')
                },
                {
                    id: 'cloud-security',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'bitbucketnav.subnav.whybitbucket.links.cloud-security',
                        defaultMessage: 'Cloud Security'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/features/cloud-security')
                },
                {
                    id: 'dev-sec-ops',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'bitbucketnav.subnav.whybitbucket.links.dev-sec-ops',
                        defaultMessage: 'DevSecOps'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/features/devsecops')
                },
                {
                    id: 'code-review',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'bitbucketnav.subnav.whybitbucket.links.it-service-management',
                        defaultMessage: 'Code Review'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/features/code-review')
                },
                {
                    id: 'jira-integrations',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'bitbucketnav.subnav.whybitbucket.links.agile-devops',
                        defaultMessage: 'Jira Integrations'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/jira/bitbucket-integration')
                }
            ]
        },
        plans: {
            id: 'plans',
            title: (0, $fnHPc.defineMessage)({
                id: 'bitbucketnav.subnav.whybitbucket.links.plans',
                defaultMessage: 'Plans'
            }),
            items: [
                {
                    id: 'bitbucket-cloud-premium',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'bitbucketnav.subnav.whybitbucket.links.bitbucket-cloud-premium',
                        defaultMessage: 'Bitbucket Cloud Premium'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/bitbucket/premium')
                }
            ]
        }
    };
}
const $e0ef30a4e223c9fa$export$7b115720fff1fb0d = ({ productKey: productKey = 'bitbucket' })=>{
    const intl = (0, $8e22h.default)();
    const bitbucketLinks = $e0ef30a4e223c9fa$var$useWhyBitbucketLinks();
    const linkColumns = Object.values(bitbucketLinks);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nFt2.MotionContainer), {
                direction: "up",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bfhkg7ng"
                    ]),
                    style: {
                        "--_1lg4sj9": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light100'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgdMW.RowGrid), {
                        numCols: 2,
                        columnGap: "var(--ds-space-500, 40px)",
                        paddingBlock: "var(--ds-space-500, 40px)",
                        paddingInline: "var(--ds-space-500, 40px)",
                        children: linkColumns.map((column)=>{
                            return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $dfBhn.LinkColumn), {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_1p1dangw _syaz1pfd _1wyboqnp _ect4z4z1 _k48p1fw0 _vwz41j6v"
                                        ]),
                                        style: {
                                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                        },
                                        children: intl.formatMessage(column.title)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c11p5 _2z0510ma"
                                        ]),
                                        children: column.items.map((link)=>{
                                            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_bpsp1nn1 _19tboxwj _43ds1pfd _qfs11r31 _s41oglyw _1k6pnqa1 _1cay1pfd _oavvftjs _oxk4ftjs _1e0c1txw _4cvrh9n0"
                                                ]),
                                                style: {
                                                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                                    "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
                                                },
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                                    type: "anchor",
                                                    href: link.href,
                                                    text: intl.formatMessage(link.text),
                                                    ariaLabel: intl.formatMessage(link.text),
                                                    dataEventProps: {
                                                        'data-event': 'clicked',
                                                        'data-event-component': 'linkButton',
                                                        'data-event-container': 'globalNavSubnav',
                                                        'data-product-key': productKey
                                                    }
                                                })
                                            }, link.id);
                                        })
                                    })
                                ]
                            }, column.id);
                        })
                    })
                })
            })
        })
    });
};

});


parcelRegister("aTHox", function(module, exports) {
$parcel$export(module.exports, "BITBUCKET_DEFAULT_BILLING_CYCLE", function () { return $4c3894076c255a40$export$6e78cb64dcbedbb9; });
$parcel$export(module.exports, "BITBUCKET_DEFAULT_UNIT_COUNT", function () { return $4c3894076c255a40$export$36a5806a0e4fc360; });
$parcel$export(module.exports, "BITBUCKET_MIN_ENTERPRISE_USER_COUNT", function () { return $4c3894076c255a40$export$2b15976b7672c2da; });
$parcel$export(module.exports, "bitbucketOfferingSkus", function () { return $4c3894076c255a40$export$eeb88db779daf862; });
$parcel$export(module.exports, "BITBUCKET_SIGNUP_LIMIT", function () { return $4c3894076c255a40$export$4d264dc26702f23b; });
$parcel$export(module.exports, "bitbucketOfferingSkusArray", function () { return $4c3894076c255a40$export$9a2735659d85fd7c; });
$parcel$export(module.exports, "bitbucketPlanLimitConfigs", function () { return $4c3894076c255a40$export$66d05a9262b43b7f; });
$parcel$export(module.exports, "bitbucketBillingCycleConfig", function () { return $4c3894076c255a40$export$f9cab01559b23739; });
const $4c3894076c255a40$export$6e78cb64dcbedbb9 = 'MONTHLY';
const $4c3894076c255a40$export$36a5806a0e4fc360 = 5;
const $4c3894076c255a40$export$2b15976b7672c2da = 201;
const $4c3894076c255a40$export$eeb88db779daf862 = {
    free: 'bitbucket-test-free',
    standard: 'bitbucket-std',
    premium: 'bitbucket-premium'
};
const $4c3894076c255a40$export$4d264dc26702f23b = 35000;
const $4c3894076c255a40$export$9a2735659d85fd7c = Object.values($4c3894076c255a40$export$eeb88db779daf862);
const $4c3894076c255a40$export$66d05a9262b43b7f = [
    {
        planName: 'Free',
        offeringSku: $4c3894076c255a40$export$eeb88db779daf862.free,
        recommendationLimit: 0,
        signupLimit: $4c3894076c255a40$export$4d264dc26702f23b
    },
    {
        planName: 'Standard',
        offeringSku: $4c3894076c255a40$export$eeb88db779daf862.standard,
        recommendationLimit: 5,
        signupLimit: $4c3894076c255a40$export$4d264dc26702f23b
    },
    {
        planName: 'Premium',
        offeringSku: $4c3894076c255a40$export$eeb88db779daf862.premium,
        recommendationLimit: 100,
        signupLimit: $4c3894076c255a40$export$4d264dc26702f23b
    }
];
const $4c3894076c255a40$export$f9cab01559b23739 = {
    monthly: true,
    annual: false
};

});

parcelRegister("29JVp", function(module, exports) {
$parcel$export(module.exports, "CONFLUENCE_DEFAULT_BILLING_CYCLE", function () { return $1e226e69d394223a$export$d60dc2d142b5e9dd; });
$parcel$export(module.exports, "CONFLUENCE_DEFAULT_UNIT_COUNT", function () { return $1e226e69d394223a$export$ab3750ec8101ffcc; });
$parcel$export(module.exports, "CONFLUENCE_MIN_ENTERPRISE_USER_COUNT", function () { return $1e226e69d394223a$export$f76a76b996ace375; });
$parcel$export(module.exports, "confluenceOfferingSkus", function () { return $1e226e69d394223a$export$ffe6d3f38b5f7c3a; });
$parcel$export(module.exports, "confluenceOfferingSkusArray", function () { return $1e226e69d394223a$export$39e8fbae2abd0443; });
$parcel$export(module.exports, "confluencePlanLimitConfigs", function () { return $1e226e69d394223a$export$53fbba6eb29a73ad; });
$parcel$export(module.exports, "confluenceBillingCycleConfig", function () { return $1e226e69d394223a$export$e8f1610e98745fd7; });
const $1e226e69d394223a$export$d60dc2d142b5e9dd = 'MONTHLY';
const $1e226e69d394223a$export$ab3750ec8101ffcc = 300;
const $1e226e69d394223a$export$f76a76b996ace375 = 801;
const $1e226e69d394223a$export$ffe6d3f38b5f7c3a = {
    free: 'confluence-free',
    standard: 'confluence-standard',
    premium: 'confluence-premium',
    enterprise: 'confluence-enterprise-sku'
};
const $1e226e69d394223a$export$39e8fbae2abd0443 = Object.values($1e226e69d394223a$export$ffe6d3f38b5f7c3a);
const $1e226e69d394223a$export$53fbba6eb29a73ad = [
    {
        planName: 'Free',
        offeringSku: $1e226e69d394223a$export$ffe6d3f38b5f7c3a.free,
        recommendationLimit: 0,
        signupLimit: 250000
    },
    {
        planName: 'Standard',
        offeringSku: $1e226e69d394223a$export$ffe6d3f38b5f7c3a.standard,
        recommendationLimit: 10,
        signupLimit: 250000
    },
    {
        planName: 'Premium',
        offeringSku: $1e226e69d394223a$export$ffe6d3f38b5f7c3a.premium,
        recommendationLimit: 250,
        signupLimit: 250000
    },
    {
        planName: 'Enterprise',
        offeringSku: $1e226e69d394223a$export$ffe6d3f38b5f7c3a.enterprise,
        recommendationLimit: 5000,
        signupLimit: 250000,
        minUnitCount: $1e226e69d394223a$export$f76a76b996ace375
    }
];
const $1e226e69d394223a$export$e8f1610e98745fd7 = {
    monthly: true,
    annual: true
};

});

parcelRegister("j1ORI", function(module, exports) {
$parcel$export(module.exports, "JIRA_DEFAULT_BILLING_CYCLE", function () { return $2a2b2c5bc611aa86$export$c34e5566df36b6ba; });
$parcel$export(module.exports, "JIRA_DEFAULT_UNIT_COUNT", function () { return $2a2b2c5bc611aa86$export$6521a918e64524fb; });
$parcel$export(module.exports, "JIRA_MIN_ENTERPRISE_USER_COUNT", function () { return $2a2b2c5bc611aa86$export$9aef50cd5f48bb38; });
$parcel$export(module.exports, "jiraOfferingSkus", function () { return $2a2b2c5bc611aa86$export$7529f2cfeec98447; });
$parcel$export(module.exports, "jiraOfferingSkusArray", function () { return $2a2b2c5bc611aa86$export$b2b09200ca76754f; });
$parcel$export(module.exports, "jiraPlanLimitConfigs", function () { return $2a2b2c5bc611aa86$export$3070b86c7bc28aea; });
$parcel$export(module.exports, "jiraBillingCycleConfig", function () { return $2a2b2c5bc611aa86$export$7a133a10c706882b; });
const $2a2b2c5bc611aa86$export$c34e5566df36b6ba = 'MONTHLY';
const $2a2b2c5bc611aa86$export$6521a918e64524fb = 300;
const $2a2b2c5bc611aa86$export$9aef50cd5f48bb38 = 801;
const $2a2b2c5bc611aa86$export$7529f2cfeec98447 = {
    free: 'jira-software-free',
    standard: 'jira-software-standard',
    premium: 'jira-software-premium',
    enterprise: 'jira-software-enterprise-sku'
};
const $2a2b2c5bc611aa86$export$b2b09200ca76754f = Object.values($2a2b2c5bc611aa86$export$7529f2cfeec98447);
const $2a2b2c5bc611aa86$export$3070b86c7bc28aea = [
    {
        planName: 'Free',
        offeringSku: $2a2b2c5bc611aa86$export$7529f2cfeec98447.free,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: 'Standard',
        offeringSku: $2a2b2c5bc611aa86$export$7529f2cfeec98447.standard,
        recommendationLimit: 10,
        signupLimit: 100000
    },
    {
        planName: 'Premium',
        offeringSku: $2a2b2c5bc611aa86$export$7529f2cfeec98447.premium,
        recommendationLimit: 250,
        signupLimit: 100000
    },
    {
        planName: 'Enterprise',
        offeringSku: $2a2b2c5bc611aa86$export$7529f2cfeec98447.enterprise,
        recommendationLimit: 5000,
        signupLimit: 100000,
        minUnitCount: $2a2b2c5bc611aa86$export$9aef50cd5f48bb38
    }
];
const $2a2b2c5bc611aa86$export$7a133a10c706882b = {
    monthly: true,
    annual: true
};

});

parcelRegister("lc7EO", function(module, exports) {
$parcel$export(module.exports, "JPD_DEFAULT_BILLING_CYCLE", function () { return $a2567840a72a8d9f$export$513f99bdcd3bd2; });
$parcel$export(module.exports, "JPD_DEFAULT_UNIT_COUNT", function () { return $a2567840a72a8d9f$export$503245d941330408; });
$parcel$export(module.exports, "JPD_MIN_ENTERPRISE_USER_COUNT", function () { return $a2567840a72a8d9f$export$4ebabaf17c585254; });
$parcel$export(module.exports, "jpdOfferingSkus", function () { return $a2567840a72a8d9f$export$400db592c8d58797; });
$parcel$export(module.exports, "jpdBillingCycleConfig", function () { return $a2567840a72a8d9f$export$370b1f24abd91670; });
$parcel$export(module.exports, "jpdPlanLimitConfigs", function () { return $a2567840a72a8d9f$export$886e6b42d7675517; });
$parcel$export(module.exports, "jpdOfferingSkusArray", function () { return $a2567840a72a8d9f$export$cf1798af40f51188; });
$parcel$export(module.exports, "useJpdPlanLimitConfigs", function () { return $a2567840a72a8d9f$export$489f0bd45c02b5f3; });
$parcel$export(module.exports, "useJpdPlanTitlesAllowList", function () { return $a2567840a72a8d9f$export$74aab5e5781ecaa8; });
$parcel$export(module.exports, "stripJpdHighlightedFeatures", function () { return $a2567840a72a8d9f$export$7f3e0ab07e999189; });
$parcel$export(module.exports, "useShouldStripJpdHighlightedFeatures", function () { return $a2567840a72a8d9f$export$5b64204eb3ad795a; });

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
const $a2567840a72a8d9f$export$513f99bdcd3bd2 = 'MONTHLY';
const $a2567840a72a8d9f$export$503245d941330408 = 10;
const $a2567840a72a8d9f$export$4ebabaf17c585254 = 100;
const $a2567840a72a8d9f$export$400db592c8d58797 = {
    free: 'jira-servicedesk-free',
    // jpd-free shares the same sku as jsm-free
    standard: 'jira-product-discovery-standard',
    premium: 'jira-product-discovery-premium-sku',
    enterprise: 'jira-product-discovery-enterprise'
};
const $a2567840a72a8d9f$export$370b1f24abd91670 = {
    monthly: true,
    annual: true
};
const $a2567840a72a8d9f$var$JPD_FREE_PLAN_LIMIT_CONFIG = {
    planName: 'Free',
    offeringSku: $a2567840a72a8d9f$export$400db592c8d58797.free,
    recommendationLimit: 0,
    signupLimit: 20000
};
const $a2567840a72a8d9f$var$JPD_STANDARD_PLAN_LIMIT_CONFIG = {
    planName: 'Standard',
    offeringSku: $a2567840a72a8d9f$export$400db592c8d58797.standard,
    recommendationLimit: 3,
    signupLimit: 20000
};
const $a2567840a72a8d9f$var$JPD_PREMIUM_PLAN_LIMIT_CONFIG = {
    planName: 'Premium',
    offeringSku: $a2567840a72a8d9f$export$400db592c8d58797.premium,
    recommendationLimit: 50,
    signupLimit: 20000
};
const $a2567840a72a8d9f$var$JPD_ENTERPRISE_PLAN_LIMIT_CONFIG = {
    planName: 'Enterprise',
    offeringSku: $a2567840a72a8d9f$export$400db592c8d58797.enterprise,
    recommendationLimit: 250,
    signupLimit: 20000,
    minUnitCount: $a2567840a72a8d9f$export$4ebabaf17c585254
};
const $a2567840a72a8d9f$export$33b06374587a97d9 = ()=>{
    return (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp10907JpdEnterpriseSku);
};
const $a2567840a72a8d9f$export$886e6b42d7675517 = ()=>{
    const isEnterpriseSkuEnabled = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp10907JpdEnterpriseSku);
    const base = [
        $a2567840a72a8d9f$var$JPD_FREE_PLAN_LIMIT_CONFIG,
        $a2567840a72a8d9f$var$JPD_STANDARD_PLAN_LIMIT_CONFIG,
        $a2567840a72a8d9f$var$JPD_PREMIUM_PLAN_LIMIT_CONFIG
    ];
    return isEnterpriseSkuEnabled ? [
        ...base,
        $a2567840a72a8d9f$var$JPD_ENTERPRISE_PLAN_LIMIT_CONFIG
    ] : base;
};
const $a2567840a72a8d9f$export$cf1798af40f51188 = ()=>$a2567840a72a8d9f$export$886e6b42d7675517().map((config)=>config.offeringSku);
const $a2567840a72a8d9f$export$489f0bd45c02b5f3 = ()=>{
    return $a2567840a72a8d9f$export$886e6b42d7675517();
};
const $a2567840a72a8d9f$export$3dbf1d01fece31ca = ()=>{
    return $a2567840a72a8d9f$export$489f0bd45c02b5f3().map((config)=>config.offeringSku);
};
const $a2567840a72a8d9f$export$74aab5e5781ecaa8 = ()=>{
    return $a2567840a72a8d9f$export$489f0bd45c02b5f3().map((config)=>config.planName);
};
const $a2567840a72a8d9f$export$89d0322d6cc3b745 = ()=>{
    return $a2567840a72a8d9f$export$33b06374587a97d9();
};
const $a2567840a72a8d9f$export$7f3e0ab07e999189 = (plans)=>plans.map((plan)=>({
            ...plan,
            fields: {
                ...plan.fields,
                highlightedFeaturesContainer: undefined,
                highlightedFeaturesTitle: undefined
            }
        }));
const $a2567840a72a8d9f$export$5b64204eb3ad795a = (urlSlug)=>{
    const shouldShow = $a2567840a72a8d9f$export$89d0322d6cc3b745();
    return urlSlug === 'product-discovery' && !shouldShow;
};

});

parcelRegister("9Nmuw", function(module, exports) {
$parcel$export(module.exports, "ROVO_DEV_DEFAULT_BILLING_CYCLE", function () { return $5113a0e17f25a106$export$f7b45b42f23a06a6; });
$parcel$export(module.exports, "ROVO_DEV_DEFAULT_UNIT_COUNT", function () { return $5113a0e17f25a106$export$c80f45e98f559c29; });
$parcel$export(module.exports, "ROVO_DEV_MIN_ENTERPRISE_USER_COUNT", function () { return $5113a0e17f25a106$export$5cdb7bb84622bb8e; });
$parcel$export(module.exports, "rovoDevOfferingSkus", function () { return $5113a0e17f25a106$export$6a8477cfea6a8fb8; });
$parcel$export(module.exports, "rovoDevOfferingSkusArray", function () { return $5113a0e17f25a106$export$69f1beff4f684452; });
$parcel$export(module.exports, "rovoDevPlanLimitConfigs", function () { return $5113a0e17f25a106$export$93aaa2531823d54e; });
$parcel$export(module.exports, "rovoDevBillingCycleConfig", function () { return $5113a0e17f25a106$export$120b0272a23f9b21; });
const $5113a0e17f25a106$export$f7b45b42f23a06a6 = 'MONTHLY';
const $5113a0e17f25a106$export$c80f45e98f559c29 = 10;
const $5113a0e17f25a106$export$5cdb7bb84622bb8e = Infinity;
const $5113a0e17f25a106$export$6a8477cfea6a8fb8 = {
    standard: 'rovodev-standard'
};
const $5113a0e17f25a106$export$69f1beff4f684452 = Object.values($5113a0e17f25a106$export$6a8477cfea6a8fb8);
const $5113a0e17f25a106$export$93aaa2531823d54e = [
    {
        planName: 'Standard',
        offeringSku: $5113a0e17f25a106$export$6a8477cfea6a8fb8.standard,
        recommendationLimit: Infinity,
        signupLimit: Infinity,
        minUnitCount: $5113a0e17f25a106$export$5cdb7bb84622bb8e
    }
];
const $5113a0e17f25a106$export$120b0272a23f9b21 = {
    monthly: false,
    annual: false
};

});

parcelRegister("fEBe5", function(module, exports) {
$parcel$export(module.exports, "SERVICE_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $6246fc483000f258$export$9423de11a8a6dfa7; });
$parcel$export(module.exports, "SERVICE_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $6246fc483000f258$export$515fa2affea780b3; });
$parcel$export(module.exports, "SERVICE_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $6246fc483000f258$export$3df704b75c4818f2; });
$parcel$export(module.exports, "serviceCollectionOfferingSkus", function () { return $6246fc483000f258$export$84b191ede7d628ea; });
$parcel$export(module.exports, "serviceCollectionOfferingSkusArray", function () { return $6246fc483000f258$export$953539e2774d6323; });
$parcel$export(module.exports, "serviceCollectionPlanLimitConfigs", function () { return $6246fc483000f258$export$29e5f53cb4f38894; });
$parcel$export(module.exports, "serviceCollectionBillingCycleConfig", function () { return $6246fc483000f258$export$7c96cfb0c18bfb05; });
const $6246fc483000f258$export$9423de11a8a6dfa7 = 'MONTHLY';
const $6246fc483000f258$export$515fa2affea780b3 = 75;
const $6246fc483000f258$export$3df704b75c4818f2 = 201;
const $6246fc483000f258$export$84b191ede7d628ea = {
    free: 'service-collection-free',
    standard: 'service-collection-standard',
    premium: 'service-collection-premium',
    enterprise: 'service-collection-enterprise'
};
const $6246fc483000f258$export$953539e2774d6323 = Object.values($6246fc483000f258$export$84b191ede7d628ea);
const $6246fc483000f258$export$29e5f53cb4f38894 = [
    {
        planName: 'Free',
        offeringSku: $6246fc483000f258$export$84b191ede7d628ea.free,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: 'Standard',
        offeringSku: $6246fc483000f258$export$84b191ede7d628ea.standard,
        recommendationLimit: 3,
        signupLimit: 100000
    },
    {
        planName: 'Premium',
        offeringSku: $6246fc483000f258$export$84b191ede7d628ea.premium,
        recommendationLimit: 50,
        signupLimit: 100000
    },
    {
        planName: 'Enterprise',
        offeringSku: $6246fc483000f258$export$84b191ede7d628ea.enterprise,
        recommendationLimit: 250,
        signupLimit: 100000,
        minUnitCount: $6246fc483000f258$export$3df704b75c4818f2
    }
];
const $6246fc483000f258$export$7c96cfb0c18bfb05 = {
    monthly: true,
    annual: true
};

});

parcelRegister("YmHME", function(module, exports) {
$parcel$export(module.exports, "TEAMWORK_COLLECTION_DEFAULT_BILLING_CYCLE", function () { return $bf49a3d87bcf04a1$export$5784a04bb778d3c1; });
$parcel$export(module.exports, "TEAMWORK_COLLECTION_DEFAULT_UNIT_COUNT", function () { return $bf49a3d87bcf04a1$export$482604a575f7b4a5; });
$parcel$export(module.exports, "TEAMWORK_COLLECTION_MIN_ENTERPRISE_USER_COUNT", function () { return $bf49a3d87bcf04a1$export$da0d6abd6eaa52b2; });
$parcel$export(module.exports, "teamworkCollectionOfferingSkus", function () { return $bf49a3d87bcf04a1$export$2e2107bfa20be1d8; });
$parcel$export(module.exports, "teamworkCollectionOfferingSkusArray", function () { return $bf49a3d87bcf04a1$export$b61ab2c6a18de6d4; });
$parcel$export(module.exports, "teamworkCollectionPlanLimitConfigs", function () { return $bf49a3d87bcf04a1$export$88bcddbae46dd5f1; });
$parcel$export(module.exports, "teamworkCollectionBillingCycleConfig", function () { return $bf49a3d87bcf04a1$export$5861c5ce06e1556; });
const $bf49a3d87bcf04a1$export$5784a04bb778d3c1 = 'MONTHLY';
const $bf49a3d87bcf04a1$export$482604a575f7b4a5 = 300;
const $bf49a3d87bcf04a1$export$da0d6abd6eaa52b2 = 801;
const $bf49a3d87bcf04a1$export$2e2107bfa20be1d8 = {
    free: 'teamwork-collection-free-sku',
    standard: 'teamwork-collection-standard-sku',
    premium: 'teamwork-collection-premium-sku',
    enterprise: 'teamwork-collection-enterprise-sku'
};
const $bf49a3d87bcf04a1$export$b61ab2c6a18de6d4 = Object.values($bf49a3d87bcf04a1$export$2e2107bfa20be1d8);
const $bf49a3d87bcf04a1$export$88bcddbae46dd5f1 = [
    {
        planName: 'Free',
        offeringSku: $bf49a3d87bcf04a1$export$2e2107bfa20be1d8.free,
        recommendationLimit: 0,
        signupLimit: 10
    },
    {
        planName: 'Standard',
        offeringSku: $bf49a3d87bcf04a1$export$2e2107bfa20be1d8.standard,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: 'Premium',
        offeringSku: $bf49a3d87bcf04a1$export$2e2107bfa20be1d8.premium,
        recommendationLimit: 0,
        signupLimit: 100000
    },
    {
        planName: 'Enterprise',
        offeringSku: $bf49a3d87bcf04a1$export$2e2107bfa20be1d8.enterprise,
        recommendationLimit: 5000,
        signupLimit: 100000,
        minUnitCount: $bf49a3d87bcf04a1$export$da0d6abd6eaa52b2
    }
];
const $bf49a3d87bcf04a1$export$5861c5ce06e1556 = {
    monthly: true,
    annual: true
};

});

parcelRegister("e0LCf", function(module, exports) {
$parcel$export(module.exports, "CollectionPricingHero", function () { return $2a773e3b9098f7a0$export$8065869e82d5a4c7; });
/* collection-pricing-hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $hnmMQ = parcelRequire("hnmMQ");

var $kbpa7 = parcelRequire("kbpa7");

var $8A3gV = parcelRequire("8A3gV");
const $2a773e3b9098f7a0$var$horizontalOrientationCss = null;
const $2a773e3b9098f7a0$var$verticalOrientationCss = null;
const $2a773e3b9098f7a0$var$logoCss = null;
const $2a773e3b9098f7a0$var$verticalLogoCss = null;
const $2a773e3b9098f7a0$export$8065869e82d5a4c7 = (props)=>{
    const orientation = props.orientation || 'horizontal';
    const messages = (0, $8A3gV.useCollectionPricingHeroMessages)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _1f2ygktf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1bsb1ns9 _p12fuoas"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _zulppxbi _1yt417la _1lp7vrvc _19wgxy5q _6yttgfpe"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _4cvr1h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                image: {
                                    src: props.collectionImage.src,
                                    alt: props.collectionImage.alt,
                                    height: props.collectionImage.height,
                                    width: props.collectionImage.width
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _2lx21bp4 _zulp1crf"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                    className: (0, $2jatx.default)([
                                        "_ect4z4z1 _1wyb19bv _k48p1nn1 _1p1dangw _syaz1qc2 _vwz47vkz _y3gn1h6o _uj6k18uv"
                                    ]),
                                    style: {
                                        "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text')),
                                        "--_1fww9ud": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light800'))
                                    },
                                    children: messages.includes
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        orientation === 'horizontal' ? "_1e0c11p5 _yv0efsjm _2z05im57 _zulpxy5q _gy1pxy5q _1p57pxbi _ect41vau _k48p1nn1 _1wyb1wbj" : "_1e0c1txw _2lx21bp4 _zulppxbi"
                                    ]),
                                    style: {
                                        "--_1vugql0": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.display'))
                                    },
                                    children: props.products.map((product, key)=>{
                                        return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                            className: (0, $2jatx.default)([
                                                orientation === 'horizontal' ? "_1e0c1txw _4cvr1h6o _zulp12x7 _1bsb1n5l" : "_1e0c1txw _4cvr1h6o _4t3igktf"
                                            ]),
                                            children: [
                                                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                                                    image: {
                                                        src: product.image.src,
                                                        alt: product.image.alt
                                                    },
                                                    className: (0, $2jatx.default)([
                                                        "_y4ti1xn6"
                                                    ]),
                                                    style: {
                                                        height: '20px',
                                                        "--_1tc2js6": (0, $6ZVlx.default)(orientation === 'vertical' ? "var(--ds-space-075, 6px)" : 0)
                                                    }
                                                }),
                                                product.name
                                            ]
                                        }, key);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _mqm21hma"
                    ]),
                    style: {
                        "--_1hwkv7u": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark1100'))
                    }
                }),
                /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            className: (0, $2jatx.default)([
                                "_syaz1pfd _1e0c1ule _y3gn1h6o _ect4z4z1 _1wyb7vkz _zg8l4jg8 _k48p1fw0 _vwz41ou6 _1yt4zu5n"
                            ]),
                            style: {
                                "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                            },
                            children: messages.heading
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1e0c1txw _1bah1h6o"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _1n261g80 _1bah1h6o _zulpu2gc _19wgpxbi"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/k383m26br4w8fu6i68s0qbnym881f0wb.svg",
                                        name: messages.home,
                                        alt: messages.home
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/r7k15161ensv07cht48h87c31ueh7sh3.svg",
                                        name: messages.goals,
                                        alt: messages.goals
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/51ht267g50ve2d3051aw8nrgs0k11ad6.svg",
                                        name: messages.teams,
                                        alt: messages.teams
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/2pqaabre17cu7mx66ydvhplnbt4hh3ub.svg",
                                        name: messages.studio,
                                        alt: messages.studio
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/to7s6r4xr4564x6jhc134qhgevi13wo3.svg",
                                        name: messages.search,
                                        alt: messages.search
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/pe661ex05dvkmxul5nf4fi1e20hq8063.svg",
                                        name: messages.chat,
                                        alt: messages.chat
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/8f6ta76fw1d04u40k8fp622i67154764.svg",
                                        name: messages.analytics,
                                        alt: messages.analytics
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)($2a773e3b9098f7a0$var$Subproduct, {
                                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/dv817l8n01hct543cmd030ksu3hfj0k6.svg",
                                        name: messages.admin,
                                        alt: messages.admin
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};
const $2a773e3b9098f7a0$var$Subproduct = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulp1b66 _1ul91l27 _1yt41giy"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _1bah1h6o _4cvr1h6o"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_19pkrdoj _2hwxrdoj _otyrrdoj _18u0rdoj _4t3igktf _1bsbgktf"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hnmMQ.Picture), {
                        image: {
                            src: props.src,
                            alt: props.alt
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_y3gn1h6o _ect4z4z1 _1wybsm30 _zg8l4jg8 _k48p1nn1 _vwz41crf"
                ]),
                style: {
                    "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                },
                children: props.name
            })
        ]
    });
};

});
parcelRegister("8A3gV", function(module, exports) {
$parcel$export(module.exports, "useCollectionPricingHeroMessages", function () { return $6e2ac6bb4e232ff3$export$7c226aa081048b2; });

var $8e22h = parcelRequire("8e22h");

var $cN0Nw = parcelRequire("cN0Nw");

var $ai3ZP = parcelRequire("ai3ZP");
function $6e2ac6bb4e232ff3$export$7c226aa081048b2() {
    const intl = (0, $8e22h.default)();
    const hardcoded = (0, $cN0Nw.checkFeatureFlagGate)((0, $ai3ZP.featureFlags).gwp8279CollectionHeroIntl);
    if (hardcoded) return $6e2ac6bb4e232ff3$export$22298271baa6ded9(intl.locale);
    return {
        heading: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.platformAppsHeading',
            defaultMessage: 'Plus all Atlassian Platform Apps'
        }),
        includes: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.includes',
            defaultMessage: 'Includes'
        }),
        home: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.app.home.alt',
            defaultMessage: 'Home'
        }),
        goals: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.app.goals',
            defaultMessage: 'Goals'
        }),
        teams: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.app.teams',
            defaultMessage: 'Teams'
        }),
        studio: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.app.studio',
            defaultMessage: 'Studio'
        }),
        search: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.app.search',
            defaultMessage: 'Search'
        }),
        chat: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.app.chat',
            defaultMessage: 'Chat'
        }),
        analytics: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.app.analytics',
            defaultMessage: 'Analytics'
        }),
        admin: intl.formatMessage({
            id: 'TeamworkCollectionPricingPageHero.app.admin',
            defaultMessage: 'Admin'
        })
    };
}
function $6e2ac6bb4e232ff3$export$22298271baa6ded9(locale) {
    return $6e2ac6bb4e232ff3$var$MESSAGES[locale] ?? $6e2ac6bb4e232ff3$var$enMessages;
}
const $6e2ac6bb4e232ff3$var$enMessages = {
    home: 'Home',
    heading: 'Plus all Atlassian Platform Apps',
    includes: 'Includes',
    goals: 'Goals',
    teams: 'Teams',
    studio: 'Studio',
    search: 'Search',
    chat: 'Chat',
    analytics: 'Analytics',
    admin: 'Admin'
};
const $6e2ac6bb4e232ff3$var$MESSAGES = {
    en: $6e2ac6bb4e232ff3$var$enMessages,
    nl: {
        home: 'Home',
        heading: 'Plus alle Atlassian Platform-apps',
        includes: 'Omvat',
        goals: 'Doelstellingen',
        teams: 'Teams',
        studio: 'Studio',
        search: 'Zoeken',
        chat: 'Chat',
        analytics: 'Analyses',
        admin: 'Beheerder'
    },
    es: {
        home: 'Inicio',
        heading: "Adem\xe1s de todas las aplicaciones de la plataforma de Atlassian",
        includes: 'Incluye',
        goals: 'Objetivos',
        teams: 'Equipos',
        studio: 'Studio',
        search: 'Buscar',
        chat: 'Chat',
        analytics: "An\xe1lisis",
        admin: 'Administrativo'
    },
    ru: {
        home: "\u0413\u043B\u0430\u0432\u043D\u0430\u044F",
        heading: "\u0410 \u0442\u0430\u043A\u0436\u0435 \u0432\u0441\u0435 \u043F\u0440\u0438\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u043F\u043B\u0430\u0442\u0444\u043E\u0440\u043C\u044B Atlassian",
        includes: "\u0412\u043A\u043B\u044E\u0447\u0430\u0435\u0442",
        goals: "\u0426\u0435\u043B\u0438",
        teams: "\u041A\u043E\u043C\u0430\u043D\u0434\u044B",
        studio: "\u041C\u0430\u0441\u0442\u0435\u0440\u0441\u043A\u0430\u044F",
        search: "\u041F\u043E\u0438\u0441\u043A",
        chat: "\u0427\u0430\u0442",
        analytics: "\u0410\u043D\u0430\u043B\u0438\u0442\u0438\u043A\u0430",
        admin: "\u0410\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440"
    },
    fr: {
        home: 'Accueil',
        heading: 'Et toutes les apps de la plateforme Atlassian',
        includes: "Fonctionnalit\xe9s incluses",
        goals: 'Objectifs',
        teams: "\xc9quipes",
        studio: 'Studio',
        search: 'Recherche',
        chat: 'Chat',
        analytics: 'Analyses',
        admin: 'Administrateur'
    },
    ko: {
        home: "\uD648",
        heading: "\uBC0F \uBAA8\uB4E0 Atlassian \uD50C\uB7AB\uD3FC \uC571",
        includes: "\uD3EC\uD568 \uC0AC\uD56D",
        goals: "\uBAA9\uD45C",
        teams: "\uD300",
        studio: "\uC2A4\uD29C\uB514\uC624",
        search: "\uAC80\uC0C9",
        chat: "\uCC44\uD305",
        analytics: "\uBD84\uC11D",
        admin: "\uAD00\uB9AC\uC790"
    },
    br: {
        home: "In\xedcio",
        heading: "Al\xe9m de todos os apps da plataforma Atlassian",
        includes: 'Inclui',
        goals: 'Metas',
        teams: 'Equipes',
        studio: 'Studio',
        search: 'Pesquisar',
        chat: 'Bate-papo',
        analytics: "Dados de An\xe1lise",
        admin: 'Admin'
    },
    pl: {
        home: "Strona g\u0142\xf3wna",
        heading: 'Plus wszystkie aplikacje platformy Atlassian',
        includes: 'Obejmuje',
        goals: 'Cele',
        teams: "Zespo\u0142y",
        studio: 'Studio',
        search: 'Wyszukiwanie',
        chat: 'Czat',
        analytics: 'Analizy',
        admin: 'Administrator'
    },
    de: {
        home: 'Home',
        heading: 'Plus alle Apps der Atlassian-Plattform',
        includes: 'Beinhaltet',
        goals: 'Ziele',
        teams: 'Teams',
        studio: 'Studio',
        search: 'Suchen',
        chat: 'Chat',
        analytics: 'Analysen',
        admin: 'Administrator'
    },
    zh: {
        home: "\u9996\u9875",
        heading: "\u4EE5\u53CA\u6240\u6709 Atlassian \u5E73\u53F0\u5E94\u7528",
        includes: "\u5305\u62EC",
        goals: "\u76EE\u6807",
        teams: "\u56E2\u961F",
        studio: "\u5DE5\u4F5C\u5BA4",
        search: "\u641C\u7D22",
        chat: "\u804A\u5929",
        analytics: "\u5206\u6790",
        admin: "\u7BA1\u7406\u5458"
    },
    it: {
        home: 'Pagina iniziale',
        heading: 'E tutte le app della piattaforma di Atlassian',
        includes: 'Include',
        goals: 'Obiettivi',
        teams: 'Team',
        studio: 'Studio',
        search: 'Cerca',
        chat: 'Chat',
        analytics: 'Analisi',
        admin: 'Amministratore'
    },
    ja: {
        home: "\u30DB\u30FC\u30E0",
        heading: "\u3055\u3089\u306B\u3059\u3079\u3066\u306E\u30A2\u30C8\u30E9\u30B7\u30A2\u30F3 \u30D7\u30E9\u30C3\u30C8\u30D5\u30A9\u30FC\u30E0 \u30A2\u30D7\u30EA",
        includes: "\u30A4\u30F3\u30AF\u30EB\u30FC\u30C9",
        goals: "\u76EE\u6A19",
        teams: "\u30C1\u30FC\u30E0",
        studio: "\u30B9\u30BF\u30B8\u30AA",
        search: "\u691C\u7D22",
        chat: "\u30C1\u30E3\u30C3\u30C8",
        analytics: "\u5206\u6790\u6A5F\u80FD",
        admin: "\u7BA1\u7406\u8005"
    }
};

});


parcelRegister("jfojT", function(module, exports) {
$parcel$export(module.exports, "TeamworkCollectionPricingHero", function () { return $e2d3685819b80935$export$11d510446f2a0235; });

var $7VQPk = parcelRequire("7VQPk");

var $e0LCf = parcelRequire("e0LCf");
const $e2d3685819b80935$export$11d510446f2a0235 = ()=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $e0LCf.CollectionPricingHero), {
        collectionImage: {
            src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/wwq35151x13e6200i5xc4qs5r21er0q5.svg',
            alt: 'Teamwork Collection'
        },
        products: [
            {
                name: 'Jira',
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/36a5pi244g3e1j3540td888vgj855s0u/collections-teamwork-jira.svg',
                    alt: 'Jira'
                }
            },
            {
                name: 'Confluence',
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/nj0wofvhj3q26f3vy866q801p5bbw83w/collections-teamwork-confluence.svg',
                    alt: 'Confluence'
                }
            },
            {
                name: 'Loom',
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/138cux5d67t757a2ddy0l833ihe728l8/collections-teamwork-loom.svg',
                    alt: 'Loom'
                }
            },
            {
                name: 'Rovo',
                image: {
                    src: 'https://dam-cdn.atl.orangelogic.com/AssetLink/bijp0lf52qxqdt3257q0kj73t8d5681g.svg',
                    alt: 'Rovo'
                }
            }
        ]
    });
};

});

parcelRegister("aTuVh", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::cca747bf584e772ee6e9df3631122996>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7ee7070fa3cc9dab$var$_react = $7ee7070fa3cc9dab$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $7ee7070fa3cc9dab$var$_baseNew = $7ee7070fa3cc9dab$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $7ee7070fa3cc9dab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Incident".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for incidents in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7ee7070fa3cc9dab$var$IncidentIcon = (props)=>/*#__PURE__*/ $7ee7070fa3cc9dab$var$_react.default.createElement($7ee7070fa3cc9dab$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1a.75.75 0 0 1 .696.471l2.2 5.5 2.612 6.529H15V15H1v-1.5h1.492L7.304 1.471A.75.75 0 0 1 8 1M4.108 13.5h7.784l-.8-2H4.908zm1.4-3.5h4.984l-.8-2H6.308zm1.4-3.5h2.184L8 3.77z" clip-rule="evenodd"/>`
    }, props));
$7ee7070fa3cc9dab$var$IncidentIcon.displayName = 'IncidentIcon';
var $7ee7070fa3cc9dab$var$_default = module.exports.default = $7ee7070fa3cc9dab$var$IncidentIcon;

});

parcelRegister("7Sdq5", function(module, exports) {
$parcel$export(module.exports, "CollectionsCompoundNav", function () { return $61c36fa46e5ad31f$export$c217303c3f69f1be; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $jQ0cd = parcelRequire("jQ0cd");

var $cR2Ov = parcelRequire("cR2Ov");

var $hcVGp = parcelRequire("hcVGp");
const $61c36fa46e5ad31f$export$c217303c3f69f1be = ()=>{
    const intl = (0, $8e22h.default)();
    const teamworkOverviewHref = (0, $jQ0cd.useLocalizedHref)('/collections/teamwork');
    const teamworkFeaturesHref = (0, $jQ0cd.useLocalizedHref)('/collections/teamwork/features');
    const teamworkGuidesHref = (0, $jQ0cd.useLocalizedHref)('/collections/teamwork/guides');
    const teamworkEnterpriseHref = (0, $jQ0cd.useLocalizedHref)('/collections/teamwork/enterprise');
    const teamworkPricingHref = (0, $jQ0cd.useLocalizedHref)('/collections/teamwork/pricing');
    const teamworkResourcesHref = (0, $jQ0cd.useLocalizedHref)('/collections/teamwork/resources');
    const strategyOverviewHref = (0, $jQ0cd.useLocalizedHref)('/collections/strategy');
    const strategyDemosHref = (0, $jQ0cd.useLocalizedHref)('/collections/strategy/demo-center');
    const strategyPricingHref = (0, $jQ0cd.useLocalizedHref)('/collections/strategy/pricing');
    const strategyResourcesHref = (0, $jQ0cd.useLocalizedHref)('/collections/strategy/resources');
    const strategyUseCasesHref = (0, $jQ0cd.useLocalizedHref)('/collections/strategy/use-cases');
    const strategyCustomersHref = (0, $jQ0cd.useLocalizedHref)('/collections/strategy/customers');
    const serviceOverviewHref = (0, $jQ0cd.useLocalizedHref)('/collections/service');
    const serviceGuidesHref = (0, $jQ0cd.useLocalizedHref)('/collections/service/guides');
    const servicePricingHref = (0, $jQ0cd.useLocalizedHref)('/collections/service/pricing');
    const softwareHref = (0, $jQ0cd.useLocalizedHref)('/collections/software');
    const productHref = (0, $jQ0cd.useLocalizedHref)('/collections/product');
    const collectionsHref = (0, $jQ0cd.useLocalizedHref)('/collections');
    const props = {
        optionalClassName: 'collections-nav',
        compoundSubNavTitle: 'Collections',
        compoundSubNavTitleHref: collectionsHref,
        compoundSubNavLinksProps: [
            {
                globalLinksKey: 'teamwork',
                linkText: 'Teamwork',
                hasSubnav: true,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.overview',
                                        defaultMessage: 'Overview'
                                    }),
                                    href: teamworkOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.features',
                                        defaultMessage: 'Features'
                                    }),
                                    href: teamworkFeaturesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.guides',
                                        defaultMessage: 'Guides'
                                    }),
                                    href: teamworkGuidesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.enterprise',
                                        defaultMessage: 'Enterprise'
                                    }),
                                    href: teamworkEnterpriseHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.pricing',
                                        defaultMessage: 'Pricing'
                                    }),
                                    href: teamworkPricingHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.resources',
                                        defaultMessage: 'Resources'
                                    }),
                                    href: teamworkResourcesHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: 'strategy',
                linkText: 'Strategy',
                hasSubnav: true,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.overview',
                                        defaultMessage: 'Overview'
                                    }),
                                    href: strategyOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.demos',
                                        defaultMessage: 'Demos'
                                    }),
                                    href: strategyDemosHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.pricing',
                                        defaultMessage: 'Pricing'
                                    }),
                                    href: strategyPricingHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.resources',
                                        defaultMessage: 'Resources'
                                    }),
                                    href: strategyResourcesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.useCases',
                                        defaultMessage: 'Use Cases'
                                    }),
                                    href: strategyUseCasesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.customers',
                                        defaultMessage: 'Customers'
                                    }),
                                    href: strategyCustomersHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: 'service',
                linkText: 'Service',
                hasSubnav: true,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    orientation: "column",
                    contentSections: [
                        {
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.overview',
                                        defaultMessage: 'Overview'
                                    }),
                                    href: serviceOverviewHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.guides',
                                        defaultMessage: 'Guides'
                                    }),
                                    href: serviceGuidesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'CollectionsCompoundSubNavProps.pricing',
                                        defaultMessage: 'Pricing'
                                    }),
                                    href: servicePricingHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: 'software',
                linkText: 'Software',
                hasSubnav: false,
                href: softwareHref
            },
            {
                globalLinksKey: 'product',
                linkText: 'Product',
                hasSubnav: false,
                href: productHref
            }
        ],
        isShowCta: false
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $hcVGp.GlobalNav), {
        productKey: 'collection',
        compoundNav: props
    });
};

});

parcelRegister("lgKym", function(module, exports) {
$parcel$export(module.exports, "CompassNav", function () { return $73340f47439b5afe$export$78e93448314ae49; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $iOXki = parcelRequire("iOXki");
const $73340f47439b5afe$var$CompassLogoComponent = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "compass",
        type: "logo",
        appearance: "brand",
        lightMode: isDarkTheme
    });
};
const $73340f47439b5afe$export$78e93448314ae49 = ()=>{
    const intl = (0, $8e22h.default)();
    const pricingHref = (0, $jQ0cd.useLocalizedHref)('/software/compass/pricing');
    const resourcesHref = (0, $jQ0cd.useLocalizedHref)('/software/compass/resources');
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-CompassNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
            productLogoUrl: "/software/compass",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($73340f47439b5afe$var$CompassLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: 'CompassPageTemplate.navbar.compass-logo',
                defaultMessage: 'Compass logo'
            }),
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($73340f47439b5afe$var$CompassLogoComponent, {}),
            productPageNavLinks: [
                {
                    globalLinksKey: 'features',
                    linkText: intl.formatMessage({
                        id: 'CompassPageTemplate.navbar.features',
                        defaultMessage: 'Features'
                    }),
                    hasSubnav: false,
                    productKey: 'compass',
                    href: (0, $jQ0cd.useLocalizedHref)('/software/compass/features')
                },
                {
                    globalLinksKey: 'pricing',
                    linkText: intl.formatMessage({
                        id: 'CompassPageTemplate.navbar.pricing',
                        defaultMessage: 'Pricing'
                    }),
                    hasSubnav: false,
                    productKey: 'compass',
                    href: pricingHref
                },
                {
                    globalLinksKey: 'resources',
                    linkText: intl.formatMessage({
                        id: 'CompassPageTemplate.navbar.resources',
                        defaultMessage: 'Resources'
                    }),
                    hasSubnav: false,
                    productKey: 'compass',
                    href: resourcesHref
                }
            ],
            isShowTryNowLink: false,
            mobileLinksSections: [
                {
                    mobileLinkKey: 'mobile-compass',
                    mobileLinksProps: [
                        {
                            globalLinksKey: 'features',
                            linkText: intl.formatMessage({
                                id: 'CompassPageTemplate.navbar.features',
                                defaultMessage: 'Features'
                            }),
                            hasSubnav: false,
                            productKey: 'compass',
                            href: (0, $jQ0cd.useLocalizedHref)('/software/compass/features')
                        },
                        {
                            globalLinksKey: 'pricing',
                            linkText: intl.formatMessage({
                                id: 'CompassPageTemplate.navbar.pricing',
                                defaultMessage: 'Pricing'
                            }),
                            hasSubnav: false,
                            productKey: 'compass',
                            href: pricingHref
                        },
                        {
                            globalLinksKey: 'resources',
                            linkText: intl.formatMessage({
                                id: 'CompassPageTemplate.navbar.resources',
                                defaultMessage: 'Resources'
                            }),
                            hasSubnav: false,
                            productKey: 'compass',
                            href: resourcesHref
                        }
                    ]
                }
            ]
        })
    });
};

});

parcelRegister("g2lQR", function(module, exports) {
$parcel$export(module.exports, "GuardNav", function () { return $97dc5fc3d3238142$export$941339143e9f5522; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $bQjAr = parcelRequire("bQjAr");

var $20OkY = parcelRequire("20OkY");

var $asbmK = parcelRequire("asbmK");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $iOXki = parcelRequire("iOXki");
const $97dc5fc3d3238142$var$GuardLogoComponent = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "guard",
        type: "logo",
        appearance: "brand",
        lightMode: isDarkTheme
    });
};
const $97dc5fc3d3238142$export$941339143e9f5522 = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = 'https://admin.atlassian.com/atlassian-guard';
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const capabilitiesHref = (0, $jQ0cd.useLocalizedHref)('/software/guard/capabilities');
    const pricingHref = (0, $jQ0cd.useLocalizedHref)('/software/guard/pricing');
    const guidesHref = (0, $jQ0cd.useLocalizedHref)('/software/guard/guide#getting-started');
    const demoHref = (0, $jQ0cd.useLocalizedHref)('/software/guard/demo');
    const links = [
        {
            globalLinksKey: 'capabilities',
            linkText: intl.formatMessage({
                id: 'GuardPageTemplate.navbar.capabilities',
                defaultMessage: 'Capabilities'
            }),
            hasSubnav: false,
            productKey: 'guard',
            href: capabilitiesHref
        },
        {
            globalLinksKey: 'guides',
            linkText: intl.formatMessage({
                id: 'GuardPageTemplate.navbar.guides',
                defaultMessage: 'Guides'
            }),
            hasSubnav: false,
            productKey: 'guard',
            href: guidesHref
        },
        {
            globalLinksKey: 'demo',
            linkText: intl.formatMessage({
                id: 'GuardPageTemplate.navbar.demo',
                defaultMessage: 'Demo'
            }),
            hasSubnav: false,
            productKey: 'guard',
            href: demoHref
        },
        {
            globalLinksKey: 'pricing',
            linkText: intl.formatMessage({
                id: 'GuardPageTemplate.navbar.pricing',
                defaultMessage: 'Pricing'
            }),
            hasSubnav: false,
            productKey: 'guard',
            href: pricingHref
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "confluence-pt-cfind-1234-GuardNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
            productLogoUrl: "/software/guard",
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($97dc5fc3d3238142$var$GuardLogoComponent, {}),
            productLogoAriaLabel: intl.formatMessage({
                id: 'GuardPageTemplate.navbar.guard-logo',
                defaultMessage: 'Guard logo'
            }),
            mobileCtaText: intl.formatMessage({
                id: 'GuardPageTemplate.navbar.tryitfree',
                defaultMessage: 'Try it free'
            }),
            navigationTrynowCtaText: intl.formatMessage({
                id: 'GuardPageTemplate.navbar.tryitfree',
                defaultMessage: 'Try it free'
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: openCrossFlow,
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($97dc5fc3d3238142$var$GuardLogoComponent, {}),
            productPageNavLinks: links,
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: openCrossFlow,
            mobileLinksSections: [
                {
                    mobileLinkKey: 'mobile-guard',
                    mobileLinksProps: links
                }
            ]
        })
    });
};

});

parcelRegister("aYwTu", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $a060b684c4f472c9$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $20OkY = parcelRequire("20OkY");

var $asbmK = parcelRequire("asbmK");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $iOXki = parcelRequire("iOXki");
const $a060b684c4f472c9$var$JpdLogo = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "jiraproductdiscovery",
        type: "logo",
        appearance: "brand",
        lightMode: isDarkTheme
    });
};
const $a060b684c4f472c9$var$JiraProductDiscoveryNavV2 = ()=>{
    const intl = (0, $8e22h.default)();
    const signupLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=jira-product-discovery');
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_PRODUCT_DISCOVERY,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const links = [
        {
            globalLinksKey: 'features',
            linkText: intl.formatMessage({
                // this id can be renamed once the above has been fixed as well
                id: 'jiraproductdiscovery.navbar.product-features',
                defaultMessage: 'Features'
            }),
            hasSubnav: false,
            productKey: 'jiraProductDiscovery',
            href: (0, $jQ0cd.useLocalizedHref)('/software/jira/product-discovery/features')
        },
        {
            globalLinksKey: 'resources',
            linkText: intl.formatMessage({
                id: 'jiraproductdiscovery.navbar.resources',
                defaultMessage: 'Resources'
            }),
            hasSubnav: false,
            productKey: 'jiraProductDiscovery',
            href: (0, $jQ0cd.useLocalizedHref)('/software/jira/product-discovery/resources')
        },
        {
            globalLinksKey: 'guides',
            linkText: intl.formatMessage({
                id: 'jiraproductdiscovery.navbar.guides',
                defaultMessage: 'Guides'
            }),
            hasSubnav: false,
            productKey: 'jiraProductDiscovery',
            href: (0, $jQ0cd.useLocalizedHref)('/software/jira/product-discovery/guides/getting-started/introduction')
        },
        {
            globalLinksKey: 'pricing',
            linkText: intl.formatMessage({
                // this id should be renamed, but for Team'24 hotfix we need to keep existing mapping
                id: 'jiraproductdiscovery.navbar.features',
                defaultMessage: 'Pricing'
            }),
            hasSubnav: false,
            productKey: 'jiraProductDiscovery',
            href: (0, $jQ0cd.useLocalizedHref)('/software/jira/product-discovery/pricing')
        }
    ];
    const ctaText = intl.formatMessage({
        id: 'productNavBar.get-it-free-button',
        defaultMessage: 'Get it free'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
        productLogoUrl: (0, $jQ0cd.useLocalizedHref)('/software/jira/product-discovery'),
        productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($a060b684c4f472c9$var$JpdLogo, {}),
        productLogoAriaLabel: intl.formatMessage({
            id: 'wacJiraProductDiscoveryNavigation.logo-label',
            defaultMessage: 'Jira Product Discovery logo'
        }),
        mobileCtaText: ctaText,
        mobileCtaUrl: signupLink,
        mobileCtaOnClick: openCrossFlow,
        mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($a060b684c4f472c9$var$JpdLogo, {}),
        navigationTrynowCtaText: ctaText,
        navigationTrynowCtaUrl: signupLink,
        navigationTrynowCtaOnClick: openCrossFlow,
        productPageNavLinks: links,
        mobileLinksSections: [
            {
                mobileLinkKey: 'mobile-jira-product-discovery',
                mobileLinksProps: links
            }
        ]
    });
};
$a060b684c4f472c9$var$JiraProductDiscoveryNavV2.displayName = 'JiraProductDiscoveryNavV2';
var $a060b684c4f472c9$export$2e2bcd8739ae039 = $a060b684c4f472c9$var$JiraProductDiscoveryNavV2;

});

parcelRegister("aYVVm", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $133256a5190381b7$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $8e22h = parcelRequire("8e22h");

var $20OkY = parcelRequire("20OkY");

var $asbmK = parcelRequire("asbmK");

var $b31tm = parcelRequire("b31tm");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $cR2Ov = parcelRequire("cR2Ov");

var $iOXki = parcelRequire("iOXki");

var $iSeHD = parcelRequire("iSeHD");

var $9KOR3 = parcelRequire("9KOR3");
const $133256a5190381b7$var$JiraServiceManagementLogo = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "jiraservicemanagement",
        type: "logo",
        appearance: "brand",
        lightMode: isDarkTheme
    });
};
const $133256a5190381b7$var$JiraServiceManagementSoftwareNavV2 = ({ productNavCtaCTAClickFunction: productNavCtaCTAClickFunction, isUseOpenCrossFlow: isUseOpenCrossFlow = false })=>{
    const intl = (0, $8e22h.default)();
    const featuresHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/features');
    const pricingHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/pricing');
    const itSupportHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/itsm-software');
    const itOperationsHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/it-operations');
    const enterpriseServiceManagementHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/features/enterprise-service-management');
    const customerServiceHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/customer-service-software');
    const hrHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/hr');
    const smallTeamsHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/help-desk-software-small-business-software');
    const premiumHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/premium');
    const enterpriseHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/enterprise');
    const technologyTelecomHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/technology-telecommunications');
    const financialServicesHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/financial-services');
    const retailHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/retail-ecommerce');
    const manufacturingHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/manufacturing');
    const itsmHref = (0, $jQ0cd.useLocalizedHref)('/itsm');
    const guidesHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/product-guide');
    const resourcesHref = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/resources');
    const solutionsDropdownStyles = (0, $1oC0p.useMemo)(()=>{
        return {
            width: 'fit-content !important',
            margin: 0,
            transform: 'translateX(-40%)'
        };
    }, []);
    const templatesUrl = (0, $jQ0cd.useLocalizedHref)('/software/jira/templates/service-management');
    const { fireUIEvent: fireUIEvent } = (0, $b31tm.useFireEvent)();
    const viewedUIEvent = (0, $1oC0p.useRef)(false);
    const analyticsClient = (0, $iSeHD.useAnalyticsClient)();
    (0, $1oC0p.useEffect)(()=>{
        if (!viewedUIEvent.current && analyticsClient) {
            viewedUIEvent.current = true;
            fireUIEvent({
                action: 'viewed',
                actionSubject: 'jiraServiceManagementSoftwareNavV2'
            });
        }
    }, [
        analyticsClient,
        fireUIEvent
    ]);
    const links = (0, $1oC0p.useMemo)(()=>[
            {
                globalLinksKey: 'features',
                linkText: intl.formatMessage({
                    id: 'software-jira-service-management.navbar.features',
                    defaultMessage: 'Features'
                }),
                hasSubnav: false,
                productKey: 'jira-servicedesk.ondemand',
                href: featuresHref
            },
            {
                globalLinksKey: 'solutions',
                linkText: intl.formatMessage({
                    id: 'software-jira-service-management.navbar.solutions',
                    defaultMessage: 'Solutions'
                }),
                hasSubnav: true,
                dropdownType: 'solutions',
                productKey: 'jira-servicedesk.ondemand',
                containerPosition: 'relative',
                containerStyles: solutionsDropdownStyles,
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    contentSections: [
                        {
                            header: intl.formatMessage({
                                id: 'software-jira-service-management.navbar.solutions.useCases.header',
                                defaultMessage: 'By use case'
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.useCases.itSupport',
                                        defaultMessage: 'IT Support'
                                    }),
                                    href: itSupportHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.useCases.itOperations',
                                        defaultMessage: 'IT Operations'
                                    }),
                                    href: itOperationsHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.useCases.businessTeams',
                                        defaultMessage: 'Business Teams'
                                    }),
                                    href: enterpriseServiceManagementHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.useCases.customerService',
                                        defaultMessage: 'Customer Service'
                                    }),
                                    href: customerServiceHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.useCases.humanResources',
                                        defaultMessage: 'Human Resources'
                                    }),
                                    href: hrHref
                                }
                            ]
                        },
                        {
                            header: intl.formatMessage({
                                id: 'software-jira-service-management.navbar.solutions.capability.header',
                                defaultMessage: 'By capability'
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.capability.smallTeams',
                                        defaultMessage: 'Small Teams'
                                    }),
                                    href: smallTeamsHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.capability.premium',
                                        defaultMessage: 'Premium'
                                    }),
                                    href: premiumHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.capability.enterprise',
                                        defaultMessage: 'Enterprise'
                                    }),
                                    href: enterpriseHref
                                }
                            ]
                        },
                        {
                            header: intl.formatMessage({
                                id: 'software-jira-service-management.navbar.solutions.industry.customerService',
                                defaultMessage: 'By industry'
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.industry.technologyTelecom',
                                        defaultMessage: 'Technology & Telecom'
                                    }),
                                    href: technologyTelecomHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.industry.financialServices',
                                        defaultMessage: 'Financial Services'
                                    }),
                                    href: financialServicesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.industry.retail',
                                        defaultMessage: 'Retail'
                                    }),
                                    href: retailHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.solutions.useCases.manufacturing',
                                        defaultMessage: 'Manufacturing'
                                    }),
                                    href: manufacturingHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: 'resources',
                linkText: intl.formatMessage({
                    id: 'software-jira-service-management.navbar.resources',
                    defaultMessage: 'Resources'
                }),
                hasSubnav: true,
                dropdownType: 'resources',
                productKey: 'jira-servicedesk.ondemand',
                containerPosition: 'relative',
                content: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $cR2Ov.DropdownContent), {
                    contentSections: [
                        {
                            header: intl.formatMessage({
                                id: 'software-jira-service-management.navbar.resources.type.header',
                                defaultMessage: 'By type'
                            }),
                            links: [
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.resources.type.itsm',
                                        defaultMessage: 'ITSM'
                                    }),
                                    href: itsmHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.resources.type.guides',
                                        defaultMessage: 'Guides'
                                    }),
                                    href: guidesHref
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.templates',
                                        defaultMessage: 'Templates'
                                    }),
                                    href: templatesUrl
                                },
                                {
                                    text: intl.formatMessage({
                                        id: 'software-jira-service-management.navbar.resources.type.additionalResources',
                                        defaultMessage: 'Additional Resources'
                                    }),
                                    href: resourcesHref
                                }
                            ]
                        }
                    ]
                })
            },
            {
                globalLinksKey: 'pricing',
                linkText: intl.formatMessage({
                    id: 'software-jira-service-management.navbar.pricing',
                    defaultMessage: 'Pricing'
                }),
                hasSubnav: false,
                productKey: 'jira-servicedesk.ondemand',
                href: pricingHref
            }
        ], // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        customerServiceHref,
        solutionsDropdownStyles,
        enterpriseHref,
        enterpriseServiceManagementHref,
        featuresHref,
        financialServicesHref,
        hrHref,
        intl,
        itOperationsHref,
        itSupportHref,
        itsmHref,
        manufacturingHref,
        premiumHref,
        pricingHref,
        guidesHref,
        resourcesHref,
        retailHref,
        smallTeamsHref,
        technologyTelecomHref,
        templatesUrl
    ]);
    const signupLink = (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management/free');
    const { openCrossFlow: openCrossFlow } = (0, $asbmK.useCrossFlowFrontendTouchpoint)({
        productKey: (0, $20OkY.ProductKeys).JIRA_SERVICE_DESK,
        edition: (0, $20OkY.Editions).FREE,
        redirectUrl: signupLink
    });
    const productNavOnClick = (0, $1oC0p.useMemo)(()=>productNavCtaCTAClickFunction && isUseOpenCrossFlow ? productNavCtaCTAClickFunction : openCrossFlow, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        openCrossFlow,
        productNavCtaCTAClickFunction
    ]);
    const globalNavItemKeys = (0, $1oC0p.useMemo)(()=>{
        return links.map((link)=>link.globalLinksKey);
    }, [
        links
    ]);
    const ctaText = intl.formatMessage({
        id: 'productNavBar.get-it-free-button',
        defaultMessage: 'Get it free'
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.GlobalNavProvider), {
        globalNavItemKeys: globalNavItemKeys,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
            productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($133256a5190381b7$var$JiraServiceManagementLogo, {}),
            mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($133256a5190381b7$var$JiraServiceManagementLogo, {}),
            productLogoUrl: (0, $jQ0cd.useLocalizedHref)('/software/jira/service-management'),
            productLogoAriaLabel: "Jira Service Management",
            productPageNavLinks: links,
            isShowTryNowLink: false,
            mobileLinksSections: [
                {
                    mobileLinkKey: 'mobile-jira-service-management',
                    mobileLinksProps: links
                }
            ],
            isIncludeMobileCTA: false,
            mobileCtaText: intl.formatMessage({
                id: 'productNavBar.get-it-free-button',
                defaultMessage: 'Get it free'
            }),
            mobileCtaUrl: signupLink,
            mobileCtaOnClick: (e)=>{
                if (productNavOnClick) productNavOnClick(e);
            },
            navigationTrynowCtaText: ctaText,
            navigationTrynowCtaUrl: signupLink,
            navigationTrynowCtaOnClick: (e)=>{
                if (productNavOnClick) productNavOnClick(e);
            },
            additionalMenuPageObjectsArray: [
                {
                    menuPageKey: 'solutions',
                    menuPageObjects: links.find((link)=>link.globalLinksKey === 'solutions')?.content
                },
                {
                    menuPageKey: 'resources',
                    menuPageObjects: links.find((link)=>link.globalLinksKey === 'resources')?.content
                }
            ]
        })
    });
};
var $133256a5190381b7$export$2e2bcd8739ae039 = $133256a5190381b7$var$JiraServiceManagementSoftwareNavV2;

});

parcelRegister("1K6kz", function(module, exports) {
$parcel$export(module.exports, "LoomNav", function () { return $b0045c9e2971c8ff$export$e9541932877c1f74; });
$parcel$export(module.exports, "default", function () { return $b0045c9e2971c8ff$export$2e2bcd8739ae039; });
/* loom-navbar.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $8e22h = parcelRequire("8e22h");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $jsxHL = parcelRequire("jsxHL");

var $8nFt2 = parcelRequire("8nFt2");

var $9KOR3 = parcelRequire("9KOR3");

var $iOXki = parcelRequire("iOXki");

var $gWusH = parcelRequire("gWusH");

var $635dy = parcelRequire("635dy");
const $b0045c9e2971c8ff$var$wrapSubnav = (subnav)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nFt2.MotionContainer), {
                direction: "none",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1rjc1jfw _18zr1jfw"
                    ]),
                    children: subnav
                })
            })
        })
    });
};
const $b0045c9e2971c8ff$var$LoomLogoComponent = ()=>{
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "loomcircular",
        type: "logo",
        appearance: "brand",
        lightMode: isDarkTheme
    });
};
const $b0045c9e2971c8ff$export$e9541932877c1f74 = ()=>{
    const intl = (0, $8e22h.default)();
    const dropdownStyles = (0, $1oC0p.useMemo)(()=>{
        return {
            width: 'fit-content !important',
            margin: 0,
            insetBlockStart: '4.25rem',
            transform: 'translateX(-25%)'
        };
    }, []);
    const signupLink = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=loom&edition=premium');
    const resourcesHref = (0, $jQ0cd.useLocalizedHref)('/software/loom/resources');
    const guidesHref = (0, $jQ0cd.useLocalizedHref)('/software/loom/resources/guides/getting-started');
    const pricingHref = (0, $jQ0cd.useLocalizedHref)('/software/loom/pricing');
    const links = [
        {
            globalLinksKey: 'features',
            productKey: 'loom',
            linkText: intl.formatMessage({
                id: 'LoomPageTemplate.navbar.features',
                defaultMessage: 'Features'
            }),
            hasSubnav: true,
            content: $b0045c9e2971c8ff$var$wrapSubnav(/*#__PURE__*/ (0, $7VQPk.jsx)((0, $gWusH.LoomFeaturesSubnav), {})),
            containerPosition: 'relative'
        },
        {
            globalLinksKey: 'solutions',
            productKey: 'loom',
            linkText: intl.formatMessage({
                id: 'LoomPageTemplate.navbar.resources',
                defaultMessage: 'Solutions'
            }),
            hasSubnav: true,
            containerStyles: dropdownStyles,
            content: $b0045c9e2971c8ff$var$wrapSubnav(/*#__PURE__*/ (0, $7VQPk.jsx)((0, $635dy.LoomSolutionsSubnav), {})),
            containerPosition: 'relative'
        },
        {
            globalLinksKey: 'resources',
            productKey: 'loom',
            linkText: intl.formatMessage({
                id: 'LoomPageTemplate.navbar.useCases',
                defaultMessage: 'Resources'
            }),
            hasSubnav: false,
            href: resourcesHref
        },
        {
            globalLinksKey: 'guides',
            productKey: 'loom',
            linkText: intl.formatMessage({
                id: 'LoomPageTemplate.navbar.guides',
                defaultMessage: 'Guides'
            }),
            hasSubnav: false,
            href: guidesHref
        },
        {
            globalLinksKey: 'pricing',
            productKey: 'loom',
            linkText: intl.formatMessage({
                id: 'LoomPageTemplate.navbar.pricing',
                defaultMessage: 'Pricing'
            }),
            hasSubnav: false,
            href: pricingHref
        }
    ];
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
        productKey: 'loom',
        productLogoUrl: "/software/loom",
        productLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($b0045c9e2971c8ff$var$LoomLogoComponent, {}),
        productLogoAriaLabel: intl.formatMessage({
            id: 'LoomPageTemplate.navbar.loom-logo',
            defaultMessage: 'Loom logo'
        }),
        mobileCtaText: intl.formatMessage({
            id: 'LoomPageTemplate.navbar.getitfree',
            defaultMessage: 'Get it Free'
        }),
        navigationTrynowCtaText: intl.formatMessage({
            id: 'LoomPageTemplate.navbar.getitfree',
            defaultMessage: 'Get it Free'
        }),
        mobileCtaUrl: signupLink,
        mobileLogo: /*#__PURE__*/ (0, $7VQPk.jsx)($b0045c9e2971c8ff$var$LoomLogoComponent, {}),
        productPageNavLinks: links,
        navigationTrynowCtaUrl: signupLink,
        mobileLinksSections: [
            {
                mobileLinkKey: 'mobile-loom',
                mobileLinksProps: links
            }
        ],
        additionalMenuPageObjectsArray: [
            {
                menuPageKey: 'features',
                menuPageObjects: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $gWusH.LoomFeaturesSubnav), {})
            },
            {
                menuPageKey: 'solutions',
                menuPageObjects: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $635dy.LoomSolutionsSubnav), {})
            }
        ]
    });
};
var $b0045c9e2971c8ff$export$2e2bcd8739ae039 = $b0045c9e2971c8ff$export$e9541932877c1f74;

});
parcelRegister("gWusH", function(module, exports) {
$parcel$export(module.exports, "LoomFeaturesSubnav", function () { return $d35e5cc4cca0feb2$export$a7a6399eaf95e9b8; });
/* features-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $dfBhn = parcelRequire("dfBhn");
const $d35e5cc4cca0feb2$export$a7a6399eaf95e9b8 = ()=>{
    const intl = (0, $8e22h.default)();
    const productKey = 'loom';
    const loomLinks = {
        features: {
            id: 'features',
            title: (0, $fnHPc.defineMessage)({
                id: 'bitbucketnav.subnav.loomFeatures.links.features',
                defaultMessage: 'Explore Features'
            }),
            items: [
                {
                    id: 'meeting-notes',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.loomFeatures.links.meeting-notes',
                        defaultMessage: 'Meeting Notes'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/ai-meeting')
                },
                {
                    id: 'screen-recorder',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.loomFeatures.links.screen-recorder',
                        defaultMessage: 'Screen Recorder'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/screen-recorder')
                },
                {
                    id: 'screenshots',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.loomFeatures.links.screenshots',
                        defaultMessage: 'Screenshots'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/screenshot')
                },
                {
                    id: 'loom-ai',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.loomFeatures.links.loom-ai',
                        defaultMessage: 'Loom AI'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/ai')
                },
                {
                    id: 'editing',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.loomFeatures.links.editing',
                        defaultMessage: 'Editing'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/editing')
                }
            ]
        }
    };
    const linkColumns = Object.values(loomLinks);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7VQPk.Fragment), {
        children: linkColumns.map((column)=>{
            return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $dfBhn.LinkColumn), {
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_1p1dangw _syazsjoz _1wyboqnp _ect4z4z1 _k48p1fw0 _vwz41j6v"
                        ]),
                        style: {
                            "--_8vca0i": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark0')),
                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                        },
                        children: intl.formatMessage(column.title)
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c11p5 _umai1ylp"
                        ]),
                        children: column.items.map((link)=>{
                            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_bpsp1nn1 _19tboxwj _43dssjoz _qfs11r31 _s41oglyw _1k6pnqa1 _1caysjoz _1e0c1txw _4cvrh9n0"
                                ]),
                                style: {
                                    "--_8vca0i": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.dark0'))
                                },
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                    type: "anchor",
                                    href: link.href,
                                    text: intl.formatMessage(link.text),
                                    ariaLabel: intl.formatMessage(link.text),
                                    dataEventProps: {
                                        'data-event': 'clicked',
                                        'data-event-component': 'linkButton',
                                        'data-event-container': 'globalNavSubnav',
                                        'data-product-key': productKey
                                    }
                                })
                            }, link.id);
                        })
                    })
                ]
            }, column.id);
        })
    });
};

});

parcelRegister("635dy", function(module, exports) {
$parcel$export(module.exports, "LoomSolutionsSubnav", function () { return $7ae29eaf01c2e45b$export$e7b21fd28cd3f276; });
/* solutions-subnav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $fnHPc = parcelRequire("fnHPc");
var $8e22h = parcelRequire("8e22h");

var $iPPTB = parcelRequire("iPPTB");

var $kbpa7 = parcelRequire("kbpa7");

var $jQ0cd = parcelRequire("jQ0cd");

var $jsxHL = parcelRequire("jsxHL");

var $8nFt2 = parcelRequire("8nFt2");

var $jgdMW = parcelRequire("jgdMW");

var $dfBhn = parcelRequire("dfBhn");

var $9KOR3 = parcelRequire("9KOR3");
function $7ae29eaf01c2e45b$var$useLoomSolutionsLinks() {
    return {
        features: {
            id: 'teams',
            title: (0, $fnHPc.defineMessage)({
                id: 'loom-product-nav.solutions.links.solution',
                defaultMessage: 'Teams'
            }),
            items: [
                {
                    id: 'sales',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.sales',
                        defaultMessage: 'Sales'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/use-case/sales')
                },
                {
                    id: 'marketing',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.marketing',
                        defaultMessage: 'Marketing'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/use-case/marketing')
                },
                {
                    id: 'design',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.design',
                        defaultMessage: 'Design'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/use-case/design')
                },
                {
                    id: 'support',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.support',
                        defaultMessage: 'Support'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/use-case/support')
                },
                {
                    id: 'productmanagement',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.product-management',
                        defaultMessage: 'Product Management'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/use-case/product-management')
                },
                {
                    id: 'engineering',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.engineering',
                        defaultMessage: 'Engineering'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/use-case/engineering')
                }
            ]
        },
        usecases: {
            id: 'usecases',
            title: (0, $fnHPc.defineMessage)({
                id: 'loom-product-nav.solutions.links.use-cases',
                defaultMessage: 'Use cases'
            }),
            items: [
                {
                    id: 'loom-jira',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.loom-jira',
                        defaultMessage: 'Loom + Jira'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/loom-jira')
                },
                {
                    id: 'loom-confluence',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.loom-confluence',
                        defaultMessage: 'Loom + Confluence'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/loom-confluence')
                }
            ]
        },
        companysize: {
            id: 'companysize',
            title: (0, $fnHPc.defineMessage)({
                id: 'loom-product-nav.solutions.links.company-size',
                defaultMessage: 'Company Size'
            }),
            items: [
                {
                    id: 'enterprise',
                    text: (0, $fnHPc.defineMessage)({
                        id: 'loom-product-nav.solutions.links.enterprise',
                        defaultMessage: 'Enterprise'
                    }),
                    href: (0, $jQ0cd.useLocalizedHref)('/software/loom/enterprise')
                }
            ]
        }
    };
}
const $7ae29eaf01c2e45b$export$e7b21fd28cd3f276 = ({ productKey: productKey = 'loom' })=>{
    const intl = (0, $8e22h.default)();
    const loomSolutionLinks = $7ae29eaf01c2e45b$var$useLoomSolutionsLinks();
    const linkColumns = Object.values(loomSolutionLinks);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $9KOR3.DivOnHoverExit), {
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jsxHL.TypographyStyles), {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8nFt2.MotionContainer), {
                direction: "up",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bfhk1afi _fn1q1txw _12nx1bp4 _196i1ylp"
                    ]),
                    style: {
                        "--_1flnf7r": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.neutral.light0'))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jgdMW.RowGrid), {
                        numCols: 3,
                        columnGap: "var(--ds-space-500, 40px)",
                        children: linkColumns.map((column)=>{
                            return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $dfBhn.LinkColumn), {
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_1p1dangw _syaz1pfd _1wyboqnp _ect4z4z1 _k48p1fw0 _vwz41j6v"
                                        ]),
                                        style: {
                                            "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                            "--_bs1jwf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('font.charlie.text'))
                                        },
                                        children: intl.formatMessage(column.title)
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                        className: (0, $2jatx.default)([
                                            "_1e0c11p5 _umai1ylp"
                                        ]),
                                        children: column.items.map((link)=>{
                                            return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_bpsp1nn1 _19tboxwj _43ds1pfd _qfs11r31 _s41oglyw _1k6pnqa1 _1cay1pfd _oavvftjs _oxk4ftjs _1e0c1txw _4cvrh9n0"
                                                ]),
                                                style: {
                                                    "--_1k78eu": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.primary.black')),
                                                    "--_16ciuzt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)('color.extended.blue800'))
                                                },
                                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
                                                    type: "anchor",
                                                    href: link.href,
                                                    text: intl.formatMessage(link.text),
                                                    ariaLabel: intl.formatMessage(link.text),
                                                    dataEventProps: {
                                                        'data-event': 'clicked',
                                                        'data-event-component': 'linkButton',
                                                        'data-event-container': 'globalNavSubnav',
                                                        'data-product-key': productKey
                                                    }
                                                })
                                            }, link.id);
                                        })
                                    })
                                ]
                            }, column.id);
                        })
                    })
                })
            })
        })
    });
};

});


parcelRegister("3wzIU", function(module, exports) {
$parcel$export(module.exports, "RovoNav", function () { return $d94e8e579fb0c00d$export$f7b51e35c95f667c; });

var $7VQPk = parcelRequire("7VQPk");

var $8e22h = parcelRequire("8e22h");

var $3o1l4 = parcelRequire("3o1l4");

var $bQjAr = parcelRequire("bQjAr");

var $2WL8B = parcelRequire("2WL8B");

var $eOIix = parcelRequire("eOIix");

var $jQ0cd = parcelRequire("jQ0cd");

var $2Df35 = parcelRequire("2Df35");

var $iOXki = parcelRequire("iOXki");

var $3riD8 = parcelRequire("3riD8");
const $d94e8e579fb0c00d$export$f7b51e35c95f667c = ()=>{
    const intl = (0, $8e22h.default)();
    const navLinks = [
        {
            globalLinksKey: 'features',
            linkText: intl.formatMessage({
                id: 'RovoPageTemplate.navbar.features',
                defaultMessage: 'Features'
            }),
            hasSubnav: false,
            productKey: 'rovo',
            href: (0, $jQ0cd.useLocalizedHref)('/software/rovo/features')
        },
        {
            globalLinksKey: 'connectors',
            linkText: intl.formatMessage({
                id: 'RovoPageTemplate.navbar.connectors',
                defaultMessage: 'Connectors'
            }),
            hasSubnav: false,
            productKey: 'rovo',
            href: (0, $jQ0cd.useLocalizedHref)('/software/rovo/connectors')
        },
        {
            globalLinksKey: 'use-cases',
            linkText: intl.formatMessage({
                id: 'RovoPageTemplate.navbar.use-cases',
                defaultMessage: 'Use cases'
            }),
            hasSubnav: false,
            productKey: 'rovo',
            href: (0, $jQ0cd.useLocalizedHref)('/software/rovo/use-cases')
        },
        {
            globalLinksKey: 'guides',
            linkText: intl.formatMessage({
                id: 'RovoPageTemplate.navbar.guides',
                defaultMessage: 'Guides'
            }),
            hasSubnav: false,
            productKey: 'rovo',
            href: (0, $jQ0cd.useLocalizedHref)('/software/rovo/guides/end-user-guide/introduction')
        },
        {
            globalLinksKey: 'licensing',
            linkText: intl.formatMessage({
                id: 'RovoPageTemplate.navbar.licensing',
                defaultMessage: 'Licensing'
            }),
            hasSubnav: false,
            productKey: 'rovo',
            href: (0, $jQ0cd.useLocalizedHref)('/licensing/rovo')
        }
    ];
    const { requestInProgress: requestInProgress } = (0, $3riD8.useLoggedInUser)();
    const { data: userSegments } = (0, $3o1l4.useUserSegments)();
    const isRovoEnabledCohort = (0, $2WL8B.useRovoEnabledCohort)();
    const isRovoInPlanList = userSegments?.[(0, $3o1l4.UserSegmentTypes).OWNED_PRODUCTS]?.includes('rovo.ondemand');
    const defaultCTAUrl = (0, $jQ0cd.useLocalizedHref)('/try/cloud/signup?bundle=teamwork-collection&primaryCollectionProduct=rovo.ondemand&edition=premium');
    const isUserLoggedInAndCtasEnabledAndInPlan = isRovoInPlanList;
    const ctaText = intl.formatMessage({
        id: 'RovoPageTemplate.navbar.cta.try-rovo',
        defaultMessage: 'Try Rovo'
    });
    const tryNowCTAUrl = isUserLoggedInAndCtasEnabledAndInPlan ? 'https://home.atlassian.com/chat' : defaultCTAUrl;
    const isShowTryNowLink = !requestInProgress && tryNowCTAUrl && ctaText ? true : false;
    const buttonVariant = isRovoEnabledCohort ? 'secondary' : 'primary';
    const { isDarkTheme: isDarkTheme } = (0, $eOIix.useTheme)();
    const rovoLogo = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2Df35.LogoV3), {
        brand: "rovo",
        type: "logo",
        appearance: "brand",
        lightMode: isDarkTheme
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bQjAr.default), {
        name: "RovoNav",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iOXki.ProductPageSubNav), {
            productLogoUrl: "/software/rovo",
            productLogo: rovoLogo,
            productLogoAriaLabel: intl.formatMessage({
                id: 'RovoPageTemplate.navbar.rovo-logo',
                defaultMessage: 'Rovo logo'
            }),
            mobileLogo: rovoLogo,
            isShowTryNowLink: isShowTryNowLink,
            isIncludeMobileCTA: isShowTryNowLink,
            navigationTrynowCtaText: isShowTryNowLink ? ctaText : undefined,
            navigationTrynowCtaUrl: isShowTryNowLink ? tryNowCTAUrl : undefined,
            navigationTrynowCtaButtonVariant: buttonVariant,
            mobileCtaText: isShowTryNowLink ? ctaText : undefined,
            mobileCtaUrl: isShowTryNowLink ? tryNowCTAUrl : undefined,
            mobileCtaButtonVariant: buttonVariant,
            productPageNavLinks: navLinks,
            mobileLinksSections: [
                {
                    mobileLinkKey: 'mobile-rovo',
                    mobileLinksProps: navLinks
                }
            ]
        })
    });
};

});

parcelRegister("9xKEy", function(module, exports) {
$parcel$export(module.exports, "ChatWidgetProvider", function () { return $c6548387155117f6$export$a4cac963ae9f34ca; });
$parcel$export(module.exports, "default", function () { return $c6548387155117f6$export$2e2bcd8739ae039; });

var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $jIe84 = parcelRequire("jIe84");
var $ac0eX = parcelRequire("ac0eX");
var $6NMje = parcelRequire("6NMje");
var $aCV3p = parcelRequire("aCV3p");

var $fuLgT = parcelRequire("fuLgT");

var $6e3tU = parcelRequire("6e3tU");

var $7qFQI = parcelRequire("7qFQI");

var $lP7A9 = parcelRequire("lP7A9");

var $kbpa7 = parcelRequire("kbpa7");

var $j2b52 = parcelRequire("j2b52");

var $gx3aw = parcelRequire("gx3aw");

var $3riD8 = parcelRequire("3riD8");

var $kEjoI = parcelRequire("kEjoI");

// Load omni-channel UI only on the client when widget is open to avoid SSR 503 (Tesseract)
const $c6548387155117f6$var$ChatWidgetOmniChannelUI = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>(parcelRequire("fGhtO")));

// Lazy-load analytics when fetchChatConnectionConfig succeeds (keeps @atlassian/omni-channel out of main bundle)
const $c6548387155117f6$var$ChatWidgetCustomerJoinedAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>(parcelRequire("jap9H")));

// Lazy-load analytics when fetchToken fails (same chunk as customer-joined analytics)
const $c6548387155117f6$var$ChatWidgetTokenErrorAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>(parcelRequire("jap9H")).then((m)=>({
            default: m.ChatWidgetTokenErrorAnalytics
        })));

// Lazy-load analytics when fetchChatConnectionConfig succeeds
const $c6548387155117f6$var$ChatWidgetConnectionConfigSuccessAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>(parcelRequire("jap9H")).then((m)=>({
            default: m.ChatWidgetConnectionConfigSuccessAnalytics
        })));

// Lazy-load analytics when fetchToken succeeds (channelPlatformTokenError empty or null)
const $c6548387155117f6$var$ChatWidgetTokenSuccessAnalytics = /*#__PURE__*/ (0, $1oC0p.lazy)(()=>(parcelRequire("jap9H")).then((m)=>({
            default: m.ChatWidgetTokenSuccessAnalytics
        })));
const $c6548387155117f6$export$8a240b2f27c2948f = (url)=>{
    try {
        const urlObj = new URL(url);
        let pathname = urlObj.pathname.replace(/\/+$/, '');
        if (pathname.startsWith('/wac/')) pathname = pathname.slice(4);
        return pathname.replace(/^\/+/, '');
    } catch  {
        const match = /\/\/[^/]+(\/[^#?]*)/.exec(url);
        if (match?.[1]) {
            let pathname = match[1].replace(/\/+$/, '');
            if (pathname.startsWith('/wac/')) pathname = pathname.slice(4);
            return pathname.replace(/^\/+/, '');
        }
        return '';
    }
};
const $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH = {
    'software/jira/product-discovery': {
        contactFlowId: "39457874-4e30-4774-89a6-e086842bdcb6",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'software/jira/service-management': {
        contactFlowId: "39457874-4e30-4774-89a6-e086842bdcb6",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'software/jira': {
        contactFlowId: "1825e6f7-75fc-47e2-b634-98923fa4a3b1",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'software/loom': {
        contactFlowId: "dc335c33-9da5-4291-842b-80956f53d2b7",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'software/loom/loom-confluence': {
        contactFlowId: "7cf56869-3db7-431e-8311-b524e6065934",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'software/loom/loom-jira': {
        contactFlowId: "199f4750-6436-4b88-a2db-c2b87c1bdaed",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'software/loom/resources': {
        contactFlowId: "eadd2afc-29bb-4e9c-a0d6-370fd70186eb",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'software/loom/ai-meeting': {
        contactFlowId: "364f6abb-5628-41c1-bf90-b3ca2486378d",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'software/loom/editing': {
        contactFlowId: "a4addd51-eb96-46fc-b5a9-3f99c3d923de",
        formKey: [
            'ca-growth-pricing-billing-and-licensing'
        ]
    },
    'ja/company/contact/japan': {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            'jpns-growth-pricing-billing-and-licensing'
        ]
    },
    'ja/software/jira/service-management': {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            'jpns-growth-pricing-billing-and-licensing'
        ]
    },
    'ja/software/jira/pricing': {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            'jpns-growth-pricing-billing-and-licensing'
        ]
    },
    ja: {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            'jpns-growth-pricing-billing-and-licensing'
        ]
    },
    'ja/software/confluence': {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            'jpns-growth-pricing-billing-and-licensing'
        ]
    },
    'ja/software/confluence/pricing': {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            'jpns-growth-pricing-billing-and-licensing'
        ]
    },
    'ja/software/jira/service-management/pricing': {
        contactFlowId: "e472b4ee-f815-4e12-9773-7965ba7733ee",
        formKey: [
            'jpns-growth-pricing-billing-and-licensing'
        ]
    }
};
const $c6548387155117f6$export$a8ad7472af635967 = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, '');
    return $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH[normalizedPath] ?? {
        contactFlowId: ''
    };
};
const $c6548387155117f6$export$b28607ea792e8283 = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, '');
    const entry = $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH[normalizedPath];
    if (entry && Array.isArray(entry.formKey)) return entry.formKey;
    return [
        ''
    ];
};
const $c6548387155117f6$export$39f87d2399b576ea = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, '');
    const entry = $c6548387155117f6$var$CHAT_SUPPORT_CONFIG_BY_URL_PATH[normalizedPath];
    if (entry && typeof entry.attributes === 'object' && entry.attributes !== null) return JSON.stringify(entry.attributes, null, 2);
    return '{}';
};
const $c6548387155117f6$export$c452173f1b4082d7 = (path)=>{
    const normalizedPath = path.replace(/^\/+|\/+$/g, '');
    return normalizedPath === 'ja' || normalizedPath.startsWith('ja/');
};
const $c6548387155117f6$export$8378cdc69cfc311a = (url)=>{
    try {
        const urlObj = new URL(url);
        const pathname = urlObj.pathname;
        // Remove leading and trailing slashes, then split by '/' and filter out empty strings
        const pathParts = pathname.replace(/^\/+|\/+$/g, '').split('/').filter((part)=>part.length > 0);
        // Join with underscores
        return pathParts.join('_');
    } catch  {
        // If URL parsing fails, try to extract path manually
        const match = /\/\/[^\/]+(\/[^?#]*)/.exec(url);
        if (match && match[1]) {
            const pathname = match[1];
            const pathParts = pathname.replace(/^\/+|\/+$/g, '').split('/').filter((part)=>part.length > 0);
            return pathParts.join('_');
        }
        return '';
    }
};
const $c6548387155117f6$export$2b66390f6eecea5c = (payload)=>{
    const transformed = {};
    if (!payload) return transformed;
    Object.entries(payload).forEach(([key, value])=>{
        // Skip attachments
        if (key === 'attachments') return;
        // Skip null or undefined values
        if (value === null || value === undefined) return;
        // Handle arrays - normalize to array of strings
        if (Array.isArray(value)) transformed[key] = value.map((v)=>{
            // If array element is an object (like {userEmail: "value"}), extract the first value
            if (typeof v === 'object' && v !== null && !Array.isArray(v)) {
                const firstValue = Object.values(v)[0];
                return firstValue !== undefined ? String(firstValue) : String(v);
            }
            // Already a string or primitive
            return String(v);
        });
        else transformed[key] = [
            String(value)
        ];
    });
    return transformed;
};
const $c6548387155117f6$export$a40d7197cc58cf92 = (payload)=>{
    return JSON.stringify(payload);
};
const $c6548387155117f6$export$b13b32483d23f773 = (formValues, flowId, analyticsSessionId)=>{
    const metadata = {};
    if (analyticsSessionId) metadata['analyticsSessionId'] = analyticsSessionId;
    // Only include flowId if it has a value
    if (flowId) metadata['flowId'] = flowId;
    if (formValues?.contactEmail) metadata['email'] = formValues.contactEmail;
    return JSON.stringify(metadata);
};
const $c6548387155117f6$export$6999922c2cdd8944 = (chatConnectionConfigResponse)=>{
    const submitRequest = chatConnectionConfigResponse?.channelPlatform_createContact;
    return {
        channelPlatform_submitRequest: submitRequest
    };
};
function $c6548387155117f6$export$c0c7c314cc68764f(config) {
    const contact = config?.channelPlatform_createContact;
    return contact?.value?.contactId;
}
function $c6548387155117f6$export$f0671fd2506d780c(config) {
    const contact = config?.channelPlatform_createContact;
    const value = contact?.value;
    return {
        contactId: value?.contactId,
        participantId: value?.participantId,
        region: value?.region
    };
}
function $c6548387155117f6$var$getChatConnectionFormValues(contextId, userEmail, isUserLoggedIn) {
    return {
        cst_support_forms_data_fieldDescMap: [
            '{"inquiry_category":"Inquiry Category","email":"Email","raised_obo_by":"Raised on behalf of by","language":"language","customer_working_hours":"Support Business Hours Select"}'
        ],
        customer_email: [
            isUserLoggedIn ? userEmail : ''
        ],
        authenticated: isUserLoggedIn ? null : [
            'No'
        ],
        email: [
            isUserLoggedIn ? userEmail : ''
        ],
        customer_status: [
            'Customer'
        ],
        cst_support_forms_data_formKey: $c6548387155117f6$export$b28607ea792e8283($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)),
        cst_support_forms_data_formLabel: $c6548387155117f6$export$b28607ea792e8283($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)),
        cst_support_forms_data_timezone: [
            'GMT+6'
        ],
        referral_url: [
            window.location.href
        ],
        language: [
            'en'
        ],
        is_partner_dc_exception: [
            'Customer not in SFDC'
        ],
        topic: [
            $c6548387155117f6$export$8378cdc69cfc311a(window.location.href)
        ],
        summary: [
            $c6548387155117f6$export$8378cdc69cfc311a(window.location.href).split('_').join(' ')
        ],
        support_channel: [
            'chat'
        ],
        inquiry_category: [
            'access_issues'
        ],
        cst_support_forms_data_contextId: [
            contextId
        ]
    };
}
function $c6548387155117f6$var$shouldFetchConversationsOnOpen(isWidgetOpen, wasOpenCurrent, clientToken, clientWithToken) {
    return isWidgetOpen && !wasOpenCurrent && !!clientToken && !!clientWithToken;
}
function $c6548387155117f6$var$getChatConnectionMetadataPayload(userEmail, isUserLoggedIn) {
    return {
        flowId: $c6548387155117f6$export$a8ad7472af635967($c6548387155117f6$export$8a240b2f27c2948f(window.location.href)).contactFlowId,
        formContext: {
            summary: [
                'Chat Transcript for <email removed for privacy>'
            ],
            details: '',
            contactEmail: isUserLoggedIn ? userEmail ?? '' : '',
            isAuthenticated: isUserLoggedIn
        }
    };
}
function $c6548387155117f6$var$hasCustomerConversations(response) {
    const count = response?.channelPlatform_getCustomerConversations?.conversations?.length ?? 0;
    return count > 0;
}
function $c6548387155117f6$var$getChatWidgetViewState(isWidgetOpen, clientToken, chatConnectionConfig, isCustomerComponentLoaded) {
    const isChatLoaded = isWidgetOpen && !!clientToken && !!chatConnectionConfig && isCustomerComponentLoaded;
    return {
        isChatLoaded: isChatLoaded,
        showFloatingButton: !isChatLoaded,
        isButtonLoading: isWidgetOpen && (!clientToken || !chatConnectionConfig || !isCustomerComponentLoaded)
    };
}
const $c6548387155117f6$var$ChatFloatingButton = ({ isLoading: isLoading, onClick: onClick, onKeyDown: onKeyDown })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        role: "button",
        tabIndex: 0,
        "aria-label": isLoading ? 'Loading chat' : 'Open chat widget',
        style: {
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: 1000,
            cursor: isLoading ? 'wait' : 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '56px',
            height: '56px',
            borderRadius: '50%',
            backgroundColor: (0, $kbpa7.wacToken)('color.primary.blue'),
            color: 'white',
            boxShadow: (0, $lP7A9.default)('elevation.shadow.raised')
        },
        onClick: onClick,
        onKeyDown: onKeyDown,
        children: isLoading ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $7qFQI.default), {
            size: "medium",
            label: "Loading chat",
            appearance: "invert"
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6e3tU))), {
            label: "",
            size: "medium",
            color: "currentColor"
        })
    });
};

function $c6548387155117f6$var$useChatWidgetConnection({ isWidgetOpen: isWidgetOpen, contextId: contextId, userEmail: userEmail, isUserLoggedIn: isUserLoggedIn, setIsCustomerComponentLoaded: setIsCustomerComponentLoaded }) {
    const [clientToken, setClientToken] = (0, $1oC0p.useState)(null);
    const [chatConnectionConfig, setChatConnectionConfig] = (0, $1oC0p.useState)(null);
    const [loading, setLoading] = (0, $1oC0p.useState)(false);
    const [error, setError] = (0, $1oC0p.useState)(null);
    const [channelPlatformTokenError, setChannelPlatformTokenError] = (0, $1oC0p.useState)(null);
    const [customerConversationsResponse, setCustomerConversationsResponse] = (0, $1oC0p.useState)(null);
    const generateAuthHeader = (channelsIdentityHash)=>new (0, $ac0eX.ApolloLink)((operation, forward)=>{
            operation.setContext(({ headers: headers = {} })=>({
                    headers: {
                        ...headers,
                        'Content-Type': 'application/json',
                        'X-Client-Hash': channelsIdentityHash
                    }
                }));
            return forward(operation);
        });
    const client = (0, $1oC0p.useMemo)(()=>{
        const link = new (0, $6NMje.HttpLink)({
            uri: "https://www.atlassian.com/gateway/api/graphql",
            credentials: 'include'
        });
        return new (0, $jIe84.ApolloClient)({
            link: link,
            cache: new (0, $aCV3p.InMemoryCache)()
        });
    }, []);
    const wasWidgetOpenRef = (0, $1oC0p.useRef)(false);
    const clientWithToken = (0, $1oC0p.useMemo)(()=>{
        if (!clientToken) return null;
        const link = new (0, $6NMje.HttpLink)({
            uri: "https://www.atlassian.com/gateway/api/graphql",
            credentials: 'include'
        });
        return new (0, $jIe84.ApolloClient)({
            link: (0, $ac0eX.ApolloLink).from([
                generateAuthHeader(clientToken),
                link
            ]),
            cache: new (0, $aCV3p.InMemoryCache)()
        });
    }, [
        clientToken
    ]);
    const isRefreshed = (0, $1oC0p.useMemo)(()=>$c6548387155117f6$var$hasCustomerConversations(customerConversationsResponse), [
        customerConversationsResponse
    ]);
    const fetchCustomerConversations = (0, $1oC0p.useCallback)(()=>{
        if (!clientWithToken) return;
        const anonymousId = (0, $gx3aw.Cookie).readCookie('ajs_anonymous_id') || '';
        clientWithToken.query({
            query: (0, $kEjoI.getCustomerConversations),
            variables: {
                anonymousId: anonymousId
            }
        }).then((response)=>{
            setCustomerConversationsResponse(response?.data ?? null);
        }).catch((err)=>{
            console.warn('Error fetching customer conversations:', err);
            setCustomerConversationsResponse(null);
        });
    }, [
        clientWithToken
    ]);
    const fetchChatConnectionConfig = (0, $1oC0p.useCallback)(async ()=>{
        if (!clientWithToken) {
            console.warn('Client with token not available yet');
            return;
        }
        setLoading(true);
        const formValues = $c6548387155117f6$var$getChatConnectionFormValues(contextId, userEmail ?? '', isUserLoggedIn);
        // Dynamic import to avoid pulling @atlassiansox/analytics-web-client
        // (which calls setTimeout at module init) into the SSR bundle.
        const { getAnalyticsWebClient: getAnalyticsWebClient } = await (parcelRequire("ix6JR"));
        const metadataPayload = $c6548387155117f6$var$getChatConnectionMetadataPayload(userEmail, isUserLoggedIn);
        const metadata = $c6548387155117f6$export$b13b32483d23f773({
            contactEmail: metadataPayload.formContext['contactEmail']
        }, metadataPayload.flowId, getAnalyticsWebClient().getCurrentSessionId());
        clientWithToken.query({
            query: (0, $kEjoI.getChatConnectionConfigForSalesChannel),
            variables: {
                requestType: 'CHAT',
                payload: $c6548387155117f6$export$2b66390f6eecea5c(formValues),
                metadata: metadata,
                attributes: JSON.parse($c6548387155117f6$export$39f87d2399b576ea($c6548387155117f6$export$8a240b2f27c2948f(window.location.href))) ?? {},
                anonymousId: (0, $gx3aw.Cookie).readCookie('ajs_anonymous_id') || ''
            }
        }).then((response)=>{
            setChatConnectionConfig(response?.data);
            setLoading(false);
        }).catch((err)=>{
            console.error('Error fetching chat connection config:', err);
            setError(err);
            setLoading(false);
        });
    }, [
        clientWithToken,
        contextId,
        isUserLoggedIn,
        userEmail
    ]);
    (0, $1oC0p.useEffect)(()=>{
        if ($c6548387155117f6$var$shouldFetchConversationsOnOpen(isWidgetOpen, wasWidgetOpenRef.current, clientToken, clientWithToken)) {
            wasWidgetOpenRef.current = true;
            fetchCustomerConversations();
            fetchChatConnectionConfig();
        }
        if (!isWidgetOpen) {
            wasWidgetOpenRef.current = false;
            setIsCustomerComponentLoaded(false);
        }
    }, [
        isWidgetOpen,
        clientToken,
        clientWithToken,
        fetchCustomerConversations,
        fetchChatConnectionConfig,
        setIsCustomerComponentLoaded
    ]);
    const fetchToken = (0, $1oC0p.useCallback)(()=>{
        setLoading(true);
        client.query({
            query: (0, $kEjoI.getChannelPlatformTokenByClientName),
            variables: {
                clientName: 'sales'
            }
        }).then((response)=>{
            const token = response.data?.supportInquiry_channelsIdentityHashByClientName;
            if (token) {
                setClientToken(token);
                setChannelPlatformTokenError(null);
            }
            setLoading(false);
        }).catch((err)=>{
            console.error('Error fetching channel platform token:', err);
            setError(err);
            setLoading(false);
            const errorMessage = err instanceof Error ? err.message : String(err);
            setChannelPlatformTokenError(errorMessage);
        });
    }, [
        client
    ]);
    return {
        clientToken: clientToken,
        chatConnectionConfig: chatConnectionConfig,
        loading: loading,
        error: error,
        channelPlatformTokenError: channelPlatformTokenError,
        client: client,
        clientWithToken: clientWithToken,
        isRefreshed: isRefreshed,
        customerConversationsResponse: customerConversationsResponse,
        setClientToken: setClientToken,
        fetchToken: fetchToken
    };
}
const $c6548387155117f6$export$a4cac963ae9f34ca = ({ children: children })=>{
    const [isWidgetOpen, setIsWidgetOpen] = (0, $1oC0p.useState)(false);
    const [isCustomerComponentLoaded, setIsCustomerComponentLoaded] = (0, $1oC0p.useState)(false);
    const { accountId: aaid, email: userEmail, isUserLoggedIn: isUserLoggedIn } = (0, $3riD8.useLoggedInUser)();
    const contextId = (0, $1oC0p.useMemo)(()=>(0, $fuLgT.default)(), []);
    const connection = $c6548387155117f6$var$useChatWidgetConnection({
        isWidgetOpen: isWidgetOpen,
        contextId: contextId,
        userEmail: userEmail,
        isUserLoggedIn: isUserLoggedIn,
        setIsCustomerComponentLoaded: setIsCustomerComponentLoaded
    });
    const { clientToken: clientToken, chatConnectionConfig: chatConnectionConfig, loading: loading, error: error, channelPlatformTokenError: channelPlatformTokenError, isRefreshed: isRefreshed, customerConversationsResponse: customerConversationsResponse } = connection;
    const surveyModalAttributes = {
        width: '80%',
        height: 500
    };
    const omniChannelEnv = 'production';
    const handleChatButtonClick = ()=>{
        const opening = !isWidgetOpen;
        setIsWidgetOpen(opening);
        if (opening) connection.fetchToken();
    };
    const handleChatButtonKeyDown = (event)=>{
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            handleChatButtonClick();
        }
    };
    const viewState = $c6548387155117f6$var$getChatWidgetViewState(isWidgetOpen, clientToken, chatConnectionConfig, isCustomerComponentLoaded);
    const showChatPanel = isWidgetOpen && !!chatConnectionConfig && !!clientToken;
    const conversationId = $c6548387155117f6$export$c0c7c314cc68764f(chatConnectionConfig);
    const connectionConfigAttributes = $c6548387155117f6$export$f0671fd2506d780c(chatConnectionConfig);
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $j2b52.ClientOnly), {
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
            children: [
                children,
                chatConnectionConfig && /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetCustomerJoinedAnalytics, {
                            conversationId: conversationId
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetConnectionConfigSuccessAnalytics, {
                            contactId: connectionConfigAttributes.contactId,
                            participantId: connectionConfigAttributes.participantId,
                            region: connectionConfigAttributes.region
                        })
                    ]
                }),
                channelPlatformTokenError && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetTokenErrorAnalytics, {
                        channelPlatformTokenError: channelPlatformTokenError
                    })
                }),
                clientToken && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetTokenSuccessAnalytics, {
                        clientToken: clientToken,
                        channelPlatformTokenError: channelPlatformTokenError
                    })
                }),
                viewState.showFloatingButton && /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatFloatingButton, {
                    isLoading: viewState.isButtonLoading,
                    onClick: handleChatButtonClick,
                    onKeyDown: handleChatButtonKeyDown
                }),
                showChatPanel && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $1oC0p.Suspense), {
                    fallback: null,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($c6548387155117f6$var$ChatWidgetOmniChannelUI, {
                        env: omniChannelEnv,
                        clientIdentityHash: clientToken || '',
                        chatContactDetails: $c6548387155117f6$export$6999922c2cdd8944(chatConnectionConfig),
                        accountId: aaid || '',
                        isRefreshed: isRefreshed,
                        customerConversations: customerConversationsResponse,
                        loading: loading,
                        error: error,
                        isUserLoggedIn: isUserLoggedIn,
                        surveyModalAttributes: surveyModalAttributes,
                        onLoaded: ()=>setIsCustomerComponentLoaded(true)
                    })
                })
            ]
        })
    });
};
var $c6548387155117f6$export$2e2bcd8739ae039 = $c6548387155117f6$export$a4cac963ae9f34ca;

});
parcelRegister("kEjoI", function(module, exports) {
$parcel$export(module.exports, "getChatConnectionConfigForSalesChannel", function () { return $59b9792633dffc77$export$2fedc4b0d22f20b3; });
$parcel$export(module.exports, "getCustomerConversations", function () { return $59b9792633dffc77$export$54e9b7f1aad2199a; });
$parcel$export(module.exports, "getChannelPlatformTokenByClientName", function () { return $59b9792633dffc77$export$c543cd67c9b21e36; });

var $4Wqet = parcelRequire("4Wqet");
const $59b9792633dffc77$export$51e62cbd534f416c = (0, $4Wqet.gql)`
	query channelPlatformTokenGeneration {
		supportInquiry_channelsIdentityHash
	}
`;
const $59b9792633dffc77$export$2fedc4b0d22f20b3 = (0, $4Wqet.gql)`
	query CreateContact(
		$requestType: ChannelPlatformChannelType!
		$payload: JSON
		$metadata: JSON
		$anonymousId: String
		$attributes: JSON
	) {
		channelPlatform_createContact(
			requestType: $requestType
			request: { payload: $payload, metadata: $metadata, attributes: $attributes }
			anonymousId: $anonymousId
		) {
			channel
			value {
				... on ChannelPlatformGetChannelTokenResponse {
					participantId
					participantToken
					region
					contactId
				}
			}
		}
	}
`;
const $59b9792633dffc77$export$54e9b7f1aad2199a = (0, $4Wqet.gql)`
	query CustomerConversations($anonymousId: String) {
		channelPlatform_getCustomerConversations(anonymousId: $anonymousId) {
			conversations
		}
	}
`;
const $59b9792633dffc77$export$f843774d31ce9c0c = (0, $4Wqet.gql)`
	query CreateContact($requestType: ChannelPlatformChannelType!, $payload: JSON, $metadata: JSON) {
		channelPlatform_createContact(
			requestType: $requestType
			request: { payload: $payload, metadata: $metadata }
		) {
			channel
			value {
				... on ChannelPlatformGetChannelTokenResponse {
					participantId
					participantToken
					region
					contactId
				}
			}
		}
	}
`;
const $59b9792633dffc77$export$c543cd67c9b21e36 = (0, $4Wqet.gql)`
	query channelPlatformTokenGenerationByClientName($clientName: String) {
		supportInquiry_channelsIdentityHashByClientName(request: { clientName: $clientName })
	}
`;

});

parcelRegister("fGhtO", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = Promise.all([
    $eao4m("iwtJN"),
    $eao4m("69gSk"),
    $eao4m("2TJ5h"),
    $eao4m("cjcRX"),
    $eao4m("b8KTD"),
    $eao4m("9OXzg"),
    $eao4m("kY8TR"),
    $eao4m("lzpxo"),
    $eao4m("f4Cqx"),
    $eao4m("Oum3S"),
    $eao4m("38uoB"),
    $eao4m("iYBBz"),
    $eao4m("7Kz5J"),
    $eao4m("gmcn8"),
    $eao4m("erzni"),
    $eao4m("1evvT"),
    $eao4m("gsjcw"),
    $eao4m("69oGP"),
    $eao4m("ch50F"),
    $eao4m("DSYwq"),
    $eao4m("8Hh5M"),
    $eao4m("aWPy3"),
    $eao4m("76kmj")
]).then(()=>parcelRequire('8Cs4z'));

});

parcelRegister("jap9H", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = Promise.all([
    $eao4m("iwtJN"),
    $eao4m("lzpxo"),
    $eao4m("69oGP"),
    $eao4m("hx68B")
]).then(()=>parcelRequire('cJIcN'));

});

parcelRegister("ix6JR", function(module, exports) {

var $eao4m = parcelRequire("eao4m");
module.exports = $eao4m("4lJtX").then(()=>parcelRequire('k1dhr'));

});


parcelRegister("grkXZ", function(module, exports) {
$parcel$export(module.exports, "DropdownSelector", function () { return $7df351058cf48215$export$67ffdcf8cfce0fd; });
/* dropdown-selector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $kKAAc = parcelRequire("kKAAc");
const $7df351058cf48215$var$dropdownSelectorContainerStyle = null;
const $7df351058cf48215$var$labelStyle = null;
const $7df351058cf48215$var$labelStyleSignup = null;
const $7df351058cf48215$export$67ffdcf8cfce0fd = ({ options: options, name: name, id: id, testId: testId, label: label, onChangeHandler: onChangeHandler, defaultValue: defaultValue, cssOverrides: cssOverrides, className: className })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $1oC0p.useState)(false);
    const elementID = id ? id : `${name}-dropdown`;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c116y _2lx21bp4 _1bsb1osq",
            className
        ]),
        children: [
            cssOverrides?.labelStyle === 'signup' && /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                htmlFor: elementID,
                className: (0, $2jatx.default)([
                    "_syazvwuj _vwz41gnr _6rth1b66 _y3gn1e5h _k48pbfng _1wybdlk8"
                ]),
                children: label
            }),
            !cssOverrides?.labelStyle && /*#__PURE__*/ (0, $7VQPk.jsx)("label", {
                htmlFor: elementID,
                className: (0, $2jatx.default)([
                    "_syazvwuj _1wyboqnp _vwz41gnr _6rth1b66 _y3gn1e5h"
                ]),
                children: label
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: "select-dropdown-container",
                "data-testid": testId ? testId : elementID,
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kKAAc.default), {
                    defaultValue: defaultValue || {
                        label: 'Select...',
                        value: ''
                    },
                    options: options,
                    unstyled: true,
                    inputId: elementID,
                    onChange: (selectedOption)=>{
                        onChangeHandler?.(selectedOption?.value || '');
                    },
                    onMenuOpen: ()=>setIsMenuOpen(true),
                    onMenuClose: ()=>setIsMenuOpen(false),
                    styles: {
                        // @ts-ignore
                        container: (provided)=>({
                                ...provided,
                                appearance: 'none',
                                flexDirection: 'row',
                                fontSize: '1rem',
                                lineHeight: '1.2',
                                textAlign: 'left',
                                ...(cssOverrides || {}).container
                            }),
                        // @ts-ignore
                        singleValue: (provided)=>({
                                ...provided,
                                marginLeft: "var(--ds-space-025, 2px)",
                                marginRight: "var(--ds-space-025, 2px)",
                                ...(cssOverrides || {}).singleValue
                            }),
                        // @ts-ignore
                        placeholder: (provided)=>({
                                ...provided,
                                marginLeft: "var(--ds-space-025, 2px)",
                                marginRight: "var(--ds-space-025, 2px)",
                                ...(cssOverrides || {}).placeholder
                            }),
                        // @ts-ignore
                        valueContainer: (provided)=>({
                                ...provided,
                                paddingLeft: "var(--ds-space-075, 6px)",
                                paddingRight: "var(--ds-space-075, 6px)",
                                ...(cssOverrides || {}).valueContainer
                            }),
                        // @ts-ignore
                        menu: (provided)=>({
                                ...provided,
                                marginTop: "var(--ds-space-050, 4px)",
                                // eslint-disable-next-line local/ensure-wac-token-usage
                                boxShadow: '0px 3px 5px 0px #091E4233',
                                // eslint-disable-next-line local/ensure-wac-token-usage
                                background: '#ffffff',
                                padding: 0,
                                borderRadius: "var(--ds-space-050, 4px)",
                                ...(cssOverrides || {}).menu
                            }),
                        // @ts-ignore
                        control: (provided, state)=>({
                                ...provided,
                                cursor: 'pointer',
                                backgroundColor: isMenuOpen ? '#253858' : '#FAFBFC',
                                color: isMenuOpen ? '#ffffff' : '#172B4D',
                                height: '2.65rem',
                                border: state.isFocused ? `2px solid #4C9AFF` : `2px solid #dfe1e6`,
                                borderRadius: "var(--ds-space-050, 4px)",
                                '&:hover': {
                                    background: isMenuOpen ? undefined : '#F4F5F7'
                                },
                                ...(cssOverrides || {}).control
                            }),
                        // @ts-ignore
                        dropdownIndicator: (provided, state)=>({
                                ...provided,
                                transition: 'all .2s ease',
                                transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : undefined,
                                ...(cssOverrides || {}).dropdownIndicator
                            }),
                        // @ts-ignore
                        indicatorsContainer: (provided)=>({
                                ...provided,
                                paddingTop: "var(--ds-space-075, 6px)",
                                paddingBottom: "var(--ds-space-075, 6px)",
                                paddingLeft: "var(--ds-space-025, 2px)",
                                paddingRight: "var(--ds-space-075, 6px)",
                                ...(cssOverrides || {}).indicatorsContainer
                            }),
                        // @ts-ignore
                        option: (provided, state)=>({
                                ...provided,
                                cursor: 'pointer',
                                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-200, 16px)"}`,
                                whiteSpace: 'pre-wrap',
                                overflowWrap: 'break-word',
                                backgroundColor: state.isSelected ? '#B2D4FF' : state.isFocused ? '#EBECF0' : '#FAFBFC',
                                color: state.isSelected ? '#0065FF' : '#172B4D',
                                '&:hover': {
                                    background: state.isSelected ? '#B2D4FF' : '#EBECF0'
                                },
                                '&:active': {
                                    // eslint-disable-next-line local/ensure-wac-token-usage
                                    background: '#DFE1E5'
                                },
                                ...(cssOverrides || {}).option
                            }),
                        // @ts-ignore
                        input: (provided)=>({
                                ...provided,
                                color: 'transparent',
                                ...(cssOverrides || {}).input
                            })
                    }
                })
            })
        ]
    });
};

});

parcelRegister("8cfMz", function(module, exports) {
$parcel$export(module.exports, "getProductCalculationInputs", function () { return $2c139569c5386442$export$915d8a609f55f86e; });

var $hrGO1 = parcelRequire("hrGO1");
const $2c139569c5386442$export$915d8a609f55f86e = (productPlans, unitMinEnterprise, unitCount, billingCycle)=>{
    const getNumUnits = (planName, signupUnitLimit)=>{
        let adjNumUnits = 0;
        // following scenarios do not have pricing and should send a zero unit count,
        // the zero pricing will not be displayed and is needed only to retain the
        // correct array order of the pricing requests/responses
        // Free plan has no pricing
        const isFree = planName === (0, $hrGO1.SpecialPlanNames).FREE;
        // Enterprise plans do not have monthly pricing
        const isMonthlyEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && billingCycle === 'MONTHLY';
        // Enterprise plans have a minimum unit count
        const isUnmetUnitCountEnterprise = planName === (0, $hrGO1.SpecialPlanNames).ENTERPRISE && unitCount < unitMinEnterprise;
        const isOverSignupUnitLimit = unitCount > signupUnitLimit;
        if (![
            isFree,
            isMonthlyEnterprise,
            isUnmetUnitCountEnterprise,
            isOverSignupUnitLimit
        ].includes(true)) adjNumUnits = unitCount;
        // keep unit count to general maximum limit
        return Math.min(adjNumUnits, signupUnitLimit);
    };
    const planPriceReqs = productPlans.map(({ offeringSku: offeringSku, planName: planName, signupLimit: signupLimit })=>({
            ccpOfferingSKU: offeringSku,
            hamsProductKey: undefined,
            numUnits: getNumUnits(planName, signupLimit || (0, $hrGO1.DefaultPlanLimits).UNIT_LIMIT),
            period: billingCycle
        }));
    return planPriceReqs;
};

});

parcelRegister("5CQu1", function(module, exports) {
$parcel$export(module.exports, "calculateProductPricing", function () { return $a686a54aa7deba91$export$6c0aa9d51dade71d; });

var $1mbEv = parcelRequire("1mbEv");
const $a686a54aa7deba91$export$6c0aa9d51dade71d = (ccpPricingData, productCalculationInputs, currencyISOCode, localeISOCode)=>{
    const productPricing = [];
    for (const planCalculationInputs of productCalculationInputs){
        const { ccpOfferingSKU: ccpOfferingSKU, numUnits: numUnits, period: period } = planCalculationInputs;
        const planPricing = (0, $1mbEv.calculatePlanPricing)({
            ccpPricingData: ccpPricingData,
            ccpOfferingSKU: ccpOfferingSKU,
            numUnits: numUnits,
            period: period,
            currencyISOCode: currencyISOCode,
            localeISOCode: localeISOCode
        });
        productPricing.push({
            // @ts-ignore
            offeringSku: ccpOfferingSKU,
            ...planPricing
        });
    }
    return productPricing;
};

});
parcelRegister("1mbEv", function(module, exports) {
$parcel$export(module.exports, "calculatePlanPricing", function () { return $0f584d23bad95648$export$f9574505c9651410; });

var $69Lp1 = parcelRequire("69Lp1");

var $8dsKS = parcelRequire("8dsKS");

var $1RK9J = parcelRequire("1RK9J");

var $aTHox = parcelRequire("aTHox");

var $9Nmuw = parcelRequire("9Nmuw");
const $0f584d23bad95648$var$hamsPricingDataStub = {};
const $0f584d23bad95648$var$hamsProductKeyStub = '';
function $0f584d23bad95648$export$f9574505c9651410(args) {
    const { ccpPricingData: ccpPricingData, ccpOfferingSKU: ccpOfferingSKU, period: period, numUnits: numUnits, currencyISOCode: currencyISOCode, localeISOCode: localeISOCode } = args;
    if (numUnits === 0) return {
        offeringSku: ccpOfferingSKU,
        ...(0, $1RK9J.getFreePriceCalc)(currencyISOCode)
    };
    else {
        let getCcpTiers = undefined;
        if (ccpOfferingSKU === (0, $9Nmuw.rovoDevOfferingSkus).standard || ccpOfferingSKU === (0, $aTHox.bitbucketOfferingSkus).standard || ccpOfferingSKU === (0, $aTHox.bitbucketOfferingSkus).premium) // rovodev-standard price-plans contain both user and rovodev-credits charge-items
        // bitbucket-standard and bitbucket-premium price-plans contain both user and bitbucket-credits charge-items as well
        // so, we need to get the plan with the user charge-item
        // todo: GWP-8253 move out of reusable calc logic
        getCcpTiers = (pricingPlans)=>pricingPlans.items.find((item)=>item.chargeElement === 'user');
        const pricingTiers = (0, $69Lp1.extractPricingTiersFromEntry)(ccpPricingData, $0f584d23bad95648$var$hamsPricingDataStub, period, currencyISOCode, ccpOfferingSKU, $0f584d23bad95648$var$hamsProductKeyStub, getCcpTiers);
        if (!pricingTiers) {
            console.log(`Pricing tiers not found for ${period}.`);
            return {
                offeringSku: ccpOfferingSKU,
                ...(0, $1RK9J.getFreePriceCalc)(currencyISOCode)
            };
        } else return {
            offeringSku: ccpOfferingSKU,
            ...(0, $8dsKS.calculatePrice)(numUnits, pricingTiers, currencyISOCode, period, localeISOCode)
        };
    }
}

});


parcelRegister("loQfN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d4a862ad906af43648c20a01ac989d3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f9445f6570be1c0c$var$_react = $f9445f6570be1c0c$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $f9445f6570be1c0c$var$_baseNew = $f9445f6570be1c0c$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $f9445f6570be1c0c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartTrend".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f9445f6570be1c0c$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $f9445f6570be1c0c$var$_react.default.createElement($f9445f6570be1c0c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1h1.5v7.94l3.22-3.22a.75.75 0 0 1 1.06 0L8.5 7.44l3.94-3.94H10V2h4.25a.75.75 0 0 1 .75.75V7h-1.5V4.56L9.03 9.03a.75.75 0 0 1-1.06 0L6.25 7.31 2.5 11.06V13a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$f9445f6570be1c0c$var$ChartTrendIcon.displayName = 'ChartTrendIcon';
var $f9445f6570be1c0c$var$_default = module.exports.default = $f9445f6570be1c0c$var$ChartTrendIcon;

});

parcelRegister("49zFb", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d43a7428702b82788297fb999fe29f0a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3063aaa999ab433f$var$_react = $3063aaa999ab433f$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3063aaa999ab433f$var$_baseNew = $3063aaa999ab433f$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $3063aaa999ab433f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for information statuses and messaging. 
Filled status icons provide higher visual contrast to draw attention to important information.
For information tooltips, use the unfilled 'information circle' icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3063aaa999ab433f$var$InformationIcon = (props)=>/*#__PURE__*/ $3063aaa999ab433f$var$_react.default.createElement($3063aaa999ab433f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$3063aaa999ab433f$var$InformationIcon.displayName = 'InformationIcon';
var $3063aaa999ab433f$var$_default = module.exports.default = $3063aaa999ab433f$var$InformationIcon;

});

parcelRegister("bECX9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f64abe706416b0877b5dd221be64e7d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87c1a5674979a6af$var$_react = $87c1a5674979a6af$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $87c1a5674979a6af$var$_baseNew = $87c1a5674979a6af$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $87c1a5674979a6af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Page".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87c1a5674979a6af$var$PageIcon = (props)=>/*#__PURE__*/ $87c1a5674979a6af$var$_react.default.createElement($87c1a5674979a6af$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM12 6H4V4.5h8zm-2 3.5H4V8h6z" clip-rule="evenodd"/>`
    }, props));
$87c1a5674979a6af$var$PageIcon.displayName = 'PageIcon';
var $87c1a5674979a6af$var$_default = module.exports.default = $87c1a5674979a6af$var$PageIcon;

});

parcelRegister("kvde0", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c2b2be59784c9b52b8b3b5b23f53d5b2>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eed0f61411f9d686$var$_react = $eed0f61411f9d686$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $eed0f61411f9d686$var$_baseNew = $eed0f61411f9d686$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $eed0f61411f9d686$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdded".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for a user added to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $eed0f61411f9d686$var$PersonAddedIcon = (props)=>/*#__PURE__*/ $eed0f61411f9d686$var$_react.default.createElement($eed0f61411f9d686$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m14.877 2.03-4 4a.75.75 0 0 1-1.051.01L8.98 8.262l1.04-1.08 1.316 1.267 3.48-3.48zM3.75 10.5a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.52a3.75 3.75 0 0 1 3.75 3.75V15h-1.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$eed0f61411f9d686$var$PersonAddedIcon.displayName = 'PersonAddedIcon';
var $eed0f61411f9d686$var$_default = module.exports.default = $eed0f61411f9d686$var$PersonAddedIcon;

});

parcelRegister("7V9HC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b34e6857b52d4ec156a688609aa0810c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5c4561fcacc10609$var$_react = $5c4561fcacc10609$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $5c4561fcacc10609$var$_baseNew = $5c4561fcacc10609$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $5c4561fcacc10609$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Phone".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: call us, phone number input.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5c4561fcacc10609$var$PhoneIcon = (props)=>/*#__PURE__*/ $5c4561fcacc10609$var$_react.default.createElement($5c4561fcacc10609$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 1.75A.75.75 0 0 1 1.75 1h3.5a.75.75 0 0 1 .721.544l.821 2.874a1.75 1.75 0 0 1-.562 1.825L4.29 7.86c.975 1.55 2.3 2.875 3.85 3.85l1.617-1.94a1.75 1.75 0 0 1 1.825-.562l2.874.82a.75.75 0 0 1 .544.722v3.5a.75.75 0 0 1-.75.75c-2.266 0-4.422-.61-6.309-1.664a13.77 13.77 0 0 1-5.277-5.277A12.9 12.9 0 0 1 1 1.75m8.484 10.69c1.25.578 2.606.94 4.016 1.035v-2.16l-2.33-.665a.25.25 0 0 0-.26.08zM3.56 6.516 5.27 5.09a.25.25 0 0 0 .08-.261L4.684 2.5H2.525A11.4 11.4 0 0 0 3.56 6.516" clip-rule="evenodd"/>`
    }, props));
$5c4561fcacc10609$var$PhoneIcon.displayName = 'PhoneIcon';
var $5c4561fcacc10609$var$_default = module.exports.default = $5c4561fcacc10609$var$PhoneIcon;

});

parcelRegister("2Qv7t", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::84298877a5ffec5302189e1356603055>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $212893c4a5d4c950$var$_react = $212893c4a5d4c950$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $212893c4a5d4c950$var$_baseNew = $212893c4a5d4c950$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $212893c4a5d4c950$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "StarStarred".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for starred or favourited objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $212893c4a5d4c950$var$StarStarredIcon = (props)=>/*#__PURE__*/ $212893c4a5d4c950$var$_react.default.createElement($212893c4a5d4c950$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a.75.75 0 0 1 .7.48l1.705 4.434 4.403.338a.75.75 0 0 1 .422 1.324l-3.38 2.818 1.25 4.662a.75.75 0 0 1-1.148.813L8 12.159l-3.95 2.71a.75.75 0 0 1-1.15-.813l1.251-4.662L.77 6.576a.75.75 0 0 1 .422-1.324l4.403-.338L7.3.48A.75.75 0 0 1 8 0m0 2.84L6.655 6.335l-3.506.27 2.7 2.25-.973 3.627L8 10.341l3.124 2.142-.973-3.627 2.7-2.25-3.506-.27z" clip-rule="evenodd"/><path fill="currentcolor" d="M6.655 6.336 8 2.84l1.345 3.497 3.506.27-2.7 2.25.973 3.627L8 10.341l-3.124 2.142.973-3.627-2.7-2.25z"/>`
    }, props));
$212893c4a5d4c950$var$StarStarredIcon.displayName = 'StarStarredIcon';
var $212893c4a5d4c950$var$_default = module.exports.default = $212893c4a5d4c950$var$StarStarredIcon;

});

parcelRegister("48PMv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::338651941b03ec38a528c6808ae2ffcd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3040137f93e7a89a$var$_react = $3040137f93e7a89a$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $3040137f93e7a89a$var$_baseNew = $3040137f93e7a89a$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $3040137f93e7a89a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Tag".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tags in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3040137f93e7a89a$var$TagIcon = (props)=>/*#__PURE__*/ $3040137f93e7a89a$var$_react.default.createElement($3040137f93e7a89a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M11 4a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/><path fill="currentcolor" fill-rule="evenodd" d="M9.286 1a3.25 3.25 0 0 0-2.299.952L1.604 7.336a2 2 0 0 0 0 2.828l4.232 4.232a2 2 0 0 0 2.828 0l5.384-5.383A3.25 3.25 0 0 0 15 6.714V3a2 2 0 0 0-2-2zM8.048 3.013A1.75 1.75 0 0 1 9.286 2.5H13a.5.5 0 0 1 .5.5v3.714c0 .465-.184.91-.513 1.238l-5.383 5.384a.5.5 0 0 1-.708 0L2.664 9.104a.5.5 0 0 1 0-.708z" clip-rule="evenodd"/>`
    }, props));
$3040137f93e7a89a$var$TagIcon.displayName = 'TagIcon';
var $3040137f93e7a89a$var$_default = module.exports.default = $3040137f93e7a89a$var$TagIcon;

});

parcelRegister("aUEBX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7de7c2be3f7c9d9cc79e629bb0768f3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7f1ea2e2c453dc33$var$_react = $7f1ea2e2c453dc33$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $7f1ea2e2c453dc33$var$_baseNew = $7f1ea2e2c453dc33$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $7f1ea2e2c453dc33$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Timeline".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for timelines in Jira or Trello.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7f1ea2e2c453dc33$var$TimelineIcon = (props)=>/*#__PURE__*/ $7f1ea2e2c453dc33$var$_react.default.createElement($7f1ea2e2c453dc33$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11 2.5H1V1h10zm4 4.167H5v-1.5h10zm-4 4.167H1v-1.5h10zM15 15H5v-1.5h10z" clip-rule="evenodd"/>`
    }, props));
$7f1ea2e2c453dc33$var$TimelineIcon.displayName = 'TimelineIcon';
var $7f1ea2e2c453dc33$var$_default = module.exports.default = $7f1ea2e2c453dc33$var$TimelineIcon;

});

parcelRegister("1DU5m", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0d7f4cbe44d53d27d30976de2191c923>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1324f0579617a371$var$_react = $1324f0579617a371$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $1324f0579617a371$var$_baseNew = $1324f0579617a371$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $1324f0579617a371$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Video".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for representing video content across Atlassian and Loom.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1324f0579617a371$var$VideoIcon = (props)=>/*#__PURE__*/ $1324f0579617a371$var$_react.default.createElement($1324f0579617a371$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 4a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5v-7A.5.5 0 0 0 10 4zm-2 .5a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v.218l2.137-1.203A1.25 1.25 0 0 1 16 4.605v6.79a1.25 1.25 0 0 1-1.863 1.09L12 11.282v.218a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm12 5.061 2.5 1.407V5.032L12 6.44z" clip-rule="evenodd"/>`
    }, props));
$1324f0579617a371$var$VideoIcon.displayName = 'VideoIcon';
var $1324f0579617a371$var$_default = module.exports.default = $1324f0579617a371$var$VideoIcon;

});

parcelRegister("djIg7", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c615014b011664b243a37531e093f861>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9b1f619c052c2afa$var$_react = $9b1f619c052c2afa$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $9b1f619c052c2afa$var$_baseNew = $9b1f619c052c2afa$var$_interopRequireDefault((parcelRequire("6GHa2")));
function $9b1f619c052c2afa$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Warning".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for warning statuses.
Filled status icons provide higher visual contrast to draw attention to important information.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9b1f619c052c2afa$var$WarningIcon = (props)=>/*#__PURE__*/ $9b1f619c052c2afa$var$_react.default.createElement($9b1f619c052c2afa$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6.242 1.169c.757-1.396 2.76-1.396 3.516 0l5.9 10.878C16.381 13.379 15.416 15 13.9 15H2.1C.584 15-.38 13.38.342 12.047zM7.25 9.5v-5h1.5v5zM8 12.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$9b1f619c052c2afa$var$WarningIcon.displayName = 'WarningIcon';
var $9b1f619c052c2afa$var$_default = module.exports.default = $9b1f619c052c2afa$var$WarningIcon;

});


var $67UrT = parcelRequire("67UrT");

var $3NQOU = parcelRequire("3NQOU");
(0, $3NQOU.init)((0, $67UrT.UniformEntryPage));


//# sourceMappingURL=uniform-entry-page.08020885.js.map
